(() => {
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $c106e002a49a00cb$var$extendStatics = function(d, b) {
    $c106e002a49a00cb$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $c106e002a49a00cb$var$extendStatics(d, b);
};
function $c106e002a49a00cb$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $c106e002a49a00cb$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $c106e002a49a00cb$export$18ce0697a983be9b = function() {
    $c106e002a49a00cb$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c106e002a49a00cb$export$18ce0697a983be9b.apply(this, arguments);
};
function $c106e002a49a00cb$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $c106e002a49a00cb$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $c106e002a49a00cb$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $c106e002a49a00cb$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $c106e002a49a00cb$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $c106e002a49a00cb$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $c106e002a49a00cb$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $c106e002a49a00cb$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $c106e002a49a00cb$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $c106e002a49a00cb$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $c106e002a49a00cb$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $c106e002a49a00cb$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $c106e002a49a00cb$export$45d3717a4c69092e(o, m, p);
}
function $c106e002a49a00cb$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $c106e002a49a00cb$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $c106e002a49a00cb$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($c106e002a49a00cb$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $c106e002a49a00cb$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $c106e002a49a00cb$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $c106e002a49a00cb$export$10c90e4f7922046c(v) {
    return this instanceof $c106e002a49a00cb$export$10c90e4f7922046c ? (this.v = v, this) : new $c106e002a49a00cb$export$10c90e4f7922046c(v);
}
function $c106e002a49a00cb$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $c106e002a49a00cb$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $c106e002a49a00cb$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $c106e002a49a00cb$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $c106e002a49a00cb$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $c106e002a49a00cb$export$19a8beecd37a4c45 === "function" ? $c106e002a49a00cb$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $c106e002a49a00cb$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $c106e002a49a00cb$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $c106e002a49a00cb$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $c106e002a49a00cb$export$45d3717a4c69092e(result, mod, k);
    }
    $c106e002a49a00cb$var$__setModuleDefault(result, mod);
    return result;
}
function $c106e002a49a00cb$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $c106e002a49a00cb$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $c106e002a49a00cb$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $c106e002a49a00cb$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
var $c106e002a49a00cb$export$2e2bcd8739ae039 = {
    __extends: $c106e002a49a00cb$export$a8ba968b8961cb8a,
    __assign: $c106e002a49a00cb$export$18ce0697a983be9b,
    __rest: $c106e002a49a00cb$export$3c9a16f847548506,
    __decorate: $c106e002a49a00cb$export$29e00dfd3077644b,
    __param: $c106e002a49a00cb$export$d5ad3fd78186038f,
    __metadata: $c106e002a49a00cb$export$f1db080c865becb9,
    __awaiter: $c106e002a49a00cb$export$1050f835b63b671e,
    __generator: $c106e002a49a00cb$export$67ebef60e6f28a6,
    __createBinding: $c106e002a49a00cb$export$45d3717a4c69092e,
    __exportStar: $c106e002a49a00cb$export$f33643c0debef087,
    __values: $c106e002a49a00cb$export$19a8beecd37a4c45,
    __read: $c106e002a49a00cb$export$8d051b38c9118094,
    __spread: $c106e002a49a00cb$export$afc72e2116322959,
    __spreadArrays: $c106e002a49a00cb$export$6388937ca91ccae8,
    __spreadArray: $c106e002a49a00cb$export$1216008129fb82ed,
    __await: $c106e002a49a00cb$export$10c90e4f7922046c,
    __asyncGenerator: $c106e002a49a00cb$export$e427f37a30a4de9b,
    __asyncDelegator: $c106e002a49a00cb$export$bbd80228419bb833,
    __asyncValues: $c106e002a49a00cb$export$e3b29a3d6162315f,
    __makeTemplateObject: $c106e002a49a00cb$export$4fb47efe1390b86f,
    __importStar: $c106e002a49a00cb$export$c21735bcef00d192,
    __importDefault: $c106e002a49a00cb$export$da59b14a69baef04,
    __classPrivateFieldGet: $c106e002a49a00cb$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $c106e002a49a00cb$export$d40a35129aaff81f,
    __classPrivateFieldIn: $c106e002a49a00cb$export$81fdc39f203e4e04
};


/*! *****************************************************************************
Copyright (C) Microsoft. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ var $d3c1734dacb01657$exports = {};
// shim for using process in browser
var $d3c1734dacb01657$var$process = $d3c1734dacb01657$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $d3c1734dacb01657$var$cachedSetTimeout;
var $d3c1734dacb01657$var$cachedClearTimeout;
function $d3c1734dacb01657$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $d3c1734dacb01657$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $d3c1734dacb01657$var$cachedSetTimeout = setTimeout;
        else $d3c1734dacb01657$var$cachedSetTimeout = $d3c1734dacb01657$var$defaultSetTimout;
    } catch (e) {
        $d3c1734dacb01657$var$cachedSetTimeout = $d3c1734dacb01657$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $d3c1734dacb01657$var$cachedClearTimeout = clearTimeout;
        else $d3c1734dacb01657$var$cachedClearTimeout = $d3c1734dacb01657$var$defaultClearTimeout;
    } catch (e) {
        $d3c1734dacb01657$var$cachedClearTimeout = $d3c1734dacb01657$var$defaultClearTimeout;
    }
})();
function $d3c1734dacb01657$var$runTimeout(fun) {
    if ($d3c1734dacb01657$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($d3c1734dacb01657$var$cachedSetTimeout === $d3c1734dacb01657$var$defaultSetTimout || !$d3c1734dacb01657$var$cachedSetTimeout) && setTimeout) {
        $d3c1734dacb01657$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d3c1734dacb01657$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $d3c1734dacb01657$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $d3c1734dacb01657$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $d3c1734dacb01657$var$runClearTimeout(marker) {
    if ($d3c1734dacb01657$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($d3c1734dacb01657$var$cachedClearTimeout === $d3c1734dacb01657$var$defaultClearTimeout || !$d3c1734dacb01657$var$cachedClearTimeout) && clearTimeout) {
        $d3c1734dacb01657$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d3c1734dacb01657$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $d3c1734dacb01657$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $d3c1734dacb01657$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $d3c1734dacb01657$var$queue = [];
var $d3c1734dacb01657$var$draining = false;
var $d3c1734dacb01657$var$currentQueue;
var $d3c1734dacb01657$var$queueIndex = -1;
function $d3c1734dacb01657$var$cleanUpNextTick() {
    if (!$d3c1734dacb01657$var$draining || !$d3c1734dacb01657$var$currentQueue) return;
    $d3c1734dacb01657$var$draining = false;
    if ($d3c1734dacb01657$var$currentQueue.length) $d3c1734dacb01657$var$queue = $d3c1734dacb01657$var$currentQueue.concat($d3c1734dacb01657$var$queue);
    else $d3c1734dacb01657$var$queueIndex = -1;
    if ($d3c1734dacb01657$var$queue.length) $d3c1734dacb01657$var$drainQueue();
}
function $d3c1734dacb01657$var$drainQueue() {
    if ($d3c1734dacb01657$var$draining) return;
    var timeout = $d3c1734dacb01657$var$runTimeout($d3c1734dacb01657$var$cleanUpNextTick);
    $d3c1734dacb01657$var$draining = true;
    var len = $d3c1734dacb01657$var$queue.length;
    while(len){
        $d3c1734dacb01657$var$currentQueue = $d3c1734dacb01657$var$queue;
        $d3c1734dacb01657$var$queue = [];
        while(++$d3c1734dacb01657$var$queueIndex < len)if ($d3c1734dacb01657$var$currentQueue) $d3c1734dacb01657$var$currentQueue[$d3c1734dacb01657$var$queueIndex].run();
        $d3c1734dacb01657$var$queueIndex = -1;
        len = $d3c1734dacb01657$var$queue.length;
    }
    $d3c1734dacb01657$var$currentQueue = null;
    $d3c1734dacb01657$var$draining = false;
    $d3c1734dacb01657$var$runClearTimeout(timeout);
}
$d3c1734dacb01657$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $d3c1734dacb01657$var$queue.push(new $d3c1734dacb01657$var$Item(fun, args));
    if ($d3c1734dacb01657$var$queue.length === 1 && !$d3c1734dacb01657$var$draining) $d3c1734dacb01657$var$runTimeout($d3c1734dacb01657$var$drainQueue);
};
// v8 likes predictible objects
function $d3c1734dacb01657$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$d3c1734dacb01657$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$d3c1734dacb01657$var$process.title = "browser";
$d3c1734dacb01657$var$process.browser = true;
$d3c1734dacb01657$var$process.env = {};
$d3c1734dacb01657$var$process.argv = [];
$d3c1734dacb01657$var$process.version = ""; // empty string to avoid regexp issues
$d3c1734dacb01657$var$process.versions = {};
function $d3c1734dacb01657$var$noop() {}
$d3c1734dacb01657$var$process.on = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.addListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.once = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.off = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.removeListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.removeAllListeners = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.emit = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.prependListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.prependOnceListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.listeners = function(name) {
    return [];
};
$d3c1734dacb01657$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$d3c1734dacb01657$var$process.cwd = function() {
    return "/";
};
$d3c1734dacb01657$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$d3c1734dacb01657$var$process.umask = function() {
    return 0;
};


var $371d3923400cf1b1$var$Reflect;
(function(Reflect) {
    // Metadata Proposal
    // https://rbuckton.github.io/reflect-metadata/
    (function(factory) {
        var root = typeof $parcel$global === "object" ? $parcel$global : typeof self === "object" ? self : typeof this === "object" ? this : Function("return this;")();
        var exporter = makeExporter(Reflect);
        if (typeof root.Reflect === "undefined") root.Reflect = Reflect;
        else exporter = makeExporter(root.Reflect, exporter);
        factory(exporter);
        function makeExporter(target, previous) {
            return function(key, value) {
                if (typeof target[key] !== "function") Object.defineProperty(target, key, {
                    configurable: true,
                    writable: true,
                    value: value
                });
                if (previous) previous(key, value);
            };
        }
    })(function(exporter) {
        var hasOwn = Object.prototype.hasOwnProperty;
        // feature test for Symbol support
        var supportsSymbol = typeof Symbol === "function";
        var toPrimitiveSymbol = supportsSymbol && typeof Symbol.toPrimitive !== "undefined" ? Symbol.toPrimitive : "@@toPrimitive";
        var iteratorSymbol = supportsSymbol && typeof Symbol.iterator !== "undefined" ? Symbol.iterator : "@@iterator";
        var supportsCreate = typeof Object.create === "function"; // feature test for Object.create support
        var supportsProto = ({
            __proto__: []
        }) instanceof Array; // feature test for __proto__ support
        var downLevel = !supportsCreate && !supportsProto;
        var HashMap = {
            // create an object in dictionary mode (a.k.a. "slow" mode in v8)
            create: supportsCreate ? function() {
                return MakeDictionary(Object.create(null));
            } : supportsProto ? function() {
                return MakeDictionary({
                    __proto__: null
                });
            } : function() {
                return MakeDictionary({});
            },
            has: downLevel ? function(map, key) {
                return hasOwn.call(map, key);
            } : function(map, key) {
                return key in map;
            },
            get: downLevel ? function(map, key) {
                return hasOwn.call(map, key) ? map[key] : undefined;
            } : function(map, key) {
                return map[key];
            }
        };
        // Load global or shim versions of Map, Set, and WeakMap
        var functionPrototype = Object.getPrototypeOf(Function);
        var usePolyfill = typeof $d3c1734dacb01657$exports === "object" && $d3c1734dacb01657$exports.env && false;
        var _Map = !usePolyfill && typeof Map === "function" && typeof Map.prototype.entries === "function" ? Map : CreateMapPolyfill();
        var _Set = !usePolyfill && typeof Set === "function" && typeof Set.prototype.entries === "function" ? Set : CreateSetPolyfill();
        var _WeakMap = !usePolyfill && typeof WeakMap === "function" ? WeakMap : CreateWeakMapPolyfill();
        // [[Metadata]] internal slot
        // https://rbuckton.github.io/reflect-metadata/#ordinary-object-internal-methods-and-internal-slots
        var Metadata = new _WeakMap();
        /**
         * Applies a set of decorators to a property of a target object.
         * @param decorators An array of decorators.
         * @param target The target object.
         * @param propertyKey (Optional) The property key to decorate.
         * @param attributes (Optional) The property descriptor for the target key.
         * @remarks Decorators are applied in reverse order.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     Example = Reflect.decorate(decoratorsArray, Example);
         *
         *     // property (on constructor)
         *     Reflect.decorate(decoratorsArray, Example, "staticProperty");
         *
         *     // property (on prototype)
         *     Reflect.decorate(decoratorsArray, Example.prototype, "property");
         *
         *     // method (on constructor)
         *     Object.defineProperty(Example, "staticMethod",
         *         Reflect.decorate(decoratorsArray, Example, "staticMethod",
         *             Object.getOwnPropertyDescriptor(Example, "staticMethod")));
         *
         *     // method (on prototype)
         *     Object.defineProperty(Example.prototype, "method",
         *         Reflect.decorate(decoratorsArray, Example.prototype, "method",
         *             Object.getOwnPropertyDescriptor(Example.prototype, "method")));
         *
         */ function decorate(decorators, target, propertyKey, attributes) {
            if (!IsUndefined(propertyKey)) {
                if (!IsArray(decorators)) throw new TypeError();
                if (!IsObject(target)) throw new TypeError();
                if (!IsObject(attributes) && !IsUndefined(attributes) && !IsNull(attributes)) throw new TypeError();
                if (IsNull(attributes)) attributes = undefined;
                propertyKey = ToPropertyKey(propertyKey);
                return DecorateProperty(decorators, target, propertyKey, attributes);
            } else {
                if (!IsArray(decorators)) throw new TypeError();
                if (!IsConstructor(target)) throw new TypeError();
                return DecorateConstructor(decorators, target);
            }
        }
        exporter("decorate", decorate);
        // 4.1.2 Reflect.metadata(metadataKey, metadataValue)
        // https://rbuckton.github.io/reflect-metadata/#reflect.metadata
        /**
         * A default metadata decorator factory that can be used on a class, class member, or parameter.
         * @param metadataKey The key for the metadata entry.
         * @param metadataValue The value for the metadata entry.
         * @returns A decorator function.
         * @remarks
         * If `metadataKey` is already defined for the target and target key, the
         * metadataValue for that key will be overwritten.
         * @example
         *
         *     // constructor
         *     @Reflect.metadata(key, value)
         *     class Example {
         *     }
         *
         *     // property (on constructor, TypeScript only)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         static staticProperty;
         *     }
         *
         *     // property (on prototype, TypeScript only)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         property;
         *     }
         *
         *     // method (on constructor)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         static staticMethod() { }
         *     }
         *
         *     // method (on prototype)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         method() { }
         *     }
         *
         */ function metadata(metadataKey, metadataValue) {
            function decorator(target, propertyKey) {
                if (!IsObject(target)) throw new TypeError();
                if (!IsUndefined(propertyKey) && !IsPropertyKey(propertyKey)) throw new TypeError();
                OrdinaryDefineOwnMetadata(metadataKey, metadataValue, target, propertyKey);
            }
            return decorator;
        }
        exporter("metadata", metadata);
        /**
         * Define a unique metadata entry on the target.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param metadataValue A value that contains attached metadata.
         * @param target The target object on which to define metadata.
         * @param propertyKey (Optional) The property key for the target.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     Reflect.defineMetadata("custom:annotation", options, Example);
         *
         *     // property (on constructor)
         *     Reflect.defineMetadata("custom:annotation", options, Example, "staticProperty");
         *
         *     // property (on prototype)
         *     Reflect.defineMetadata("custom:annotation", options, Example.prototype, "property");
         *
         *     // method (on constructor)
         *     Reflect.defineMetadata("custom:annotation", options, Example, "staticMethod");
         *
         *     // method (on prototype)
         *     Reflect.defineMetadata("custom:annotation", options, Example.prototype, "method");
         *
         *     // decorator factory as metadata-producing annotation.
         *     function MyAnnotation(options): Decorator {
         *         return (target, key?) => Reflect.defineMetadata("custom:annotation", options, target, key);
         *     }
         *
         */ function defineMetadata(metadataKey, metadataValue, target, propertyKey) {
            if (!IsObject(target)) throw new TypeError();
            if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryDefineOwnMetadata(metadataKey, metadataValue, target, propertyKey);
        }
        exporter("defineMetadata", defineMetadata);
        /**
         * Gets a value indicating whether the target object or its prototype chain has the provided metadata key defined.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns `true` if the metadata key was defined on the target object or its prototype chain; otherwise, `false`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.hasMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.hasMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.hasMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.hasMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.hasMetadata("custom:annotation", Example.prototype, "method");
         *
         */ function hasMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target)) throw new TypeError();
            if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryHasMetadata(metadataKey, target, propertyKey);
        }
        exporter("hasMetadata", hasMetadata);
        /**
         * Gets a value indicating whether the target object has the provided metadata key defined.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns `true` if the metadata key was defined on the target object; otherwise, `false`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example.prototype, "method");
         *
         */ function hasOwnMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target)) throw new TypeError();
            if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryHasOwnMetadata(metadataKey, target, propertyKey);
        }
        exporter("hasOwnMetadata", hasOwnMetadata);
        /**
         * Gets the metadata value for the provided metadata key on the target object or its prototype chain.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns The metadata value for the metadata key if found; otherwise, `undefined`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getMetadata("custom:annotation", Example.prototype, "method");
         *
         */ function getMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target)) throw new TypeError();
            if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryGetMetadata(metadataKey, target, propertyKey);
        }
        exporter("getMetadata", getMetadata);
        /**
         * Gets the metadata value for the provided metadata key on the target object.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns The metadata value for the metadata key if found; otherwise, `undefined`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getOwnMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example.prototype, "method");
         *
         */ function getOwnMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target)) throw new TypeError();
            if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryGetOwnMetadata(metadataKey, target, propertyKey);
        }
        exporter("getOwnMetadata", getOwnMetadata);
        /**
         * Gets the metadata keys defined on the target object or its prototype chain.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns An array of unique metadata keys.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getMetadataKeys(Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getMetadataKeys(Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getMetadataKeys(Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getMetadataKeys(Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getMetadataKeys(Example.prototype, "method");
         *
         */ function getMetadataKeys(target, propertyKey) {
            if (!IsObject(target)) throw new TypeError();
            if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryMetadataKeys(target, propertyKey);
        }
        exporter("getMetadataKeys", getMetadataKeys);
        /**
         * Gets the unique metadata keys defined on the target object.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns An array of unique metadata keys.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getOwnMetadataKeys(Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getOwnMetadataKeys(Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getOwnMetadataKeys(Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getOwnMetadataKeys(Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getOwnMetadataKeys(Example.prototype, "method");
         *
         */ function getOwnMetadataKeys(target, propertyKey) {
            if (!IsObject(target)) throw new TypeError();
            if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryOwnMetadataKeys(target, propertyKey);
        }
        exporter("getOwnMetadataKeys", getOwnMetadataKeys);
        /**
         * Deletes the metadata entry from the target object with the provided key.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns `true` if the metadata entry was found and deleted; otherwise, false.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.deleteMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.deleteMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.deleteMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.deleteMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.deleteMetadata("custom:annotation", Example.prototype, "method");
         *
         */ function deleteMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target)) throw new TypeError();
            if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
            var metadataMap = GetOrCreateMetadataMap(target, propertyKey, /*Create*/ false);
            if (IsUndefined(metadataMap)) return false;
            if (!metadataMap.delete(metadataKey)) return false;
            if (metadataMap.size > 0) return true;
            var targetMetadata = Metadata.get(target);
            targetMetadata.delete(propertyKey);
            if (targetMetadata.size > 0) return true;
            Metadata.delete(target);
            return true;
        }
        exporter("deleteMetadata", deleteMetadata);
        function DecorateConstructor(decorators, target) {
            for(var i = decorators.length - 1; i >= 0; --i){
                var decorator = decorators[i];
                var decorated = decorator(target);
                if (!IsUndefined(decorated) && !IsNull(decorated)) {
                    if (!IsConstructor(decorated)) throw new TypeError();
                    target = decorated;
                }
            }
            return target;
        }
        function DecorateProperty(decorators, target, propertyKey, descriptor) {
            for(var i = decorators.length - 1; i >= 0; --i){
                var decorator = decorators[i];
                var decorated = decorator(target, propertyKey, descriptor);
                if (!IsUndefined(decorated) && !IsNull(decorated)) {
                    if (!IsObject(decorated)) throw new TypeError();
                    descriptor = decorated;
                }
            }
            return descriptor;
        }
        function GetOrCreateMetadataMap(O, P, Create) {
            var targetMetadata = Metadata.get(O);
            if (IsUndefined(targetMetadata)) {
                if (!Create) return undefined;
                targetMetadata = new _Map();
                Metadata.set(O, targetMetadata);
            }
            var metadataMap = targetMetadata.get(P);
            if (IsUndefined(metadataMap)) {
                if (!Create) return undefined;
                metadataMap = new _Map();
                targetMetadata.set(P, metadataMap);
            }
            return metadataMap;
        }
        // 3.1.1.1 OrdinaryHasMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinaryhasmetadata
        function OrdinaryHasMetadata(MetadataKey, O, P) {
            var hasOwn = OrdinaryHasOwnMetadata(MetadataKey, O, P);
            if (hasOwn) return true;
            var parent = OrdinaryGetPrototypeOf(O);
            if (!IsNull(parent)) return OrdinaryHasMetadata(MetadataKey, parent, P);
            return false;
        }
        // 3.1.2.1 OrdinaryHasOwnMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinaryhasownmetadata
        function OrdinaryHasOwnMetadata(MetadataKey, O, P) {
            var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
            if (IsUndefined(metadataMap)) return false;
            return ToBoolean(metadataMap.has(MetadataKey));
        }
        // 3.1.3.1 OrdinaryGetMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarygetmetadata
        function OrdinaryGetMetadata(MetadataKey, O, P) {
            var hasOwn = OrdinaryHasOwnMetadata(MetadataKey, O, P);
            if (hasOwn) return OrdinaryGetOwnMetadata(MetadataKey, O, P);
            var parent = OrdinaryGetPrototypeOf(O);
            if (!IsNull(parent)) return OrdinaryGetMetadata(MetadataKey, parent, P);
            return undefined;
        }
        // 3.1.4.1 OrdinaryGetOwnMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarygetownmetadata
        function OrdinaryGetOwnMetadata(MetadataKey, O, P) {
            var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
            if (IsUndefined(metadataMap)) return undefined;
            return metadataMap.get(MetadataKey);
        }
        // 3.1.5.1 OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarydefineownmetadata
        function OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P) {
            var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ true);
            metadataMap.set(MetadataKey, MetadataValue);
        }
        // 3.1.6.1 OrdinaryMetadataKeys(O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarymetadatakeys
        function OrdinaryMetadataKeys(O, P) {
            var ownKeys = OrdinaryOwnMetadataKeys(O, P);
            var parent = OrdinaryGetPrototypeOf(O);
            if (parent === null) return ownKeys;
            var parentKeys = OrdinaryMetadataKeys(parent, P);
            if (parentKeys.length <= 0) return ownKeys;
            if (ownKeys.length <= 0) return parentKeys;
            var set = new _Set();
            var keys = [];
            for(var _i = 0, ownKeys_1 = ownKeys; _i < ownKeys_1.length; _i++){
                var key = ownKeys_1[_i];
                var hasKey = set.has(key);
                if (!hasKey) {
                    set.add(key);
                    keys.push(key);
                }
            }
            for(var _a = 0, parentKeys_1 = parentKeys; _a < parentKeys_1.length; _a++){
                var key = parentKeys_1[_a];
                var hasKey = set.has(key);
                if (!hasKey) {
                    set.add(key);
                    keys.push(key);
                }
            }
            return keys;
        }
        // 3.1.7.1 OrdinaryOwnMetadataKeys(O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinaryownmetadatakeys
        function OrdinaryOwnMetadataKeys(O, P) {
            var keys = [];
            var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
            if (IsUndefined(metadataMap)) return keys;
            var keysObj = metadataMap.keys();
            var iterator = GetIterator(keysObj);
            var k = 0;
            while(true){
                var next = IteratorStep(iterator);
                if (!next) {
                    keys.length = k;
                    return keys;
                }
                var nextValue = IteratorValue(next);
                try {
                    keys[k] = nextValue;
                } catch (e) {
                    try {
                        IteratorClose(iterator);
                    } finally{
                        throw e;
                    }
                }
                k++;
            }
        }
        // 6 ECMAScript Data Typ0es and Values
        // https://tc39.github.io/ecma262/#sec-ecmascript-data-types-and-values
        function Type(x) {
            if (x === null) return 1 /* Null */ ;
            switch(typeof x){
                case "undefined":
                    return 0 /* Undefined */ ;
                case "boolean":
                    return 2 /* Boolean */ ;
                case "string":
                    return 3 /* String */ ;
                case "symbol":
                    return 4 /* Symbol */ ;
                case "number":
                    return 5 /* Number */ ;
                case "object":
                    return x === null ? 1 /* Null */  : 6 /* Object */ ;
                default:
                    return 6 /* Object */ ;
            }
        }
        // 6.1.1 The Undefined Type
        // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-undefined-type
        function IsUndefined(x) {
            return x === undefined;
        }
        // 6.1.2 The Null Type
        // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-null-type
        function IsNull(x) {
            return x === null;
        }
        // 6.1.5 The Symbol Type
        // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-symbol-type
        function IsSymbol(x) {
            return typeof x === "symbol";
        }
        // 6.1.7 The Object Type
        // https://tc39.github.io/ecma262/#sec-object-type
        function IsObject(x) {
            return typeof x === "object" ? x !== null : typeof x === "function";
        }
        // 7.1 Type Conversion
        // https://tc39.github.io/ecma262/#sec-type-conversion
        // 7.1.1 ToPrimitive(input [, PreferredType])
        // https://tc39.github.io/ecma262/#sec-toprimitive
        function ToPrimitive(input, PreferredType) {
            switch(Type(input)){
                case 0 /* Undefined */ :
                    return input;
                case 1 /* Null */ :
                    return input;
                case 2 /* Boolean */ :
                    return input;
                case 3 /* String */ :
                    return input;
                case 4 /* Symbol */ :
                    return input;
                case 5 /* Number */ :
                    return input;
            }
            var hint = PreferredType === 3 /* String */  ? "string" : PreferredType === 5 /* Number */  ? "number" : "default";
            var exoticToPrim = GetMethod(input, toPrimitiveSymbol);
            if (exoticToPrim !== undefined) {
                var result = exoticToPrim.call(input, hint);
                if (IsObject(result)) throw new TypeError();
                return result;
            }
            return OrdinaryToPrimitive(input, hint === "default" ? "number" : hint);
        }
        // 7.1.1.1 OrdinaryToPrimitive(O, hint)
        // https://tc39.github.io/ecma262/#sec-ordinarytoprimitive
        function OrdinaryToPrimitive(O, hint) {
            if (hint === "string") {
                var toString_1 = O.toString;
                if (IsCallable(toString_1)) {
                    var result = toString_1.call(O);
                    if (!IsObject(result)) return result;
                }
                var valueOf = O.valueOf;
                if (IsCallable(valueOf)) {
                    var result = valueOf.call(O);
                    if (!IsObject(result)) return result;
                }
            } else {
                var valueOf = O.valueOf;
                if (IsCallable(valueOf)) {
                    var result = valueOf.call(O);
                    if (!IsObject(result)) return result;
                }
                var toString_2 = O.toString;
                if (IsCallable(toString_2)) {
                    var result = toString_2.call(O);
                    if (!IsObject(result)) return result;
                }
            }
            throw new TypeError();
        }
        // 7.1.2 ToBoolean(argument)
        // https://tc39.github.io/ecma262/2016/#sec-toboolean
        function ToBoolean(argument) {
            return !!argument;
        }
        // 7.1.12 ToString(argument)
        // https://tc39.github.io/ecma262/#sec-tostring
        function ToString(argument) {
            return "" + argument;
        }
        // 7.1.14 ToPropertyKey(argument)
        // https://tc39.github.io/ecma262/#sec-topropertykey
        function ToPropertyKey(argument) {
            var key = ToPrimitive(argument, 3 /* String */ );
            if (IsSymbol(key)) return key;
            return ToString(key);
        }
        // 7.2 Testing and Comparison Operations
        // https://tc39.github.io/ecma262/#sec-testing-and-comparison-operations
        // 7.2.2 IsArray(argument)
        // https://tc39.github.io/ecma262/#sec-isarray
        function IsArray(argument) {
            return Array.isArray ? Array.isArray(argument) : argument instanceof Object ? argument instanceof Array : Object.prototype.toString.call(argument) === "[object Array]";
        }
        // 7.2.3 IsCallable(argument)
        // https://tc39.github.io/ecma262/#sec-iscallable
        function IsCallable(argument) {
            // NOTE: This is an approximation as we cannot check for [[Call]] internal method.
            return typeof argument === "function";
        }
        // 7.2.4 IsConstructor(argument)
        // https://tc39.github.io/ecma262/#sec-isconstructor
        function IsConstructor(argument) {
            // NOTE: This is an approximation as we cannot check for [[Construct]] internal method.
            return typeof argument === "function";
        }
        // 7.2.7 IsPropertyKey(argument)
        // https://tc39.github.io/ecma262/#sec-ispropertykey
        function IsPropertyKey(argument) {
            switch(Type(argument)){
                case 3 /* String */ :
                    return true;
                case 4 /* Symbol */ :
                    return true;
                default:
                    return false;
            }
        }
        // 7.3 Operations on Objects
        // https://tc39.github.io/ecma262/#sec-operations-on-objects
        // 7.3.9 GetMethod(V, P)
        // https://tc39.github.io/ecma262/#sec-getmethod
        function GetMethod(V, P) {
            var func = V[P];
            if (func === undefined || func === null) return undefined;
            if (!IsCallable(func)) throw new TypeError();
            return func;
        }
        // 7.4 Operations on Iterator Objects
        // https://tc39.github.io/ecma262/#sec-operations-on-iterator-objects
        function GetIterator(obj) {
            var method = GetMethod(obj, iteratorSymbol);
            if (!IsCallable(method)) throw new TypeError(); // from Call
            var iterator = method.call(obj);
            if (!IsObject(iterator)) throw new TypeError();
            return iterator;
        }
        // 7.4.4 IteratorValue(iterResult)
        // https://tc39.github.io/ecma262/2016/#sec-iteratorvalue
        function IteratorValue(iterResult) {
            return iterResult.value;
        }
        // 7.4.5 IteratorStep(iterator)
        // https://tc39.github.io/ecma262/#sec-iteratorstep
        function IteratorStep(iterator) {
            var result = iterator.next();
            return result.done ? false : result;
        }
        // 7.4.6 IteratorClose(iterator, completion)
        // https://tc39.github.io/ecma262/#sec-iteratorclose
        function IteratorClose(iterator) {
            var f = iterator["return"];
            if (f) f.call(iterator);
        }
        // 9.1 Ordinary Object Internal Methods and Internal Slots
        // https://tc39.github.io/ecma262/#sec-ordinary-object-internal-methods-and-internal-slots
        // 9.1.1.1 OrdinaryGetPrototypeOf(O)
        // https://tc39.github.io/ecma262/#sec-ordinarygetprototypeof
        function OrdinaryGetPrototypeOf(O) {
            var proto = Object.getPrototypeOf(O);
            if (typeof O !== "function" || O === functionPrototype) return proto;
            // TypeScript doesn't set __proto__ in ES5, as it's non-standard.
            // Try to determine the superclass constructor. Compatible implementations
            // must either set __proto__ on a subclass constructor to the superclass constructor,
            // or ensure each class has a valid `constructor` property on its prototype that
            // points back to the constructor.
            // If this is not the same as Function.[[Prototype]], then this is definately inherited.
            // This is the case when in ES6 or when using __proto__ in a compatible browser.
            if (proto !== functionPrototype) return proto;
            // If the super prototype is Object.prototype, null, or undefined, then we cannot determine the heritage.
            var prototype = O.prototype;
            var prototypeProto = prototype && Object.getPrototypeOf(prototype);
            if (prototypeProto == null || prototypeProto === Object.prototype) return proto;
            // If the constructor was not a function, then we cannot determine the heritage.
            var constructor = prototypeProto.constructor;
            if (typeof constructor !== "function") return proto;
            // If we have some kind of self-reference, then we cannot determine the heritage.
            if (constructor === O) return proto;
            // we have a pretty good guess at the heritage.
            return constructor;
        }
        // naive Map shim
        function CreateMapPolyfill() {
            var cacheSentinel = {};
            var arraySentinel = [];
            var MapIterator = /** @class */ function() {
                function MapIterator(keys, values, selector) {
                    this._index = 0;
                    this._keys = keys;
                    this._values = values;
                    this._selector = selector;
                }
                MapIterator.prototype["@@iterator"] = function() {
                    return this;
                };
                MapIterator.prototype[iteratorSymbol] = function() {
                    return this;
                };
                MapIterator.prototype.next = function() {
                    var index = this._index;
                    if (index >= 0 && index < this._keys.length) {
                        var result = this._selector(this._keys[index], this._values[index]);
                        if (index + 1 >= this._keys.length) {
                            this._index = -1;
                            this._keys = arraySentinel;
                            this._values = arraySentinel;
                        } else this._index++;
                        return {
                            value: result,
                            done: false
                        };
                    }
                    return {
                        value: undefined,
                        done: true
                    };
                };
                MapIterator.prototype.throw = function(error) {
                    if (this._index >= 0) {
                        this._index = -1;
                        this._keys = arraySentinel;
                        this._values = arraySentinel;
                    }
                    throw error;
                };
                MapIterator.prototype.return = function(value) {
                    if (this._index >= 0) {
                        this._index = -1;
                        this._keys = arraySentinel;
                        this._values = arraySentinel;
                    }
                    return {
                        value: value,
                        done: true
                    };
                };
                return MapIterator;
            }();
            return /** @class */ function() {
                function Map1() {
                    this._keys = [];
                    this._values = [];
                    this._cacheKey = cacheSentinel;
                    this._cacheIndex = -2;
                }
                Object.defineProperty(Map1.prototype, "size", {
                    get: function() {
                        return this._keys.length;
                    },
                    enumerable: true,
                    configurable: true
                });
                Map1.prototype.has = function(key) {
                    return this._find(key, /*insert*/ false) >= 0;
                };
                Map1.prototype.get = function(key) {
                    var index = this._find(key, /*insert*/ false);
                    return index >= 0 ? this._values[index] : undefined;
                };
                Map1.prototype.set = function(key, value) {
                    var index = this._find(key, /*insert*/ true);
                    this._values[index] = value;
                    return this;
                };
                Map1.prototype.delete = function(key) {
                    var index = this._find(key, /*insert*/ false);
                    if (index >= 0) {
                        var size = this._keys.length;
                        for(var i = index + 1; i < size; i++){
                            this._keys[i - 1] = this._keys[i];
                            this._values[i - 1] = this._values[i];
                        }
                        this._keys.length--;
                        this._values.length--;
                        if (key === this._cacheKey) {
                            this._cacheKey = cacheSentinel;
                            this._cacheIndex = -2;
                        }
                        return true;
                    }
                    return false;
                };
                Map1.prototype.clear = function() {
                    this._keys.length = 0;
                    this._values.length = 0;
                    this._cacheKey = cacheSentinel;
                    this._cacheIndex = -2;
                };
                Map1.prototype.keys = function() {
                    return new MapIterator(this._keys, this._values, getKey);
                };
                Map1.prototype.values = function() {
                    return new MapIterator(this._keys, this._values, getValue);
                };
                Map1.prototype.entries = function() {
                    return new MapIterator(this._keys, this._values, getEntry);
                };
                Map1.prototype["@@iterator"] = function() {
                    return this.entries();
                };
                Map1.prototype[iteratorSymbol] = function() {
                    return this.entries();
                };
                Map1.prototype._find = function(key, insert) {
                    if (this._cacheKey !== key) this._cacheIndex = this._keys.indexOf(this._cacheKey = key);
                    if (this._cacheIndex < 0 && insert) {
                        this._cacheIndex = this._keys.length;
                        this._keys.push(key);
                        this._values.push(undefined);
                    }
                    return this._cacheIndex;
                };
                return Map1;
            }();
            function getKey(key, _) {
                return key;
            }
            function getValue(_, value) {
                return value;
            }
            function getEntry(key, value) {
                return [
                    key,
                    value
                ];
            }
        }
        // naive Set shim
        function CreateSetPolyfill() {
            return /** @class */ function() {
                function Set1() {
                    this._map = new _Map();
                }
                Object.defineProperty(Set1.prototype, "size", {
                    get: function() {
                        return this._map.size;
                    },
                    enumerable: true,
                    configurable: true
                });
                Set1.prototype.has = function(value) {
                    return this._map.has(value);
                };
                Set1.prototype.add = function(value) {
                    return this._map.set(value, value), this;
                };
                Set1.prototype.delete = function(value) {
                    return this._map.delete(value);
                };
                Set1.prototype.clear = function() {
                    this._map.clear();
                };
                Set1.prototype.keys = function() {
                    return this._map.keys();
                };
                Set1.prototype.values = function() {
                    return this._map.values();
                };
                Set1.prototype.entries = function() {
                    return this._map.entries();
                };
                Set1.prototype["@@iterator"] = function() {
                    return this.keys();
                };
                Set1.prototype[iteratorSymbol] = function() {
                    return this.keys();
                };
                return Set1;
            }();
        }
        // naive WeakMap shim
        function CreateWeakMapPolyfill() {
            var UUID_SIZE = 16;
            var keys = HashMap.create();
            var rootKey = CreateUniqueKey();
            return /** @class */ function() {
                function WeakMap1() {
                    this._key = CreateUniqueKey();
                }
                WeakMap1.prototype.has = function(target) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ false);
                    return table !== undefined ? HashMap.has(table, this._key) : false;
                };
                WeakMap1.prototype.get = function(target) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ false);
                    return table !== undefined ? HashMap.get(table, this._key) : undefined;
                };
                WeakMap1.prototype.set = function(target, value) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ true);
                    table[this._key] = value;
                    return this;
                };
                WeakMap1.prototype.delete = function(target) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ false);
                    return table !== undefined ? delete table[this._key] : false;
                };
                WeakMap1.prototype.clear = function() {
                    // NOTE: not a real clear, just makes the previous data unreachable
                    this._key = CreateUniqueKey();
                };
                return WeakMap1;
            }();
            function CreateUniqueKey() {
                var key;
                do key = "@@WeakMap@@" + CreateUUID();
                while (HashMap.has(keys, key));
                keys[key] = true;
                return key;
            }
            function GetOrCreateWeakMapTable(target, create) {
                if (!hasOwn.call(target, rootKey)) {
                    if (!create) return undefined;
                    Object.defineProperty(target, rootKey, {
                        value: HashMap.create()
                    });
                }
                return target[rootKey];
            }
            function FillRandomBytes(buffer, size) {
                for(var i = 0; i < size; ++i)buffer[i] = Math.random() * 0xff | 0;
                return buffer;
            }
            function GenRandomBytes(size) {
                if (typeof Uint8Array === "function") {
                    if (typeof crypto !== "undefined") return crypto.getRandomValues(new Uint8Array(size));
                    if (typeof msCrypto !== "undefined") return msCrypto.getRandomValues(new Uint8Array(size));
                    return FillRandomBytes(new Uint8Array(size), size);
                }
                return FillRandomBytes(new Array(size), size);
            }
            function CreateUUID() {
                var data = GenRandomBytes(UUID_SIZE);
                // mark as random - RFC 4122 § 4.4
                data[6] = data[6] & 0x4f | 0x40;
                data[8] = data[8] & 0xbf | 0x80;
                var result = "";
                for(var offset = 0; offset < UUID_SIZE; ++offset){
                    var byte = data[offset];
                    if (offset === 4 || offset === 6 || offset === 8) result += "-";
                    if (byte < 16) result += "0";
                    result += byte.toString(16).toLowerCase();
                }
                return result;
            }
        }
        // uses a heuristic used by v8 and chakra to force an object into dictionary mode.
        function MakeDictionary(obj) {
            obj.__ = undefined;
            delete obj.__;
            return obj;
        }
    });
})($371d3923400cf1b1$var$Reflect || ($371d3923400cf1b1$var$Reflect = {}));


var $100a17ae573d4fdc$var$Lifecycle;
(function(Lifecycle) {
    Lifecycle[Lifecycle["Transient"] = 0] = "Transient";
    Lifecycle[Lifecycle["Singleton"] = 1] = "Singleton";
    Lifecycle[Lifecycle["ResolutionScoped"] = 2] = "ResolutionScoped";
    Lifecycle[Lifecycle["ContainerScoped"] = 3] = "ContainerScoped";
})($100a17ae573d4fdc$var$Lifecycle || ($100a17ae573d4fdc$var$Lifecycle = {}));
var $100a17ae573d4fdc$export$2e2bcd8739ae039 = $100a17ae573d4fdc$var$Lifecycle;




/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $907264bab5ac1d80$var$extendStatics = function(d, b) {
    $907264bab5ac1d80$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $907264bab5ac1d80$var$extendStatics(d, b);
};
function $907264bab5ac1d80$export$a8ba968b8961cb8a(d, b) {
    $907264bab5ac1d80$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $907264bab5ac1d80$export$18ce0697a983be9b = function() {
    $907264bab5ac1d80$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $907264bab5ac1d80$export$18ce0697a983be9b.apply(this, arguments);
};
function $907264bab5ac1d80$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $907264bab5ac1d80$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $907264bab5ac1d80$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $907264bab5ac1d80$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $907264bab5ac1d80$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $907264bab5ac1d80$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $907264bab5ac1d80$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $907264bab5ac1d80$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $907264bab5ac1d80$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $907264bab5ac1d80$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $907264bab5ac1d80$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($907264bab5ac1d80$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $907264bab5ac1d80$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $907264bab5ac1d80$export$10c90e4f7922046c(v) {
    return this instanceof $907264bab5ac1d80$export$10c90e4f7922046c ? (this.v = v, this) : new $907264bab5ac1d80$export$10c90e4f7922046c(v);
}
function $907264bab5ac1d80$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $907264bab5ac1d80$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $907264bab5ac1d80$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $907264bab5ac1d80$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $907264bab5ac1d80$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $907264bab5ac1d80$export$19a8beecd37a4c45 === "function" ? $907264bab5ac1d80$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $907264bab5ac1d80$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $907264bab5ac1d80$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $907264bab5ac1d80$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $907264bab5ac1d80$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $907264bab5ac1d80$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


var $16892cc93f5964bc$export$b176dcab83c5ab0f = "injectionTokens";
function $16892cc93f5964bc$export$9faf182f78e433cb(target) {
    var params = Reflect.getMetadata("design:paramtypes", target) || [];
    var injectionTokens = Reflect.getOwnMetadata($16892cc93f5964bc$export$b176dcab83c5ab0f, target) || {};
    Object.keys(injectionTokens).forEach(function(key) {
        params[+key] = injectionTokens[key];
    });
    return params;
}
function $16892cc93f5964bc$export$ecde1113a41f71a4(data, transform) {
    return function(target, _propertyKey, parameterIndex) {
        var descriptors = Reflect.getOwnMetadata($16892cc93f5964bc$export$b176dcab83c5ab0f, target) || {};
        descriptors[parameterIndex] = transform ? {
            token: data,
            transform: transform.transformToken,
            transformArgs: transform.args || []
        } : data;
        Reflect.defineMetadata($16892cc93f5964bc$export$b176dcab83c5ab0f, descriptors, target);
    };
}



function $2f93d3d148a3b6cb$export$15acccf40f8e8591(provider) {
    return !!provider.useClass;
}


function $6c78bb93d56604f4$export$941a285414080505(provider) {
    return !!provider.useFactory;
}



var $189e0411119b242a$export$bcf9d41632409112 = function() {
    function DelayedConstructor(wrap) {
        this.wrap = wrap;
        this.reflectMethods = [
            "get",
            "getPrototypeOf",
            "setPrototypeOf",
            "getOwnPropertyDescriptor",
            "defineProperty",
            "has",
            "set",
            "deleteProperty",
            "apply",
            "construct",
            "ownKeys"
        ];
    }
    DelayedConstructor.prototype.createProxy = function(createObject) {
        var _this = this;
        var target = {};
        var init = false;
        var value;
        var delayedObject = function() {
            if (!init) {
                value = createObject(_this.wrap());
                init = true;
            }
            return value;
        };
        return new Proxy(target, this.createHandler(delayedObject));
    };
    DelayedConstructor.prototype.createHandler = function(delayedObject) {
        var handler = {};
        var install = function(name) {
            handler[name] = function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                args[0] = delayedObject();
                var method = Reflect[name];
                return method.apply(void 0, (0, $907264bab5ac1d80$export$afc72e2116322959)(args));
            };
        };
        this.reflectMethods.forEach(install);
        return handler;
    };
    return DelayedConstructor;
}();
function $189e0411119b242a$export$1391212d75b2ee65(wrappedConstructor) {
    if (typeof wrappedConstructor === "undefined") throw new Error("Attempt to `delay` undefined. Constructor must be wrapped in a callback");
    return new $189e0411119b242a$export$bcf9d41632409112(wrappedConstructor);
}


function $49d89df96b014861$export$344aa5be731b0b9c(token) {
    return typeof token === "string" || typeof token === "symbol";
}
function $49d89df96b014861$export$bdac4b7e51a04013(descriptor) {
    return typeof descriptor === "object" && "token" in descriptor && "multiple" in descriptor;
}
function $49d89df96b014861$export$c48b96891821a498(descriptor) {
    return typeof descriptor === "object" && "token" in descriptor && "transform" in descriptor;
}
function $49d89df96b014861$export$cc344ea5ce796162(token) {
    return typeof token === "function" || token instanceof (0, $189e0411119b242a$export$bcf9d41632409112);
}


function $5a1c45a7d8fd1764$export$95f13b15a6a876c6(provider) {
    return !!provider.useToken;
}


function $d8283388c509a175$export$c9ded229e20f81ca(provider) {
    return provider.useValue != undefined;
}








function $27881c45976a9e64$export$e51f846980072104(provider) {
    return (0, $2f93d3d148a3b6cb$export$15acccf40f8e8591)(provider) || (0, $d8283388c509a175$export$c9ded229e20f81ca)(provider) || (0, $5a1c45a7d8fd1764$export$95f13b15a6a876c6)(provider) || (0, $6c78bb93d56604f4$export$941a285414080505)(provider);
}




var $71e3b4173d893bef$var$RegistryBase = function() {
    function RegistryBase() {
        this._registryMap = new Map();
    }
    RegistryBase.prototype.entries = function() {
        return this._registryMap.entries();
    };
    RegistryBase.prototype.getAll = function(key) {
        this.ensure(key);
        return this._registryMap.get(key);
    };
    RegistryBase.prototype.get = function(key) {
        this.ensure(key);
        var value = this._registryMap.get(key);
        return value[value.length - 1] || null;
    };
    RegistryBase.prototype.set = function(key, value) {
        this.ensure(key);
        this._registryMap.get(key).push(value);
    };
    RegistryBase.prototype.setAll = function(key, value) {
        this._registryMap.set(key, value);
    };
    RegistryBase.prototype.has = function(key) {
        this.ensure(key);
        return this._registryMap.get(key).length > 0;
    };
    RegistryBase.prototype.clear = function() {
        this._registryMap.clear();
    };
    RegistryBase.prototype.ensure = function(key) {
        if (!this._registryMap.has(key)) this._registryMap.set(key, []);
    };
    return RegistryBase;
}();
var $71e3b4173d893bef$export$2e2bcd8739ae039 = $71e3b4173d893bef$var$RegistryBase;


var $7e6d79765a58cf98$var$Registry = function(_super) {
    (0, $907264bab5ac1d80$export$a8ba968b8961cb8a)(Registry, _super);
    function Registry() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Registry;
}((0, $71e3b4173d893bef$export$2e2bcd8739ae039));
var $7e6d79765a58cf98$export$2e2bcd8739ae039 = $7e6d79765a58cf98$var$Registry;



var $7e428231c89140a6$var$ResolutionContext = function() {
    function ResolutionContext() {
        this.scopedResolutions = new Map();
    }
    return ResolutionContext;
}();
var $7e428231c89140a6$export$2e2bcd8739ae039 = $7e428231c89140a6$var$ResolutionContext;



function $add717f5f77bbbc6$var$formatDependency(params, idx) {
    if (params === null) return "at position #" + idx;
    var argName = params.split(",")[idx].trim();
    return '"' + argName + '" at position #' + idx;
}
function $add717f5f77bbbc6$var$composeErrorMessage(msg, e, indent) {
    if (indent === void 0) indent = "    ";
    return (0, $907264bab5ac1d80$export$afc72e2116322959)([
        msg
    ], e.message.split("\n").map(function(l) {
        return indent + l;
    })).join("\n");
}
function $add717f5f77bbbc6$export$71fb617216ca01da(ctor, paramIdx, error) {
    var _a = (0, $907264bab5ac1d80$export$8d051b38c9118094)(ctor.toString().match(/constructor\(([\w, ]+)\)/) || [], 2), _b = _a[1], params = _b === void 0 ? null : _b;
    var dep = $add717f5f77bbbc6$var$formatDependency(params, paramIdx);
    return $add717f5f77bbbc6$var$composeErrorMessage("Cannot inject the dependency " + dep + ' of "' + ctor.name + '" constructor. Reason:', error);
}



function $7279a3669f01bc8d$export$e29d65b7eabdc6dd(value) {
    if (typeof value.dispose !== "function") return false;
    var disposeFun = value.dispose;
    if (disposeFun.length > 0) return false;
    return true;
}




var $5fd68402622c1a8e$export$e99a5258cf936d75 = function(_super) {
    (0, $907264bab5ac1d80$export$a8ba968b8961cb8a)(PreResolutionInterceptors, _super);
    function PreResolutionInterceptors() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PreResolutionInterceptors;
}((0, $71e3b4173d893bef$export$2e2bcd8739ae039));
var $5fd68402622c1a8e$export$641fb753cd25aac0 = function(_super) {
    (0, $907264bab5ac1d80$export$a8ba968b8961cb8a)(PostResolutionInterceptors, _super);
    function PostResolutionInterceptors() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PostResolutionInterceptors;
}((0, $71e3b4173d893bef$export$2e2bcd8739ae039));
var $5fd68402622c1a8e$var$Interceptors = function() {
    function Interceptors() {
        this.preResolution = new $5fd68402622c1a8e$export$e99a5258cf936d75();
        this.postResolution = new $5fd68402622c1a8e$export$641fb753cd25aac0();
    }
    return Interceptors;
}();
var $5fd68402622c1a8e$export$2e2bcd8739ae039 = $5fd68402622c1a8e$var$Interceptors;


var $bef43bd5f0c77276$export$748ded302730e3b = new Map();
var $bef43bd5f0c77276$var$InternalDependencyContainer = function() {
    function InternalDependencyContainer(parent) {
        this.parent = parent;
        this._registry = new (0, $7e6d79765a58cf98$export$2e2bcd8739ae039)();
        this.interceptors = new (0, $5fd68402622c1a8e$export$2e2bcd8739ae039)();
        this.disposed = false;
        this.disposables = new Set();
    }
    InternalDependencyContainer.prototype.register = function(token, providerOrConstructor, options) {
        if (options === void 0) options = {
            lifecycle: (0, $100a17ae573d4fdc$export$2e2bcd8739ae039).Transient
        };
        this.ensureNotDisposed();
        var provider;
        if (!(0, $27881c45976a9e64$export$e51f846980072104)(providerOrConstructor)) provider = {
            useClass: providerOrConstructor
        };
        else provider = providerOrConstructor;
        if ((0, $5a1c45a7d8fd1764$export$95f13b15a6a876c6)(provider)) {
            var path = [
                token
            ];
            var tokenProvider = provider;
            while(tokenProvider != null){
                var currentToken = tokenProvider.useToken;
                if (path.includes(currentToken)) throw new Error("Token registration cycle detected! " + (0, $907264bab5ac1d80$export$afc72e2116322959)(path, [
                    currentToken
                ]).join(" -> "));
                path.push(currentToken);
                var registration = this._registry.get(currentToken);
                if (registration && (0, $5a1c45a7d8fd1764$export$95f13b15a6a876c6)(registration.provider)) tokenProvider = registration.provider;
                else tokenProvider = null;
            }
        }
        if (options.lifecycle === (0, $100a17ae573d4fdc$export$2e2bcd8739ae039).Singleton || options.lifecycle == (0, $100a17ae573d4fdc$export$2e2bcd8739ae039).ContainerScoped || options.lifecycle == (0, $100a17ae573d4fdc$export$2e2bcd8739ae039).ResolutionScoped) {
            if ((0, $d8283388c509a175$export$c9ded229e20f81ca)(provider) || (0, $6c78bb93d56604f4$export$941a285414080505)(provider)) throw new Error('Cannot use lifecycle "' + (0, $100a17ae573d4fdc$export$2e2bcd8739ae039)[options.lifecycle] + '" with ValueProviders or FactoryProviders');
        }
        this._registry.set(token, {
            provider: provider,
            options: options
        });
        return this;
    };
    InternalDependencyContainer.prototype.registerType = function(from, to) {
        this.ensureNotDisposed();
        if ((0, $49d89df96b014861$export$344aa5be731b0b9c)(to)) return this.register(from, {
            useToken: to
        });
        return this.register(from, {
            useClass: to
        });
    };
    InternalDependencyContainer.prototype.registerInstance = function(token, instance) {
        this.ensureNotDisposed();
        return this.register(token, {
            useValue: instance
        });
    };
    InternalDependencyContainer.prototype.registerSingleton = function(from, to) {
        this.ensureNotDisposed();
        if ((0, $49d89df96b014861$export$344aa5be731b0b9c)(from)) {
            if ((0, $49d89df96b014861$export$344aa5be731b0b9c)(to)) return this.register(from, {
                useToken: to
            }, {
                lifecycle: (0, $100a17ae573d4fdc$export$2e2bcd8739ae039).Singleton
            });
            else if (to) return this.register(from, {
                useClass: to
            }, {
                lifecycle: (0, $100a17ae573d4fdc$export$2e2bcd8739ae039).Singleton
            });
            throw new Error('Cannot register a type name as a singleton without a "to" token');
        }
        var useClass = from;
        if (to && !(0, $49d89df96b014861$export$344aa5be731b0b9c)(to)) useClass = to;
        return this.register(from, {
            useClass: useClass
        }, {
            lifecycle: (0, $100a17ae573d4fdc$export$2e2bcd8739ae039).Singleton
        });
    };
    InternalDependencyContainer.prototype.resolve = function(token, context) {
        if (context === void 0) context = new (0, $7e428231c89140a6$export$2e2bcd8739ae039)();
        this.ensureNotDisposed();
        var registration = this.getRegistration(token);
        if (!registration && (0, $49d89df96b014861$export$344aa5be731b0b9c)(token)) throw new Error('Attempted to resolve unregistered dependency token: "' + token.toString() + '"');
        this.executePreResolutionInterceptor(token, "Single");
        if (registration) {
            var result = this.resolveRegistration(registration, context);
            this.executePostResolutionInterceptor(token, result, "Single");
            return result;
        }
        if ((0, $49d89df96b014861$export$cc344ea5ce796162)(token)) {
            var result = this.construct(token, context);
            this.executePostResolutionInterceptor(token, result, "Single");
            return result;
        }
        throw new Error("Attempted to construct an undefined constructor. Could mean a circular dependency problem. Try using `delay` function.");
    };
    InternalDependencyContainer.prototype.executePreResolutionInterceptor = function(token, resolutionType) {
        var e_1, _a;
        if (this.interceptors.preResolution.has(token)) {
            var remainingInterceptors = [];
            try {
                for(var _b = (0, $907264bab5ac1d80$export$19a8beecd37a4c45)(this.interceptors.preResolution.getAll(token)), _c = _b.next(); !_c.done; _c = _b.next()){
                    var interceptor = _c.value;
                    if (interceptor.options.frequency != "Once") remainingInterceptors.push(interceptor);
                    interceptor.callback(token, resolutionType);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            this.interceptors.preResolution.setAll(token, remainingInterceptors);
        }
    };
    InternalDependencyContainer.prototype.executePostResolutionInterceptor = function(token, result, resolutionType) {
        var e_2, _a;
        if (this.interceptors.postResolution.has(token)) {
            var remainingInterceptors = [];
            try {
                for(var _b = (0, $907264bab5ac1d80$export$19a8beecd37a4c45)(this.interceptors.postResolution.getAll(token)), _c = _b.next(); !_c.done; _c = _b.next()){
                    var interceptor = _c.value;
                    if (interceptor.options.frequency != "Once") remainingInterceptors.push(interceptor);
                    interceptor.callback(token, result, resolutionType);
                }
            } catch (e_2_1) {
                e_2 = {
                    error: e_2_1
                };
            } finally{
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally{
                    if (e_2) throw e_2.error;
                }
            }
            this.interceptors.postResolution.setAll(token, remainingInterceptors);
        }
    };
    InternalDependencyContainer.prototype.resolveRegistration = function(registration, context) {
        this.ensureNotDisposed();
        if (registration.options.lifecycle === (0, $100a17ae573d4fdc$export$2e2bcd8739ae039).ResolutionScoped && context.scopedResolutions.has(registration)) return context.scopedResolutions.get(registration);
        var isSingleton = registration.options.lifecycle === (0, $100a17ae573d4fdc$export$2e2bcd8739ae039).Singleton;
        var isContainerScoped = registration.options.lifecycle === (0, $100a17ae573d4fdc$export$2e2bcd8739ae039).ContainerScoped;
        var returnInstance = isSingleton || isContainerScoped;
        var resolved;
        if ((0, $d8283388c509a175$export$c9ded229e20f81ca)(registration.provider)) resolved = registration.provider.useValue;
        else if ((0, $5a1c45a7d8fd1764$export$95f13b15a6a876c6)(registration.provider)) resolved = returnInstance ? registration.instance || (registration.instance = this.resolve(registration.provider.useToken, context)) : this.resolve(registration.provider.useToken, context);
        else if ((0, $2f93d3d148a3b6cb$export$15acccf40f8e8591)(registration.provider)) resolved = returnInstance ? registration.instance || (registration.instance = this.construct(registration.provider.useClass, context)) : this.construct(registration.provider.useClass, context);
        else if ((0, $6c78bb93d56604f4$export$941a285414080505)(registration.provider)) resolved = registration.provider.useFactory(this);
        else resolved = this.construct(registration.provider, context);
        if (registration.options.lifecycle === (0, $100a17ae573d4fdc$export$2e2bcd8739ae039).ResolutionScoped) context.scopedResolutions.set(registration, resolved);
        return resolved;
    };
    InternalDependencyContainer.prototype.resolveAll = function(token, context) {
        var _this = this;
        if (context === void 0) context = new (0, $7e428231c89140a6$export$2e2bcd8739ae039)();
        this.ensureNotDisposed();
        var registrations = this.getAllRegistrations(token);
        if (!registrations && (0, $49d89df96b014861$export$344aa5be731b0b9c)(token)) throw new Error('Attempted to resolve unregistered dependency token: "' + token.toString() + '"');
        this.executePreResolutionInterceptor(token, "All");
        if (registrations) {
            var result_1 = registrations.map(function(item) {
                return _this.resolveRegistration(item, context);
            });
            this.executePostResolutionInterceptor(token, result_1, "All");
            return result_1;
        }
        var result = [
            this.construct(token, context)
        ];
        this.executePostResolutionInterceptor(token, result, "All");
        return result;
    };
    InternalDependencyContainer.prototype.isRegistered = function(token, recursive) {
        if (recursive === void 0) recursive = false;
        this.ensureNotDisposed();
        return this._registry.has(token) || recursive && (this.parent || false) && this.parent.isRegistered(token, true);
    };
    InternalDependencyContainer.prototype.reset = function() {
        this.ensureNotDisposed();
        this._registry.clear();
        this.interceptors.preResolution.clear();
        this.interceptors.postResolution.clear();
    };
    InternalDependencyContainer.prototype.clearInstances = function() {
        var e_3, _a;
        this.ensureNotDisposed();
        try {
            for(var _b = (0, $907264bab5ac1d80$export$19a8beecd37a4c45)(this._registry.entries()), _c = _b.next(); !_c.done; _c = _b.next()){
                var _d = (0, $907264bab5ac1d80$export$8d051b38c9118094)(_c.value, 2), token = _d[0], registrations = _d[1];
                this._registry.setAll(token, registrations.filter(function(registration) {
                    return !(0, $d8283388c509a175$export$c9ded229e20f81ca)(registration.provider);
                }).map(function(registration) {
                    registration.instance = undefined;
                    return registration;
                }));
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
    };
    InternalDependencyContainer.prototype.createChildContainer = function() {
        var e_4, _a;
        this.ensureNotDisposed();
        var childContainer = new InternalDependencyContainer(this);
        try {
            for(var _b = (0, $907264bab5ac1d80$export$19a8beecd37a4c45)(this._registry.entries()), _c = _b.next(); !_c.done; _c = _b.next()){
                var _d = (0, $907264bab5ac1d80$export$8d051b38c9118094)(_c.value, 2), token = _d[0], registrations = _d[1];
                if (registrations.some(function(_a) {
                    var options = _a.options;
                    return options.lifecycle === (0, $100a17ae573d4fdc$export$2e2bcd8739ae039).ContainerScoped;
                })) childContainer._registry.setAll(token, registrations.map(function(registration) {
                    if (registration.options.lifecycle === (0, $100a17ae573d4fdc$export$2e2bcd8739ae039).ContainerScoped) return {
                        provider: registration.provider,
                        options: registration.options
                    };
                    return registration;
                }));
            }
        } catch (e_4_1) {
            e_4 = {
                error: e_4_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_4) throw e_4.error;
            }
        }
        return childContainer;
    };
    InternalDependencyContainer.prototype.beforeResolution = function(token, callback, options) {
        if (options === void 0) options = {
            frequency: "Always"
        };
        this.interceptors.preResolution.set(token, {
            callback: callback,
            options: options
        });
    };
    InternalDependencyContainer.prototype.afterResolution = function(token, callback, options) {
        if (options === void 0) options = {
            frequency: "Always"
        };
        this.interceptors.postResolution.set(token, {
            callback: callback,
            options: options
        });
    };
    InternalDependencyContainer.prototype.dispose = function() {
        return (0, $907264bab5ac1d80$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var promises;
            return (0, $907264bab5ac1d80$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.disposed = true;
                        promises = [];
                        this.disposables.forEach(function(disposable) {
                            var maybePromise = disposable.dispose();
                            if (maybePromise) promises.push(maybePromise);
                        });
                        return [
                            4,
                            Promise.all(promises)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2
                        ];
                }
            });
        });
    };
    InternalDependencyContainer.prototype.getRegistration = function(token) {
        if (this.isRegistered(token)) return this._registry.get(token);
        if (this.parent) return this.parent.getRegistration(token);
        return null;
    };
    InternalDependencyContainer.prototype.getAllRegistrations = function(token) {
        if (this.isRegistered(token)) return this._registry.getAll(token);
        if (this.parent) return this.parent.getAllRegistrations(token);
        return null;
    };
    InternalDependencyContainer.prototype.construct = function(ctor, context) {
        var _this = this;
        if (ctor instanceof (0, $189e0411119b242a$export$bcf9d41632409112)) return ctor.createProxy(function(target) {
            return _this.resolve(target, context);
        });
        var instance = function() {
            var paramInfo = $bef43bd5f0c77276$export$748ded302730e3b.get(ctor);
            if (!paramInfo || paramInfo.length === 0) {
                if (ctor.length === 0) return new ctor();
                else throw new Error('TypeInfo not known for "' + ctor.name + '"');
            }
            var params = paramInfo.map(_this.resolveParams(context, ctor));
            return new (ctor.bind.apply(ctor, (0, $907264bab5ac1d80$export$afc72e2116322959)([
                void 0
            ], params)))();
        }();
        if ((0, $7279a3669f01bc8d$export$e29d65b7eabdc6dd)(instance)) this.disposables.add(instance);
        return instance;
    };
    InternalDependencyContainer.prototype.resolveParams = function(context, ctor) {
        var _this = this;
        return function(param, idx) {
            var _a, _b, _c;
            try {
                if ((0, $49d89df96b014861$export$bdac4b7e51a04013)(param)) {
                    if ((0, $49d89df96b014861$export$c48b96891821a498)(param)) return param.multiple ? (_a = _this.resolve(param.transform)).transform.apply(_a, (0, $907264bab5ac1d80$export$afc72e2116322959)([
                        _this.resolveAll(param.token)
                    ], param.transformArgs)) : (_b = _this.resolve(param.transform)).transform.apply(_b, (0, $907264bab5ac1d80$export$afc72e2116322959)([
                        _this.resolve(param.token, context)
                    ], param.transformArgs));
                    else return param.multiple ? _this.resolveAll(param.token) : _this.resolve(param.token, context);
                } else if ((0, $49d89df96b014861$export$c48b96891821a498)(param)) return (_c = _this.resolve(param.transform, context)).transform.apply(_c, (0, $907264bab5ac1d80$export$afc72e2116322959)([
                    _this.resolve(param.token, context)
                ], param.transformArgs));
                return _this.resolve(param, context);
            } catch (e) {
                throw new Error((0, $add717f5f77bbbc6$export$71fb617216ca01da)(ctor, idx, e));
            }
        };
    };
    InternalDependencyContainer.prototype.ensureNotDisposed = function() {
        if (this.disposed) throw new Error("This container has been disposed, you cannot interact with a disposed container");
    };
    return InternalDependencyContainer;
}();
var $bef43bd5f0c77276$export$9544d5bb712b01ea = new $bef43bd5f0c77276$var$InternalDependencyContainer();
var $bef43bd5f0c77276$export$2e2bcd8739ae039 = $bef43bd5f0c77276$export$9544d5bb712b01ea;




function $707a7cfd9d2332ef$var$autoInjectable() {
    return function(target) {
        var paramInfo = (0, $16892cc93f5964bc$export$9faf182f78e433cb)(target);
        return function(_super) {
            (0, $907264bab5ac1d80$export$a8ba968b8961cb8a)(class_1, _super);
            function class_1() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                return _super.apply(this, (0, $907264bab5ac1d80$export$afc72e2116322959)(args.concat(paramInfo.slice(args.length).map(function(type, index) {
                    var _a, _b, _c;
                    try {
                        if ((0, $49d89df96b014861$export$bdac4b7e51a04013)(type)) {
                            if ((0, $49d89df96b014861$export$c48b96891821a498)(type)) return type.multiple ? (_a = (0, $bef43bd5f0c77276$export$9544d5bb712b01ea).resolve(type.transform)).transform.apply(_a, (0, $907264bab5ac1d80$export$afc72e2116322959)([
                                (0, $bef43bd5f0c77276$export$9544d5bb712b01ea).resolveAll(type.token)
                            ], type.transformArgs)) : (_b = (0, $bef43bd5f0c77276$export$9544d5bb712b01ea).resolve(type.transform)).transform.apply(_b, (0, $907264bab5ac1d80$export$afc72e2116322959)([
                                (0, $bef43bd5f0c77276$export$9544d5bb712b01ea).resolve(type.token)
                            ], type.transformArgs));
                            else return type.multiple ? (0, $bef43bd5f0c77276$export$9544d5bb712b01ea).resolveAll(type.token) : (0, $bef43bd5f0c77276$export$9544d5bb712b01ea).resolve(type.token);
                        } else if ((0, $49d89df96b014861$export$c48b96891821a498)(type)) return (_c = (0, $bef43bd5f0c77276$export$9544d5bb712b01ea).resolve(type.transform)).transform.apply(_c, (0, $907264bab5ac1d80$export$afc72e2116322959)([
                            (0, $bef43bd5f0c77276$export$9544d5bb712b01ea).resolve(type.token)
                        ], type.transformArgs));
                        return (0, $bef43bd5f0c77276$export$9544d5bb712b01ea).resolve(type);
                    } catch (e) {
                        var argIndex = index + args.length;
                        throw new Error((0, $add717f5f77bbbc6$export$71fb617216ca01da)(target, argIndex, e));
                    }
                })))) || this;
            }
            return class_1;
        }(target);
    };
}
var $707a7cfd9d2332ef$export$2e2bcd8739ae039 = $707a7cfd9d2332ef$var$autoInjectable;



function $5c0ddbbfd03410de$var$inject(token) {
    return (0, $16892cc93f5964bc$export$ecde1113a41f71a4)(token);
}
var $5c0ddbbfd03410de$export$2e2bcd8739ae039 = $5c0ddbbfd03410de$var$inject;




function $7368727773dc6147$var$injectable() {
    return function(target) {
        (0, $bef43bd5f0c77276$export$748ded302730e3b).set(target, (0, $16892cc93f5964bc$export$9faf182f78e433cb)(target));
    };
}
var $7368727773dc6147$export$2e2bcd8739ae039 = $7368727773dc6147$var$injectable;




function $7d1eb7e12746f9f3$var$registry(registrations) {
    if (registrations === void 0) registrations = [];
    return function(target) {
        registrations.forEach(function(_a) {
            var token = _a.token, options = _a.options, provider = (0, $907264bab5ac1d80$export$3c9a16f847548506)(_a, [
                "token",
                "options"
            ]);
            return (0, $bef43bd5f0c77276$export$9544d5bb712b01ea).register(token, provider, options);
        });
        return target;
    };
}
var $7d1eb7e12746f9f3$export$2e2bcd8739ae039 = $7d1eb7e12746f9f3$var$registry;




function $79188624df80f470$var$singleton() {
    return function(target) {
        (0, $7368727773dc6147$export$2e2bcd8739ae039)()(target);
        (0, $bef43bd5f0c77276$export$9544d5bb712b01ea).registerSingleton(target);
    };
}
var $79188624df80f470$export$2e2bcd8739ae039 = $79188624df80f470$var$singleton;



function $6dc4480c48f6ecf5$var$injectAll(token) {
    var data = {
        token: token,
        multiple: true
    };
    return (0, $16892cc93f5964bc$export$ecde1113a41f71a4)(data);
}
var $6dc4480c48f6ecf5$export$2e2bcd8739ae039 = $6dc4480c48f6ecf5$var$injectAll;



function $aa77c8a9f2dd23e2$var$injectAllWithTransform(token, transformer) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    var data = {
        token: token,
        multiple: true,
        transform: transformer,
        transformArgs: args
    };
    return (0, $16892cc93f5964bc$export$ecde1113a41f71a4)(data);
}
var $aa77c8a9f2dd23e2$export$2e2bcd8739ae039 = $aa77c8a9f2dd23e2$var$injectAllWithTransform;



function $190b0b497264ac3c$var$injectWithTransform(token, transformer) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    return (0, $16892cc93f5964bc$export$ecde1113a41f71a4)(token, {
        transformToken: transformer,
        args: args
    });
}
var $190b0b497264ac3c$export$2e2bcd8739ae039 = $190b0b497264ac3c$var$injectWithTransform;




function $35b454634d8d2ecb$export$2e2bcd8739ae039(lifecycle, token) {
    return function(target) {
        (0, $7368727773dc6147$export$2e2bcd8739ae039)()(target);
        (0, $bef43bd5f0c77276$export$9544d5bb712b01ea).register(token || target, target, {
            lifecycle: lifecycle
        });
    };
}




function $ed40df6b598e6c7f$export$2e2bcd8739ae039(factoryFunc) {
    var instance;
    return function(dependencyContainer) {
        if (instance == undefined) instance = factoryFunc(dependencyContainer);
        return instance;
    };
}


function $9cfaa465e95ce34c$export$2e2bcd8739ae039(factoryFunc) {
    var cache = new WeakMap();
    return function(dependencyContainer) {
        var instance = cache.get(dependencyContainer);
        if (instance == undefined) {
            instance = factoryFunc(dependencyContainer);
            cache.set(dependencyContainer, instance);
        }
        return instance;
    };
}


function $934a14f2146b79ed$export$2e2bcd8739ae039(predicate, trueConstructor, falseConstructor, useCaching) {
    if (useCaching === void 0) useCaching = true;
    var instance;
    var previousPredicate;
    return function(dependencyContainer) {
        var currentPredicate = predicate(dependencyContainer);
        if (!useCaching || previousPredicate !== currentPredicate) {
            if (previousPredicate = currentPredicate) instance = dependencyContainer.resolve(trueConstructor);
            else instance = dependencyContainer.resolve(falseConstructor);
        }
        return instance;
    };
}







if (typeof Reflect === "undefined" || !Reflect.getMetadata) throw new Error("tsyringe requires a reflect polyfill. Please add 'import \"reflect-metadata\"' to the top of your entry point.");


var $428fcb2015744f49$exports = {};
(function(global, factory) {
    $428fcb2015744f49$exports = factory();
})($428fcb2015744f49$exports, function() {
    "use strict";
    /* eslint-disable no-var */ function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)target[key] = source[key];
        }
        return target;
    }
    /* eslint-enable no-var */ /* eslint-disable no-var */ var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    /* eslint-enable no-var */ /* eslint-disable no-var */ function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = name + "=" + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === "undefined" || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var value = parts.slice(1).join("=");
                try {
                    var found = decodeURIComponent(parts[0]);
                    jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (e) {}
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, "", assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: "/"
    });
    /* eslint-enable no-var */ return api;
});


const $b488569ebaeb416e$var$randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $b488569ebaeb416e$export$2e2bcd8739ae039 = {
    randomUUID: $b488569ebaeb416e$var$randomUUID
};


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $d0da4566d2fd20fe$var$getRandomValues;
const $d0da4566d2fd20fe$var$rnds8 = new Uint8Array(16);
function $d0da4566d2fd20fe$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$d0da4566d2fd20fe$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $d0da4566d2fd20fe$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$d0da4566d2fd20fe$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $d0da4566d2fd20fe$var$getRandomValues($d0da4566d2fd20fe$var$rnds8);
}


var $e8c673fd2604883f$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $7d240e1718cbe118$var$validate(uuid) {
    return typeof uuid === "string" && (0, $e8c673fd2604883f$export$2e2bcd8739ae039).test(uuid);
}
var $7d240e1718cbe118$export$2e2bcd8739ae039 = $7d240e1718cbe118$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $8fb7ad22aed8f433$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$8fb7ad22aed8f433$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $8fb7ad22aed8f433$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return ($8fb7ad22aed8f433$var$byteToHex[arr[offset + 0]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 1]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 2]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 3]] + "-" + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 4]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 5]] + "-" + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 6]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 7]] + "-" + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 8]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 9]] + "-" + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 10]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 11]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 12]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 13]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 14]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $8fb7ad22aed8f433$var$stringify(arr, offset = 0) {
    const uuid = $8fb7ad22aed8f433$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $7d240e1718cbe118$export$2e2bcd8739ae039)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $8fb7ad22aed8f433$export$2e2bcd8739ae039 = $8fb7ad22aed8f433$var$stringify;


function $27d7069422be255c$var$v4(options, buf, offset) {
    if ((0, $b488569ebaeb416e$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $b488569ebaeb416e$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $d0da4566d2fd20fe$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $8fb7ad22aed8f433$export$8fb373d660548968)(rnds);
}
var $27d7069422be255c$export$2e2bcd8739ae039 = $27d7069422be255c$var$v4;




const $b8e408dd2b31a250$export$9e98cacf66dcab6a = Symbol("COOKIES");
const $b8e408dd2b31a250$export$56d8a8a25bd48b81 = Symbol("WINDOW");
const $b8e408dd2b31a250$export$bc35efed93511c4b = Symbol("UUID");


var $0b30a5935923be01$var$_a;
let $0b30a5935923be01$export$36f603205c7c87a = class AdsContext {
    constructor(window){
        this.window = window;
    }
    get() {
        var _a;
        return (_a = this.window.ads) === null || _a === void 0 ? void 0 : _a.context;
    }
};
$0b30a5935923be01$export$36f603205c7c87a = (0, $c106e002a49a00cb$export$29e00dfd3077644b)([
    (0, $7368727773dc6147$export$2e2bcd8739ae039)(),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(0, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $b8e408dd2b31a250$export$56d8a8a25bd48b81))),
    (0, $c106e002a49a00cb$export$f1db080c865becb9)("design:paramtypes", [
        typeof ($0b30a5935923be01$var$_a = typeof Window !== "undefined" && Window) === "function" ? $0b30a5935923be01$var$_a : Object
    ])
], $0b30a5935923be01$export$36f603205c7c87a);




let $8a0d3010c87d3140$export$5fefc2586e00a689 = class Browser {
    getBrowser() {
        let browser;
        const { appName: appName , appVersion: appVersion , userAgent: userAgent  } = window.navigator;
        let temp;
        let matches = userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if (/trident/i.test(matches[1])) {
            temp = /\brv[ :]+(\d+)/g.exec(userAgent) || [
                ""
            ];
            browser = `IE ${temp[1] || ""}`;
            return browser;
        }
        if (matches[1] === "Chrome") {
            temp = userAgent.match(/\b(OPR|Edg)\/(\d+)/);
            if (temp !== null) {
                browser = temp.slice(1).join(" ").replace("OPR", "Opera").replace("Edg", "Edge");
                return browser;
            }
        }
        matches = matches[2] ? [
            matches[1],
            matches[2]
        ] : [
            appName,
            appVersion,
            "-?"
        ];
        temp = userAgent.match(/version\/(\d+)/i);
        if (temp !== null) matches.splice(1, 1, temp[1]);
        browser = matches.join(" ");
        return browser;
    }
};
$8a0d3010c87d3140$export$5fefc2586e00a689 = (0, $c106e002a49a00cb$export$29e00dfd3077644b)([
    (0, $79188624df80f470$export$2e2bcd8739ae039)()
], $8a0d3010c87d3140$export$5fefc2586e00a689);




var $5e95a73bc26a22b5$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
// Save the previous value of the device variable.
var $5e95a73bc26a22b5$var$previousDevice = window.device;
var $5e95a73bc26a22b5$var$device = {};
var $5e95a73bc26a22b5$var$changeOrientationList = [];
// Add device as a global object.
window.device = $5e95a73bc26a22b5$var$device;
// The <html> element.
var $5e95a73bc26a22b5$var$documentElement = window.document.documentElement;
// The client user agent string.
// Lowercase, so we can use the more efficient indexOf(), instead of Regex
var $5e95a73bc26a22b5$var$userAgent = window.navigator.userAgent.toLowerCase();
// Detectable television devices.
var $5e95a73bc26a22b5$var$television = [
    "googletv",
    "viera",
    "smarttv",
    "internet.tv",
    "netcast",
    "nettv",
    "appletv",
    "boxee",
    "kylo",
    "roku",
    "dlnadoc",
    "pov_tv",
    "hbbtv",
    "ce-html"
];
// Main functions
// --------------
$5e95a73bc26a22b5$var$device.macos = function() {
    return $5e95a73bc26a22b5$var$find("mac");
};
$5e95a73bc26a22b5$var$device.ios = function() {
    return $5e95a73bc26a22b5$var$device.iphone() || $5e95a73bc26a22b5$var$device.ipod() || $5e95a73bc26a22b5$var$device.ipad();
};
$5e95a73bc26a22b5$var$device.iphone = function() {
    return !$5e95a73bc26a22b5$var$device.windows() && $5e95a73bc26a22b5$var$find("iphone");
};
$5e95a73bc26a22b5$var$device.ipod = function() {
    return $5e95a73bc26a22b5$var$find("ipod");
};
$5e95a73bc26a22b5$var$device.ipad = function() {
    var iPadOS13Up = navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
    return $5e95a73bc26a22b5$var$find("ipad") || iPadOS13Up;
};
$5e95a73bc26a22b5$var$device.android = function() {
    return !$5e95a73bc26a22b5$var$device.windows() && $5e95a73bc26a22b5$var$find("android");
};
$5e95a73bc26a22b5$var$device.androidPhone = function() {
    return $5e95a73bc26a22b5$var$device.android() && $5e95a73bc26a22b5$var$find("mobile");
};
$5e95a73bc26a22b5$var$device.androidTablet = function() {
    return $5e95a73bc26a22b5$var$device.android() && !$5e95a73bc26a22b5$var$find("mobile");
};
$5e95a73bc26a22b5$var$device.blackberry = function() {
    return $5e95a73bc26a22b5$var$find("blackberry") || $5e95a73bc26a22b5$var$find("bb10");
};
$5e95a73bc26a22b5$var$device.blackberryPhone = function() {
    return $5e95a73bc26a22b5$var$device.blackberry() && !$5e95a73bc26a22b5$var$find("tablet");
};
$5e95a73bc26a22b5$var$device.blackberryTablet = function() {
    return $5e95a73bc26a22b5$var$device.blackberry() && $5e95a73bc26a22b5$var$find("tablet");
};
$5e95a73bc26a22b5$var$device.windows = function() {
    return $5e95a73bc26a22b5$var$find("windows");
};
$5e95a73bc26a22b5$var$device.windowsPhone = function() {
    return $5e95a73bc26a22b5$var$device.windows() && $5e95a73bc26a22b5$var$find("phone");
};
$5e95a73bc26a22b5$var$device.windowsTablet = function() {
    return $5e95a73bc26a22b5$var$device.windows() && $5e95a73bc26a22b5$var$find("touch") && !$5e95a73bc26a22b5$var$device.windowsPhone();
};
$5e95a73bc26a22b5$var$device.fxos = function() {
    return ($5e95a73bc26a22b5$var$find("(mobile") || $5e95a73bc26a22b5$var$find("(tablet")) && $5e95a73bc26a22b5$var$find(" rv:");
};
$5e95a73bc26a22b5$var$device.fxosPhone = function() {
    return $5e95a73bc26a22b5$var$device.fxos() && $5e95a73bc26a22b5$var$find("mobile");
};
$5e95a73bc26a22b5$var$device.fxosTablet = function() {
    return $5e95a73bc26a22b5$var$device.fxos() && $5e95a73bc26a22b5$var$find("tablet");
};
$5e95a73bc26a22b5$var$device.meego = function() {
    return $5e95a73bc26a22b5$var$find("meego");
};
$5e95a73bc26a22b5$var$device.cordova = function() {
    return window.cordova && location.protocol === "file:";
};
$5e95a73bc26a22b5$var$device.nodeWebkit = function() {
    return $5e95a73bc26a22b5$var$_typeof(window.process) === "object";
};
$5e95a73bc26a22b5$var$device.mobile = function() {
    return $5e95a73bc26a22b5$var$device.androidPhone() || $5e95a73bc26a22b5$var$device.iphone() || $5e95a73bc26a22b5$var$device.ipod() || $5e95a73bc26a22b5$var$device.windowsPhone() || $5e95a73bc26a22b5$var$device.blackberryPhone() || $5e95a73bc26a22b5$var$device.fxosPhone() || $5e95a73bc26a22b5$var$device.meego();
};
$5e95a73bc26a22b5$var$device.tablet = function() {
    return $5e95a73bc26a22b5$var$device.ipad() || $5e95a73bc26a22b5$var$device.androidTablet() || $5e95a73bc26a22b5$var$device.blackberryTablet() || $5e95a73bc26a22b5$var$device.windowsTablet() || $5e95a73bc26a22b5$var$device.fxosTablet();
};
$5e95a73bc26a22b5$var$device.desktop = function() {
    return !$5e95a73bc26a22b5$var$device.tablet() && !$5e95a73bc26a22b5$var$device.mobile();
};
$5e95a73bc26a22b5$var$device.television = function() {
    var i = 0;
    while(i < $5e95a73bc26a22b5$var$television.length){
        if ($5e95a73bc26a22b5$var$find($5e95a73bc26a22b5$var$television[i])) return true;
        i++;
    }
    return false;
};
$5e95a73bc26a22b5$var$device.portrait = function() {
    if (screen.orientation && Object.prototype.hasOwnProperty.call(window, "onorientationchange")) return $5e95a73bc26a22b5$var$includes(screen.orientation.type, "portrait");
    if ($5e95a73bc26a22b5$var$device.ios() && Object.prototype.hasOwnProperty.call(window, "orientation")) return Math.abs(window.orientation) !== 90;
    return window.innerHeight / window.innerWidth > 1;
};
$5e95a73bc26a22b5$var$device.landscape = function() {
    if (screen.orientation && Object.prototype.hasOwnProperty.call(window, "onorientationchange")) return $5e95a73bc26a22b5$var$includes(screen.orientation.type, "landscape");
    if ($5e95a73bc26a22b5$var$device.ios() && Object.prototype.hasOwnProperty.call(window, "orientation")) return Math.abs(window.orientation) === 90;
    return window.innerHeight / window.innerWidth < 1;
};
// Public Utility Functions
// ------------------------
// Run device.js in noConflict mode,
// returning the device variable to its previous owner.
$5e95a73bc26a22b5$var$device.noConflict = function() {
    window.device = $5e95a73bc26a22b5$var$previousDevice;
    return this;
};
// Private Utility Functions
// -------------------------
// Check if element exists
function $5e95a73bc26a22b5$var$includes(haystack, needle) {
    return haystack.indexOf(needle) !== -1;
}
// Simple UA string search
function $5e95a73bc26a22b5$var$find(needle) {
    return $5e95a73bc26a22b5$var$includes($5e95a73bc26a22b5$var$userAgent, needle);
}
// Check if documentElement already has a given class.
function $5e95a73bc26a22b5$var$hasClass(className) {
    return $5e95a73bc26a22b5$var$documentElement.className.match(new RegExp(className, "i"));
}
// Add one or more CSS classes to the <html> element.
function $5e95a73bc26a22b5$var$addClass(className) {
    var currentClassNames = null;
    if (!$5e95a73bc26a22b5$var$hasClass(className)) {
        currentClassNames = $5e95a73bc26a22b5$var$documentElement.className.replace(/^\s+|\s+$/g, "");
        $5e95a73bc26a22b5$var$documentElement.className = currentClassNames + " " + className;
    }
}
// Remove single CSS class from the <html> element.
function $5e95a73bc26a22b5$var$removeClass(className) {
    if ($5e95a73bc26a22b5$var$hasClass(className)) $5e95a73bc26a22b5$var$documentElement.className = $5e95a73bc26a22b5$var$documentElement.className.replace(" " + className, "");
}
// HTML Element Handling
// ---------------------
// Insert the appropriate CSS class based on the _user_agent.
if ($5e95a73bc26a22b5$var$device.ios()) {
    if ($5e95a73bc26a22b5$var$device.ipad()) $5e95a73bc26a22b5$var$addClass("ios ipad tablet");
    else if ($5e95a73bc26a22b5$var$device.iphone()) $5e95a73bc26a22b5$var$addClass("ios iphone mobile");
    else if ($5e95a73bc26a22b5$var$device.ipod()) $5e95a73bc26a22b5$var$addClass("ios ipod mobile");
} else if ($5e95a73bc26a22b5$var$device.macos()) $5e95a73bc26a22b5$var$addClass("macos desktop");
else if ($5e95a73bc26a22b5$var$device.android()) {
    if ($5e95a73bc26a22b5$var$device.androidTablet()) $5e95a73bc26a22b5$var$addClass("android tablet");
    else $5e95a73bc26a22b5$var$addClass("android mobile");
} else if ($5e95a73bc26a22b5$var$device.blackberry()) {
    if ($5e95a73bc26a22b5$var$device.blackberryTablet()) $5e95a73bc26a22b5$var$addClass("blackberry tablet");
    else $5e95a73bc26a22b5$var$addClass("blackberry mobile");
} else if ($5e95a73bc26a22b5$var$device.windows()) {
    if ($5e95a73bc26a22b5$var$device.windowsTablet()) $5e95a73bc26a22b5$var$addClass("windows tablet");
    else if ($5e95a73bc26a22b5$var$device.windowsPhone()) $5e95a73bc26a22b5$var$addClass("windows mobile");
    else $5e95a73bc26a22b5$var$addClass("windows desktop");
} else if ($5e95a73bc26a22b5$var$device.fxos()) {
    if ($5e95a73bc26a22b5$var$device.fxosTablet()) $5e95a73bc26a22b5$var$addClass("fxos tablet");
    else $5e95a73bc26a22b5$var$addClass("fxos mobile");
} else if ($5e95a73bc26a22b5$var$device.meego()) $5e95a73bc26a22b5$var$addClass("meego mobile");
else if ($5e95a73bc26a22b5$var$device.nodeWebkit()) $5e95a73bc26a22b5$var$addClass("node-webkit");
else if ($5e95a73bc26a22b5$var$device.television()) $5e95a73bc26a22b5$var$addClass("television");
else if ($5e95a73bc26a22b5$var$device.desktop()) $5e95a73bc26a22b5$var$addClass("desktop");
if ($5e95a73bc26a22b5$var$device.cordova()) $5e95a73bc26a22b5$var$addClass("cordova");
// Orientation Handling
// --------------------
// Handle device orientation changes.
function $5e95a73bc26a22b5$var$handleOrientation() {
    if ($5e95a73bc26a22b5$var$device.landscape()) {
        $5e95a73bc26a22b5$var$removeClass("portrait");
        $5e95a73bc26a22b5$var$addClass("landscape");
        $5e95a73bc26a22b5$var$walkOnChangeOrientationList("landscape");
    } else {
        $5e95a73bc26a22b5$var$removeClass("landscape");
        $5e95a73bc26a22b5$var$addClass("portrait");
        $5e95a73bc26a22b5$var$walkOnChangeOrientationList("portrait");
    }
    $5e95a73bc26a22b5$var$setOrientationCache();
}
function $5e95a73bc26a22b5$var$walkOnChangeOrientationList(newOrientation) {
    for(var index = 0; index < $5e95a73bc26a22b5$var$changeOrientationList.length; index++)$5e95a73bc26a22b5$var$changeOrientationList[index](newOrientation);
}
$5e95a73bc26a22b5$var$device.onChangeOrientation = function(cb) {
    if (typeof cb == "function") $5e95a73bc26a22b5$var$changeOrientationList.push(cb);
};
// Detect whether device supports orientationchange event,
// otherwise fall back to the resize event.
var $5e95a73bc26a22b5$var$orientationEvent = "resize";
if (Object.prototype.hasOwnProperty.call(window, "onorientationchange")) $5e95a73bc26a22b5$var$orientationEvent = "orientationchange";
// Listen for changes in orientation.
if (window.addEventListener) window.addEventListener($5e95a73bc26a22b5$var$orientationEvent, $5e95a73bc26a22b5$var$handleOrientation, false);
else if (window.attachEvent) window.attachEvent($5e95a73bc26a22b5$var$orientationEvent, $5e95a73bc26a22b5$var$handleOrientation);
else window[$5e95a73bc26a22b5$var$orientationEvent] = $5e95a73bc26a22b5$var$handleOrientation;
$5e95a73bc26a22b5$var$handleOrientation();
// Public functions to get the current value of type, os, or orientation
// ---------------------------------------------------------------------
function $5e95a73bc26a22b5$var$findMatch(arr) {
    for(var i = 0; i < arr.length; i++){
        if ($5e95a73bc26a22b5$var$device[arr[i]]()) return arr[i];
    }
    return "unknown";
}
$5e95a73bc26a22b5$var$device.type = $5e95a73bc26a22b5$var$findMatch([
    "mobile",
    "tablet",
    "desktop"
]);
$5e95a73bc26a22b5$var$device.os = $5e95a73bc26a22b5$var$findMatch([
    "ios",
    "iphone",
    "ipad",
    "ipod",
    "android",
    "blackberry",
    "macos",
    "windows",
    "fxos",
    "meego",
    "television"
]);
function $5e95a73bc26a22b5$var$setOrientationCache() {
    $5e95a73bc26a22b5$var$device.orientation = $5e95a73bc26a22b5$var$findMatch([
        "portrait",
        "landscape"
    ]);
}
$5e95a73bc26a22b5$var$setOrientationCache();
var $5e95a73bc26a22b5$export$2e2bcd8739ae039 = $5e95a73bc26a22b5$var$device;


let $b43564c037fb0894$export$8215d14a63d9fb10 = class Device {
    getDeviceType() {
        if ((0, $5e95a73bc26a22b5$export$2e2bcd8739ae039).tablet()) return "tablet";
        if ((0, $5e95a73bc26a22b5$export$2e2bcd8739ae039).mobile()) return "smartphone";
        return "desktop";
    }
};
$b43564c037fb0894$export$8215d14a63d9fb10 = (0, $c106e002a49a00cb$export$29e00dfd3077644b)([
    (0, $79188624df80f470$export$2e2bcd8739ae039)()
], $b43564c037fb0894$export$8215d14a63d9fb10);





class $e7ae57550c9200e9$export$eada748df1dd417f {
    static getURLSearchParams() {
        const path = window.location.search.substring(1);
        return new URLSearchParams(path);
    }
    static get(key) {
        const params = $e7ae57550c9200e9$export$eada748df1dd417f.getURLSearchParams();
        return params.get(key);
    }
    static stringify(params) {
        const queryParams = new URLSearchParams(params);
        queryParams.sort();
        return queryParams.toString();
    }
}




var $f009ac2c4949a5c1$var$_a;
class $f009ac2c4949a5c1$export$e41701f8b288055a {
    transform(logger, loggerGroup) {
        return logger.setLoggerGroup(loggerGroup);
    }
}
let $f009ac2c4949a5c1$export$efa9a398d6368992 = class Logger {
    constructor(window){
        var _a, _b;
        this.logGroup = "Global";
        this.debugGroup = this.getDebugGroup() || "";
        this.groups = this.debugGroup.split(",");
        this.initTime = (_b = (_a = window === null || window === void 0 ? void 0 : window.performance) === null || _a === void 0 ? void 0 : _a.timeOrigin) !== null && _b !== void 0 ? _b : Date.now();
    }
    setLoggerGroup(loggerGroup) {
        this.logGroup = loggerGroup;
        return this;
    }
    getTimeDelta() {
        const currentTimeStamp = Date.now();
        return currentTimeStamp - this.initTime;
    }
    getDebugGroup() {
        return (0, $e7ae57550c9200e9$export$eada748df1dd417f).get("identity_debug");
    }
    getTimeDeltaFixed() {
        const delta = this.getTimeDelta();
        const secondsResult = delta / 1000;
        return secondsResult.toFixed(4);
    }
    info(...logValues) {
        if (this.loggingEnabled()) console.info(`${this.getTimeDeltaFixed()}s\t\t [IE] ${this.logGroup}`, logValues);
    }
    warn(...logValues) {
        if (this.loggingEnabled()) console.warn(`${this.getTimeDeltaFixed()}s\t\t [IE] ${this.logGroup}`, logValues);
    }
    error(...logValues) {
        if (this.loggingEnabled()) console.error(`${this.getTimeDeltaFixed()}s\t\t [IE] ${this.logGroup}`, logValues);
    }
    loggingEnabled() {
        if (this.debugGroup === "") return false;
        return this.debugGroup === "1" || this.groups.indexOf(this.logGroup) !== -1;
    }
};
$f009ac2c4949a5c1$export$efa9a398d6368992 = (0, $c106e002a49a00cb$export$29e00dfd3077644b)([
    (0, $7368727773dc6147$export$2e2bcd8739ae039)(),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(0, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $b8e408dd2b31a250$export$56d8a8a25bd48b81))),
    (0, $c106e002a49a00cb$export$f1db080c865becb9)("design:paramtypes", [
        typeof ($f009ac2c4949a5c1$var$_a = typeof Window !== "undefined" && Window) === "function" ? $f009ac2c4949a5c1$var$_a : Object
    ])
], $f009ac2c4949a5c1$export$efa9a398d6368992);



const $c2def7e558dee4a0$export$c50418c2c95b7cca = [
    "ai",
    "aw",
    "ax",
    "at",
    "be",
    "bg",
    "bm",
    "vg",
    "bq",
    "ky",
    "hr",
    "cw",
    "cy",
    "cz",
    "dk",
    "ee",
    "fk",
    "fo",
    "fi",
    "fr",
    "gf",
    "pf",
    "tf",
    "de",
    "gi",
    "gr",
    "gl",
    "gp",
    "hu",
    "is",
    "ie",
    "im",
    "it",
    "re",
    "lv",
    "li",
    "lt",
    "lu",
    "mq",
    "mt",
    "yt",
    "ms",
    "nl",
    "nc",
    "no",
    "pn",
    "pl",
    "pt",
    "ro",
    "bl",
    "sh",
    "mf",
    "pm",
    "bq",
    "sx",
    "sk",
    "si",
    "es",
    "se",
    "ch",
    "tc",
    "gb",
    "uk",
    "wf"
];


var $2f6e53771cd92caa$var$_a, $2f6e53771cd92caa$var$_b, $2f6e53771cd92caa$var$_c;
let $2f6e53771cd92caa$export$733db4df510f8a9 = class Geo {
    constructor(cookiesManager, window, logger){
        this.cookiesManager = cookiesManager;
        this.window = window;
        this.logger = logger;
    }
    get() {
        if (this.geoData) return this.geoData;
        this.geoData = this.getGeoData();
        return this.geoData;
    }
    set(geoData) {
        this.geoData = geoData;
    }
    getGeoData() {
        const cookieData = this.getGeoDataFromCookie();
        if (Object.keys(cookieData).length) return cookieData;
        return this.getGeoDataFromOneTrust();
    }
    getGeoDataFromCookie() {
        const geoCookie = this.cookiesManager.get("Geo");
        if (!geoCookie) return {};
        const jsonData = decodeURIComponent(geoCookie);
        try {
            return JSON.parse(jsonData);
        } catch (e) {
            this.logger.error("Invalid JSON in the cookie", e);
            return {};
        }
    }
    getGeoDataFromOneTrust() {
        if (this.window.OneTrust && this.window.OneTrust.getGeolocationData()) return {
            country: this.window.OneTrust.getGeolocationData().country
        };
        return {};
    }
    getCountryCode() {
        var _a, _b;
        return (_b = (_a = this.get()) === null || _a === void 0 ? void 0 : _a.country) === null || _b === void 0 ? void 0 : _b.toLowerCase();
    }
    getRegionCode() {
        var _a, _b;
        return (_b = (_a = this.get()) === null || _a === void 0 ? void 0 : _a.region) === null || _b === void 0 ? void 0 : _b.toLowerCase();
    }
    getContinentCode() {
        var _a, _b;
        return (_b = (_a = this.get()) === null || _a === void 0 ? void 0 : _a.continent) === null || _b === void 0 ? void 0 : _b.toLowerCase();
    }
    isGdprCountry() {
        return (0, $c2def7e558dee4a0$export$c50418c2c95b7cca).includes(this.getCountryCode());
    }
};
$2f6e53771cd92caa$export$733db4df510f8a9 = (0, $c106e002a49a00cb$export$29e00dfd3077644b)([
    (0, $79188624df80f470$export$2e2bcd8739ae039)(),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(0, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $b8e408dd2b31a250$export$9e98cacf66dcab6a))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(1, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $b8e408dd2b31a250$export$56d8a8a25bd48b81))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(2, (0, $190b0b497264ac3c$export$2e2bcd8739ae039)((0, $f009ac2c4949a5c1$export$efa9a398d6368992), (0, $f009ac2c4949a5c1$export$e41701f8b288055a), "Geo")),
    (0, $c106e002a49a00cb$export$f1db080c865becb9)("design:paramtypes", [
        typeof ($2f6e53771cd92caa$var$_a = typeof CookiesManager !== "undefined" && CookiesManager) === "function" ? $2f6e53771cd92caa$var$_a : Object,
        typeof ($2f6e53771cd92caa$var$_b = typeof Window !== "undefined" && Window) === "function" ? $2f6e53771cd92caa$var$_b : Object,
        typeof ($2f6e53771cd92caa$var$_c = typeof (0, $f009ac2c4949a5c1$export$efa9a398d6368992) !== "undefined" && (0, $f009ac2c4949a5c1$export$efa9a398d6368992)) === "function" ? $2f6e53771cd92caa$var$_c : Object
    ])
], $2f6e53771cd92caa$export$733db4df510f8a9);







let $d5090ec2eb6e9ae9$export$8c6ee871e681f0f4 = class HttpClient {
    get(url) {
        return (0, $c106e002a49a00cb$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            return fetch(url, {
                method: "GET",
                mode: "cors"
            });
        });
    }
};
$d5090ec2eb6e9ae9$export$8c6ee871e681f0f4 = (0, $c106e002a49a00cb$export$29e00dfd3077644b)([
    (0, $7368727773dc6147$export$2e2bcd8739ae039)()
], $d5090ec2eb6e9ae9$export$8c6ee871e681f0f4);




var $aafb2d1d298b1a56$var$_a, $aafb2d1d298b1a56$var$_b, $aafb2d1d298b1a56$var$_c, $aafb2d1d298b1a56$var$_d;
let $aafb2d1d298b1a56$export$8d20793915672011 = class GeoCookie {
    constructor(cookiesManager, httpClient, logger, geo){
        this.cookiesManager = cookiesManager;
        this.httpClient = httpClient;
        this.logger = logger;
        this.geo = geo;
    }
    setGeoCookieIfNotExist() {
        return (0, $c106e002a49a00cb$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            if (this.cookiesManager.get("Geo")) {
                this.logger.info("Geo cookie already exists");
                return;
            }
            const GEO_SERVICE_URL = "https://services.fandom.com/geoip/location";
            const response = yield this.httpClient.get(GEO_SERVICE_URL);
            const { country_code: country_code , region: region , continent_code: continent_code  } = yield response.json();
            const geoData = {
                country: country_code,
                region: region,
                continent: continent_code
            };
            const geoCookie = JSON.stringify(geoData);
            this.cookiesManager.set("Geo", geoCookie, {
                expires: 365
            });
            this.geo.set(geoData);
            this.logger.info("Geo cookie set");
        });
    }
};
$aafb2d1d298b1a56$export$8d20793915672011 = (0, $c106e002a49a00cb$export$29e00dfd3077644b)([
    (0, $79188624df80f470$export$2e2bcd8739ae039)(),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(0, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $b8e408dd2b31a250$export$9e98cacf66dcab6a))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(1, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $d5090ec2eb6e9ae9$export$8c6ee871e681f0f4))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(2, (0, $190b0b497264ac3c$export$2e2bcd8739ae039)((0, $f009ac2c4949a5c1$export$efa9a398d6368992), (0, $f009ac2c4949a5c1$export$e41701f8b288055a), "GeoCookie")),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(3, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $2f6e53771cd92caa$export$733db4df510f8a9))),
    (0, $c106e002a49a00cb$export$f1db080c865becb9)("design:paramtypes", [
        typeof ($aafb2d1d298b1a56$var$_a = typeof CookiesManager !== "undefined" && CookiesManager) === "function" ? $aafb2d1d298b1a56$var$_a : Object,
        typeof ($aafb2d1d298b1a56$var$_b = typeof (0, $d5090ec2eb6e9ae9$export$8c6ee871e681f0f4) !== "undefined" && (0, $d5090ec2eb6e9ae9$export$8c6ee871e681f0f4)) === "function" ? $aafb2d1d298b1a56$var$_b : Object,
        typeof ($aafb2d1d298b1a56$var$_c = typeof (0, $f009ac2c4949a5c1$export$efa9a398d6368992) !== "undefined" && (0, $f009ac2c4949a5c1$export$efa9a398d6368992)) === "function" ? $aafb2d1d298b1a56$var$_c : Object,
        typeof ($aafb2d1d298b1a56$var$_d = typeof (0, $2f6e53771cd92caa$export$733db4df510f8a9) !== "undefined" && (0, $2f6e53771cd92caa$export$733db4df510f8a9)) === "function" ? $aafb2d1d298b1a56$var$_d : Object
    ])
], $aafb2d1d298b1a56$export$8d20793915672011);




function $cbba3528a6229cb1$export$a6cdc56e425d0d0a(obj) {
    return typeof obj === "object" && !Array.isArray(obj) && obj !== null;
}






let $55349e5534bb6b42$export$2dffd0b5373a4389 = class Platform {
    get() {
        var _a, _b, _c;
        const debugPlatform = (0, $e7ae57550c9200e9$export$eada748df1dd417f).get("identity_icbm_app");
        if (debugPlatform) return debugPlatform;
        // Check for MediaWiki
        if (window.mw !== undefined && ((_c = (_b = (_a = window.ads) === null || _a === void 0 ? void 0 : _a.context) === null || _b === void 0 ? void 0 : _b.opts) === null || _c === void 0 ? void 0 : _c.platformName) !== undefined) return window.ads.context.opts.platformName;
        return this.checkHostname();
    }
    checkHostname() {
        const { hostname: hostname , pathname: pathname  } = window.location;
        switch(true){
            /// www.fandom.com, bingebot.fandom.com
            case hostname.includes("fandom"):
                return hostname.includes("bingebot") ? "bingebot" : "f2";
            // futhead.com
            case hostname.includes("futhead"):
                return "futhead";
            // muthead.com
            case hostname.includes("muthead"):
                return "muthead";
            // comicvine.gamespot.com, gamefaqs.gamespot.com, gamespot.com
            case hostname.includes("gamespot"):
                return hostname.includes("comicvine") ? "comicvine" : hostname.includes("gamefaqs") ? "gamefaqs" : "gamespot";
            // metcritic.com, metacritic.com/news
            case hostname.includes("metacritic"):
                return pathname.includes("news") ? "metacritic-neutron" : "metacritic";
            // tvguide.com
            case hostname.includes("tvguide"):
                return "tvguide";
            case hostname.includes("giantbomb"):
                return "giantbomb";
            default:
                return "fandomdesktop";
        }
    }
};
$55349e5534bb6b42$export$2dffd0b5373a4389 = (0, $c106e002a49a00cb$export$29e00dfd3077644b)([
    (0, $79188624df80f470$export$2e2bcd8739ae039)()
], $55349e5534bb6b42$export$2dffd0b5373a4389);





let $62b9cd2513a767e8$export$14eb8822b262d643 = class ServiceBaseUrl {
    get() {
        const fandomDomains = [
            "fandom.com",
            "muthead.com",
            "futhead.com"
        ];
        return fandomDomains.find((domain)=>window.location.hostname.includes(domain)) ? "https://services.fandom.com/" : "https://services.fandom-dev." + (location.hostname.match(/(?!\.)(pl|us)$/) || [
            "us"
        ])[0] + "/";
    }
};
$62b9cd2513a767e8$export$14eb8822b262d643 = (0, $c106e002a49a00cb$export$29e00dfd3077644b)([
    (0, $79188624df80f470$export$2e2bcd8739ae039)()
], $62b9cd2513a767e8$export$14eb8822b262d643);






var $ab5ccb8e7b321d35$var$_a, $ab5ccb8e7b321d35$var$_b;
let $ab5ccb8e7b321d35$export$b8e0f93a76772233 = class Skin {
    constructor(platform, device){
        this.platform = platform;
        this.device = device;
        this.skinMap = {
            muthead: "turf",
            futhead: "turf",
            giantbomb: "giantbomb",
            gamefaqs: "gamefaqs",
            gamespot: "gamespot",
            metacritic: "metacritic",
            "metacritic-neutron": "metacritic_neutron",
            comicvine: "comicvine",
            f2: "fandom",
            tvguide: "tvguide",
            fandomdesktop: "ucp",
            fandommobile: "ucp"
        };
    }
    get() {
        const platform = this.platform.get();
        const device = this.device.getDeviceType() === "desktop" ? "desktop" : "mobile";
        return this.skinMap[platform] ? this.skinMap[platform] + "_" + device : "unknown";
    }
};
$ab5ccb8e7b321d35$export$b8e0f93a76772233 = (0, $c106e002a49a00cb$export$29e00dfd3077644b)([
    (0, $79188624df80f470$export$2e2bcd8739ae039)(),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(0, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $55349e5534bb6b42$export$2dffd0b5373a4389))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(1, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $b43564c037fb0894$export$8215d14a63d9fb10))),
    (0, $c106e002a49a00cb$export$f1db080c865becb9)("design:paramtypes", [
        typeof ($ab5ccb8e7b321d35$var$_a = typeof (0, $55349e5534bb6b42$export$2dffd0b5373a4389) !== "undefined" && (0, $55349e5534bb6b42$export$2dffd0b5373a4389)) === "function" ? $ab5ccb8e7b321d35$var$_a : Object,
        typeof ($ab5ccb8e7b321d35$var$_b = typeof (0, $b43564c037fb0894$export$8215d14a63d9fb10) !== "undefined" && (0, $b43564c037fb0894$export$8215d14a63d9fb10)) === "function" ? $ab5ccb8e7b321d35$var$_b : Object
    ])
], $ab5ccb8e7b321d35$export$b8e0f93a76772233);





var $a784d298db20d12c$var$_a;
let $a784d298db20d12c$export$19fffca37ef3e106 = class LocalStorage {
    constructor(window){
        this.window = window;
    }
    getItem(key) {
        const value = this.window.localStorage.getItem(key);
        try {
            return JSON.parse(value);
        } catch (_a) {
            return value;
        }
    }
    setItem(key, input) {
        const value = input instanceof Object ? JSON.stringify(input) : input;
        this.window.localStorage.setItem(key, value);
    }
    removeItem(key) {
        return this.window.localStorage.removeItem(key);
    }
};
$a784d298db20d12c$export$19fffca37ef3e106 = (0, $c106e002a49a00cb$export$29e00dfd3077644b)([
    (0, $79188624df80f470$export$2e2bcd8739ae039)(),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(0, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $b8e408dd2b31a250$export$56d8a8a25bd48b81))),
    (0, $c106e002a49a00cb$export$f1db080c865becb9)("design:paramtypes", [
        typeof ($a784d298db20d12c$var$_a = typeof Window !== "undefined" && Window) === "function" ? $a784d298db20d12c$var$_a : Object
    ])
], $a784d298db20d12c$export$19fffca37ef3e106);




let $8aacc0a72dafbc81$export$44dca8fb3e49ffe7 = class TopLevelDomainExtractor {
    static extract(hostname) {
        const parts = hostname.split(".");
        if (parts.length < 2) return hostname;
        let topLevelDomain = `.${parts[parts.length - 2]}.${parts[parts.length - 1]}`;
        // These exceptions require a third part for a valid cookie domain. This isn't
        // a definitive list but rather the most likely domains on which Fandom would
        // host a site.
        const exceptions = [
            ".co.jp",
            ".co.nz",
            ".co.uk"
        ];
        if (exceptions.indexOf(topLevelDomain) >= 0) topLevelDomain = `.${parts[parts.length - 3]}${topLevelDomain}`;
        return topLevelDomain;
    }
};
$8aacc0a72dafbc81$export$44dca8fb3e49ffe7 = (0, $c106e002a49a00cb$export$29e00dfd3077644b)([
    (0, $7368727773dc6147$export$2e2bcd8739ae039)()
], $8aacc0a72dafbc81$export$44dca8fb3e49ffe7);





var $365ce25d498a7cb4$var$_a;
let $365ce25d498a7cb4$export$5121bc3ffa707de4 = class WikiConfig {
    constructor(window){
        this.window = window;
    }
    get(key) {
        var _a, _b, _c;
        return (_c = (_b = (_a = this.window.mw) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.get(key)) !== null && _c !== void 0 ? _c : null;
    }
};
$365ce25d498a7cb4$export$5121bc3ffa707de4 = (0, $c106e002a49a00cb$export$29e00dfd3077644b)([
    (0, $79188624df80f470$export$2e2bcd8739ae039)(),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(0, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $b8e408dd2b31a250$export$56d8a8a25bd48b81))),
    (0, $c106e002a49a00cb$export$f1db080c865becb9)("design:paramtypes", [
        typeof ($365ce25d498a7cb4$var$_a = typeof Window !== "undefined" && Window) === "function" ? $365ce25d498a7cb4$var$_a : Object
    ])
], $365ce25d498a7cb4$export$5121bc3ffa707de4);




let $4929d5aa1c5d1567$export$356f5f2a609e254f = class AssetLoader {
    createScript(src, type = "text/javascript", isAsync = true, node = null, parameters = {}, datasets = {}) {
        const script = document.createElement("script");
        script.async = isAsync;
        script.type = type;
        script.src = src;
        Object.keys(parameters).forEach((parameter)=>{
            script.setAttribute(parameter, parameters[parameter]);
        });
        Object.keys(datasets).forEach((dataset)=>{
            script.dataset[dataset] = datasets[dataset];
        });
        if (typeof node === "string") {
            const temp = document.getElementsByTagName("script")[0];
            temp.parentNode.insertBefore(script, temp);
        } else {
            const temp = node || document.body;
            temp.append(script);
        }
        return script;
    }
    /**
     * Injects <script> tag
     */ loadScript(src, type = "text/javascript", isAsync = true, node = null, parameters = {}, datasets = {}) {
        return new Promise((resolve, reject)=>{
            const script = this.createScript(src, type, isAsync, node, parameters, datasets);
            script.onload = resolve;
            script.onerror = reject;
        });
    }
};
$4929d5aa1c5d1567$export$356f5f2a609e254f = (0, $c106e002a49a00cb$export$29e00dfd3077644b)([
    (0, $7368727773dc6147$export$2e2bcd8739ae039)()
], $4929d5aa1c5d1567$export$356f5f2a609e254f);









var $2339baf3570cc7fc$var$_a, $2339baf3570cc7fc$var$_b, $2339baf3570cc7fc$var$_c, $2339baf3570cc7fc$var$_d;
let $2339baf3570cc7fc$export$a6e611db690f864e = class AgeGateHandler {
    constructor(cookiesManager, window, context, logger){
        this.cookiesManager = cookiesManager;
        this.window = window;
        this.context = context;
        this.logger = logger;
        this.ageGateCookie = "ag";
        this.ageGateLegacyCookie = "age_gate";
        this.ageGateExpiryMs = 31536000000;
    }
    // We inject communicationService via method because there were some problems
    // with tsyringe reporting circular dependency when trying to inject via constructor
    init(communicationService) {
        var _a, _b;
        return (0, $c106e002a49a00cb$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            const wikiDirectedAtChildren = Boolean((_b = (_a = this.context.get()) === null || _a === void 0 ? void 0 : _a.targeting) === null || _b === void 0 ? void 0 : _b.directedAtChildren);
            const ageGateEnabled = wikiDirectedAtChildren && this.window.mw.config.get("wgAgeGateEnabled", false);
            if (!ageGateEnabled) {
                this.logger.info("disabled");
                return Promise.resolve();
            }
            // First version of the cookie has been set for 3 weeks and named "age_gate"
            // If it exists, change the name to "ag" and extend it to 1 year
            const legacyCookie = this.cookiesManager.get(this.ageGateLegacyCookie);
            if (legacyCookie) {
                this.updateLegacyCookie(legacyCookie);
                return Promise.resolve();
            }
            const ageGateCookie = this.cookiesManager.get(this.ageGateCookie);
            if (ageGateCookie) return Promise.resolve();
            else {
                yield this.waitForAgeGateDataAndSetCookie(communicationService);
                return Promise.resolve();
            }
        });
    }
    waitForAgeGateDataAndSetCookie(communicationService) {
        return (0, $c106e002a49a00cb$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            return new Promise((resolve)=>{
                communicationService.on((0, $9bac733ad19ab912$export$7f305d1b47333a2).AGE_GATE_DATA, ({ payload: payload  })=>{
                    this.setCookie(payload);
                    resolve();
                });
            });
        });
    }
    setCookie(payload) {
        var _a, _b;
        if (!payload) this.logger.warn("Payload data missing, using defaults");
        const encode = (value)=>value ? "1" : "0";
        const adult = (_a = payload === null || payload === void 0 ? void 0 : payload.adult) !== null && _a !== void 0 ? _a : false;
        const timestamp = (_b = payload === null || payload === void 0 ? void 0 : payload.timestamp) !== null && _b !== void 0 ? _b : Date.now();
        this.cookiesManager.set(this.ageGateCookie, encode(adult), {
            domain: this.getTopLevelDomain(),
            expires: new Date(timestamp + this.ageGateExpiryMs)
        });
    }
    updateLegacyCookie(ageGateLegacyCookie) {
        if (ageGateLegacyCookie.length >= 3) {
            const parts = ageGateLegacyCookie.split("|");
            this.setCookie({
                adult: parts[1] === "1",
                timestamp: Date.now()
            });
        }
        this.cookiesManager.remove(this.ageGateLegacyCookie, {
            domain: this.getTopLevelDomain()
        });
    }
    getTopLevelDomain() {
        const domain = this.window.location.hostname;
        return (0, $8aacc0a72dafbc81$export$44dca8fb3e49ffe7).extract(domain);
    }
};
$2339baf3570cc7fc$export$a6e611db690f864e = (0, $c106e002a49a00cb$export$29e00dfd3077644b)([
    (0, $79188624df80f470$export$2e2bcd8739ae039)(),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(0, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $b8e408dd2b31a250$export$9e98cacf66dcab6a))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(1, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $b8e408dd2b31a250$export$56d8a8a25bd48b81))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(2, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $0b30a5935923be01$export$36f603205c7c87a))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(3, (0, $190b0b497264ac3c$export$2e2bcd8739ae039)((0, $f009ac2c4949a5c1$export$efa9a398d6368992), (0, $f009ac2c4949a5c1$export$e41701f8b288055a), "AgeGate")),
    (0, $c106e002a49a00cb$export$f1db080c865becb9)("design:paramtypes", [
        typeof ($2339baf3570cc7fc$var$_a = typeof CookiesManager !== "undefined" && CookiesManager) === "function" ? $2339baf3570cc7fc$var$_a : Object,
        typeof ($2339baf3570cc7fc$var$_b = typeof Window !== "undefined" && Window) === "function" ? $2339baf3570cc7fc$var$_b : Object,
        typeof ($2339baf3570cc7fc$var$_c = typeof (0, $0b30a5935923be01$export$36f603205c7c87a) !== "undefined" && (0, $0b30a5935923be01$export$36f603205c7c87a)) === "function" ? $2339baf3570cc7fc$var$_c : Object,
        typeof ($2339baf3570cc7fc$var$_d = typeof (0, $f009ac2c4949a5c1$export$efa9a398d6368992) !== "undefined" && (0, $f009ac2c4949a5c1$export$efa9a398d6368992)) === "function" ? $2339baf3570cc7fc$var$_d : Object
    ])
], $2339baf3570cc7fc$export$a6e611db690f864e);




let $489f458020eb01fc$export$e5ea4aa04c1de268 = class BeaconGenerator {
    generate() {
        // for users from GDPR countries if they did not give consent for tracking
        // we assign random values to session cookies; should match results of:
        // https://developer.fastly.com/reference/vcl/functions/randomness/randomstr/
        const validCharacters = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz_-";
        let resultValue = "";
        while(resultValue.length < 10)resultValue += validCharacters[Math.random() * validCharacters.length | 0];
        return resultValue;
    }
};
$489f458020eb01fc$export$e5ea4aa04c1de268 = (0, $c106e002a49a00cb$export$29e00dfd3077644b)([
    (0, $7368727773dc6147$export$2e2bcd8739ae039)()
], $489f458020eb01fc$export$e5ea4aa04c1de268);












let $c46fbf90e37984d9$export$69b6c01a07c4eb3a = class ConsentResolver {
    resolve(consents, onConfirm, onReject) {
        if (consents.geoRequiresConsent && consents.gdprConsent || consents.geoRequiresSignal && !consents.ccpaSignal || !consents.geoRequiresSignal && !consents.geoRequiresConsent) {
            this.consentGiven = true;
            onConfirm();
        } else if (consents.geoRequiresSignal && consents.ccpaSignal || consents.geoRequiresConsent && !consents.gdprConsent) {
            this.consentGiven = false;
            onReject();
        }
    }
    getConsents() {
        return this.consentGiven;
    }
};
$c46fbf90e37984d9$export$69b6c01a07c4eb3a = (0, $c106e002a49a00cb$export$29e00dfd3077644b)([
    (0, $79188624df80f470$export$2e2bcd8739ae039)()
], $c46fbf90e37984d9$export$69b6c01a07c4eb3a);







var $695b3e3d7c40fd9b$var$_a, $695b3e3d7c40fd9b$var$_b, $695b3e3d7c40fd9b$var$_c, $695b3e3d7c40fd9b$var$_d, $695b3e3d7c40fd9b$var$_e;
const $695b3e3d7c40fd9b$var$ONE_TRUST_DOMAIN_IDS = {
    ".fanatical.com": "0ab0e172-dc9c-44b9-8a58-c80d9ba4fae0",
    ".futhead.com": "82c642a4-d3a9-4a78-a310-21a7b49ab17b",
    ".gamespot.com": "73588546-b116-4dbc-ab64-9db97e11fc0d",
    ".metacritic.com": "50e16f1d-a929-4cc0-80a7-3c5c303eea6a",
    ".muthead.com": "fb34a16e-696d-4748-af9f-96f3b9e2b4da",
    ".tvguide.com": "ffc22311-f4da-4e03-a1ad-32aecd522c5b",
    ".fandom.com": "dea70a1b-c82d-4fe0-86ff-5e164b0a6022"
};
const $695b3e3d7c40fd9b$var$ONE_TRUST_LIBRARIES = [
    {
        url: "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js",
        options: {}
    },
    {
        url: "https://cdn.cookielaw.org/opt-out/otCCPAiab.js",
        options: {
            charSet: "UTF-8",
            type: "text/javascript",
            "ccpa-opt-out-ids": "C0004",
            "ccpa-opt-out-geo": "us",
            "ccpa-opt-out-lspa": "false"
        }
    },
    {
        url: "https://cdn.cookielaw.org/consent/tcf.stub.js",
        options: {
            charSet: "UTF-8"
        }
    }
];
let $695b3e3d7c40fd9b$export$655dd1825ce8faf6 = class OneTrust {
    constructor(cookiesManager, window, assetLoader, geo, logger){
        this.cookiesManager = cookiesManager;
        this.window = window;
        this.assetLoader = assetLoader;
        this.geo = geo;
        this.logger = logger;
        this.trackingGroup = "C0004:1";
        this.testMode = false;
        this.replaceDoNotSellLink();
        this.testMode = !!(0, $e7ae57550c9200e9$export$eada748df1dd417f).get("ot_test");
        this.consentGiven = new Promise((res)=>this.resolveConsent = res);
        const modalClosed = this.oneTrustModalClosed();
        if (modalClosed) this.consentsUpdated();
        this.loadOneTrustScripts();
        if (this.geo.getCountryCode() === "us") this.consentsUpdated();
        this.subscribe();
    }
    replaceDoNotSellLink() {
        try {
            const doNotSellMyInfoLink = document.querySelector('a[href$="do-not-sell-my-info"]');
            doNotSellMyInfoLink.href = "#";
            doNotSellMyInfoLink.classList.add("ot-sdk-show-settings");
        } catch (e) {
            this.logger.error("Could not prepare Opt-out button", e);
        }
    }
    oneTrustModalClosed() {
        const oneTrustCookie = this.cookiesManager.get("OptanonAlertBoxClosed");
        return oneTrustCookie && !!oneTrustCookie;
    }
    subscribe() {
        const oldOptanonWrapper = this.window.OptanonWrapper;
        this.window.OptanonWrapper = ()=>{
            const modalClosed = this.oneTrustModalClosed();
            if (modalClosed || this.geo.getCountryCode() === "us") {
                this.consentsUpdated();
                oldOptanonWrapper === null || oldOptanonWrapper === void 0 || oldOptanonWrapper();
            }
        };
    }
    oneTrustCookieExists() {
        return !!this.cookiesManager.get("OptanonConsent");
    }
    readTrackingConsents() {
        var _a;
        const cookie = this.cookiesManager.get("OptanonConsent");
        const groups = ((_a = cookie === null || cookie === void 0 ? void 0 : cookie.split("groups=").pop()) === null || _a === void 0 ? void 0 : _a.split(";")[0]) || "";
        if (!groups.length || !cookie.includes("groups")) return this.geo.getCountryCode() === "us";
        return groups.includes(this.trackingGroup);
    }
    consentsUpdated() {
        if (!this.oneTrustCookieExists()) return;
        const location = this.geo.getCountryCode();
        // In GDPR user gives us consent. In CCPA user gives us a signal to OptOut.
        // Therefore in US we assume, that signal = true, means that user opted-out
        const trackingConsent = location === "us" ? !this.readTrackingConsents() : this.readTrackingConsents();
        if (location) this.resolveConsent({
            gdprConsent: (0, $c2def7e558dee4a0$export$c50418c2c95b7cca).includes(location) ? trackingConsent : true,
            geoRequiresConsent: (0, $c2def7e558dee4a0$export$c50418c2c95b7cca).includes(location),
            geoRequiresSignal: location === "us",
            ccpaSignal: location === "us" ? trackingConsent : false
        });
    }
    loadOneTrustScripts() {
        $695b3e3d7c40fd9b$var$ONE_TRUST_LIBRARIES.forEach((library)=>{
            this.assetLoader.loadScript(library.url, "text/javascript", false, null, Object.assign(Object.assign({}, library.options), {
                "data-domain-script": this.getDomainId()
            }));
        });
    }
    getDomainId() {
        const tld = (0, $8aacc0a72dafbc81$export$44dca8fb3e49ffe7).extract(this.window.location.hostname);
        const domainId = $695b3e3d7c40fd9b$var$ONE_TRUST_DOMAIN_IDS[tld] || $695b3e3d7c40fd9b$var$ONE_TRUST_DOMAIN_IDS[".fandom.com"];
        return this.testMode ? `${domainId}-test` : domainId;
    }
};
$695b3e3d7c40fd9b$export$655dd1825ce8faf6 = (0, $c106e002a49a00cb$export$29e00dfd3077644b)([
    (0, $79188624df80f470$export$2e2bcd8739ae039)(),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(0, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $b8e408dd2b31a250$export$9e98cacf66dcab6a))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(1, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $b8e408dd2b31a250$export$56d8a8a25bd48b81))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(2, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $4929d5aa1c5d1567$export$356f5f2a609e254f))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(3, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $2f6e53771cd92caa$export$733db4df510f8a9))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(4, (0, $190b0b497264ac3c$export$2e2bcd8739ae039)((0, $f009ac2c4949a5c1$export$efa9a398d6368992), (0, $f009ac2c4949a5c1$export$e41701f8b288055a), "OneTrust")),
    (0, $c106e002a49a00cb$export$f1db080c865becb9)("design:paramtypes", [
        typeof ($695b3e3d7c40fd9b$var$_a = typeof CookiesManager !== "undefined" && CookiesManager) === "function" ? $695b3e3d7c40fd9b$var$_a : Object,
        typeof ($695b3e3d7c40fd9b$var$_b = typeof Window !== "undefined" && Window) === "function" ? $695b3e3d7c40fd9b$var$_b : Object,
        typeof ($695b3e3d7c40fd9b$var$_c = typeof (0, $4929d5aa1c5d1567$export$356f5f2a609e254f) !== "undefined" && (0, $4929d5aa1c5d1567$export$356f5f2a609e254f)) === "function" ? $695b3e3d7c40fd9b$var$_c : Object,
        typeof ($695b3e3d7c40fd9b$var$_d = typeof (0, $2f6e53771cd92caa$export$733db4df510f8a9) !== "undefined" && (0, $2f6e53771cd92caa$export$733db4df510f8a9)) === "function" ? $695b3e3d7c40fd9b$var$_d : Object,
        typeof ($695b3e3d7c40fd9b$var$_e = typeof (0, $f009ac2c4949a5c1$export$efa9a398d6368992) !== "undefined" && (0, $f009ac2c4949a5c1$export$efa9a398d6368992)) === "function" ? $695b3e3d7c40fd9b$var$_e : Object
    ])
], $695b3e3d7c40fd9b$export$655dd1825ce8faf6);




var $df54e3172b937154$export$a130bab8794e1619;
(function(TCFCommand) {
    TCFCommand["PING"] = "ping";
    TCFCommand["GET_TC_DATA"] = "getTCData";
    TCFCommand["GET_IN_APP_TC_DATA"] = "getInAppTCData";
    TCFCommand["GET_VENDOR_LIST"] = "getVendorList";
    TCFCommand["ADD_EVENT_LISTENER"] = "addEventListener";
    TCFCommand["REMOVE_EVENT_LISTENER"] = "removeEventListener";
})($df54e3172b937154$export$a130bab8794e1619 || ($df54e3172b937154$export$a130bab8794e1619 = {}));






/**
 * An enum representing all the possible statuses for the cmpStatus returned
 * through the CMP API
 *
 * @readonly
 * @enum {string}
 */ var $c6650d4c86df4f7f$export$4810b960166e3f34;
(function(CmpStatus) {
    /**
     * CMP not yet loaded – stub still in place
     * @type {string}
     */ CmpStatus["STUB"] = "stub";
    /**
     * CMP is loading
     * @type {string}
     */ CmpStatus["LOADING"] = "loading";
    /**
     * CMP is finished loading
     * @type {string}
     */ CmpStatus["LOADED"] = "loaded";
    /**
     * CMP is in an error state. A CMP shall not respond to any other API requests if this cmpStatus is present.
     * A CMP may set this status if, for any reason, it is unable to perform the operations in compliance with the TCF.
     * @type {string}
     */ CmpStatus["ERROR"] = "error";
})($c6650d4c86df4f7f$export$4810b960166e3f34 || ($c6650d4c86df4f7f$export$4810b960166e3f34 = {}));


/**
 * An enum representing all the possible statuses for the displayStatus
 * returned through the CMP API
 *
 * @readonly
 * @enum {string}
 */ var $f64bc79bf0ed6aba$export$a66681be047b7245;
(function(DisplayStatus) {
    /**
     * User interface is currently displayed
     * @type {string}
     */ DisplayStatus["VISIBLE"] = "visible";
    /**
     * User interface is not yet or no longer displayed
     * @type {string}
     */ DisplayStatus["HIDDEN"] = "hidden";
    /**
     * User interface will not show (e.g. GDPR does not apply or TC data is current and does not need renewal)
     * @type {string}
     */ DisplayStatus["DISABLED"] = "disabled";
})($f64bc79bf0ed6aba$export$a66681be047b7245 || ($f64bc79bf0ed6aba$export$a66681be047b7245 = {}));


/**
 * EventStatus enum represents the possible values of the eventStatus property of the TCData
 */ var $7566a7528260a218$export$af4f9da7de468bf1;
(function(EventStatus) {
    /**
     * A CMP is loaded and is prepared to surface a TC String to any calling scripts on the page
     * @type {string}
     */ EventStatus["TC_LOADED"] = "tcloaded";
    /**
     * The UI is surfaced or re-surfaced
     * And TC String is available and has rendered "Transparency" in accordance with the TCF Policy.
     * @type {string}
     */ EventStatus["CMP_UI_SHOWN"] = "cmpuishown";
    /**
     * User has confirmed or re-confirmed their choices in accordance with TCF Policy
     * and a CMP is prepared to respond to any calling scripts with the corresponding TC String.
     * @type {string}
     */ EventStatus["USER_ACTION_COMPLETE"] = "useractioncomplete";
})($7566a7528260a218$export$af4f9da7de468bf1 || ($7566a7528260a218$export$af4f9da7de468bf1 = {}));




class $9a4dbb7201d7107a$export$cc7e12c76513e857 {
    listenerId;
    callback;
    next;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    param;
    success = true;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(callback, param, listenerId, next){
        Object.assign(this, {
            callback: callback,
            listenerId: listenerId,
            param: param,
            next: next
        });
        try {
            this.respond();
        } catch (error) {
            this.invokeCallback(null);
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    invokeCallback(response) {
        const success = response !== null;
        if (typeof this.next === "function") this.callback(this.next, response, success);
        else this.callback(response, success);
    }
}



class $9d10f0fbcb82d290$export$e71835e83a47e30a extends (0, $9a4dbb7201d7107a$export$cc7e12c76513e857) {
    respond() {
        this.throwIfParamInvalid();
        this.invokeCallback(new (0, $1f50b793b271350e$export$629d4e06346ac2bb)(this.param, this.listenerId));
    }
    throwIfParamInvalid() {
        /**
         * if they have passed something in as a parameter we'll need to see if
         * it's usable.  If not then we'll need to throw an error.  Check to see if
         * the array is not undefined and is an array of integers, otherwise it's
         * unusable
         */ if (this.param !== undefined && (!Array.isArray(this.param) || !this.param.every(Number.isInteger))) throw new Error("Invalid Parameter");
    }
}


class $b592251dd569e6d1$export$45e673cafbaa6701 {
    eventQueue = new Map();
    queueNumber = 0;
    add(eventItems) {
        this.eventQueue.set(this.queueNumber, eventItems);
        return this.queueNumber++;
    }
    remove(listenerId) {
        return this.eventQueue.delete(listenerId);
    }
    exec() {
        this.eventQueue.forEach((eventItem, listenerId)=>{
            new (0, $9d10f0fbcb82d290$export$e71835e83a47e30a)(eventItem.callback, eventItem.param, listenerId, eventItem.next);
        });
    }
    clear() {
        this.queueNumber = 0;
        this.eventQueue.clear();
    }
    get size() {
        return this.eventQueue.size;
    }
}


class $dee2c3d7e96324ec$export$3bd39b6208e7b7f2 {
    static apiVersion = "2";
    static tcfPolicyVersion;
    static eventQueue = new (0, $b592251dd569e6d1$export$45e673cafbaa6701)();
    static cmpStatus = (0, $c6650d4c86df4f7f$export$4810b960166e3f34).LOADING;
    static disabled = false;
    static displayStatus = (0, $f64bc79bf0ed6aba$export$a66681be047b7245).HIDDEN;
    static cmpId;
    static cmpVersion;
    static eventStatus;
    static gdprApplies;
    static tcModel;
    static tcString;
    static reset() {
        delete this.cmpId;
        delete this.cmpVersion;
        delete this.eventStatus;
        delete this.gdprApplies;
        delete this.tcModel;
        delete this.tcString;
        delete this.tcfPolicyVersion;
        this.cmpStatus = (0, $c6650d4c86df4f7f$export$4810b960166e3f34).LOADING;
        this.disabled = false;
        this.displayStatus = (0, $f64bc79bf0ed6aba$export$a66681be047b7245).HIDDEN;
        this.eventQueue.clear();
    }
}


class $4c454f53cff47cbd$export$9f633d56d7ec90d3 {
    cmpId = (0, $dee2c3d7e96324ec$export$3bd39b6208e7b7f2).cmpId;
    cmpVersion = (0, $dee2c3d7e96324ec$export$3bd39b6208e7b7f2).cmpVersion;
    gdprApplies = (0, $dee2c3d7e96324ec$export$3bd39b6208e7b7f2).gdprApplies;
    tcfPolicyVersion = (0, $dee2c3d7e96324ec$export$3bd39b6208e7b7f2).tcfPolicyVersion;
}



class $c3acf110f760e7a8$export$9a986b15f53d6d10 extends (0, $4c454f53cff47cbd$export$9f633d56d7ec90d3) {
    cmpStatus = (0, $c6650d4c86df4f7f$export$4810b960166e3f34).ERROR;
}




class $1f50b793b271350e$export$629d4e06346ac2bb extends (0, $4c454f53cff47cbd$export$9f633d56d7ec90d3) {
    tcString;
    listenerId;
    eventStatus;
    cmpStatus;
    isServiceSpecific;
    useNonStandardStacks;
    publisherCC;
    purposeOneTreatment;
    outOfBand;
    purpose;
    vendor;
    specialFeatureOptins;
    publisher;
    /**
     * Constructor to create a TCData object from a TCModel
     * @param {number[]} vendorIds - if not undefined, will be used to filter vendor ids
     * @param {number} listenerId - if there is a listenerId to add
     */ constructor(vendorIds, listenerId){
        super();
        this.eventStatus = (0, $dee2c3d7e96324ec$export$3bd39b6208e7b7f2).eventStatus;
        this.cmpStatus = (0, $dee2c3d7e96324ec$export$3bd39b6208e7b7f2).cmpStatus;
        this.listenerId = listenerId;
        if ((0, $dee2c3d7e96324ec$export$3bd39b6208e7b7f2).gdprApplies) {
            const tcModel = (0, $dee2c3d7e96324ec$export$3bd39b6208e7b7f2).tcModel;
            this.tcString = (0, $dee2c3d7e96324ec$export$3bd39b6208e7b7f2).tcString;
            this.isServiceSpecific = tcModel.isServiceSpecific;
            this.useNonStandardStacks = tcModel.useNonStandardStacks;
            this.purposeOneTreatment = tcModel.purposeOneTreatment;
            this.publisherCC = tcModel.publisherCountryCode;
            this.outOfBand = {
                allowedVendors: this.createVectorField(tcModel.vendorsAllowed, vendorIds),
                disclosedVendors: this.createVectorField(tcModel.vendorsDisclosed, vendorIds)
            };
            this.purpose = {
                consents: this.createVectorField(tcModel.purposeConsents),
                legitimateInterests: this.createVectorField(tcModel.purposeLegitimateInterests)
            };
            this.vendor = {
                consents: this.createVectorField(tcModel.vendorConsents, vendorIds),
                legitimateInterests: this.createVectorField(tcModel.vendorLegitimateInterests, vendorIds)
            };
            this.specialFeatureOptins = this.createVectorField(tcModel.specialFeatureOptins);
            this.publisher = {
                consents: this.createVectorField(tcModel.publisherConsents),
                legitimateInterests: this.createVectorField(tcModel.publisherLegitimateInterests),
                customPurpose: {
                    consents: this.createVectorField(tcModel.publisherCustomConsents),
                    legitimateInterests: this.createVectorField(tcModel.publisherCustomLegitimateInterests)
                },
                restrictions: this.createRestrictions(tcModel.publisherRestrictions)
            };
        }
    }
    /**
     * Creates a restrictions object given a PurposeRestrictionVector
     * @param {PurposeRestrictionVector} purpRestrictions
     * @return {Restrictions}
     */ createRestrictions(purpRestrictions) {
        const retr = {};
        if (purpRestrictions.numRestrictions > 0) {
            const max = purpRestrictions.getMaxVendorId();
            for(let vendorId = 1; vendorId <= max; vendorId++){
                const strVendorId = vendorId.toString();
                // vendors restrictions
                purpRestrictions.getRestrictions(vendorId).forEach((pRestrict)=>{
                    const strPurpId = pRestrict.purposeId.toString();
                    if (!retr[strPurpId]) retr[strPurpId] = {};
                    retr[strPurpId][strVendorId] = pRestrict.restrictionType;
                });
            }
        }
        return retr;
    }
    /**
     * Creates a string bit field with a value for each id where each value is
     * '1' if its id is in the passed in vector Can be overwritten to return a
     * string
     * @param {Vector} vector
     * @param {number[]} ids filter
     * @return {BooleanVector | string}
     */ createVectorField(vector, ids) {
        if (ids) return ids.reduce((booleanVector, obj)=>{
            booleanVector[String(obj)] = vector.has(Number(obj));
            return booleanVector;
        }, {});
        return [
            ...vector
        ].reduce((booleanVector, keys)=>{
            booleanVector[keys[0].toString(10)] = keys[1];
            return booleanVector;
        }, {});
    }
}


class $d2528dffb42f8001$export$928e78306bc800f1 extends (0, $1f50b793b271350e$export$629d4e06346ac2bb) {
    constructor(vendorIds){
        super(vendorIds);
        delete this.outOfBand;
    }
    /**
     * Creates a string bit field with a value for each id where each value is '1' if its id is in the passed in vector
     * @override
     * @param {Vector} vector
     * @return {string}
     */ createVectorField(vector) {
        return [
            ...vector
        ].reduce((str, tpl)=>{
            str += tpl[1] ? "1" : "0";
            return str;
        }, "");
    }
    /**
     * Creates a restrictions object given a PurposeRestrictionVector
     * @override
     * @param {PurposeRestrictionVector} purpRestrictions
     * @return {Restrictions}
     */ createRestrictions(purpRestrictions) {
        const retr = {};
        if (purpRestrictions.numRestrictions > 0) {
            const maxVendorId = purpRestrictions.getMaxVendorId();
            /**
             * First create a string of empty values for each purpose that is long
             * enough to contain up to the max vendor id
             */ purpRestrictions.getRestrictions().forEach((pRestrict)=>{
                retr[pRestrict.purposeId.toString()] = "_".repeat(maxVendorId);
            });
            /**
             * go through all of the vendor ids and insert their restriction type
             * number at the index of their vendor id on the purposeID string
             */ for(let i = 0; i < maxVendorId; i++){
                // offset by one
                const vendorId = i + 1;
                // Gets a list of purpose restrictions for this vendor
                purpRestrictions.getRestrictions(vendorId).forEach((pRestrict)=>{
                    const strType = pRestrict.restrictionType.toString();
                    const strPurp = pRestrict.purposeId.toString();
                    // insert the restriction type at the index of the vendor ID
                    const firstPart = retr[strPurp].substr(0, i);
                    const lastPart = retr[strPurp].substr(i + 1);
                    retr[strPurp] = firstPart + strType + lastPart;
                });
            }
        }
        return retr;
    }
}




class $07cad2ae180be633$export$a88c495dfbdf4bad extends (0, $4c454f53cff47cbd$export$9f633d56d7ec90d3) {
    /**
     * true - CMP main script is loaded
     * false - still running stub
     */ cmpLoaded = true;
    /**
     * see Ping Status Codes in following table
     */ cmpStatus = (0, $dee2c3d7e96324ec$export$3bd39b6208e7b7f2).cmpStatus;
    /**
     * see Ping Status Codes in following table
     */ displayStatus = (0, $dee2c3d7e96324ec$export$3bd39b6208e7b7f2).displayStatus;
    /**
     * version of the CMP API that is supported; e.g. “2”
     */ apiVersion = String((0, $dee2c3d7e96324ec$export$3bd39b6208e7b7f2).apiVersion);
    /**
     * Version of the GVL currently loaded by the CMP
     * undefined if still the stub
     */ gvlVersion;
    constructor(){
        super();
        // only if the tcModel is defined
        if ((0, $dee2c3d7e96324ec$export$3bd39b6208e7b7f2).tcModel && (0, $dee2c3d7e96324ec$export$3bd39b6208e7b7f2).tcModel.vendorListVersion) this.gvlVersion = +(0, $dee2c3d7e96324ec$export$3bd39b6208e7b7f2).tcModel.vendorListVersion;
    }
}












class $df163a1ff88c93a8$export$1aca4d096434e94 extends (0, $9a4dbb7201d7107a$export$cc7e12c76513e857) {
    respond() {
        this.invokeCallback(new (0, $07cad2ae180be633$export$a88c495dfbdf4bad)());
    }
}





class $080146056b0c6a46$export$dcda0d941af8ba18 extends (0, $9d10f0fbcb82d290$export$e71835e83a47e30a) {
    respond() {
        this.throwIfParamInvalid();
        this.invokeCallback(new (0, $d2528dffb42f8001$export$928e78306bc800f1)(this.param));
    }
}




// created from 'create-ts-index'
/**
 * class for decoding errors
 *
 * @extends {Error}
 */ class $de2216fa542c1236$export$86630708b3dd13bd extends Error {
    /**
     * constructor - constructs an DecodingError
     *
     * @param {string} msg - Decoding Error Message
     * @return {undefined}
     */ constructor(msg){
        super(msg);
        this.name = "DecodingError";
    }
}


/**
 * class for encoding errors
 *
 * @extends {Error}
 */ class $2f33d7c6c1118ef1$export$4d0aacd3c8649e13 extends Error {
    /**
     * constructor - constructs an EncodingError
     *
     * @param {string} msg - Encoding Error Message
     * @return {undefined}
     */ constructor(msg){
        super(msg);
        this.name = "EncodingError";
    }
}


/**
 * class for General GVL Errors
 *
 * @extends {Error}
 */ class $8655c96636a60690$export$cfebf68bd7a6a21 extends Error {
    /**
     * constructor - constructs a GVLError
     *
     * @param {string} msg - Error message to display
     * @return {undefined}
     */ constructor(msg){
        super(msg);
        this.name = "GVLError";
    }
}


/**
 * class for decoding errors
 *
 * @extends {Error}
 */ class $a93cb9a7fa28bd41$export$ae87575734af973 extends Error {
    /**
     * constructor - constructs an TCModelError
     *
     * @param {string} fieldName - the errored field
     * @param {string} passedValue - what was passed
     * @return {undefined}
     */ constructor(fieldName, passedValue, msg = ""){
        super(`invalid value ${passedValue} passed for ${fieldName} ${msg}`);
        this.name = "TCModelError";
    }
}




class $3bc4d6646eacc1d5$export$bad7b18cc08bb8a3 {
    /**
     * Base 64 URL character set.  Different from standard Base64 char set
     * in that '+' and '/' are replaced with '-' and '_'.
     */ static DICT = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_";
    static REVERSE_DICT = new Map([
        [
            "A",
            0
        ],
        [
            "B",
            1
        ],
        [
            "C",
            2
        ],
        [
            "D",
            3
        ],
        [
            "E",
            4
        ],
        [
            "F",
            5
        ],
        [
            "G",
            6
        ],
        [
            "H",
            7
        ],
        [
            "I",
            8
        ],
        [
            "J",
            9
        ],
        [
            "K",
            10
        ],
        [
            "L",
            11
        ],
        [
            "M",
            12
        ],
        [
            "N",
            13
        ],
        [
            "O",
            14
        ],
        [
            "P",
            15
        ],
        [
            "Q",
            16
        ],
        [
            "R",
            17
        ],
        [
            "S",
            18
        ],
        [
            "T",
            19
        ],
        [
            "U",
            20
        ],
        [
            "V",
            21
        ],
        [
            "W",
            22
        ],
        [
            "X",
            23
        ],
        [
            "Y",
            24
        ],
        [
            "Z",
            25
        ],
        [
            "a",
            26
        ],
        [
            "b",
            27
        ],
        [
            "c",
            28
        ],
        [
            "d",
            29
        ],
        [
            "e",
            30
        ],
        [
            "f",
            31
        ],
        [
            "g",
            32
        ],
        [
            "h",
            33
        ],
        [
            "i",
            34
        ],
        [
            "j",
            35
        ],
        [
            "k",
            36
        ],
        [
            "l",
            37
        ],
        [
            "m",
            38
        ],
        [
            "n",
            39
        ],
        [
            "o",
            40
        ],
        [
            "p",
            41
        ],
        [
            "q",
            42
        ],
        [
            "r",
            43
        ],
        [
            "s",
            44
        ],
        [
            "t",
            45
        ],
        [
            "u",
            46
        ],
        [
            "v",
            47
        ],
        [
            "w",
            48
        ],
        [
            "x",
            49
        ],
        [
            "y",
            50
        ],
        [
            "z",
            51
        ],
        [
            "0",
            52
        ],
        [
            "1",
            53
        ],
        [
            "2",
            54
        ],
        [
            "3",
            55
        ],
        [
            "4",
            56
        ],
        [
            "5",
            57
        ],
        [
            "6",
            58
        ],
        [
            "7",
            59
        ],
        [
            "8",
            60
        ],
        [
            "9",
            61
        ],
        [
            "-",
            62
        ],
        [
            "_",
            63
        ]
    ]);
    /**
     * log2(64) = 6
     */ static BASIS = 6;
    static LCM = 24;
    /**
     * encodes an arbitrary-length bitfield string into base64url
     *
     * @static
     * @param {string} str - arbitrary-length bitfield string to be encoded to base64url
     * @return {string} - base64url encoded result
     */ static encode(str) {
        /**
         * should only be 0 or 1
         */ if (!/^[0-1]+$/.test(str)) throw new (0, $2f33d7c6c1118ef1$export$4d0aacd3c8649e13)("Invalid bitField");
        /**
         * Pad the end of the string to the least common mutliple of 6 (basis for
         * base64) and 8 (one byte)
         */ const padding = str.length % this.LCM;
        str += padding ? "0".repeat(this.LCM - padding) : "";
        let result = "";
        for(let i = 0; i < str.length; i += this.BASIS)result += this.DICT[parseInt(str.substr(i, this.BASIS), 2)];
        return result;
    }
    /**
     * decodes a base64url encoded bitfield string
     *
     * @static
     * @param {string} str - base64url encoded bitfield string to be decoded
     * @return {string} - bitfield string
     */ static decode(str) {
        /**
         * should contain only characters from the base64url set
         */ if (!/^[A-Za-z0-9\-_]+$/.test(str)) throw new (0, $de2216fa542c1236$export$86630708b3dd13bd)("Invalidly encoded Base64URL string");
        let result = "";
        for(let i = 0; i < str.length; i++){
            /**
             * index the binary value of the character from out reverse map
             */ const strBits = this.REVERSE_DICT.get(str[i]).toString(2);
            /**
             * Since a bit string converted to an integer on encoding will lose
             * leading zeros – pad to the left for those missing leading zeros
             */ result += "0".repeat(this.BASIS - strBits.length) + strBits;
        }
        return result;
    }
}


/**
 * Abstract Class Cloneable<T> can be extended to give the child class the ability to clone its self.
 * The child class must pass its class to super. You can then pass any needed arguments to help build
 * the cloned class to the protected _clone() method.
 *
 * Example:
 *
 * class Example extends Cloneable<Example> {
 *
 * }
 * Todo: There must be more non primitive build in types to check. But for our current purposes, this works great.
 */ class $3867cebb1f83913e$export$a17144d9403e9d84 {
    /**
     * clone - returns a copy of the classes with new values and not references
     *
     * @return {T}
     */ clone() {
        const myClone = new this.constructor();
        const keys = Object.keys(this);
        keys.forEach((key)=>{
            const value = this.deepClone(this[key]);
            if (value !== undefined) myClone[key] = value;
        });
        return myClone;
    }
    /**
     * deepClone - recursive function that makes copies of reference values
     *
     * @param {unknown} item
     * @return {unknown}
     */ deepClone(item) {
        const itsType = typeof item;
        if (itsType === "number" || itsType === "string" || itsType === "boolean") return item;
        else if (item !== null && itsType === "object") {
            if (typeof item.clone === "function") return item.clone();
            else if (item instanceof Date) return new Date(item.getTime());
            else if (item[Symbol.iterator] !== undefined) {
                const ar = [];
                for (const subItem of item)ar.push(this.deepClone(subItem));
                if (item instanceof Array) return ar;
                else return new item.constructor(ar);
            } else {
                const retr = {};
                for(const prop in item)if (item.hasOwnProperty(prop)) retr[prop] = this.deepClone(item[prop]);
                return retr;
            }
        }
    /**
         * ignore functions because those will be initialized with the cloning
         * process
         */ }
}


class $613bdb9468aa067c$export$a3148abf59590961 extends (0, $3867cebb1f83913e$export$a17144d9403e9d84) {
    root = null;
    getRoot() {
        return this.root;
    }
    isEmpty() {
        // if root is undefined or null then by definition this is empty
        return !this.root;
    }
    add(value) {
        // create new node object
        const node = {
            value: value,
            left: null,
            right: null
        };
        let current;
        // first item?
        if (this.isEmpty()) this.root = node;
        else {
            // start at the root
            current = this.root;
            // infinite loop, figure out where to put it
            while(true){
                // if the value is less than current value; go left
                if (value < current.value) {
                    // if it's empty, we can insert
                    if (current.left === null) {
                        // insert on the left
                        current.left = node;
                        break;
                    } else /**
                         * if there's something there already, we'll reset the pointer and
                         * wait for the next loop to do something ie. keep traversing
                         */ current = current.left;
                } else if (value > current.value) {
                    // if the value is greater than our current value; go right
                    if (current.right === null) {
                        // there's nothing to the right, so put it here
                        current.right = node;
                        break;
                    } else /**
                         * if there's something there already, we'll reset the pointer and
                         * wait for the next loop to do something ie. keep traversing
                         */ current = current.right;
                } else break;
            }
        }
    }
    /**
     * performs Morris in-order traversal
     * @return {number[]} sorted array
     */ get() {
        const retr = [];
        let current = this.root;
        while(current)if (!current.left) {
            retr.push(current.value); // if there is no left child, visit current node
            current = current.right; // then we go the right branch
        } else {
            // find the right most leaf of root.left node.
            let pre = current.left;
            // when pre.right == null, it means we go to the right most leaf
            // when pre.right == current, it means the right most leaf has been visited in the last round
            while(pre.right && pre.right != current)pre = pre.right;
            // this means the pre.right has been set, it's time to go to current node
            if (pre.right == current) {
                pre.right = null;
                // means the current node is pointed by left right most child
                // the left branch has been visited, it's time to push the current node
                retr.push(current.value);
                current = current.right;
            } else {
                // the fist time to visit the pre node, make its right child point to current node
                pre.right = current;
                current = current.left;
            }
        }
        return retr;
    }
    contains(value) {
        let retr = false;
        let current = this.root;
        while(current){
            if (current.value === value) {
                retr = true;
                break;
            } else if (value > current.value) current = current.right;
            else if (value < current.value) current = current.left;
        }
        return retr;
    }
    min(current = this.root) {
        let retr;
        while(current)if (current.left) current = current.left;
        else {
            retr = current.value;
            current = null;
        }
        return retr;
    }
    max(current = this.root) {
        let retr;
        while(current)if (current.right) current = current.right;
        else {
            retr = current.value;
            current = null;
        }
        return retr;
    }
    remove(value, current = this.root) {
        // we start at the root, so the parent is null
        let parent = null;
        let parentSide = "left";
        while(current){
            if (value < current.value) {
                // set our parent to the current value
                parent = current;
                // value is less than current value, so go left
                current = current.left;
                parentSide = "left";
            } else if (value > current.value) {
                // set our parent to the current value
                parent = current;
                // value is greater than current value, so go right
                current = current.right;
                parentSide = "right";
            } else {
                /**
                   * if it's neither greater than or less than, then it's equal so BINGO!
                   * we've found it
                   *
                   * If we have children, we've got to figure out what to do with
                   * them once we are no longer around...  Woah, code is like real
                   * life...
                   *
                   * There are three cases we care about when it comes to this removal
                   * process:
                   *
                   * 1. No children -- If not children we just delete an do nothing
                   * else, no harm no foul.
                   *
                   * 2. One child -- Just link the parent's link to current to the
                   * child.
                   *
                   * 3. Two children --  Find the minimum value from the right subtree
                   * replace us with the minimum value and of course remove that
                   * minimum value from the right stubtree
                   */ if (!current.left && !current.right) {
                    // case 1 there are no children easy peasy lemon squeezy
                    if (parent) parent[parentSide] = null;
                    else this.root = null;
                } else if (!current.left) {
                    // no left side only right, so link right
                    if (parent) parent[parentSide] = current.right;
                    else this.root = current.right;
                } else if (!current.right) {
                    // no right side only left, so link left
                    if (parent) parent[parentSide] = current.left;
                    else this.root = current.left;
                } else {
                    /**
                     * case 3 just like real life, if you delete a parent the more kids
                     * that parent has the more complicated things get... in this case we
                     * have two children.  We're gonna have to figure out who goes where.
                     */ const minVal = this.min(current.right);
                    // little bit of recursion...
                    this.remove(minVal, current.right);
                    current.value = minVal;
                }
                current = null;
            }
        }
    }
    /**
     * Build Binary Search Tree from the ordered number array.
     *  The depth of the tree will be the `log2` of the array length.
     * @param {number[]} values number array in ascending order
     * @return {BinarySearchTree} Binary Search Tree
     */ static build(values) {
        if (!values || values.length === 0) return null;
        else if (values.length === 1) {
            const tree = new $613bdb9468aa067c$export$a3148abf59590961();
            tree.add(values[0]);
            return tree;
        } else {
            const rootIndex = values.length >> 1;
            const tree = new $613bdb9468aa067c$export$a3148abf59590961();
            tree.add(values[rootIndex]);
            const root = tree.getRoot();
            if (root) {
                if (rootIndex + 1 < values.length) {
                    const rightTree = $613bdb9468aa067c$export$a3148abf59590961.build(values.slice(rootIndex + 1));
                    root.right = rightTree ? rightTree.getRoot() : null;
                }
                if (rootIndex - 1 > 0) {
                    const leftTree = $613bdb9468aa067c$export$a3148abf59590961.build(values.slice(0, rootIndex - 1));
                    root.left = leftTree ? leftTree.getRoot() : null;
                }
            }
            return tree;
        }
    }
}


class $c8e1695ef6ed80b9$export$1c7a19f2c7470871 {
    static langSet = new Set([
        "BG",
        "CA",
        "CS",
        "DA",
        "DE",
        "EL",
        "EN",
        "ES",
        "ET",
        "FI",
        "FR",
        "HR",
        "HU",
        "IT",
        "JA",
        "LT",
        "LV",
        "MT",
        "NL",
        "NO",
        "PL",
        "PT",
        "RO",
        "RU",
        "SK",
        "SL",
        "SV",
        "TR",
        "ZH"
    ]);
    has(key) {
        return $c8e1695ef6ed80b9$export$1c7a19f2c7470871.langSet.has(key);
    }
    forEach(callback) {
        $c8e1695ef6ed80b9$export$1c7a19f2c7470871.langSet.forEach(callback);
    }
    get size() {
        return $c8e1695ef6ed80b9$export$1c7a19f2c7470871.langSet.size;
    }
}


class $6618d4cef05f38ff$export$833b3e5a19fb8939 {
    static cmpId = "cmpId";
    static cmpVersion = "cmpVersion";
    static consentLanguage = "consentLanguage";
    static consentScreen = "consentScreen";
    static created = "created";
    static supportOOB = "supportOOB";
    static isServiceSpecific = "isServiceSpecific";
    static lastUpdated = "lastUpdated";
    static numCustomPurposes = "numCustomPurposes";
    static policyVersion = "policyVersion";
    static publisherCountryCode = "publisherCountryCode";
    static publisherCustomConsents = "publisherCustomConsents";
    static publisherCustomLegitimateInterests = "publisherCustomLegitimateInterests";
    static publisherLegitimateInterests = "publisherLegitimateInterests";
    static publisherConsents = "publisherConsents";
    static publisherRestrictions = "publisherRestrictions";
    static purposeConsents = "purposeConsents";
    static purposeLegitimateInterests = "purposeLegitimateInterests";
    static purposeOneTreatment = "purposeOneTreatment";
    static specialFeatureOptins = "specialFeatureOptins";
    static useNonStandardStacks = "useNonStandardStacks";
    static vendorConsents = "vendorConsents";
    static vendorLegitimateInterests = "vendorLegitimateInterests";
    static vendorListVersion = "vendorListVersion";
    static vendorsAllowed = "vendorsAllowed";
    static vendorsDisclosed = "vendorsDisclosed";
    static version = "version";
}








/**
 * if a Vendor has declared flexible purposes (see: [[Vendor]] under
 * `flexiblePurposeIds`) on the Global Vendor List ([[Declarations]]) a CMP may
 * change their legal basis for processing in the encoding.
 */ var $e3e388fdc6670e56$export$c74010cd6874a9d0;
(function(RestrictionType) {
    /**
     * under no circumstances is this purpose allowed.
     */ RestrictionType[RestrictionType["NOT_ALLOWED"] = 0] = "NOT_ALLOWED";
    /**
     * if the default declaration is legitimate interest then this flips the purpose to consent in the encoding.
     */ RestrictionType[RestrictionType["REQUIRE_CONSENT"] = 1] = "REQUIRE_CONSENT";
    /**
     * if the default declaration is consent then this flips the purpose to Legitimate Interest in the encoding.
     */ RestrictionType[RestrictionType["REQUIRE_LI"] = 2] = "REQUIRE_LI";
})($e3e388fdc6670e56$export$c74010cd6874a9d0 || ($e3e388fdc6670e56$export$c74010cd6874a9d0 = {}));


class $3940e20a5fdb4400$export$d8a6104f5b3b3eb7 extends (0, $3867cebb1f83913e$export$a17144d9403e9d84) {
    static hashSeparator = "-";
    purposeId_;
    restrictionType;
    /**
     * constructor
     *
     * @param {number} purposeId? - may optionally pass the purposeId into the
     * constructor
     * @param {RestrictionType} restrictionType? - may
     * optionally pass the restrictionType into the constructor
     * @return {undefined}
     */ constructor(purposeId, restrictionType){
        super();
        if (purposeId !== undefined) this.purposeId = purposeId;
        if (restrictionType !== undefined) this.restrictionType = restrictionType;
    }
    static unHash(hash) {
        const splitUp = hash.split(this.hashSeparator);
        const purpRestriction = new $3940e20a5fdb4400$export$d8a6104f5b3b3eb7();
        if (splitUp.length !== 2) throw new (0, $a93cb9a7fa28bd41$export$ae87575734af973)("hash", hash);
        purpRestriction.purposeId = parseInt(splitUp[0], 10);
        purpRestriction.restrictionType = parseInt(splitUp[1], 10);
        return purpRestriction;
    }
    get hash() {
        if (!this.isValid()) throw new Error("cannot hash invalid PurposeRestriction");
        return `${this.purposeId}${$3940e20a5fdb4400$export$d8a6104f5b3b3eb7.hashSeparator}${this.restrictionType}`;
    }
    /**
     * @return {number} The purpose Id associated with a publisher
     * purpose-by-vendor restriction that resulted in a different consent or LI
     * status than the consent or LI purposes allowed lists.
     */ get purposeId() {
        return this.purposeId_;
    }
    /**
     * @param {number} idNum - The purpose Id associated with a publisher
     * purpose-by-vendor restriction that resulted in a different consent or LI
     * status than the consent or LI purposes allowed lists.
     */ set purposeId(idNum) {
        this.purposeId_ = idNum;
    }
    isValid() {
        return Number.isInteger(this.purposeId) && this.purposeId > 0 && (this.restrictionType === (0, $e3e388fdc6670e56$export$c74010cd6874a9d0).NOT_ALLOWED || this.restrictionType === (0, $e3e388fdc6670e56$export$c74010cd6874a9d0).REQUIRE_CONSENT || this.restrictionType === (0, $e3e388fdc6670e56$export$c74010cd6874a9d0).REQUIRE_LI);
    }
    isSameAs(otherPR) {
        return this.purposeId === otherPR.purposeId && this.restrictionType === otherPR.restrictionType;
    }
}






class $0ff930ce4fd6f184$export$f0de1ae98060331 extends (0, $3867cebb1f83913e$export$a17144d9403e9d84) {
    /**
     * if this originatd from an encoded string we'll need a place to store the
     * bit length; it can be set and got from here
     */ bitLength = 0;
    /**
     * a map indexed by a string which will be a 'hash' of the purpose and
     * restriction type.
     *
     * Using a BST to keep vendors in a sorted order for encoding later
     */ map = new Map();
    gvl_;
    has(hash) {
        return this.map.has(hash);
    }
    isOkToHave(restrictionType, purposeId, vendorId) {
        let result = true;
        /**
         * without a gvl set, there's no way to know... in that case we'll return
         * true but once the GVL is set later we'll go through these and clean up
         * the mess.
         */ if (this.gvl?.vendors) {
            const vendor = this.gvl.vendors[vendorId];
            if (vendor) {
                if (restrictionType === (0, $e3e388fdc6670e56$export$c74010cd6874a9d0).NOT_ALLOWED) /**
                     * if it's "not allowed" then flexible declaration is ignored but if
                     * if it isn't even listed as one of the purposes the vendor uses,
                     * then there is no reason to encode the value so check both arrays
                     * to see if it exists.  If it does then we can restrict it.
                     */ result = vendor.legIntPurposes.includes(purposeId) || vendor.purposes.includes(purposeId);
                else if (vendor.flexiblePurposes.length) switch(restrictionType){
                    /**
                         * If the vendor has the purposeId in flexiblePurposes and it is
                         * listed as a legitimate interest purpose we can set the
                         * override to require consent.
                         */ case (0, $e3e388fdc6670e56$export$c74010cd6874a9d0).REQUIRE_CONSENT:
                        result = vendor.flexiblePurposes.includes(purposeId) && vendor.legIntPurposes.includes(purposeId);
                        break;
                    /**
                         * If the vendor has the purposeId in flexiblePurposes and it is
                         * listed as a consent purpose we can set the
                         * override to require legitimate interest.
                         */ case (0, $e3e388fdc6670e56$export$c74010cd6874a9d0).REQUIRE_LI:
                        result = vendor.flexiblePurposes.includes(purposeId) && vendor.purposes.includes(purposeId);
                        break;
                }
                else result = false;
            } else // this vendor doesn't exist
            result = false;
        }
        // if the gvl isn't defined, we can't do anything until later
        return result;
    }
    /**
     * add - adds a given Vendor ID under a given Purpose Restriction
     *
     * @param {number} vendorId
     * @param {PurposeRestriction} purposeRestriction
     * @return {void}
     */ add(vendorId, purposeRestriction) {
        if (this.isOkToHave(purposeRestriction.restrictionType, purposeRestriction.purposeId, vendorId)) {
            const hash = purposeRestriction.hash;
            if (!this.has(hash)) {
                this.map.set(hash, new (0, $613bdb9468aa067c$export$a3148abf59590961)());
                this.bitLength = 0;
            }
            /**
             * Previously I had a check here to remove a duplicate value, but because
             * we're using a tree the value is guaranteed to be unique so there is no
             * need to add an additional de-duplication here.
             */ this.map.get(hash).add(vendorId);
        }
    }
    /**
     * restrictPurposeToLegalBasis - adds all Vendors under a given Purpose Restriction
     *
     * @param {PurposeRestriction} purposeRestriction
     * @return {void}
     */ restrictPurposeToLegalBasis(purposeRestriction) {
        const vendors = this.gvl.vendorIds;
        const hash = purposeRestriction.hash;
        const lastEntry = function() {
            let value;
            for (value of vendors);
            return value;
        }();
        /**
         * Create an ordered array of vendor IDs from `1` (the minimum value for Vendor ID) to `lastEntry`
         */ const values = [
            ...Array(lastEntry).keys()
        ].map((i)=>i + 1);
        for(let i = 1; i <= lastEntry; i++){
            if (!this.has(hash)) {
                this.map.set(hash, (0, $613bdb9468aa067c$export$a3148abf59590961).build(values)); // use static method `build` to create a `BST` from the ordered array of IDs
                this.bitLength = 0;
            }
            /**
             * Previously I had a check here to remove a duplicate value, but because
             * we're using a tree the value is guaranteed to be unique so there is no
             * need to add an additional de-duplication here.
             */ this.map.get(hash).add(i);
        }
    }
    /**
     * getVendors - returns array of vendor ids optionally narrowed by a given
     * Purpose Restriction.  If no purpose restriction is passed then all vendor
     * ids will be returned.  One can expect this result to be a unique set of
     * ids no duplicates.
     *
     * @param {PurposeRestriction} [purposeRestriction] - optionally passed to
     * get only Vendor IDs restricted under the given Purpose Restriction
     * @return {number[]} - Unique ID set of vendors
     */ getVendors(purposeRestriction) {
        let vendorIds = [];
        if (purposeRestriction) {
            const hash = purposeRestriction.hash;
            if (this.has(hash)) vendorIds = this.map.get(hash).get();
        } else {
            const vendorSet = new Set();
            this.map.forEach((bst)=>{
                bst.get().forEach((vendorId)=>{
                    vendorSet.add(vendorId);
                });
            });
            vendorIds = Array.from(vendorSet);
        }
        return vendorIds;
    }
    getRestrictionType(vendorId, purposeId) {
        let rType;
        this.getRestrictions(vendorId).forEach((purposeRestriction)=>{
            if (purposeRestriction.purposeId === purposeId) {
                if (rType === undefined || rType > purposeRestriction.restrictionType) rType = purposeRestriction.restrictionType;
            }
        });
        return rType;
    }
    /**
     * vendorHasRestriction - determines whether a given Vendor ID is under a
     * given Purpose Restriction
     *
     * @param {number} vendorId
     * @param {PurposeRestriction} purposeRestriction
     * @return {boolean} - true if the give Vendor ID is under the given Purpose
     * Restriction
     */ vendorHasRestriction(vendorId, purposeRestriction) {
        let has = false;
        const restrictions = this.getRestrictions(vendorId);
        for(let i = 0; i < restrictions.length && !has; i++)has = purposeRestriction.isSameAs(restrictions[i]);
        return has;
    }
    /**
     * getMaxVendorId - gets the Maximum Vendor ID regardless of Purpose
     * Restriction
     *
     * @return {number} - maximum Vendor ID
     */ getMaxVendorId() {
        let retr = 0;
        this.map.forEach((bst)=>{
            retr = Math.max(bst.max(), retr);
        });
        return retr;
    }
    getRestrictions(vendorId) {
        const retr = [];
        this.map.forEach((bst, hash)=>{
            if (vendorId) {
                if (bst.contains(vendorId)) retr.push((0, $3940e20a5fdb4400$export$d8a6104f5b3b3eb7).unHash(hash));
            } else retr.push((0, $3940e20a5fdb4400$export$d8a6104f5b3b3eb7).unHash(hash));
        });
        return retr;
    }
    getPurposes() {
        const purposeIds = new Set();
        this.map.forEach((bst, hash)=>{
            purposeIds.add((0, $3940e20a5fdb4400$export$d8a6104f5b3b3eb7).unHash(hash).purposeId);
        });
        return Array.from(purposeIds);
    }
    /**
     * remove - removes Vendor ID from a Purpose Restriction
     *
     * @param {number} vendorId
     * @param {PurposeRestriction} purposeRestriction
     * @return {void}
     */ remove(vendorId, purposeRestriction) {
        const hash = purposeRestriction.hash;
        const bst = this.map.get(hash);
        if (bst) {
            bst.remove(vendorId);
            // if it's empty let's delete the key so it doesn't show up empty
            if (bst.isEmpty()) {
                this.map.delete(hash);
                this.bitLength = 0;
            }
        }
    }
    /**
     * Essential for being able to determine whether we can actually set a
     * purpose restriction since they have to have a flexible legal basis
     *
     * @param {GVL} value - the GVL instance
     */ set gvl(value) {
        if (!this.gvl_) {
            this.gvl_ = value;
            /**
             * if we have restrictions set before the gvl is set then we'll have to
             * go through and remove some if they're not valid
             */ this.map.forEach((bst, hash)=>{
                const purposeRestriction = (0, $3940e20a5fdb4400$export$d8a6104f5b3b3eb7).unHash(hash);
                const vendors = bst.get();
                vendors.forEach((vendorId)=>{
                    if (!this.isOkToHave(purposeRestriction.restrictionType, purposeRestriction.purposeId, vendorId)) bst.remove(vendorId);
                });
            });
        }
    }
    /**
     * gvl returns local copy of the GVL these restrictions apply to
     *
     * @return {GVL}
     */ get gvl() {
        return this.gvl_;
    }
    /**
     * isEmpty - whether or not this vector has any restrictions in it
     *
     * @return {boolean}
     */ isEmpty() {
        return this.map.size === 0;
    }
    /**
     * numRestrictions - returns the number of Purpose Restrictions.
     *
     * @return {number}
     */ get numRestrictions() {
        return this.map.size;
    }
}


var $f59d573f643599ce$export$c7adb5ee9940333b;
(function(DeviceDisclosureStorageAccessType) {
    DeviceDisclosureStorageAccessType["COOKIE"] = "cookie";
    DeviceDisclosureStorageAccessType["WEB"] = "web";
    DeviceDisclosureStorageAccessType["APP"] = "app";
})($f59d573f643599ce$export$c7adb5ee9940333b || ($f59d573f643599ce$export$c7adb5ee9940333b = {}));





var $36d6995c8c6f3891$export$d53aa5c5ab432700;
(function(Segment) {
    Segment["CORE"] = "core";
    Segment["VENDORS_DISCLOSED"] = "vendorsDisclosed";
    Segment["VENDORS_ALLOWED"] = "vendorsAllowed";
    Segment["PUBLISHER_TC"] = "publisherTC";
})($36d6995c8c6f3891$export$d53aa5c5ab432700 || ($36d6995c8c6f3891$export$d53aa5c5ab432700 = {}));



class $ea2b59a0eb08e264$export$a7590c36d83c4992 {
    /**
     * 0 = default - reserved for core string (does not need to be present in the core string)
     * 1 = OOB vendors disclosed
     * 2 = OOB vendors allowed
     * 3 = PublisherTC
     */ static ID_TO_KEY = [
        (0, $36d6995c8c6f3891$export$d53aa5c5ab432700).CORE,
        (0, $36d6995c8c6f3891$export$d53aa5c5ab432700).VENDORS_DISCLOSED,
        (0, $36d6995c8c6f3891$export$d53aa5c5ab432700).VENDORS_ALLOWED,
        (0, $36d6995c8c6f3891$export$d53aa5c5ab432700).PUBLISHER_TC
    ];
    static KEY_TO_ID = {
        [(0, $36d6995c8c6f3891$export$d53aa5c5ab432700).CORE]: 0,
        [(0, $36d6995c8c6f3891$export$d53aa5c5ab432700).VENDORS_DISCLOSED]: 1,
        [(0, $36d6995c8c6f3891$export$d53aa5c5ab432700).VENDORS_ALLOWED]: 2,
        [(0, $36d6995c8c6f3891$export$d53aa5c5ab432700).PUBLISHER_TC]: 3
    };
}




class $908c228bb5be525f$export$9b781de7bf37bf48 extends (0, $3867cebb1f83913e$export$a17144d9403e9d84) {
    /**
     * if this originatd from an encoded string we'll need a place to store the
     * bit length; it can be set and got from here
     */ bitLength = 0;
    maxId_ = 0;
    set_ = new Set();
    *[Symbol.iterator]() {
        for(let i = 1; i <= this.maxId; i++)yield [
            i,
            this.has(i)
        ];
    }
    /**
     * values()
     *
     * @return {IterableIterator<number>} - returns an iterator of the positive
     * values in the set
     */ values() {
        return this.set_.values();
    }
    /**
     * maxId
     *
     * @return {number} - the highest id in this Vector
     */ get maxId() {
        return this.maxId_;
    }
    /**
     * get
     *
     * @param {number} id - key for value to check
     * @return {boolean} - value of that key, if never set it will be false
     */ has(id) {
        /**
         * if it exists in the set we'll return true
         */ return this.set_.has(id);
    }
    /**
     * unset
     *
     * @param {SingleIDOrCollection} id - id or ids to unset
     * @return {void}
     */ unset(id) {
        if (Array.isArray(id)) id.forEach((id)=>this.unset(id));
        else if (typeof id === "object") this.unset(Object.keys(id).map((strId)=>Number(strId)));
        else {
            this.set_.delete(Number(id));
            /**
             * if bitLength was set before, it must now be unset
             */ this.bitLength = 0;
            if (id === this.maxId) {
                /**
                 * aww bummer we lost our maxId... now we've got to search through
                 * all the ids and find the biggest one.
                 */ this.maxId_ = 0;
                this.set_.forEach((id)=>{
                    this.maxId_ = Math.max(this.maxId, id);
                });
            }
        }
    }
    isIntMap(item) {
        let result = typeof item === "object";
        result = result && Object.keys(item).every((key)=>{
            let itemResult = Number.isInteger(parseInt(key, 10));
            itemResult = itemResult && this.isValidNumber(item[key].id);
            itemResult = itemResult && item[key].name !== undefined;
            return itemResult;
        });
        return result;
    }
    isValidNumber(item) {
        return parseInt(item, 10) > 0;
    }
    isSet(item) {
        let result = false;
        if (item instanceof Set) result = Array.from(item).every(this.isValidNumber);
        return result;
    }
    /**
     * set - sets an item assumed to be a truthy value by its presence
     *
     * @param {SingleIDOrCollection} item - May be a single id (positive integer)
     * or collection of ids in a set, GVL Int Map, or Array.
     *
     * @return {void}
     */ set(item) {
        /**
         * strategy here is to just recursively call set if it's a collection until
         * we get to the final integer ID
         */ if (Array.isArray(item)) item.forEach((item)=>this.set(item));
        else if (this.isSet(item)) this.set(Array.from(item));
        else if (this.isIntMap(item)) this.set(Object.keys(item).map((strId)=>Number(strId)));
        else if (this.isValidNumber(item)) {
            this.set_.add(item);
            this.maxId_ = Math.max(this.maxId, item);
            /**
             * if bitLength was set before, it must now be unset
             */ this.bitLength = 0;
        } else /**
             * Super not cool to try and set something that's not valid
             */ throw new (0, $a93cb9a7fa28bd41$export$ae87575734af973)("set()", item, "must be positive integer array, positive integer, Set<number>, or IntMap");
    }
    empty() {
        this.set_ = new Set();
    }
    /**
     * forEach - to traverse from id=1 to id=maxId in a sequential non-sparse manner
     *
     *
     * @param {forEachCallback} callback - callback to execute
     * @return {void}
     *
     * @callback forEachCallback
     * @param {boolean} value - whether or not this id exists in the vector
     * @param {number} id - the id number of the current iteration
     */ forEach(callback) {
        for(let i = 1; i <= this.maxId; i++)callback(this.has(i), i);
    }
    get size() {
        return this.set_.size;
    }
    setAll(intMap) {
        this.set(intMap);
    }
}


// created from 'create-ts-index'






















class $a29b574660309e88$export$391437f908389469 {
    static [(0, $6618d4cef05f38ff$export$833b3e5a19fb8939).cmpId] = 12;
    static [(0, $6618d4cef05f38ff$export$833b3e5a19fb8939).cmpVersion] = 12;
    static [(0, $6618d4cef05f38ff$export$833b3e5a19fb8939).consentLanguage] = 12;
    static [(0, $6618d4cef05f38ff$export$833b3e5a19fb8939).consentScreen] = 6;
    static [(0, $6618d4cef05f38ff$export$833b3e5a19fb8939).created] = 36;
    static [(0, $6618d4cef05f38ff$export$833b3e5a19fb8939).isServiceSpecific] = 1;
    static [(0, $6618d4cef05f38ff$export$833b3e5a19fb8939).lastUpdated] = 36;
    static [(0, $6618d4cef05f38ff$export$833b3e5a19fb8939).policyVersion] = 6;
    static [(0, $6618d4cef05f38ff$export$833b3e5a19fb8939).publisherCountryCode] = 12;
    static [(0, $6618d4cef05f38ff$export$833b3e5a19fb8939).publisherLegitimateInterests] = 24;
    static [(0, $6618d4cef05f38ff$export$833b3e5a19fb8939).publisherConsents] = 24;
    static [(0, $6618d4cef05f38ff$export$833b3e5a19fb8939).purposeConsents] = 24;
    static [(0, $6618d4cef05f38ff$export$833b3e5a19fb8939).purposeLegitimateInterests] = 24;
    static [(0, $6618d4cef05f38ff$export$833b3e5a19fb8939).purposeOneTreatment] = 1;
    static [(0, $6618d4cef05f38ff$export$833b3e5a19fb8939).specialFeatureOptins] = 12;
    static [(0, $6618d4cef05f38ff$export$833b3e5a19fb8939).useNonStandardStacks] = 1;
    static [(0, $6618d4cef05f38ff$export$833b3e5a19fb8939).vendorListVersion] = 12;
    static [(0, $6618d4cef05f38ff$export$833b3e5a19fb8939).version] = 6;
    static anyBoolean = 1;
    static encodingType = 1;
    static maxId = 16;
    static numCustomPurposes = 6;
    static numEntries = 12;
    static numRestrictions = 12;
    static purposeId = 6;
    static restrictionType = 2;
    static segmentType = 3;
    static singleOrRange = 1;
    static vendorId = 16;
}






class $95b4827e48a379bb$export$c480a1bdd5c67cac {
    static encode(value) {
        return String(Number(value));
    }
    static decode(value) {
        // less operations than !!parseInt(value, 2)
        return value === "1";
    }
}



class $8e08330dc250a556$export$652ce6ae9d26cb14 {
    static encode(value, numBits) {
        let bitString;
        if (typeof value === "string") value = parseInt(value, 10);
        bitString = value.toString(2);
        if (bitString.length > numBits || value < 0) throw new (0, $2f33d7c6c1118ef1$export$4d0aacd3c8649e13)(`${value} too large to encode into ${numBits}`);
        // Pad the string if not filling all bits
        if (bitString.length < numBits) // pad left
        bitString = "0".repeat(numBits - bitString.length) + bitString;
        return bitString;
    }
    static decode(value, numBits) {
        if (numBits !== value.length) throw new (0, $de2216fa542c1236$export$86630708b3dd13bd)("invalid bit length");
        return parseInt(value, 2);
    }
}



class $9099a2d983a3413b$export$be00a5c431c9e2be {
    static encode(value, numBits) {
        return (0, $8e08330dc250a556$export$652ce6ae9d26cb14).encode(Math.round(value.getTime() / 100), numBits);
    }
    static decode(value, numBits) {
        if (numBits !== value.length) throw new (0, $de2216fa542c1236$export$86630708b3dd13bd)("invalid bit length");
        const date = new Date();
        date.setTime((0, $8e08330dc250a556$export$652ce6ae9d26cb14).decode(value, numBits) * 100);
        return date;
    }
}








class $2dc93ee3b5ae8231$export$dcd4d91b6e09afa8 {
    static encode(value, numBits) {
        let bitString = "";
        for(let i = 1; i <= numBits; i++)bitString += (0, $95b4827e48a379bb$export$c480a1bdd5c67cac).encode(value.has(i));
        return bitString;
    }
    static decode(value, numBits) {
        if (value.length !== numBits) throw new (0, $de2216fa542c1236$export$86630708b3dd13bd)("bitfield encoding length mismatch");
        const vector = new (0, $908c228bb5be525f$export$9b781de7bf37bf48)();
        for(let i = 1; i <= numBits; i++)if ((0, $95b4827e48a379bb$export$c480a1bdd5c67cac).decode(value[i - 1])) vector.set(i);
        vector.bitLength = value.length;
        return vector;
    }
}





class $6e5ca3a2f1bb6454$export$59ec574003c7c77a {
    static encode(value, numBits) {
        value = value.toUpperCase();
        const ASCII_START = 65;
        const firstLetter = value.charCodeAt(0) - ASCII_START;
        const secondLetter = value.charCodeAt(1) - ASCII_START;
        // check some things to throw some good errors
        if (firstLetter < 0 || firstLetter > 25 || secondLetter < 0 || secondLetter > 25) throw new (0, $2f33d7c6c1118ef1$export$4d0aacd3c8649e13)(`invalid language code: ${value}`);
        if (numBits % 2 === 1) throw new (0, $2f33d7c6c1118ef1$export$4d0aacd3c8649e13)(`numBits must be even, ${numBits} is not valid`);
        numBits = numBits / 2;
        const firstLetterBString = (0, $8e08330dc250a556$export$652ce6ae9d26cb14).encode(firstLetter, numBits);
        const secondLetterBString = (0, $8e08330dc250a556$export$652ce6ae9d26cb14).encode(secondLetter, numBits);
        return firstLetterBString + secondLetterBString;
    }
    static decode(value, numBits) {
        let retr;
        // is it an even number of bits? we have to divide it
        if (numBits === value.length && !(value.length % 2)) {
            const ASCII_START = 65;
            const mid = value.length / 2;
            const firstLetter = (0, $8e08330dc250a556$export$652ce6ae9d26cb14).decode(value.slice(0, mid), mid) + ASCII_START;
            const secondLetter = (0, $8e08330dc250a556$export$652ce6ae9d26cb14).decode(value.slice(mid), mid) + ASCII_START;
            retr = String.fromCharCode(firstLetter) + String.fromCharCode(secondLetter);
        } else throw new (0, $de2216fa542c1236$export$86630708b3dd13bd)("invalid bit length for language");
        return retr;
    }
}







class $98dff2f294be22a0$export$b8827fa22efe0b50 {
    static encode(prVector) {
        // start with the number of restrictions
        let bitString = (0, $8e08330dc250a556$export$652ce6ae9d26cb14).encode(prVector.numRestrictions, (0, $a29b574660309e88$export$391437f908389469).numRestrictions);
        // if the vector is empty we'll just return a string with just the numRestricitons being 0
        if (!prVector.isEmpty()) // create each restriction group
        prVector.getRestrictions().forEach((purpRestriction)=>{
            // every restriction group has the purposeId and the restrictionType;
            bitString += (0, $8e08330dc250a556$export$652ce6ae9d26cb14).encode(purpRestriction.purposeId, (0, $a29b574660309e88$export$391437f908389469).purposeId);
            bitString += (0, $8e08330dc250a556$export$652ce6ae9d26cb14).encode(purpRestriction.restrictionType, (0, $a29b574660309e88$export$391437f908389469).restrictionType);
            // now get all the vendors under that restriction
            const vendors = prVector.getVendors(purpRestriction);
            const len = vendors.length;
            /**
                 * numEntries comes first so we will have to keep a counter and the do
                 * the encoding at the end
                 */ let numEntries = 0;
            let startId = 0;
            let rangeField = "";
            for(let i = 0; i < len; i++){
                const vendorId = vendors[i];
                if (startId === 0) {
                    numEntries++;
                    startId = vendorId;
                }
                // we know that `len` is greater than zero because we entered the loop
                const lastVendorId = vendors[len - 1];
                const gvlVendorIds = prVector.gvl.vendorIds;
                const nextGvlVendor = (vendorId)=>{
                    while(++vendorId <= lastVendorId && !gvlVendorIds.has(vendorId));
                    return vendorId;
                };
                /**
                     * either end of the loop or there are GVL vendor IDs before the next one
                     */ if (i === len - 1 || vendors[i + 1] > nextGvlVendor(vendorId)) {
                    /**
                         * it's a range entry if we've got something other than the start
                         * ID
                         */ const isRange = !(vendorId === startId);
                    // 0 means single 1 means range
                    rangeField += (0, $95b4827e48a379bb$export$c480a1bdd5c67cac).encode(isRange);
                    rangeField += (0, $8e08330dc250a556$export$652ce6ae9d26cb14).encode(startId, (0, $a29b574660309e88$export$391437f908389469).vendorId);
                    if (isRange) rangeField += (0, $8e08330dc250a556$export$652ce6ae9d26cb14).encode(vendorId, (0, $a29b574660309e88$export$391437f908389469).vendorId);
                    // reset the startId so we grab the next id in the list
                    startId = 0;
                }
            }
            /**
                 * now that  the range encoding is built, encode the number of ranges
                 * and then append the range field to the bitString.
                 */ bitString += (0, $8e08330dc250a556$export$652ce6ae9d26cb14).encode(numEntries, (0, $a29b574660309e88$export$391437f908389469).numEntries);
            bitString += rangeField;
        });
        return bitString;
    }
    static decode(encodedString) {
        let index = 0;
        const vector = new (0, $0ff930ce4fd6f184$export$f0de1ae98060331)();
        const numRestrictions = (0, $8e08330dc250a556$export$652ce6ae9d26cb14).decode(encodedString.substr(index, (0, $a29b574660309e88$export$391437f908389469).numRestrictions), (0, $a29b574660309e88$export$391437f908389469).numRestrictions);
        index += (0, $a29b574660309e88$export$391437f908389469).numRestrictions;
        for(let i = 0; i < numRestrictions; i++){
            // First is purpose ID
            const purposeId = (0, $8e08330dc250a556$export$652ce6ae9d26cb14).decode(encodedString.substr(index, (0, $a29b574660309e88$export$391437f908389469).purposeId), (0, $a29b574660309e88$export$391437f908389469).purposeId);
            index += (0, $a29b574660309e88$export$391437f908389469).purposeId;
            // Second Restriction Type
            const restrictionType = (0, $8e08330dc250a556$export$652ce6ae9d26cb14).decode(encodedString.substr(index, (0, $a29b574660309e88$export$391437f908389469).restrictionType), (0, $a29b574660309e88$export$391437f908389469).restrictionType);
            index += (0, $a29b574660309e88$export$391437f908389469).restrictionType;
            const purposeRestriction = new (0, $3940e20a5fdb4400$export$d8a6104f5b3b3eb7)(purposeId, restrictionType);
            // Num Entries (number of vendors)
            const numEntries = (0, $8e08330dc250a556$export$652ce6ae9d26cb14).decode(encodedString.substr(index, (0, $a29b574660309e88$export$391437f908389469).numEntries), (0, $a29b574660309e88$export$391437f908389469).numEntries);
            index += (0, $a29b574660309e88$export$391437f908389469).numEntries;
            for(let j = 0; j < numEntries; j++){
                const isARange = (0, $95b4827e48a379bb$export$c480a1bdd5c67cac).decode(encodedString.substr(index, (0, $a29b574660309e88$export$391437f908389469).anyBoolean));
                index += (0, $a29b574660309e88$export$391437f908389469).anyBoolean;
                const startOrOnlyVendorId = (0, $8e08330dc250a556$export$652ce6ae9d26cb14).decode(encodedString.substr(index, (0, $a29b574660309e88$export$391437f908389469).vendorId), (0, $a29b574660309e88$export$391437f908389469).vendorId);
                index += (0, $a29b574660309e88$export$391437f908389469).vendorId;
                if (isARange) {
                    const endVendorId = (0, $8e08330dc250a556$export$652ce6ae9d26cb14).decode(encodedString.substr(index, (0, $a29b574660309e88$export$391437f908389469).vendorId), (0, $a29b574660309e88$export$391437f908389469).vendorId);
                    index += (0, $a29b574660309e88$export$391437f908389469).vendorId;
                    if (endVendorId < startOrOnlyVendorId) throw new (0, $de2216fa542c1236$export$86630708b3dd13bd)(`Invalid RangeEntry: endVendorId ${endVendorId} is less than ${startOrOnlyVendorId}`);
                    for(let k = startOrOnlyVendorId; k <= endVendorId; k++)vector.add(k, purposeRestriction);
                } else vector.add(startOrOnlyVendorId, purposeRestriction);
            }
        }
        vector.bitLength = index;
        return vector;
    }
}







var $b634c81447f80d4d$export$4207b65f4f98461a;
(function(VectorEncodingType) {
    VectorEncodingType[VectorEncodingType["FIELD"] = 0] = "FIELD";
    VectorEncodingType[VectorEncodingType["RANGE"] = 1] = "RANGE";
})($b634c81447f80d4d$export$4207b65f4f98461a || ($b634c81447f80d4d$export$4207b65f4f98461a = {}));



class $5077b4dc89beed18$export$8b37a2193faf4dea {
    static encode(value) {
        // collectors for range encoding
        const ranges = [];
        let range = [];
        // since both encodings need the maxId, start with that
        let retrString = (0, $8e08330dc250a556$export$652ce6ae9d26cb14).encode(value.maxId, (0, $a29b574660309e88$export$391437f908389469).maxId);
        // bit field will be just the vendors as we walk through the vector
        let bitField = "";
        let rangeIsSmaller;
        // some math
        const headerLength = (0, $a29b574660309e88$export$391437f908389469).maxId + (0, $a29b574660309e88$export$391437f908389469).encodingType;
        const bitFieldLength = headerLength + value.maxId;
        const minRangeLength = (0, $a29b574660309e88$export$391437f908389469).vendorId * 2 + (0, $a29b574660309e88$export$391437f908389469).singleOrRange + (0, $a29b574660309e88$export$391437f908389469).numEntries;
        // gets larger as we walk through the vector
        let rangeLength = headerLength + (0, $a29b574660309e88$export$391437f908389469).numEntries;
        // walk through every value in the vector
        value.forEach((curValue, i)=>{
            // build our bitfield no matter what
            bitField += (0, $95b4827e48a379bb$export$c480a1bdd5c67cac).encode(curValue);
            /**
             * A range is a minimum of 45 bits, if the number of vendors in this
             * vector is less than 45 then we know that a bitfield encoding will be
             * shorter than any range encoding.
             *
             * The second check checks while we walk through the vector and abandons
             * building the ranges once it becomes larger
             */ rangeIsSmaller = value.maxId > minRangeLength && rangeLength < bitFieldLength;
            /**
             * if the curValue is true and our rangeLength is less than the bitField
             * length, we'll continue to push these ranges into the array.  Once the
             * ranges become a larger encoding there is no reason to continue
             * building the structure because we will be choosing the bitfield
             * encoding
             */ if (rangeIsSmaller && curValue) {
                /**
                 * Look ahead to see if this is the last value in our range
                 */ const nextValue = value.has(i + 1);
                // if there isn't a next value, then we'll wrap up this range
                if (!nextValue) {
                    /**
                     * this is the last value of the range, so we'll push it on to the
                     * end into position 1
                     */ range.push(i);
                    // add to the range length the additional vendorId
                    rangeLength += (0, $a29b574660309e88$export$391437f908389469).vendorId;
                    // store the array in our bigger array
                    ranges.push(range);
                    // clear the array for the next range
                    range = [];
                } else if (range.length === 0) {
                    // this is the first  value for this range
                    range.push(i);
                    // update our count with new range overhead
                    rangeLength += (0, $a29b574660309e88$export$391437f908389469).singleOrRange;
                    rangeLength += (0, $a29b574660309e88$export$391437f908389469).vendorId;
                }
            }
        });
        if (rangeIsSmaller) {
            retrString += String((0, $b634c81447f80d4d$export$4207b65f4f98461a).RANGE);
            retrString += this.buildRangeEncoding(ranges);
        } else {
            retrString += String((0, $b634c81447f80d4d$export$4207b65f4f98461a).FIELD);
            retrString += bitField;
        }
        return retrString;
    }
    static decode(value, version) {
        let vector;
        let index = 0;
        const maxId = (0, $8e08330dc250a556$export$652ce6ae9d26cb14).decode(value.substr(index, (0, $a29b574660309e88$export$391437f908389469).maxId), (0, $a29b574660309e88$export$391437f908389469).maxId);
        index += (0, $a29b574660309e88$export$391437f908389469).maxId;
        const encodingType = (0, $8e08330dc250a556$export$652ce6ae9d26cb14).decode(value.charAt(index), (0, $a29b574660309e88$export$391437f908389469).encodingType);
        index += (0, $a29b574660309e88$export$391437f908389469).encodingType;
        /**
         * Range is handled in batches so we'll need a different decoding scheme
         */ if (encodingType === (0, $b634c81447f80d4d$export$4207b65f4f98461a).RANGE) {
            vector = new (0, $908c228bb5be525f$export$9b781de7bf37bf48)();
            if (version === 1) {
                if (value.substr(index, 1) === "1") throw new (0, $de2216fa542c1236$export$86630708b3dd13bd)("Unable to decode default consent=1");
                // jump over the default encoding
                index++;
            }
            const numEntries = (0, $8e08330dc250a556$export$652ce6ae9d26cb14).decode(value.substr(index, (0, $a29b574660309e88$export$391437f908389469).numEntries), (0, $a29b574660309e88$export$391437f908389469).numEntries);
            index += (0, $a29b574660309e88$export$391437f908389469).numEntries;
            // loop through each group of entries
            for(let i = 0; i < numEntries; i++){
                // Ranges can represent a single id or a range of ids.
                const isIdRange = (0, $95b4827e48a379bb$export$c480a1bdd5c67cac).decode(value.charAt(index));
                index += (0, $a29b574660309e88$export$391437f908389469).singleOrRange;
                /**
                 * regardless of whether or not it's a single entry or range, the next
                 * set of bits is a vendor ID
                 */ const firstId = (0, $8e08330dc250a556$export$652ce6ae9d26cb14).decode(value.substr(index, (0, $a29b574660309e88$export$391437f908389469).vendorId), (0, $a29b574660309e88$export$391437f908389469).vendorId);
                index += (0, $a29b574660309e88$export$391437f908389469).vendorId;
                // if it's a range, the next set of bits is the second id
                if (isIdRange) {
                    const secondId = (0, $8e08330dc250a556$export$652ce6ae9d26cb14).decode(value.substr(index, (0, $a29b574660309e88$export$391437f908389469).vendorId), (0, $a29b574660309e88$export$391437f908389469).vendorId);
                    index += (0, $a29b574660309e88$export$391437f908389469).vendorId;
                    // we'll need to set or unset all the vendor ids between the first and second
                    for(let j = firstId; j <= secondId; j++)vector.set(j);
                } else vector.set(firstId);
            }
        } else {
            const bitField = value.substr(index, maxId);
            index += maxId;
            vector = (0, $2dc93ee3b5ae8231$export$dcd4d91b6e09afa8).decode(bitField, maxId);
        }
        vector.bitLength = index;
        return vector;
    }
    static buildRangeEncoding(ranges) {
        // describe the number of entries to follow
        const numEntries = ranges.length;
        let rangeString = (0, $8e08330dc250a556$export$652ce6ae9d26cb14).encode(numEntries, (0, $a29b574660309e88$export$391437f908389469).numEntries);
        // each range
        ranges.forEach((range)=>{
            // is this range a single?
            const single = range.length === 1;
            // first is the indicator of whether this is a single id or range (two)
            // 0 is single and range is 1
            rangeString += (0, $95b4827e48a379bb$export$c480a1bdd5c67cac).encode(!single);
            // second is the first (or only) vendorId
            rangeString += (0, $8e08330dc250a556$export$652ce6ae9d26cb14).encode(range[0], (0, $a29b574660309e88$export$391437f908389469).vendorId);
            if (!single) // add the second id if it exists
            rangeString += (0, $8e08330dc250a556$export$652ce6ae9d26cb14).encode(range[1], (0, $a29b574660309e88$export$391437f908389469).vendorId);
        });
        return rangeString;
    }
}


function $ff6d6e5525854658$export$e9cc2a0da1cb9e6c() {
    return {
        [(0, $6618d4cef05f38ff$export$833b3e5a19fb8939).version]: (0, $8e08330dc250a556$export$652ce6ae9d26cb14),
        [(0, $6618d4cef05f38ff$export$833b3e5a19fb8939).created]: (0, $9099a2d983a3413b$export$be00a5c431c9e2be),
        [(0, $6618d4cef05f38ff$export$833b3e5a19fb8939).lastUpdated]: (0, $9099a2d983a3413b$export$be00a5c431c9e2be),
        [(0, $6618d4cef05f38ff$export$833b3e5a19fb8939).cmpId]: (0, $8e08330dc250a556$export$652ce6ae9d26cb14),
        [(0, $6618d4cef05f38ff$export$833b3e5a19fb8939).cmpVersion]: (0, $8e08330dc250a556$export$652ce6ae9d26cb14),
        [(0, $6618d4cef05f38ff$export$833b3e5a19fb8939).consentScreen]: (0, $8e08330dc250a556$export$652ce6ae9d26cb14),
        [(0, $6618d4cef05f38ff$export$833b3e5a19fb8939).consentLanguage]: (0, $6e5ca3a2f1bb6454$export$59ec574003c7c77a),
        [(0, $6618d4cef05f38ff$export$833b3e5a19fb8939).vendorListVersion]: (0, $8e08330dc250a556$export$652ce6ae9d26cb14),
        [(0, $6618d4cef05f38ff$export$833b3e5a19fb8939).policyVersion]: (0, $8e08330dc250a556$export$652ce6ae9d26cb14),
        [(0, $6618d4cef05f38ff$export$833b3e5a19fb8939).isServiceSpecific]: (0, $95b4827e48a379bb$export$c480a1bdd5c67cac),
        [(0, $6618d4cef05f38ff$export$833b3e5a19fb8939).useNonStandardStacks]: (0, $95b4827e48a379bb$export$c480a1bdd5c67cac),
        [(0, $6618d4cef05f38ff$export$833b3e5a19fb8939).specialFeatureOptins]: (0, $2dc93ee3b5ae8231$export$dcd4d91b6e09afa8),
        [(0, $6618d4cef05f38ff$export$833b3e5a19fb8939).purposeConsents]: (0, $2dc93ee3b5ae8231$export$dcd4d91b6e09afa8),
        [(0, $6618d4cef05f38ff$export$833b3e5a19fb8939).purposeLegitimateInterests]: (0, $2dc93ee3b5ae8231$export$dcd4d91b6e09afa8),
        [(0, $6618d4cef05f38ff$export$833b3e5a19fb8939).purposeOneTreatment]: (0, $95b4827e48a379bb$export$c480a1bdd5c67cac),
        [(0, $6618d4cef05f38ff$export$833b3e5a19fb8939).publisherCountryCode]: (0, $6e5ca3a2f1bb6454$export$59ec574003c7c77a),
        [(0, $6618d4cef05f38ff$export$833b3e5a19fb8939).vendorConsents]: (0, $5077b4dc89beed18$export$8b37a2193faf4dea),
        [(0, $6618d4cef05f38ff$export$833b3e5a19fb8939).vendorLegitimateInterests]: (0, $5077b4dc89beed18$export$8b37a2193faf4dea),
        [(0, $6618d4cef05f38ff$export$833b3e5a19fb8939).publisherRestrictions]: (0, $98dff2f294be22a0$export$b8827fa22efe0b50),
        segmentType: (0, $8e08330dc250a556$export$652ce6ae9d26cb14),
        [(0, $6618d4cef05f38ff$export$833b3e5a19fb8939).vendorsDisclosed]: (0, $5077b4dc89beed18$export$8b37a2193faf4dea),
        [(0, $6618d4cef05f38ff$export$833b3e5a19fb8939).vendorsAllowed]: (0, $5077b4dc89beed18$export$8b37a2193faf4dea),
        [(0, $6618d4cef05f38ff$export$833b3e5a19fb8939).publisherConsents]: (0, $2dc93ee3b5ae8231$export$dcd4d91b6e09afa8),
        [(0, $6618d4cef05f38ff$export$833b3e5a19fb8939).publisherLegitimateInterests]: (0, $2dc93ee3b5ae8231$export$dcd4d91b6e09afa8),
        [(0, $6618d4cef05f38ff$export$833b3e5a19fb8939).numCustomPurposes]: (0, $8e08330dc250a556$export$652ce6ae9d26cb14),
        [(0, $6618d4cef05f38ff$export$833b3e5a19fb8939).publisherCustomConsents]: (0, $2dc93ee3b5ae8231$export$dcd4d91b6e09afa8),
        [(0, $6618d4cef05f38ff$export$833b3e5a19fb8939).publisherCustomLegitimateInterests]: (0, $2dc93ee3b5ae8231$export$dcd4d91b6e09afa8)
    };
}










// created from 'create-ts-index'

class $d7d1065296c83338$export$54e544094d345e66 {
    "1" = {
        [(0, $36d6995c8c6f3891$export$d53aa5c5ab432700).CORE]: [
            (0, $6618d4cef05f38ff$export$833b3e5a19fb8939).version,
            (0, $6618d4cef05f38ff$export$833b3e5a19fb8939).created,
            (0, $6618d4cef05f38ff$export$833b3e5a19fb8939).lastUpdated,
            (0, $6618d4cef05f38ff$export$833b3e5a19fb8939).cmpId,
            (0, $6618d4cef05f38ff$export$833b3e5a19fb8939).cmpVersion,
            (0, $6618d4cef05f38ff$export$833b3e5a19fb8939).consentScreen,
            (0, $6618d4cef05f38ff$export$833b3e5a19fb8939).consentLanguage,
            (0, $6618d4cef05f38ff$export$833b3e5a19fb8939).vendorListVersion,
            (0, $6618d4cef05f38ff$export$833b3e5a19fb8939).purposeConsents,
            (0, $6618d4cef05f38ff$export$833b3e5a19fb8939).vendorConsents
        ]
    };
    "2" = {
        [(0, $36d6995c8c6f3891$export$d53aa5c5ab432700).CORE]: [
            (0, $6618d4cef05f38ff$export$833b3e5a19fb8939).version,
            (0, $6618d4cef05f38ff$export$833b3e5a19fb8939).created,
            (0, $6618d4cef05f38ff$export$833b3e5a19fb8939).lastUpdated,
            (0, $6618d4cef05f38ff$export$833b3e5a19fb8939).cmpId,
            (0, $6618d4cef05f38ff$export$833b3e5a19fb8939).cmpVersion,
            (0, $6618d4cef05f38ff$export$833b3e5a19fb8939).consentScreen,
            (0, $6618d4cef05f38ff$export$833b3e5a19fb8939).consentLanguage,
            (0, $6618d4cef05f38ff$export$833b3e5a19fb8939).vendorListVersion,
            (0, $6618d4cef05f38ff$export$833b3e5a19fb8939).policyVersion,
            (0, $6618d4cef05f38ff$export$833b3e5a19fb8939).isServiceSpecific,
            (0, $6618d4cef05f38ff$export$833b3e5a19fb8939).useNonStandardStacks,
            (0, $6618d4cef05f38ff$export$833b3e5a19fb8939).specialFeatureOptins,
            (0, $6618d4cef05f38ff$export$833b3e5a19fb8939).purposeConsents,
            (0, $6618d4cef05f38ff$export$833b3e5a19fb8939).purposeLegitimateInterests,
            (0, $6618d4cef05f38ff$export$833b3e5a19fb8939).purposeOneTreatment,
            (0, $6618d4cef05f38ff$export$833b3e5a19fb8939).publisherCountryCode,
            (0, $6618d4cef05f38ff$export$833b3e5a19fb8939).vendorConsents,
            (0, $6618d4cef05f38ff$export$833b3e5a19fb8939).vendorLegitimateInterests,
            (0, $6618d4cef05f38ff$export$833b3e5a19fb8939).publisherRestrictions
        ],
        [(0, $36d6995c8c6f3891$export$d53aa5c5ab432700).PUBLISHER_TC]: [
            (0, $6618d4cef05f38ff$export$833b3e5a19fb8939).publisherConsents,
            (0, $6618d4cef05f38ff$export$833b3e5a19fb8939).publisherLegitimateInterests,
            (0, $6618d4cef05f38ff$export$833b3e5a19fb8939).numCustomPurposes,
            (0, $6618d4cef05f38ff$export$833b3e5a19fb8939).publisherCustomConsents,
            (0, $6618d4cef05f38ff$export$833b3e5a19fb8939).publisherCustomLegitimateInterests
        ],
        [(0, $36d6995c8c6f3891$export$d53aa5c5ab432700).VENDORS_ALLOWED]: [
            (0, $6618d4cef05f38ff$export$833b3e5a19fb8939).vendorsAllowed
        ],
        [(0, $36d6995c8c6f3891$export$d53aa5c5ab432700).VENDORS_DISCLOSED]: [
            (0, $6618d4cef05f38ff$export$833b3e5a19fb8939).vendorsDisclosed
        ]
    };
}



class $e0290ed542a4d980$export$b6961ee31e192e0 {
    "1" = [
        (0, $36d6995c8c6f3891$export$d53aa5c5ab432700).CORE
    ];
    "2" = [
        (0, $36d6995c8c6f3891$export$d53aa5c5ab432700).CORE
    ];
    constructor(tcModel, options){
        if (tcModel.version === 2) {
            if (tcModel.isServiceSpecific) /**
                 * If it's service specific only, then the publisher TC String can be
                 * stored in the cookie and would be transmitted if it's not for
                 * storage.  So it's included regardless of whether or not it's for
                 * saving or the cmp api to surface.
                 */ this["2"].push((0, $36d6995c8c6f3891$export$d53aa5c5ab432700).PUBLISHER_TC);
            else {
                const isForVendors = !!(options && options.isForVendors);
                /**
                 * including vendors disclosed only if it is for saving (to the global
                 * scope and not for vendors through the CMP API) or supportOOB is
                 * turned on (either or both).  The compliment of this being not for
                 * saving (surfaced to CMP) and no support of OOB.
                 */ if (!isForVendors || tcModel[(0, $6618d4cef05f38ff$export$833b3e5a19fb8939).supportOOB] === true) this["2"].push((0, $36d6995c8c6f3891$export$d53aa5c5ab432700).VENDORS_DISCLOSED);
                if (isForVendors) {
                    /**
                     * If a publisher does support OOB and they have narrowed the allowed
                     * vendors to utilize it, then we should include the vendors allowed
                     * segment.  If it is empty then there are no restrictions, if that
                     * is intended to mean no support for OOB, then the flag should be
                     * set for that instead.
                     *
                     */ if (tcModel[(0, $6618d4cef05f38ff$export$833b3e5a19fb8939).supportOOB] && tcModel[(0, $6618d4cef05f38ff$export$833b3e5a19fb8939).vendorsAllowed].size > 0) this["2"].push((0, $36d6995c8c6f3891$export$d53aa5c5ab432700).VENDORS_ALLOWED);
                    /**
                     * Always include the publisher TC segment as long as this TC string
                     * is not intended to be saved in the global scope.
                     */ this["2"].push((0, $36d6995c8c6f3891$export$d53aa5c5ab432700).PUBLISHER_TC);
                }
            }
        }
    }
}









class $23e4abe6592ced17$export$fa5ec974bf69adda {
    static fieldSequence = new (0, $d7d1065296c83338$export$54e544094d345e66)();
    static encode(tcModel, segment) {
        let sequence;
        try {
            sequence = this.fieldSequence[String(tcModel.version)][segment];
        } catch (err) {
            throw new (0, $2f33d7c6c1118ef1$export$4d0aacd3c8649e13)(`Unable to encode version: ${tcModel.version}, segment: ${segment}`);
        }
        let bitField = "";
        /**
         * If this is anything other than the core segment we have a "segment id"
         * to append to the front of the string
         */ if (segment !== (0, $36d6995c8c6f3891$export$d53aa5c5ab432700).CORE) bitField = (0, $8e08330dc250a556$export$652ce6ae9d26cb14).encode((0, $ea2b59a0eb08e264$export$a7590c36d83c4992).KEY_TO_ID[segment], (0, $a29b574660309e88$export$391437f908389469).segmentType);
        const fieldEncoderMap = (0, $ff6d6e5525854658$export$e9cc2a0da1cb9e6c)();
        sequence.forEach((key)=>{
            const value = tcModel[key];
            const encoder = fieldEncoderMap[key];
            let numBits = (0, $a29b574660309e88$export$391437f908389469)[key];
            if (numBits === undefined) {
                if (this.isPublisherCustom(key)) /**
                     * publisherCustom[Consents | LegitimateInterests] are an edge case
                     * because they are of variable length. The length is defined in a
                     * separate field named numCustomPurposes.
                     */ numBits = Number(tcModel[(0, $6618d4cef05f38ff$export$833b3e5a19fb8939).numCustomPurposes]);
            }
            try {
                bitField += encoder.encode(value, numBits);
            } catch (err) {
                throw new (0, $2f33d7c6c1118ef1$export$4d0aacd3c8649e13)(`Error encoding ${segment}->${key}: ${err.message}`);
            }
        });
        // base64url encode the string and return
        return (0, $3bc4d6646eacc1d5$export$bad7b18cc08bb8a3).encode(bitField);
    }
    static decode(encodedString, tcModel, segment) {
        const bitField = (0, $3bc4d6646eacc1d5$export$bad7b18cc08bb8a3).decode(encodedString);
        let bStringIdx = 0;
        if (segment === (0, $36d6995c8c6f3891$export$d53aa5c5ab432700).CORE) tcModel.version = (0, $8e08330dc250a556$export$652ce6ae9d26cb14).decode(bitField.substr(bStringIdx, (0, $a29b574660309e88$export$391437f908389469)[(0, $6618d4cef05f38ff$export$833b3e5a19fb8939).version]), (0, $a29b574660309e88$export$391437f908389469)[(0, $6618d4cef05f38ff$export$833b3e5a19fb8939).version]);
        if (segment !== (0, $36d6995c8c6f3891$export$d53aa5c5ab432700).CORE) bStringIdx += (0, $a29b574660309e88$export$391437f908389469).segmentType;
        const sequence = this.fieldSequence[String(tcModel.version)][segment];
        const fieldEncoderMap = (0, $ff6d6e5525854658$export$e9cc2a0da1cb9e6c)();
        sequence.forEach((key)=>{
            const encoder = fieldEncoderMap[key];
            let numBits = (0, $a29b574660309e88$export$391437f908389469)[key];
            if (numBits === undefined) {
                if (this.isPublisherCustom(key)) /**
                     * publisherCustom[Consents | LegitimateInterests] are an edge case
                     * because they are of variable length. The length is defined in a
                     * separate field named numCustomPurposes.
                     */ numBits = Number(tcModel[(0, $6618d4cef05f38ff$export$833b3e5a19fb8939).numCustomPurposes]);
            }
            if (numBits !== 0) {
                /**
                 * numBits could be 0 if this is a publisher custom purposes field and
                 * no custom purposes are defined. If that is the case, we don't need
                 * to gather no bits and we don't need to increment our bStringIdx
                 * pointer because those would all be 0 increments and would mess up
                 * the next logical if statement.
                 */ const bits = bitField.substr(bStringIdx, numBits);
                if (encoder === (0, $5077b4dc89beed18$export$8b37a2193faf4dea)) tcModel[key] = encoder.decode(bits, tcModel.version);
                else tcModel[key] = encoder.decode(bits, numBits);
                if (Number.isInteger(numBits)) bStringIdx += numBits;
                else if (Number.isInteger(tcModel[key].bitLength)) bStringIdx += tcModel[key].bitLength;
                else throw new (0, $de2216fa542c1236$export$86630708b3dd13bd)(key);
            }
        });
        return tcModel;
    }
    static isPublisherCustom(key) {
        return key.indexOf("publisherCustom") === 0;
    }
}




class $05880e4772fc5ff4$export$b176d473004a672c {
    static processor = [
        (tcModel)=>tcModel,
        (tcModel, gvl)=>{
            /**
             * in case this wasn't set previously.  This should filter out invalid
             * purpose restrictions.
             */ tcModel.publisherRestrictions.gvl = gvl;
            /**
             * Purpose 1 is never allowed to be true for legitimate interest
             */ tcModel.purposeLegitimateInterests.unset(1);
            /**
             * If a Vendor does not declare a purpose for consent or legitimate
             * interest they should not have a positive signal for it. This code
             * removes positive signals created mistakingly.
             */ const vectorToIntMap = new Map();
            vectorToIntMap.set("legIntPurposes", tcModel.vendorLegitimateInterests);
            vectorToIntMap.set("purposes", tcModel.vendorConsents);
            vectorToIntMap.forEach((vector, gvlVendorKey)=>{
                vector.forEach((value, vendorId)=>{
                    if (value) {
                        const vendor = gvl.vendors[vendorId];
                        if (!vendor || vendor.deletedDate) /**
                             * If the vendor doesn't exist, then they should not receive a
                             * positive signal
                             */ vector.unset(vendorId);
                        else if (vendor[gvlVendorKey].length === 0) {
                            if (gvlVendorKey === "legIntPurposes" && vendor["purposes"].length === 0 && vendor["legIntPurposes"].length === 0 && vendor["specialPurposes"].length > 0) ;
                            else /**
                                 * If the vendor does exist, but they haven't declared any
                                 * purposes for this legal basis, then we need to see if they can
                                 * possibly have the legal basis from their flexible purposes.
                                 */ if (tcModel.isServiceSpecific) {
                                if (vendor.flexiblePurposes.length === 0) /**
                                         * No flexible basis for any purposes, so we can safely remove
                                         * this vendor from the legal basis.
                                         */ vector.unset(vendorId);
                                else {
                                    /**
                                         * They have some flexible purposes, we should check for a
                                         * publisher restriction value that would enable this vendor to
                                         * have the override-preferred basis.
                                         */ const restrictions = tcModel.publisherRestrictions.getRestrictions(vendorId);
                                    let isValid = false;
                                    for(let i = 0, len = restrictions.length; i < len && !isValid; i++)/**
                                             * If this condition is true the loop will break.  If we are
                                             * dealing with the consent purposes ('purposes') and the
                                             * publisher restriction overrides to consent then it is
                                             * valid for the vendor to have a positive signal for
                                             * consent.  Likewise for legitimate interest purposes
                                             * ('legIntPurposes') and requiring legitimate interest.
                                             */ isValid = restrictions[i].restrictionType === (0, $e3e388fdc6670e56$export$c74010cd6874a9d0).REQUIRE_CONSENT && gvlVendorKey === "purposes" || restrictions[i].restrictionType === (0, $e3e388fdc6670e56$export$c74010cd6874a9d0).REQUIRE_LI && gvlVendorKey === "legIntPurposes";
                                    if (!isValid) /**
                                             * if we came through the previous  loop without finding a
                                             * valid reasing: no overriding restrictions (changes in
                                             * legal basis) then it's not valid for this vendor to have
                                             * this legal basis.
                                             */ vector.unset(vendorId);
                                }
                            } else /**
                                     * This is a globally-scoped string so flexible purposes will not
                                     * be able to change this value because purposeRestrictions only
                                     * apply to service-specific strings.
                                     */ vector.unset(vendorId);
                        }
                    }
                });
            });
            tcModel.vendorsDisclosed.set(gvl.vendors);
            return tcModel;
        }
    ];
    static process(tcModel, options) {
        const gvl = tcModel.gvl;
        if (!gvl) throw new (0, $2f33d7c6c1118ef1$export$4d0aacd3c8649e13)("Unable to encode TCModel without a GVL");
        if (!gvl.isReady) throw new (0, $2f33d7c6c1118ef1$export$4d0aacd3c8649e13)("Unable to encode TCModel tcModel.gvl.readyPromise is not resolved");
        tcModel = tcModel.clone();
        tcModel.consentLanguage = gvl.language.toUpperCase();
        if (options?.version > 0 && options?.version <= this.processor.length) tcModel.version = options.version;
        else /**
             * this is equal to the latest or most current version
             */ tcModel.version = this.processor.length;
        const processorFunctionIndex = tcModel.version - 1;
        if (!this.processor[processorFunctionIndex]) throw new (0, $2f33d7c6c1118ef1$export$4d0aacd3c8649e13)(`Invalid version: ${tcModel.version}`);
        return this.processor[processorFunctionIndex](tcModel, gvl);
    }
}











class $a28103e4c108656a$export$48880ac635f47186 {
    static absCall(url, body, sendCookies, timeout) {
        return new Promise((resolve, reject)=>{
            const req = new XMLHttpRequest();
            const onLoad = ()=>{
                // is the response done
                if (req.readyState == XMLHttpRequest.DONE) {
                    /**
                     * For our purposes if it's not a 200 range response, then it's a
                     * failure.
                     */ if (req.status >= 200 && req.status < 300) {
                        let response = req.response;
                        if (typeof response === "string") try {
                            response = JSON.parse(response);
                        } catch (e) {}
                        resolve(response);
                    } else reject(new Error(`HTTP Status: ${req.status} response type: ${req.responseType}`));
                }
            };
            const onError = ()=>{
                reject(new Error("error"));
            };
            const onAbort = ()=>{
                reject(new Error("aborted"));
            };
            const onTimeout = ()=>{
                reject(new Error("Timeout " + timeout + "ms " + url));
            };
            req.withCredentials = sendCookies;
            req.addEventListener("load", onLoad);
            req.addEventListener("error", onError);
            req.addEventListener("abort", onAbort);
            if (body === null) req.open("GET", url, true);
            else req.open("POST", url, true);
            req.responseType = "json";
            // IE has a problem if this is before the open
            req.timeout = timeout;
            req.ontimeout = onTimeout;
            req.send(body);
        });
    }
    /**
     * @static
     * @param {string} url - full path to POST to
     * @param {object} body - JSON object to post
     * @param {boolean} sendCookies - Whether or not to send the XMLHttpRequest with credentials or not
     * @param {number} [timeout] - optional timeout in milliseconds
     * @return {Promise<object>} - if the server responds the response will be returned here
     */ static post(url, body, sendCookies = false, timeout = 0) {
        return this.absCall(url, JSON.stringify(body), sendCookies, timeout);
    }
    /**
     * @static
     * @param {string} url - full path to the json
     * @param {boolean} sendCookies - Whether or not to send the XMLHttpRequest with credentials or not
     * @param {number} [timeout] - optional timeout in milliseconds
     * @return {Promise<object>} - resolves with parsed JSON
     */ static fetch(url, sendCookies = false, timeout = 0) {
        return this.absCall(url, null, sendCookies, timeout);
    }
}



class $b330330a857276b4$export$839e4e368d076bb1 extends (0, $3867cebb1f83913e$export$a17144d9403e9d84) {
    static LANGUAGE_CACHE = new Map();
    static CACHE = new Map();
    static LATEST_CACHE_KEY = 0;
    static DEFAULT_LANGUAGE = "EN";
    /**
     * Set of available consent languages published by the IAB
     */ static consentLanguages = new (0, $c8e1695ef6ed80b9$export$1c7a19f2c7470871)();
    static baseUrl_;
    /**
     * baseUrl - Entities using the vendor-list.json are required by the iab to
     * host their own copy of it to reduce the load on the iab's infrastructure
     * so a 'base' url must be set to be put together with the versioning scheme
     * of the filenames.
     *
     * @static
     * @param {string} url - the base url to load the vendor-list.json from.  This is
     * broken out from the filename because it follows a different scheme for
     * latest file vs versioned files.
     *
     * @throws {GVLError} - If the url is http[s]://vendorlist.consensu.org/...
     * this will throw an error.  IAB Europe requires that that CMPs and Vendors
     * cache their own copies of the GVL to minimize load on their
     * infrastructure.  For more information regarding caching of the
     * vendor-list.json, please see [the TCF documentation on 'Caching the Global
     * Vendor List'
     * ](https://github.com/InteractiveAdvertisingBureau/GDPR-Transparency-and-Consent-Framework/blob/master/TCFv2/IAB%20Tech%20Lab%20-%20Consent%20string%20and%20vendor%20list%20formats%20v2.md#caching-the-global-vendor-list)
     */ static set baseUrl(url) {
        const notValid = /^https?:\/\/vendorlist\.consensu\.org\//;
        if (notValid.test(url)) throw new (0, $8655c96636a60690$export$cfebf68bd7a6a21)("Invalid baseUrl!  You may not pull directly from vendorlist.consensu.org and must provide your own cache");
        // if a trailing slash was forgotten
        if (url.length > 0 && url[url.length - 1] !== "/") url += "/";
        this.baseUrl_ = url;
    }
    /**
     * baseUrl - Entities using the vendor-list.json are required by the iab to
     * host their own copy of it to reduce the load on the iab's infrastructure
     * so a 'base' url must be set to be put together with the versioning scheme
     * of the filenames.
     *
     * @static
     * @return {string} - returns the previously set baseUrl, the default is
     * `undefined`
     */ static get baseUrl() {
        return this.baseUrl_;
    }
    /**
     * @static
     * @param {string} - the latest is assumed to be vendor-list.json because
     * that is what the iab uses, but it could be different... if you want
     */ static latestFilename = "vendor-list.json";
    /**
     * @static
     * @param {string} - the versioned name is assumed to be
     * vendor-list-v[VERSION].json where [VERSION] will be replaced with the
     * specified version.  But it could be different... if you want just make
     * sure to include the [VERSION] macro if you have a numbering scheme, it's a
     * simple string substitution.
     *
     * eg.
     * ```javascript
     * GVL.baseUrl = "http://www.mydomain.com/iabcmp/";
     * GVL.versionedFilename = "vendorlist?getVersion=[VERSION]";
     * ```
     */ static versionedFilename = "archives/vendor-list-v[VERSION].json";
    /**
     * @param {string} - Translations of the names and descriptions for Purposes,
     * Special Purposes, Features, and Special Features to non-English languages
     * are contained in a file where attributes containing English content
     * (except vendor declaration information) are translated.  The iab publishes
     * one following the scheme below where the LANG is the iso639-1 language
     * code.  For a list of available translations
     * [please go here](https://register.consensu.org/Translation).
     *
     * eg.
     * ```javascript
     * GVL.baseUrl = "http://www.mydomain.com/iabcmp/";
     * GVL.languageFilename = "purposes?getPurposes=[LANG]";
     * ```
     */ static languageFilename = "purposes-[LANG].json";
    /**
     * @param {Promise} resolved when this GVL object is populated with the data
     * or rejected if there is an error.
     */ readyPromise;
    /**
     * @param {number} gvlSpecificationVersion - schema version for the GVL that is used
     */ gvlSpecificationVersion;
    /**
     * @param {number} incremented with each published file change
     */ vendorListVersion;
    /**
     * @param {number} tcfPolicyVersion - The TCF MO will increment this value
     * whenever a GVL change (such as adding a new Purpose or Feature or a change
     * in Purpose wording) legally invalidates existing TC Strings and requires
     * CMPs to re-establish transparency and consent from users. If the policy
     * version number in the latest GVL is different from the value in your TC
     * String, then you need to re-establish transparency and consent for that
     * user. A version 1 format TC String is considered to have a version value
     * of 1.
     */ tcfPolicyVersion;
    /**
     * @param {string | Date} lastUpdated - the date in which the vendor list
     * json file  was last updated.
     */ lastUpdated;
    /**
     * @param {IntMap<Purpose>} a collection of [[Purpose]]s
     */ purposes;
    /**
     * @param {IntMap<Purpose>} a collection of [[Purpose]]s
     */ specialPurposes;
    /**
     * @param {IntMap<Feature>} a collection of [[Feature]]s
     */ features;
    /**
     * @param {IntMap<Feature>} a collection of [[Feature]]s
     */ specialFeatures;
    /**
     * @param {boolean} internal reference of when the GVL is ready to be used
     */ isReady_ = false;
    /**
     * @param {IntMap<Vendor>} a collection of [[Vendor]]s
     */ vendors_;
    vendorIds;
    /**
     * @param {IntMap<Vendor>} a collection of [[Vendor]]. Used as a backup if a whitelist is sets
     */ fullVendorList;
    /**
     * @param {ByPurposeVendorMap} vendors by purpose
     */ byPurposeVendorMap;
    /**
     * @param {IDSetMap} vendors by special purpose
     */ bySpecialPurposeVendorMap;
    /**
     * @param {IDSetMap} vendors by feature
     */ byFeatureVendorMap;
    /**
     * @param {IDSetMap} vendors by special feature
     */ bySpecialFeatureVendorMap;
    /**
     * @param {IntMap<Stack>} a collection of [[Stack]]s
     */ stacks;
    lang_;
    isLatest = false;
    /**
     * @param {VersionOrVendorList} [versionOrVendorList] - can be either a
     * [[VendorList]] object or a version number represented as a string or
     * number to download.  If nothing is passed the latest version of the GVL
     * will be loaded
     */ constructor(versionOrVendorList){
        super();
        /**
         * should have been configured before and instance was created and will
         * persist through the app
         */ let url = $b330330a857276b4$export$839e4e368d076bb1.baseUrl;
        this.lang_ = $b330330a857276b4$export$839e4e368d076bb1.DEFAULT_LANGUAGE;
        if (this.isVendorList(versionOrVendorList)) {
            this.populate(versionOrVendorList);
            this.readyPromise = Promise.resolve();
        } else {
            if (!url) throw new (0, $8655c96636a60690$export$cfebf68bd7a6a21)("must specify GVL.baseUrl before loading GVL json");
            if (versionOrVendorList > 0) {
                const version = versionOrVendorList;
                if ($b330330a857276b4$export$839e4e368d076bb1.CACHE.has(version)) {
                    this.populate($b330330a857276b4$export$839e4e368d076bb1.CACHE.get(version));
                    this.readyPromise = Promise.resolve();
                } else {
                    // load version specified
                    url += $b330330a857276b4$export$839e4e368d076bb1.versionedFilename.replace("[VERSION]", String(version));
                    this.readyPromise = this.fetchJson(url);
                }
            } else /**
                 * whatever it is (or isn't)... it doesn't matter we'll just get the
                 * latest. In this case we may have cached the latest version at key 0.
                 * If we have then we'll just use that instead of making a request.
                 * Otherwise we'll have to load it (and then we'll cache it for next
                 * time)
                 */ if ($b330330a857276b4$export$839e4e368d076bb1.CACHE.has($b330330a857276b4$export$839e4e368d076bb1.LATEST_CACHE_KEY)) {
                this.populate($b330330a857276b4$export$839e4e368d076bb1.CACHE.get($b330330a857276b4$export$839e4e368d076bb1.LATEST_CACHE_KEY));
                this.readyPromise = Promise.resolve();
            } else {
                this.isLatest = true;
                this.readyPromise = this.fetchJson(url + $b330330a857276b4$export$839e4e368d076bb1.latestFilename);
            }
        }
    }
    /**
     * emptyLanguageCache
     *
     * @param {string} [lang] - Optional ISO 639-1 langauge code to remove from
     * the cache.  Should be one of the languages in GVL.consentLanguages set.
     * If not then the whole cache will be deleted.
     * @return {boolean} - true if anything was deleted from the cache
     */ static emptyLanguageCache(lang) {
        let retr = false;
        if (lang === undefined && $b330330a857276b4$export$839e4e368d076bb1.LANGUAGE_CACHE.size > 0) {
            $b330330a857276b4$export$839e4e368d076bb1.LANGUAGE_CACHE = new Map();
            retr = true;
        } else if (typeof lang === "string" && this.consentLanguages.has(lang.toUpperCase())) {
            $b330330a857276b4$export$839e4e368d076bb1.LANGUAGE_CACHE.delete(lang.toUpperCase());
            retr = true;
        }
        return retr;
    }
    /**
     * emptyCache
     *
     * @param {number} [vendorListVersion] - version of the vendor list to delete
     * from the cache.  If none is specified then the whole cache is deleted.
     * @return {boolean} - true if anything was deleted from the cache
     */ static emptyCache(vendorListVersion) {
        let retr = false;
        if (Number.isInteger(vendorListVersion) && vendorListVersion >= 0) {
            $b330330a857276b4$export$839e4e368d076bb1.CACHE.delete(vendorListVersion);
            retr = true;
        } else if (vendorListVersion === undefined) {
            $b330330a857276b4$export$839e4e368d076bb1.CACHE = new Map();
            retr = true;
        }
        return retr;
    }
    cacheLanguage() {
        if (!$b330330a857276b4$export$839e4e368d076bb1.LANGUAGE_CACHE.has(this.lang_)) $b330330a857276b4$export$839e4e368d076bb1.LANGUAGE_CACHE.set(this.lang_, {
            purposes: this.purposes,
            specialPurposes: this.specialPurposes,
            features: this.features,
            specialFeatures: this.specialFeatures,
            stacks: this.stacks
        });
    }
    async fetchJson(url) {
        try {
            this.populate(await (0, $a28103e4c108656a$export$48880ac635f47186).fetch(url));
        } catch (err) {
            throw new (0, $8655c96636a60690$export$cfebf68bd7a6a21)(err.message);
        }
    }
    /**
     * getJson - Method for getting the JSON that was downloaded to created this
     * `GVL` object
     *
     * @return {VendorList} - The basic JSON structure without the extra
     * functionality and methods of this class.
     */ getJson() {
        return JSON.parse(JSON.stringify({
            gvlSpecificationVersion: this.gvlSpecificationVersion,
            vendorListVersion: this.vendorListVersion,
            tcfPolicyVersion: this.tcfPolicyVersion,
            lastUpdated: this.lastUpdated,
            purposes: this.purposes,
            specialPurposes: this.specialPurposes,
            features: this.features,
            specialFeatures: this.specialFeatures,
            stacks: this.stacks,
            vendors: this.fullVendorList
        }));
    }
    /**
     * changeLanguage - retrieves the purpose language translation and sets the
     * internal language variable
     *
     * @param {string} lang - ISO 639-1 langauge code to change language to
     * @return {Promise<void | GVLError>} - returns the `readyPromise` and
     * resolves when this GVL is populated with the data from the language file.
     */ async changeLanguage(lang) {
        const langUpper = lang.toUpperCase();
        if ($b330330a857276b4$export$839e4e368d076bb1.consentLanguages.has(langUpper)) {
            if (langUpper !== this.lang_) {
                this.lang_ = langUpper;
                if ($b330330a857276b4$export$839e4e368d076bb1.LANGUAGE_CACHE.has(langUpper)) {
                    const cached = $b330330a857276b4$export$839e4e368d076bb1.LANGUAGE_CACHE.get(langUpper);
                    for(const prop in cached)if (cached.hasOwnProperty(prop)) this[prop] = cached[prop];
                } else {
                    // load Language specified
                    const url = $b330330a857276b4$export$839e4e368d076bb1.baseUrl + $b330330a857276b4$export$839e4e368d076bb1.languageFilename.replace("[LANG]", lang);
                    try {
                        await this.fetchJson(url);
                        this.cacheLanguage();
                    } catch (err) {
                        throw new (0, $8655c96636a60690$export$cfebf68bd7a6a21)("unable to load language: " + err.message);
                    }
                }
            }
        } else throw new (0, $8655c96636a60690$export$cfebf68bd7a6a21)(`unsupported language ${lang}`);
    }
    get language() {
        return this.lang_;
    }
    isVendorList(gvlObject) {
        return gvlObject !== undefined && gvlObject.vendors !== undefined;
    }
    populate(gvlObject) {
        /**
         * these are populated regardless of whether it's a Declarations file or
         * a VendorList
         */ this.purposes = gvlObject.purposes;
        this.specialPurposes = gvlObject.specialPurposes;
        this.features = gvlObject.features;
        this.specialFeatures = gvlObject.specialFeatures;
        this.stacks = gvlObject.stacks;
        if (this.isVendorList(gvlObject)) {
            this.gvlSpecificationVersion = gvlObject.gvlSpecificationVersion;
            this.tcfPolicyVersion = gvlObject.tcfPolicyVersion;
            this.vendorListVersion = gvlObject.vendorListVersion;
            this.lastUpdated = gvlObject.lastUpdated;
            if (typeof this.lastUpdated === "string") this.lastUpdated = new Date(this.lastUpdated);
            this.vendors_ = gvlObject.vendors;
            this.fullVendorList = gvlObject.vendors;
            this.mapVendors();
            this.isReady_ = true;
            if (this.isLatest) /**
                 * If the "LATEST" was requested then this flag will be set to true.
                 * In that case we'll cache the GVL at the special key
                 */ $b330330a857276b4$export$839e4e368d076bb1.CACHE.set($b330330a857276b4$export$839e4e368d076bb1.LATEST_CACHE_KEY, this.getJson());
            /**
             * Whether or not it's the "LATEST" we'll cache the gvl at the version it
             * is declared to be (if it's not already). to avoid downloading it again
             * in the future.
             */ if (!$b330330a857276b4$export$839e4e368d076bb1.CACHE.has(this.vendorListVersion)) $b330330a857276b4$export$839e4e368d076bb1.CACHE.set(this.vendorListVersion, this.getJson());
        }
        this.cacheLanguage();
    }
    mapVendors(vendorIds) {
        // create new instances of the maps
        this.byPurposeVendorMap = {};
        this.bySpecialPurposeVendorMap = {};
        this.byFeatureVendorMap = {};
        this.bySpecialFeatureVendorMap = {};
        // initializes data structure for purpose map
        Object.keys(this.purposes).forEach((purposeId)=>{
            this.byPurposeVendorMap[purposeId] = {
                legInt: new Set(),
                consent: new Set(),
                flexible: new Set()
            };
        });
        // initializes data structure for special purpose map
        Object.keys(this.specialPurposes).forEach((purposeId)=>{
            this.bySpecialPurposeVendorMap[purposeId] = new Set();
        });
        // initializes data structure for feature map
        Object.keys(this.features).forEach((featureId)=>{
            this.byFeatureVendorMap[featureId] = new Set();
        });
        // initializes data structure for feature map
        Object.keys(this.specialFeatures).forEach((featureId)=>{
            this.bySpecialFeatureVendorMap[featureId] = new Set();
        });
        if (!Array.isArray(vendorIds)) vendorIds = Object.keys(this.fullVendorList).map((vId)=>+vId);
        this.vendorIds = new Set(vendorIds);
        // assigns vendor ids to their respective maps
        this.vendors_ = vendorIds.reduce((vendors, vendorId)=>{
            const vendor = this.vendors_[String(vendorId)];
            if (vendor && vendor.deletedDate === undefined) {
                vendor.purposes.forEach((purposeId)=>{
                    const purpGroup = this.byPurposeVendorMap[String(purposeId)];
                    purpGroup.consent.add(vendorId);
                });
                vendor.specialPurposes.forEach((purposeId)=>{
                    this.bySpecialPurposeVendorMap[String(purposeId)].add(vendorId);
                });
                vendor.legIntPurposes.forEach((purposeId)=>{
                    this.byPurposeVendorMap[String(purposeId)].legInt.add(vendorId);
                });
                // could not be there
                if (vendor.flexiblePurposes) vendor.flexiblePurposes.forEach((purposeId)=>{
                    this.byPurposeVendorMap[String(purposeId)].flexible.add(vendorId);
                });
                vendor.features.forEach((featureId)=>{
                    this.byFeatureVendorMap[String(featureId)].add(vendorId);
                });
                vendor.specialFeatures.forEach((featureId)=>{
                    this.bySpecialFeatureVendorMap[String(featureId)].add(vendorId);
                });
                vendors[vendorId] = vendor;
            }
            return vendors;
        }, {});
    }
    getFilteredVendors(purposeOrFeature, id, subType, special) {
        const properPurposeOrFeature = purposeOrFeature.charAt(0).toUpperCase() + purposeOrFeature.slice(1);
        let vendorSet;
        const retr = {};
        if (purposeOrFeature === "purpose" && subType) vendorSet = this["by" + properPurposeOrFeature + "VendorMap"][String(id)][subType];
        else vendorSet = this["by" + (special ? "Special" : "") + properPurposeOrFeature + "VendorMap"][String(id)];
        vendorSet.forEach((vendorId)=>{
            retr[String(vendorId)] = this.vendors[String(vendorId)];
        });
        return retr;
    }
    /**
     * getVendorsWithConsentPurpose
     *
     * @param {number} purposeId
     * @return {IntMap<Vendor>} - list of vendors that have declared the consent purpose id
     */ getVendorsWithConsentPurpose(purposeId) {
        return this.getFilteredVendors("purpose", purposeId, "consent");
    }
    /**
     * getVendorsWithLegIntPurpose
     *
     * @param {number} purposeId
     * @return {IntMap<Vendor>} - list of vendors that have declared the legInt (Legitimate Interest) purpose id
     */ getVendorsWithLegIntPurpose(purposeId) {
        return this.getFilteredVendors("purpose", purposeId, "legInt");
    }
    /**
     * getVendorsWithFlexiblePurpose
     *
     * @param {number} purposeId
     * @return {IntMap<Vendor>} - list of vendors that have declared the flexible purpose id
     */ getVendorsWithFlexiblePurpose(purposeId) {
        return this.getFilteredVendors("purpose", purposeId, "flexible");
    }
    /**
     * getVendorsWithSpecialPurpose
     *
     * @param {number} specialPurposeId
     * @return {IntMap<Vendor>} - list of vendors that have declared the special purpose id
     */ getVendorsWithSpecialPurpose(specialPurposeId) {
        return this.getFilteredVendors("purpose", specialPurposeId, undefined, true);
    }
    /**
     * getVendorsWithFeature
     *
     * @param {number} featureId
     * @return {IntMap<Vendor>} - list of vendors that have declared the feature id
     */ getVendorsWithFeature(featureId) {
        return this.getFilteredVendors("feature", featureId);
    }
    /**
     * getVendorsWithSpecialFeature
     *
     * @param {number} specialFeatureId
     * @return {IntMap<Vendor>} - list of vendors that have declared the special feature id
     */ getVendorsWithSpecialFeature(specialFeatureId) {
        return this.getFilteredVendors("feature", specialFeatureId, undefined, true);
    }
    /**
     * vendors
     *
     * @return {IntMap<Vendor>} - the list of vendors as it would on the JSON file
     * except if `narrowVendorsTo` was called, it would be that narrowed list
     */ get vendors() {
        return this.vendors_;
    }
    /**
     * narrowVendorsTo - narrows vendors represented in this GVL to the list of ids passed in
     *
     * @param {number[]} vendorIds - list of ids to narrow this GVL to
     * @return {void}
     */ narrowVendorsTo(vendorIds) {
        this.mapVendors(vendorIds);
    }
    /**
     * isReady - Whether or not this instance is ready to be used.  This will be
     * immediately and synchronously true if a vendorlist object is passed into
     * the constructor or once the JSON vendorllist is retrieved.
     *
     * @return {boolean} whether or not the instance is ready to be interacted
     * with and all the data is populated
     */ get isReady() {
        return this.isReady_;
    }
    /**
     * clone - overrides base `clone()` method since GVL is a special class that
     * represents a JSON structure with some additional functionality.
     *
     * @return {GVL}
     */ clone() {
        const result = new $b330330a857276b4$export$839e4e368d076bb1(this.getJson());
        /*
         * If the current language of the GVL is not the default language, we set the language of
         * the clone to the current language since a new GVL is always created with the default
         * language. */ if (this.lang_ !== $b330330a857276b4$export$839e4e368d076bb1.DEFAULT_LANGUAGE) /*
             * Since the GVL language was changed, this means that an asynchronous changeLanguage
             * call was made prior to cloning the GVL.  The new language specified has been cached
             * by the GVL and this changeLanguage call made as a part of cloning the GVL will be
             * synchronous. The code will look for the language definitions in the cache instead
             * of creating a http request. */ result.changeLanguage(this.lang_);
        return result;
    }
    static isInstanceOf(questionableInstance) {
        const isSo = typeof questionableInstance === "object";
        return isSo && typeof questionableInstance.narrowVendorsTo === "function";
    }
}







class $28340fe6e38fb614$export$ff866215f0b6054a extends (0, $3867cebb1f83913e$export$a17144d9403e9d84) {
    /**
     * Set of available consent languages published by the IAB
     */ static consentLanguages = (0, $b330330a857276b4$export$839e4e368d076bb1).consentLanguages;
    isServiceSpecific_ = false;
    supportOOB_ = true;
    useNonStandardStacks_ = false;
    purposeOneTreatment_ = false;
    publisherCountryCode_ = "AA";
    version_ = 2;
    consentScreen_ = 0;
    policyVersion_ = 2;
    consentLanguage_ = "EN";
    cmpId_ = 0;
    cmpVersion_ = 0;
    vendorListVersion_ = 0;
    numCustomPurposes_ = 0;
    // Member Variable for GVL
    gvl_;
    created;
    lastUpdated;
    /**
     * The TCF designates certain Features as special, that is, a CMP must afford
     * the user a means to opt in to their use. These Special Features are
     * published and numbered in the GVL separately from normal Features.
     * Provides for up to 12 special features.
     */ specialFeatureOptins = new (0, $908c228bb5be525f$export$9b781de7bf37bf48)();
    /**
     * Renamed from `PurposesAllowed` in TCF v1.1
     * The user’s consent value for each Purpose established on the legal basis
     * of consent. Purposes are published in the Global Vendor List (see. [[GVL]]).
     */ purposeConsents = new (0, $908c228bb5be525f$export$9b781de7bf37bf48)();
    /**
     * The user’s permission for each Purpose established on the legal basis of
     * legitimate interest. If the user has exercised right-to-object for a
     * purpose.
     */ purposeLegitimateInterests = new (0, $908c228bb5be525f$export$9b781de7bf37bf48)();
    /**
     * The user’s consent value for each Purpose established on the legal basis
     * of consent, for the publisher.  Purposes are published in the Global
     * Vendor List.
     */ publisherConsents = new (0, $908c228bb5be525f$export$9b781de7bf37bf48)();
    /**
     * The user’s permission for each Purpose established on the legal basis of
     * legitimate interest.  If the user has exercised right-to-object for a
     * purpose.
     */ publisherLegitimateInterests = new (0, $908c228bb5be525f$export$9b781de7bf37bf48)();
    /**
     * The user’s consent value for each Purpose established on the legal basis
     * of consent, for the publisher.  Purposes are published in the Global
     * Vendor List.
     */ publisherCustomConsents = new (0, $908c228bb5be525f$export$9b781de7bf37bf48)();
    /**
     * The user’s permission for each Purpose established on the legal basis of
     * legitimate interest.  If the user has exercised right-to-object for a
     * purpose that is established in the publisher's custom purposes.
     */ publisherCustomLegitimateInterests = new (0, $908c228bb5be525f$export$9b781de7bf37bf48)();
    /**
     * set by a publisher if they wish to collect consent and LI Transparency for
     * purposes outside of the TCF
     */ customPurposes;
    /**
     * Each [[Vendor]] is keyed by id. Their consent value is true if it is in
     * the Vector
     */ vendorConsents = new (0, $908c228bb5be525f$export$9b781de7bf37bf48)();
    /**
     * Each [[Vendor]] is keyed by id. Whether their Legitimate Interests
     * Disclosures have been established is stored as boolean.
     * see: [[Vector]]
     */ vendorLegitimateInterests = new (0, $908c228bb5be525f$export$9b781de7bf37bf48)();
    /**
     * The value included for disclosed vendors signals which vendors have been
     * disclosed to the user in the interface surfaced by the CMP. This section
     * content is required when writing a TC string to the global (consensu)
     * scope. When a CMP has read from and is updating a TC string from the
     * global consensu.org storage, the CMP MUST retain the existing disclosure
     * information and only add information for vendors that it has disclosed
     * that had not been disclosed by other CMPs in prior interactions with this
     * device/user agent.
     */ vendorsDisclosed = new (0, $908c228bb5be525f$export$9b781de7bf37bf48)();
    /**
     * Signals which vendors the publisher permits to use OOB legal bases.
     */ vendorsAllowed = new (0, $908c228bb5be525f$export$9b781de7bf37bf48)();
    publisherRestrictions = new (0, $0ff930ce4fd6f184$export$f0de1ae98060331)();
    /**
     * Constructs the TCModel. Passing a [[GVL]] is optional when constructing
     * as this TCModel may be constructed from decoding an existing encoded
     * TCString.
     *
     * @param {GVL} [gvl]
     */ constructor(gvl){
        super();
        if (gvl) this.gvl = gvl;
        this.updated();
    }
    /**
     * sets the [[GVL]] with side effects of also setting the `vendorListVersion`, `policyVersion`, and `consentLanguage`
     * @param {GVL} gvl
     */ set gvl(gvl) {
        /**
         * set the reference, but make sure it's our GVL wrapper class.
         */ if (!(0, $b330330a857276b4$export$839e4e368d076bb1).isInstanceOf(gvl)) gvl = new (0, $b330330a857276b4$export$839e4e368d076bb1)(gvl);
        this.gvl_ = gvl;
        this.publisherRestrictions.gvl = gvl;
    }
    /**
     * @return {GVL} the gvl instance set on this TCModel instance
     */ get gvl() {
        return this.gvl_;
    }
    /**
     * @param {number} integer - A unique ID will be assigned to each Consent
     * Manager Provider (CMP) from the iab.
     *
     * @throws {TCModelError} if the value is not an integer greater than 1 as those are not valid.
     */ set cmpId(integer) {
        integer = Number(integer);
        if (Number.isInteger(integer) && integer > 1) this.cmpId_ = integer;
        else throw new (0, $a93cb9a7fa28bd41$export$ae87575734af973)("cmpId", integer);
    }
    get cmpId() {
        return this.cmpId_;
    }
    /**
     * Each change to an operating CMP should receive a
     * new version number, for logging proof of consent. CmpVersion defined by
     * each CMP.
     *
     * @param {number} integer
     *
     * @throws {TCModelError} if the value is not an integer greater than 1 as those are not valid.
     */ set cmpVersion(integer) {
        integer = Number(integer);
        if (Number.isInteger(integer) && integer > -1) this.cmpVersion_ = integer;
        else throw new (0, $a93cb9a7fa28bd41$export$ae87575734af973)("cmpVersion", integer);
    }
    get cmpVersion() {
        return this.cmpVersion_;
    }
    /**
     * The screen number is CMP and CmpVersion
     * specific, and is for logging proof of consent.(For example, a CMP could
     * keep records so that a publisher can request information about the context
     * in which consent was gathered.)
     *
     * @param {number} integer
     *
     * @throws {TCModelError} if the value is not an integer greater than 0 as those are not valid.
     */ set consentScreen(integer) {
        integer = Number(integer);
        if (Number.isInteger(integer) && integer > -1) this.consentScreen_ = integer;
        else throw new (0, $a93cb9a7fa28bd41$export$ae87575734af973)("consentScreen", integer);
    }
    get consentScreen() {
        return this.consentScreen_;
    }
    /**
     * @param {string} lang - [two-letter ISO 639-1 language
     * code](http://www.loc.gov/standards/iso639-2/php/code_list.php) in which
     * the CMP UI was presented
     *
     * @throws {TCModelError} if the value is not a length-2 string of alpha characters
     */ set consentLanguage(lang) {
        this.consentLanguage_ = lang;
    }
    get consentLanguage() {
        return this.consentLanguage_;
    }
    /**
     * @param {string} countryCode - [two-letter ISO 3166-1 alpha-2 country
     * code](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2) of the publisher,
     * determined by the CMP-settings of the publisher.
     *
     * @throws {TCModelError} if the value is not a length-2 string of alpha characters
     */ set publisherCountryCode(countryCode) {
        if (/^([A-z]){2}$/.test(countryCode)) this.publisherCountryCode_ = countryCode.toUpperCase();
        else throw new (0, $a93cb9a7fa28bd41$export$ae87575734af973)("publisherCountryCode", countryCode);
    }
    get publisherCountryCode() {
        return this.publisherCountryCode_;
    }
    /**
     * Version of the GVL used to create this TCModel. Global
     * Vendor List versions will be released periodically.
     *
     * @param {number} integer
     *
     * @throws {TCModelError} if the value is not an integer greater than 0 as those are not valid.
     */ set vendorListVersion(integer) {
        /**
         * first coerce to a number via leading '+' then take the integer value by
         * bitshifting to the right.  This works on all types in JavaScript and if
         * it's not valid then value will be 0.
         */ integer = Number(integer) >> 0;
        if (integer < 0) throw new (0, $a93cb9a7fa28bd41$export$ae87575734af973)("vendorListVersion", integer);
        else this.vendorListVersion_ = integer;
    }
    get vendorListVersion() {
        if (this.gvl) return this.gvl.vendorListVersion;
        else return this.vendorListVersion_;
    }
    /**
     * From the corresponding field in the GVL that was
     * used for obtaining consent. A new policy version invalidates existing
     * strings and requires CMPs to re-establish transparency and consent from
     * users.
     *
     * If a TCF policy version number is different from the one from the latest
     * GVL, the CMP must re-establish transparency and consent.
     *
     * @param {number} num - You do not need to set this.  This comes
     * directly from the [[GVL]].
     *
     */ set policyVersion(num) {
        this.policyVersion_ = parseInt(num, 10);
        if (this.policyVersion_ < 0) throw new (0, $a93cb9a7fa28bd41$export$ae87575734af973)("policyVersion", num);
    }
    get policyVersion() {
        if (this.gvl) return this.gvl.tcfPolicyVersion;
        else return this.policyVersion_;
    }
    set version(num) {
        this.version_ = parseInt(num, 10);
    }
    get version() {
        return this.version_;
    }
    /**
     * Whether the signals encoded in this TC String were from site-specific
     * storage `true` versus ‘global’ consensu.org shared storage `false`. A
     * string intended to be stored in global/shared scope but the CMP is unable
     * to store due to a user agent not accepting third-party cookies would be
     * considered site-specific `true`.
     *
     * @param {boolean} bool - value to set. Some changes to other fields in this
     * model will automatically change this value like adding publisher
     * restrictions.
     */ set isServiceSpecific(bool) {
        this.isServiceSpecific_ = bool;
    }
    get isServiceSpecific() {
        return this.isServiceSpecific_;
    }
    /**
     * Non-standard stacks means that a CMP is using publisher-customized stack
     * descriptions. Stacks (in terms of purposes in a stack) are pre-set by the
     * IAB. As are titles. Descriptions are pre-set, but publishers can customize
     * them. If they do, they need to set this bit to indicate that they've
     * customized descriptions.
     *
     * @param {boolean} bool - value to set
     */ set useNonStandardStacks(bool) {
        this.useNonStandardStacks_ = bool;
    }
    get useNonStandardStacks() {
        return this.useNonStandardStacks_;
    }
    /**
     * Whether or not this publisher supports OOB signaling.  On Global TC String
     * OOB Vendors Disclosed will be included if the publish wishes to no allow
     * these vendors they should set this to false.
     * @param {boolean} bool - value to set
     */ set supportOOB(bool) {
        this.supportOOB_ = bool;
    }
    get supportOOB() {
        return this.supportOOB_;
    }
    /**
     * `false` There is no special Purpose 1 status.
     * Purpose 1 was disclosed normally (consent) as expected by Policy.  `true`
     * Purpose 1 not disclosed at all. CMPs use PublisherCC to indicate the
     * publisher’s country of establishment to help Vendors determine whether the
     * vendor requires Purpose 1 consent. In global scope TC strings, this field
     * must always have a value of `false`. When a CMP encounters a global scope
     * string with `purposeOneTreatment=true` then that string should be
     * considered invalid and the CMP must re-establish transparency and consent.
     *
     * @param {boolean} bool
     */ set purposeOneTreatment(bool) {
        this.purposeOneTreatment_ = bool;
    }
    get purposeOneTreatment() {
        return this.purposeOneTreatment_;
    }
    /**
     * setAllVendorConsents - sets all vendors on the GVL Consent (true)
     *
     * @return {void}
     */ setAllVendorConsents() {
        this.vendorConsents.set(this.gvl.vendors);
    }
    /**
     * unsetAllVendorConsents - unsets all vendors on the GVL Consent (false)
     *
     * @return {void}
     */ unsetAllVendorConsents() {
        this.vendorConsents.empty();
    }
    /**
     * setAllVendorsDisclosed - sets all vendors on the GVL Vendors Disclosed (true)
     *
     * @return {void}
     */ setAllVendorsDisclosed() {
        this.vendorsDisclosed.set(this.gvl.vendors);
    }
    /**
     * unsetAllVendorsDisclosed - unsets all vendors on the GVL Consent (false)
     *
     * @return {void}
     */ unsetAllVendorsDisclosed() {
        this.vendorsDisclosed.empty();
    }
    /**
     * setAllVendorsAllowed - sets all vendors on the GVL Consent (true)
     *
     * @return {void}
     */ setAllVendorsAllowed() {
        this.vendorsAllowed.set(this.gvl.vendors);
    }
    /**
     * unsetAllVendorsAllowed - unsets all vendors on the GVL Consent (false)
     *
     * @return {void}
     */ unsetAllVendorsAllowed() {
        this.vendorsAllowed.empty();
    }
    /**
     * setAllVendorLegitimateInterests - sets all vendors on the GVL LegitimateInterests (true)
     *
     * @return {void}
     */ setAllVendorLegitimateInterests() {
        this.vendorLegitimateInterests.set(this.gvl.vendors);
    }
    /**
     * unsetAllVendorLegitimateInterests - unsets all vendors on the GVL LegitimateInterests (false)
     *
     * @return {void}
     */ unsetAllVendorLegitimateInterests() {
        this.vendorLegitimateInterests.empty();
    }
    /**
     * setAllPurposeConsents - sets all purposes on the GVL Consent (true)
     *
     * @return {void}
     */ setAllPurposeConsents() {
        this.purposeConsents.set(this.gvl.purposes);
    }
    /**
     * unsetAllPurposeConsents - unsets all purposes on the GVL Consent (false)
     *
     * @return {void}
     */ unsetAllPurposeConsents() {
        this.purposeConsents.empty();
    }
    /**
     * setAllPurposeLegitimateInterests - sets all purposes on the GVL LI Transparency (true)
     *
     * @return {void}
     */ setAllPurposeLegitimateInterests() {
        this.purposeLegitimateInterests.set(this.gvl.purposes);
    }
    /**
     * unsetAllPurposeLegitimateInterests - unsets all purposes on the GVL LI Transparency (false)
     *
     * @return {void}
     */ unsetAllPurposeLegitimateInterests() {
        this.purposeLegitimateInterests.empty();
    }
    /**
     * setAllSpecialFeatureOptins - sets all special featuresOptins on the GVL (true)
     *
     * @return {void}
     */ setAllSpecialFeatureOptins() {
        this.specialFeatureOptins.set(this.gvl.specialFeatures);
    }
    /**
     * unsetAllSpecialFeatureOptins - unsets all special featuresOptins on the GVL (true)
     *
     * @return {void}
     */ unsetAllSpecialFeatureOptins() {
        this.specialFeatureOptins.empty();
    }
    setAll() {
        this.setAllVendorConsents();
        this.setAllPurposeLegitimateInterests();
        this.setAllSpecialFeatureOptins();
        this.setAllPurposeConsents();
        this.setAllVendorLegitimateInterests();
    }
    unsetAll() {
        this.unsetAllVendorConsents();
        this.unsetAllPurposeLegitimateInterests();
        this.unsetAllSpecialFeatureOptins();
        this.unsetAllPurposeConsents();
        this.unsetAllVendorLegitimateInterests();
    }
    get numCustomPurposes() {
        let len = this.numCustomPurposes_;
        if (typeof this.customPurposes === "object") {
            /**
             * Keys are not guaranteed to be in order and likewise there is no
             * requirement that the customPurposes be non-sparse.  So we have to sort
             * and take the highest value.  Even if the set only contains 3 purposes
             * but goes to ID 6 we need to set the number to 6 for the encoding to
             * work properly since it's positional.
             */ const purposeIds = Object.keys(this.customPurposes).sort((a, b)=>Number(a) - Number(b));
            len = parseInt(purposeIds.pop(), 10);
        }
        return len;
    }
    set numCustomPurposes(num) {
        this.numCustomPurposes_ = parseInt(num, 10);
        if (this.numCustomPurposes_ < 0) throw new (0, $a93cb9a7fa28bd41$export$ae87575734af973)("numCustomPurposes", num);
    }
    /**
     * updated - updates the created and lastUpdated dates with a 'now' day-level UTC timestamp
     *
     * @return {void}
     */ updated() {
        const date = new Date();
        const utcDate = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
        this.created = utcDate;
        this.lastUpdated = utcDate;
    }
}






class $a0c9c9705c46eca5$export$785134c1047c8169 {
    /**
     * encodes a model into a TCString
     *
     * @param {TCModel} tcModel - model to convert into encoded string
     * @param {EncodingOptions} options - for encoding options other than default
     * @return {string} - base64url encoded Transparency and Consent String
     */ static encode(tcModel, options) {
        let out = "";
        let sequence;
        tcModel = (0, $05880e4772fc5ff4$export$b176d473004a672c).process(tcModel, options);
        /**
           * If they pass in a special segment sequence.
           */ if (Array.isArray(options?.segments)) sequence = options.segments;
        else sequence = new (0, $e0290ed542a4d980$export$b6961ee31e192e0)(tcModel, options)["" + tcModel.version];
        sequence.forEach((segment, idx)=>{
            let dotMaybe = "";
            if (idx < sequence.length - 1) dotMaybe = ".";
            out += (0, $23e4abe6592ced17$export$fa5ec974bf69adda).encode(tcModel, segment) + dotMaybe;
        });
        return out;
    }
    /**
     * Decodes a string into a TCModel
     *
     * @param {string} encodedTCString - base64url encoded Transparency and
     * Consent String to decode - can also be a single or group of segments of
     * the string
     * @param {string} [tcModel] - model to enhance with the information.  If
     * none is passed a new instance of TCModel will be created.
     * @return {TCModel} - Returns populated TCModel
     */ static decode(encodedTCString, tcModel) {
        const segments = encodedTCString.split(".");
        const len = segments.length;
        if (!tcModel) tcModel = new (0, $28340fe6e38fb614$export$ff866215f0b6054a)();
        for(let i = 0; i < len; i++){
            const segString = segments[i];
            /**
             * first char will contain 6 bits, we only need the first 3. In version 1
             * and 2 of the TC string there is no segment type for the CORE string.
             * Instead the first 6 bits are reserved for the encoding version, but
             * because we're only on a maximum of encoding version 2 the first 3 bits
             * in the core segment will evaluate to 0.
             */ const firstChar = (0, $3bc4d6646eacc1d5$export$bad7b18cc08bb8a3).decode(segString.charAt(0));
            const segTypeBits = firstChar.substr(0, (0, $a29b574660309e88$export$391437f908389469).segmentType);
            const segment = (0, $ea2b59a0eb08e264$export$a7590c36d83c4992).ID_TO_KEY[(0, $8e08330dc250a556$export$652ce6ae9d26cb14).decode(segTypeBits, (0, $a29b574660309e88$export$391437f908389469).segmentType).toString()];
            (0, $23e4abe6592ced17$export$fa5ec974bf69adda).decode(segString, tcModel, segment);
        }
        return tcModel;
    }
}




class $4434634b85e3417b$export$5a488586be116731 extends (0, $9a4dbb7201d7107a$export$cc7e12c76513e857) {
    respond() {
        const tcModel = (0, $dee2c3d7e96324ec$export$3bd39b6208e7b7f2).tcModel;
        const tcModelVersion = tcModel.vendorListVersion;
        let gvl;
        if (this.param === undefined) this.param = tcModelVersion;
        if (this.param === tcModelVersion && tcModel.gvl) gvl = tcModel.gvl;
        else gvl = new (0, $b330330a857276b4$export$839e4e368d076bb1)(this.param);
        gvl.readyPromise.then(()=>{
            this.invokeCallback(gvl.getJson());
        });
    }
}




class $25fc5d811b8cf3a4$export$6006eaf92e98d6fa extends (0, $9d10f0fbcb82d290$export$e71835e83a47e30a) {
    respond() {
        this.listenerId = (0, $dee2c3d7e96324ec$export$3bd39b6208e7b7f2).eventQueue.add({
            callback: this.callback,
            param: this.param,
            next: this.next
        });
        super.respond();
    }
}




class $62f7f5a697ec4ec2$export$6aa71e523bf9920e extends (0, $9a4dbb7201d7107a$export$cc7e12c76513e857) {
    respond() {
        this.invokeCallback((0, $dee2c3d7e96324ec$export$3bd39b6208e7b7f2).eventQueue.remove(this.param));
    }
}



class $2cfffba7680d848c$export$da59fe55567e9df3 {
    static [(0, $df54e3172b937154$export$a130bab8794e1619).PING] = (0, $df163a1ff88c93a8$export$1aca4d096434e94);
    static [(0, $df54e3172b937154$export$a130bab8794e1619).GET_TC_DATA] = (0, $9d10f0fbcb82d290$export$e71835e83a47e30a);
    static [(0, $df54e3172b937154$export$a130bab8794e1619).GET_IN_APP_TC_DATA] = (0, $080146056b0c6a46$export$dcda0d941af8ba18);
    static [(0, $df54e3172b937154$export$a130bab8794e1619).GET_VENDOR_LIST] = (0, $4434634b85e3417b$export$5a488586be116731);
    static [(0, $df54e3172b937154$export$a130bab8794e1619).ADD_EVENT_LISTENER] = (0, $25fc5d811b8cf3a4$export$6006eaf92e98d6fa);
    static [(0, $df54e3172b937154$export$a130bab8794e1619).REMOVE_EVENT_LISTENER] = (0, $62f7f5a697ec4ec2$export$6aa71e523bf9920e);
}




class $ca8e1005e81ea110$export$c56a411c4a8e7864 {
    static set_ = new Set([
        0,
        2,
        undefined,
        null
    ]);
    static has(value) {
        if (typeof value === "string") value = Number(value);
        return this.set_.has(value);
    }
}


const $dc8782abe3f7ab0e$export$a9861bd62f48e142 = "__tcfapi";
class $dc8782abe3f7ab0e$export$94ccae51b68346af {
    callQueue;
    customCommands;
    constructor(customCommands){
        if (customCommands) {
            /**
             * The addEventListener command and removeEventListener are the only ones
             * that shouldn't be overwritten. The addEventListener command utilizes
             * getTCData command, so overridding the TCData response should happen
             * there.
             */ let command = (0, $df54e3172b937154$export$a130bab8794e1619).ADD_EVENT_LISTENER;
            if (customCommands?.[command]) throw new Error(`Built-In Custom Commmand for ${command} not allowed: Use ${(0, $df54e3172b937154$export$a130bab8794e1619).GET_TC_DATA} instead`);
            command = (0, $df54e3172b937154$export$a130bab8794e1619).REMOVE_EVENT_LISTENER;
            if (customCommands?.[command]) throw new Error(`Built-In Custom Commmand for ${command} not allowed`);
            /**
             * If `getTCData` custom command handler is specified, we should use it
             * for `addEventListener` and `removeEventListener` commands.
             */ if (customCommands?.[(0, $df54e3172b937154$export$a130bab8794e1619).GET_TC_DATA]) {
                customCommands[(0, $df54e3172b937154$export$a130bab8794e1619).ADD_EVENT_LISTENER] = customCommands[(0, $df54e3172b937154$export$a130bab8794e1619).GET_TC_DATA];
                customCommands[(0, $df54e3172b937154$export$a130bab8794e1619).REMOVE_EVENT_LISTENER] = customCommands[(0, $df54e3172b937154$export$a130bab8794e1619).GET_TC_DATA];
            }
            this.customCommands = customCommands;
        }
        /**
         * Attempt to grab the queue – we could call ping and see if it is the stub,
         * but instead we'll just a feature-detection method of just trying to get
         * a queue by calling the function with no parameters and see if we get a
         * queue back. If there is no stub or the stub doesn't return the queue by
         * calling with no arguments, then we'll just move on and create our
         * function.
         */ try {
            // get queued commands
            this.callQueue = window[$dc8782abe3f7ab0e$export$a9861bd62f48e142]() || [];
        } catch (err) {
            this.callQueue = [];
        } finally{
            window[$dc8782abe3f7ab0e$export$a9861bd62f48e142] = this.apiCall.bind(this);
            this.purgeQueuedCalls();
        }
    }
    /**
     * Handler for all page call commands
     * @param {string} command
     * @param {number} version
     * @param {CommandCallback} callback
     * @param {any} params
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    apiCall(command, version, callback, ...params) {
        if (typeof command !== "string") callback(null, false);
        else if (!(0, $ca8e1005e81ea110$export$c56a411c4a8e7864).has(version)) /**
             * Loosely checking version here on purpose.  If a string is passed
             * that's probably ok, we don't need strict adherence here.
             */ callback(null, false);
        else if (typeof callback !== "function") throw new Error("invalid callback function");
        else if ((0, $dee2c3d7e96324ec$export$3bd39b6208e7b7f2).disabled) callback(new (0, $c3acf110f760e7a8$export$9a986b15f53d6d10)(), false);
        else if (!this.isCustomCommand(command) && !this.isBuiltInCommand(command)) /**
             * This check is here just because the call shouldn't be queued if it's
             * something we know isn't going to work.  It's kind of like breaking off a bad
             * relationshipthe instant you know things are not going to work out
             * instead of letting it linger.
             */ callback(null, false);
        else if (this.isCustomCommand(command) && !this.isBuiltInCommand(command)) this.customCommands[command](callback, ...params);
        else if (command === (0, $df54e3172b937154$export$a130bab8794e1619).PING) {
            /**
             * if it's a ping we always respond right away regardless of our tcModel
             * status or other things.
             */ if (this.isCustomCommand(command)) new (0, $2cfffba7680d848c$export$da59fe55567e9df3)[command](this.customCommands[command], params[0], null, callback);
            else new (0, $2cfffba7680d848c$export$da59fe55567e9df3)[command](callback, params[0]);
        } else if ((0, $dee2c3d7e96324ec$export$3bd39b6208e7b7f2).tcModel === undefined) /**
             * If we are still waiting for the TC data to be set we can push this
             * onto the queue that we have and once the model is set it'll be called
             */ this.callQueue.push([
            command,
            version,
            callback,
            ...params
        ]);
        else if (this.isCustomCommand(command) && this.isBuiltInCommand(command)) new (0, $2cfffba7680d848c$export$da59fe55567e9df3)[command](this.customCommands[command], params[0], null, callback);
        else /**
             * at this point we know the command exists and we are free to call it
             */ new (0, $2cfffba7680d848c$export$da59fe55567e9df3)[command](callback, params[0]);
    }
    /**
     * purgeQueuedCalls - if there have been calls that are queued up this method
     * will go through and call them in a FIFO order
     *
     * @return {void}
     */ purgeQueuedCalls() {
        const queueCopy = this.callQueue;
        this.callQueue = [];
        queueCopy.forEach((args)=>{
            window[$dc8782abe3f7ab0e$export$a9861bd62f48e142](...args);
        });
    }
    /**
     * Checks to see if the command exists in the set of custom commands
     *
     * @param {string} command - command to check
     * @return {boolean} - whether or not this command is a custom command
     */ isCustomCommand(command) {
        return this.customCommands && typeof this.customCommands[command] === "function";
    }
    /**
     * Checks to see if the command exists in the set of TCF Commands
     *
     * @param {string} command - command to check
     * @return {boolean} - whether or not this command is a built-in command
     */ isBuiltInCommand(command) {
        return (0, $2cfffba7680d848c$export$da59fe55567e9df3)[command] !== undefined;
    }
}



class $e4e024d1a2c58049$export$c49c87f3b359200 {
    callResponder;
    isServiceSpecific;
    numUpdates = 0;
    /**
     * @param {number} cmpId - IAB assigned CMP ID
     * @param {number} cmpVersion - integer version of the CMP
     * @param {boolean} isServiceSpecific - whether or not this cmp is configured to be service specific
     * @param {CustomCommands} [customCommands] - custom commands from the cmp
     */ constructor(cmpId, cmpVersion, isServiceSpecific = false, customCommands){
        this.throwIfInvalidInt(cmpId, "cmpId", 2);
        this.throwIfInvalidInt(cmpVersion, "cmpVersion", 0);
        (0, $dee2c3d7e96324ec$export$3bd39b6208e7b7f2).cmpId = cmpId;
        (0, $dee2c3d7e96324ec$export$3bd39b6208e7b7f2).cmpVersion = cmpVersion;
        (0, $dee2c3d7e96324ec$export$3bd39b6208e7b7f2).tcfPolicyVersion = 2;
        this.isServiceSpecific = !!isServiceSpecific;
        this.callResponder = new (0, $dc8782abe3f7ab0e$export$94ccae51b68346af)(customCommands);
    }
    throwIfInvalidInt(value, name, minValue) {
        if (!(typeof value === "number" && Number.isInteger(value) && value >= minValue)) throw new Error(`Invalid ${name}: ${value}`);
    }
    /**
     * update - When the state of a CMP changes this function should be called
     * with the updated tc string and whether or not the UI is visible or not
     *
     * @param {string|null} encodedTCString - set a string to signal that
     * gdprApplies and that an encoded tc string is being passed.  If GDPR does
     * not apply, set to null.
     * @param {boolean} uiVisible - default false.  set to true if the ui is
     * being shown with this tc string update, this will set the correct values
     * for eventStatus and displayStatus.
     * @return {void}
     */ update(encodedTCString, uiVisible = false) {
        if ((0, $dee2c3d7e96324ec$export$3bd39b6208e7b7f2).disabled) throw new Error("CmpApi Disabled");
        (0, $dee2c3d7e96324ec$export$3bd39b6208e7b7f2).cmpStatus = (0, $c6650d4c86df4f7f$export$4810b960166e3f34).LOADED;
        if (uiVisible) {
            (0, $dee2c3d7e96324ec$export$3bd39b6208e7b7f2).displayStatus = (0, $f64bc79bf0ed6aba$export$a66681be047b7245).VISIBLE;
            (0, $dee2c3d7e96324ec$export$3bd39b6208e7b7f2).eventStatus = (0, $7566a7528260a218$export$af4f9da7de468bf1).CMP_UI_SHOWN;
        } else if ((0, $dee2c3d7e96324ec$export$3bd39b6208e7b7f2).tcModel === undefined) {
            (0, $dee2c3d7e96324ec$export$3bd39b6208e7b7f2).displayStatus = (0, $f64bc79bf0ed6aba$export$a66681be047b7245).DISABLED;
            (0, $dee2c3d7e96324ec$export$3bd39b6208e7b7f2).eventStatus = (0, $7566a7528260a218$export$af4f9da7de468bf1).TC_LOADED;
        } else {
            (0, $dee2c3d7e96324ec$export$3bd39b6208e7b7f2).displayStatus = (0, $f64bc79bf0ed6aba$export$a66681be047b7245).HIDDEN;
            (0, $dee2c3d7e96324ec$export$3bd39b6208e7b7f2).eventStatus = (0, $7566a7528260a218$export$af4f9da7de468bf1).USER_ACTION_COMPLETE;
        }
        (0, $dee2c3d7e96324ec$export$3bd39b6208e7b7f2).gdprApplies = encodedTCString !== null;
        if (!(0, $dee2c3d7e96324ec$export$3bd39b6208e7b7f2).gdprApplies) (0, $dee2c3d7e96324ec$export$3bd39b6208e7b7f2).tcModel = null;
        else {
            if (encodedTCString === "") {
                (0, $dee2c3d7e96324ec$export$3bd39b6208e7b7f2).tcModel = new (0, $28340fe6e38fb614$export$ff866215f0b6054a)();
                (0, $dee2c3d7e96324ec$export$3bd39b6208e7b7f2).tcModel.cmpId = (0, $dee2c3d7e96324ec$export$3bd39b6208e7b7f2).cmpId;
                (0, $dee2c3d7e96324ec$export$3bd39b6208e7b7f2).tcModel.cmpVersion = (0, $dee2c3d7e96324ec$export$3bd39b6208e7b7f2).cmpVersion;
            } else (0, $dee2c3d7e96324ec$export$3bd39b6208e7b7f2).tcModel = (0, $a0c9c9705c46eca5$export$785134c1047c8169).decode(encodedTCString);
            (0, $dee2c3d7e96324ec$export$3bd39b6208e7b7f2).tcModel.isServiceSpecific = this.isServiceSpecific;
            (0, $dee2c3d7e96324ec$export$3bd39b6208e7b7f2).tcfPolicyVersion = Number((0, $dee2c3d7e96324ec$export$3bd39b6208e7b7f2).tcModel.policyVersion);
            (0, $dee2c3d7e96324ec$export$3bd39b6208e7b7f2).tcString = encodedTCString;
        }
        if (this.numUpdates === 0) /**
             * Will make AddEventListener Commands respond immediately.
             */ this.callResponder.purgeQueuedCalls();
        else /**
             * Should be no queued calls and only any addEventListener commands
             */ (0, $dee2c3d7e96324ec$export$3bd39b6208e7b7f2).eventQueue.exec();
        this.numUpdates++;
    }
    /**
     * Disables the CmpApi from serving anything but ping and custom commands
     * Cannot be undone
     *
     * @return {void}
     */ disable() {
        (0, $dee2c3d7e96324ec$export$3bd39b6208e7b7f2).disabled = true;
        (0, $dee2c3d7e96324ec$export$3bd39b6208e7b7f2).cmpStatus = (0, $c6650d4c86df4f7f$export$4810b960166e3f34).ERROR;
    }
}










var $8962dff93ebd0870$var$_a, $8962dff93ebd0870$var$_b;
let $8962dff93ebd0870$export$a0751edb8e5adc72 = class TcfApi {
    constructor(window, logger){
        this.window = window;
        this.logger = logger;
        this.IAB_PURPOSES_COUNT = 10;
        this.TCF_API_VERSION = 2;
        this.CMP_VERSION = 5; // Increment to force modal again
        this.CMP_ID = 141;
        this.initializeTcfApi();
        this.consentGiven = new Promise((res)=>this.resolveConsent = res);
        this.readTrackingConsents();
        this.subscribe();
    }
    initializeTcfApi() {
        if (this.window.__uspapi === undefined && this.window.__tcfapi === undefined) new (0, $e4e024d1a2c58049$export$c49c87f3b359200)(this.CMP_ID, this.CMP_VERSION, true);
    }
    subscribe() {
        this.window.__tcfapi && this.window.__tcfapi("addEventListener", this.TCF_API_VERSION, this.handleTcfSubscriptionResponse.bind(this));
    }
    handleTcfSubscriptionResponse(tcdata) {
        if ((tcdata === null || tcdata === void 0 ? void 0 : tcdata.eventStatus) === "useractioncomplete" || (tcdata === null || tcdata === void 0 ? void 0 : tcdata.eventStatus) === "tcloaded") {
            const consent = this.detectTcfTrackingConsent(tcdata);
            this.consentsUpdated(consent);
            this.window.__tcfapi("removeEventListener", this.TCF_API_VERSION, null, tcdata.listenerId);
        }
    }
    readTrackingConsents() {
        this.window.__tcfapi && this.window.__tcfapi("getTCData", this.TCF_API_VERSION, this.handleReadConsentsResponse.bind(this));
    }
    handleReadConsentsResponse(tcdata) {
        if ((tcdata === null || tcdata === void 0 ? void 0 : tcdata.eventStatus) === "useractioncomplete" || (tcdata === null || tcdata === void 0 ? void 0 : tcdata.eventStatus) === "tcloaded") {
            const consent = this.detectTcfTrackingConsent(tcdata);
            this.consentsUpdated(consent);
        }
    }
    detectTcfTrackingConsent(tcdata) {
        if (tcdata === null || tcdata === void 0 ? void 0 : tcdata.purpose) return Object.keys(tcdata.purpose.consents).map((key)=>tcdata.purpose.consents[key]).reduce((previousValue, currentValue)=>currentValue + previousValue, 0) === this.IAB_PURPOSES_COUNT;
        else return false;
    }
    consentsUpdated(consent) {
        this.logger.info("Consents ready");
        this.resolveConsent({
            gdprConsent: consent,
            geoRequiresConsent: true,
            geoRequiresSignal: false,
            ccpaSignal: false
        });
    }
    getTCData(version) {
        return new Promise((resolve)=>{
            if (this.window.__tcfapi) this.window.__tcfapi("getTCData", version || this.TCF_API_VERSION, (tcData)=>resolve(tcData));
            else resolve({
                gdprApplies: false
            });
        });
    }
};
$8962dff93ebd0870$export$a0751edb8e5adc72 = (0, $c106e002a49a00cb$export$29e00dfd3077644b)([
    (0, $79188624df80f470$export$2e2bcd8739ae039)(),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(0, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $b8e408dd2b31a250$export$56d8a8a25bd48b81))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(1, (0, $190b0b497264ac3c$export$2e2bcd8739ae039)((0, $f009ac2c4949a5c1$export$efa9a398d6368992), (0, $f009ac2c4949a5c1$export$e41701f8b288055a), "TCF")),
    (0, $c106e002a49a00cb$export$f1db080c865becb9)("design:paramtypes", [
        typeof ($8962dff93ebd0870$var$_a = typeof Window !== "undefined" && Window) === "function" ? $8962dff93ebd0870$var$_a : Object,
        typeof ($8962dff93ebd0870$var$_b = typeof (0, $f009ac2c4949a5c1$export$efa9a398d6368992) !== "undefined" && (0, $f009ac2c4949a5c1$export$efa9a398d6368992)) === "function" ? $8962dff93ebd0870$var$_b : Object
    ])
], $8962dff93ebd0870$export$a0751edb8e5adc72);





var $ea4cbcb3eced3cf0$var$_a;
let $ea4cbcb3eced3cf0$export$4abb2a5b079f4f1 = class UspApi {
    constructor(window){
        this.window = window;
        this.USP_API_VERSION = 1;
        this.CCPA_TRACKING_ALLOWED = "1YN";
        this.queue = [];
        // this.installUspApi();
        // ToDo: Fix CCPA Consent query. Currently it is not needed, as we do handle that query in TrackingOptIn on
        //  Fandom Pages and via OneTrust on N&R pages
        this.consentGiven = new Promise((res)=>this.resolveConsent = res);
    // this.readTrackingConsents();
    // this.subscribe();
    }
    installUspApi() {
        this.window.__uspapi = this.uspApiMessage.bind(this);
        this.addLocatorFrame();
        this.addUspMessageListener();
    }
    consentsUpdated(consent) {
        this.resolveConsent({
            gdprConsent: true,
            geoRequiresConsent: false,
            geoRequiresSignal: true,
            ccpaSignal: !consent.startsWith(this.CCPA_TRACKING_ALLOWED)
        });
    }
    uspApiMessage(commandName, version, callback) {
        if (commandName === "ping") callback({
            uspapiLoaded: false
        }, true);
        else if (commandName === "getQueue") callback(this.queue, true);
        else this.queue.push([
            commandName,
            version,
            callback
        ]);
    }
    addLocatorFrame() {
        const name = "__uspapi";
        if (this.window.frames[name]) return;
        if (document.readyState === "loading") {
            document.addEventListener("DOMContentLoaded", ()=>this.addLocatorFrame());
            return;
        }
        const iframe = document.createElement("iframe");
        iframe.name = name;
        iframe.style.display = "none";
        document.body.appendChild(iframe);
    }
    addUspMessageListener() {
        this.window.addEventListener("message", (event)=>{
            const call = this.convertUspMessageData(event);
            if (call) this.uspMessageHandler(call, event);
        }, false);
    }
    convertUspMessageData(event) {
        try {
            const data = typeof event.data === "string" ? JSON.parse(event.data) : event.data;
            return data.__uspapiCall;
        } catch (error) {}
    }
    uspMessageHandler(call, event) {
        this.window.__uspapi(call.command, call.version, (returnValue, success)=>{
            const returnMsg = {
                __uspapiReturn: {
                    returnValue: returnValue,
                    success: success,
                    callId: call.callId
                }
            };
            event.source.postMessage(returnMsg, "*");
        });
    }
    // @ts-expect-error uspApi is currently not available in IE as it needs to be fixed
    subscribe() {
        this.window.__uspapi && this.window.__uspapi("addEventListener", this.USP_API_VERSION, this.consentsUpdated.bind(this));
    }
    // @ts-expect-error uspApi is currently not available in IE as it needs to be fixed
    readTrackingConsents() {
        this.window.__uspapi && this.window.__uspapi("getUSPData", this.USP_API_VERSION, this.consentsUpdated.bind(this));
    }
};
$ea4cbcb3eced3cf0$export$4abb2a5b079f4f1 = (0, $c106e002a49a00cb$export$29e00dfd3077644b)([
    (0, $79188624df80f470$export$2e2bcd8739ae039)(),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(0, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $b8e408dd2b31a250$export$56d8a8a25bd48b81))),
    (0, $c106e002a49a00cb$export$f1db080c865becb9)("design:paramtypes", [
        typeof ($ea4cbcb3eced3cf0$var$_a = typeof Window !== "undefined" && Window) === "function" ? $ea4cbcb3eced3cf0$var$_a : Object
    ])
], $ea4cbcb3eced3cf0$export$4abb2a5b079f4f1);









var $20d61e52c5e2b7c2$var$_a, $20d61e52c5e2b7c2$var$_b;
let $20d61e52c5e2b7c2$export$53c7806d00aa5f5f = class ConsentProviderFactory {
    constructor(logger, geo){
        this.logger = logger;
        this.geo = geo;
    }
    get(fandom1TEnabled = false) {
        const location = this.geo.getCountryCode();
        this.logger.info("Location: ", location);
        if (location) {
            if (location === "us") {
                this.logger.info("CCPA location");
                this.consentProvider = (0, $bef43bd5f0c77276$export$9544d5bb712b01ea).resolve((0, $ea4cbcb3eced3cf0$export$4abb2a5b079f4f1));
            } else if ((0, $c2def7e558dee4a0$export$c50418c2c95b7cca).includes(location)) {
                this.consentProvider = (0, $bef43bd5f0c77276$export$9544d5bb712b01ea).resolve((0, $8962dff93ebd0870$export$a0751edb8e5adc72));
                this.logger.info("__tcfapi installed");
            } else {
                this.logger.info("Privacy policy is not required");
                return Promise.resolve({
                    gdprConsent: true,
                    geoRequiresSignal: false,
                    geoRequiresConsent: false,
                    ccpaSignal: false
                });
            }
        }
        if (!fandom1TEnabled) return;
        const oneTrustFallback = (0, $bef43bd5f0c77276$export$9544d5bb712b01ea).resolve((0, $695b3e3d7c40fd9b$export$655dd1825ce8faf6));
        this.logger.info("OneTrust installed");
        const constQuery = [
            oneTrustFallback.consentGiven
        ];
        this.consentProvider && constQuery.push(this.consentProvider.consentGiven);
        return Promise.race(constQuery);
    }
};
$20d61e52c5e2b7c2$export$53c7806d00aa5f5f = (0, $c106e002a49a00cb$export$29e00dfd3077644b)([
    (0, $79188624df80f470$export$2e2bcd8739ae039)(),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(0, (0, $190b0b497264ac3c$export$2e2bcd8739ae039)((0, $f009ac2c4949a5c1$export$efa9a398d6368992), (0, $f009ac2c4949a5c1$export$e41701f8b288055a), "OptInService")),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(1, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $2f6e53771cd92caa$export$733db4df510f8a9))),
    (0, $c106e002a49a00cb$export$f1db080c865becb9)("design:paramtypes", [
        typeof ($20d61e52c5e2b7c2$var$_a = typeof (0, $f009ac2c4949a5c1$export$efa9a398d6368992) !== "undefined" && (0, $f009ac2c4949a5c1$export$efa9a398d6368992)) === "function" ? $20d61e52c5e2b7c2$var$_a : Object,
        typeof ($20d61e52c5e2b7c2$var$_b = typeof (0, $2f6e53771cd92caa$export$733db4df510f8a9) !== "undefined" && (0, $2f6e53771cd92caa$export$733db4df510f8a9)) === "function" ? $20d61e52c5e2b7c2$var$_b : Object
    ])
], $20d61e52c5e2b7c2$export$53c7806d00aa5f5f);






class $697309025c6aa3ae$export$e19cd5f9376f8cee {
    constructor(action, payload){
        this.__global = true;
        this.timestamp = Date.now();
        this.name = action.name;
        this.category = action.category || "[Identity]";
        this.type = `${this.category} ${action.name}`;
        Object.assign(this, payload);
    }
}



/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ var $0579da946ed68784$var$__assign = /*@__PURE__*/ function() {
    $0579da946ed68784$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0579da946ed68784$var$__assign.apply(this, arguments);
};
var $0579da946ed68784$var$DEFAULT_OPTIONS = /*@__PURE__*/ {
    channelId: "default",
    host: window,
    coordinatorHost: window.top
};
var $0579da946ed68784$var$INTERNAL_TYPES = /*@__PURE__*/ {
    connect: "connect",
    connected: "connected"
};
var $0579da946ed68784$var$LIB_ID = /*@__PURE__*/ "@wikia/post-quecast";
function $0579da946ed68784$var$isAction(input) {
    return typeof input.type === "string" && typeof input.timestamp === "number";
}
function $0579da946ed68784$export$c7feab631c6c66b4(input) {
    var types = [];
    for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
    return types.some(function(type) {
        return input.type === type;
    });
}
function $0579da946ed68784$var$isPostMessageData(input) {
    return input.channelId && input.libId === $0579da946ed68784$var$LIB_ID && input.action && $0579da946ed68784$var$isAction(input.action);
}
function $0579da946ed68784$var$isPostQuecastEvent(input) {
    return input && input.source && input.data && $0579da946ed68784$var$isPostMessageData(input.data);
}
function $0579da946ed68784$var$isEventPublic(event) {
    return !event.data.private;
}
function $0579da946ed68784$var$isEventPrivate(event) {
    return !!event.data.private;
}
function $0579da946ed68784$var$isEventOfChannel(event, channelId) {
    return event.data.channelId === channelId;
}
function $0579da946ed68784$var$isEventExternal(event) {
    return !Object.values($0579da946ed68784$var$INTERNAL_TYPES).some(function(type) {
        return event.data.action.type === type;
    });
}
function $0579da946ed68784$var$isEventOfType(event) {
    var types = [];
    for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
    return types.some(function(type) {
        return event.data.action.type === type;
    });
}
function $0579da946ed68784$var$getEventAction(event) {
    return event.data.action;
}
function $0579da946ed68784$var$isCallbackMode(options) {
    var _a;
    return options.host === options.coordinatorHost && !!((_a = options.coordinatorHost[$0579da946ed68784$var$LIB_ID]) === null || _a === void 0 ? void 0 : _a.callbackConnector);
}
var $0579da946ed68784$var$Connector = /*@__PURE__*/ function() {
    function Connector() {}
    Connector.make = function(options) {
        if ($0579da946ed68784$var$isCallbackMode(options)) return options.coordinatorHost[$0579da946ed68784$var$LIB_ID].callbackConnector;
        return new $0579da946ed68784$var$PostMessageConnector({
            senderHost: options.coordinatorHost,
            listenerHost: options.host
        });
    };
    return Connector;
}();
var $0579da946ed68784$var$CallbackConnector = /*@__PURE__*/ function() {
    function CallbackConnector(coordinatorHost) {
        this.coordinatorHost = coordinatorHost;
        this.callbacks = [];
    }
    CallbackConnector.prototype.dispatch = function(data) {
        var _this = this;
        if (!$0579da946ed68784$var$isPostMessageData(data)) throw new Error("Incorrect object type. Expected PostMessageData, but got " + data);
        this.callbacks.forEach(function(cb) {
            return cb({
                data: data,
                source: _this.coordinatorHost
            });
        });
    };
    CallbackConnector.prototype.addListener = function(cb) {
        this.callbacks.push(cb);
    };
    CallbackConnector.prototype.removeListener = function(cb) {
        this.callbacks = this.callbacks.filter(function(_cb) {
            return _cb !== cb;
        });
    };
    return CallbackConnector;
}();
var $0579da946ed68784$var$PostMessageConnector = /*@__PURE__*/ function() {
    function PostMessageConnector(options) {
        this.options = options;
        this.map = new Map();
    }
    PostMessageConnector.prototype.dispatch = function(data) {
        if (!$0579da946ed68784$var$isPostMessageData(data)) throw new Error("Incorrect object type. Expected PostMessageData, but got " + data);
        this.options.senderHost.postMessage(data, "*");
    };
    PostMessageConnector.prototype.addListener = function(cb) {
        var wrapper = function(event) {
            if (!$0579da946ed68784$var$isPostQuecastEvent(event)) return;
            cb(event);
        };
        this.map.set(cb, wrapper);
        this.options.listenerHost.addEventListener("message", wrapper);
    };
    PostMessageConnector.prototype.removeListener = function(cb) {
        var wrapper = this.map.get(cb);
        this.options.listenerHost.removeEventListener("message", wrapper);
        this.map.delete(cb);
    };
    return PostMessageConnector;
}();
var $0579da946ed68784$var$Receiver = /*@__PURE__*/ function() {
    function Receiver(options) {
        this.callbacks = [];
        this.history = [];
        this.channelId = options.channelId;
        this.connector = $0579da946ed68784$var$Connector.make(options);
        this.setupActions();
        this.setupConnection();
    }
    Receiver.prototype.setupActions = function() {
        this.getHistory();
        this.listenEvent();
    };
    Receiver.prototype.getHistory = function() {
        var _this = this;
        var callback = function(event) {
            if (!$0579da946ed68784$var$isEventOfChannel(event, _this.channelId)) return;
            if (!$0579da946ed68784$var$isEventPrivate(event)) return;
            var action = $0579da946ed68784$var$getEventAction(event);
            if (!$0579da946ed68784$export$c7feab631c6c66b4(action, $0579da946ed68784$var$INTERNAL_TYPES.connected)) return;
            _this.connector.removeListener(callback);
            _this.handleActions.apply(_this, action.history);
        };
        this.connector.addListener(callback);
    };
    Receiver.prototype.listenEvent = function() {
        var _this = this;
        var callback = function(event) {
            if (!$0579da946ed68784$var$isEventOfChannel(event, _this.channelId)) return;
            if (!$0579da946ed68784$var$isEventPublic(event)) return;
            var action = $0579da946ed68784$var$getEventAction(event);
            _this.handleActions(action);
        };
        this.connector.addListener(callback);
    };
    Receiver.prototype.handleActions = function() {
        var _a;
        var _this = this;
        var actions = [];
        for(var _i = 0; _i < arguments.length; _i++)actions[_i] = arguments[_i];
        (_a = this.history).push.apply(_a, actions);
        actions.forEach(function(action) {
            return _this.callbacks.forEach(function(cb) {
                return cb(action);
            });
        });
    };
    Receiver.prototype.setupConnection = function() {
        this.connector.dispatch({
            action: {
                type: $0579da946ed68784$var$INTERNAL_TYPES.connect,
                timestamp: Date.now()
            },
            channelId: this.channelId,
            private: true,
            libId: $0579da946ed68784$var$LIB_ID
        });
    };
    Receiver.prototype.addListener = function(cb) {
        this.history.forEach(function(action) {
            return cb(action);
        });
        this.callbacks.push(cb);
    };
    Receiver.prototype.removeListener = function(cb) {
        this.callbacks = this.callbacks.filter(function(_cb) {
            return _cb !== cb;
        });
    };
    return Receiver;
}();
var $0579da946ed68784$export$5631e6a5c65e781c = /*@__PURE__*/ function() {
    function Transmitter(_options) {
        if (_options === void 0) _options = {};
        var options = $0579da946ed68784$var$__assign($0579da946ed68784$var$__assign({}, $0579da946ed68784$var$DEFAULT_OPTIONS), _options);
        this.channelId = options.channelId;
        this.connector = $0579da946ed68784$var$Connector.make(options);
    }
    Transmitter.prototype.dispatch = function(action) {
        this.connector.dispatch({
            action: $0579da946ed68784$var$__assign($0579da946ed68784$var$__assign({}, action), {
                timestamp: Date.now()
            }),
            channelId: this.channelId,
            private: true,
            libId: $0579da946ed68784$var$LIB_ID
        });
    };
    return Transmitter;
}();
var $0579da946ed68784$export$ec474664c5a324f1 = /*@__PURE__*/ function() {
    function Communicator(_options) {
        if (_options === void 0) _options = {};
        var options = $0579da946ed68784$var$__assign($0579da946ed68784$var$__assign({}, $0579da946ed68784$var$DEFAULT_OPTIONS), _options);
        this.transmitter = new $0579da946ed68784$export$5631e6a5c65e781c(options);
        this.receiver = new $0579da946ed68784$var$Receiver(options);
    }
    Communicator.prototype.dispatch = function(action) {
        this.transmitter.dispatch(action);
    };
    Communicator.prototype.addListener = function(cb) {
        this.receiver.addListener(cb);
    };
    Communicator.prototype.removeListener = function(cb) {
        this.receiver.removeListener(cb);
    };
    return Communicator;
}();
var $0579da946ed68784$var$Channel = /*@__PURE__*/ function() {
    function Channel(channelId, coordinatorHost) {
        this.channelId = channelId;
        this.connectors = new Map();
        this.history = [];
        this.connectors.set(coordinatorHost, coordinatorHost[$0579da946ed68784$var$LIB_ID].callbackConnector);
    }
    Channel.prototype.addConnection = function(connection) {
        this.ensureConnector(connection).dispatch({
            action: this.createConnectedAction(),
            private: true,
            channelId: this.channelId,
            libId: $0579da946ed68784$var$LIB_ID
        });
    };
    Channel.prototype.createConnectedAction = function() {
        return {
            type: $0579da946ed68784$var$INTERNAL_TYPES.connected,
            history: this.history,
            timestamp: Date.now()
        };
    };
    Channel.prototype.broadcast = function(action) {
        var _this = this;
        this.history.push(action);
        this.connectors.forEach(function(connector) {
            connector.dispatch({
                action: action,
                channelId: _this.channelId,
                libId: $0579da946ed68784$var$LIB_ID
            });
        });
    };
    Channel.prototype.ensureConnector = function(connection) {
        if (!this.connectors.has(connection)) this.connectors.set(connection, new $0579da946ed68784$var$PostMessageConnector({
            senderHost: connection,
            listenerHost: connection
        }));
        return this.connectors.get(connection);
    };
    return Channel;
}();
var $0579da946ed68784$var$Coordinator = /*@__PURE__*/ function() {
    function Coordinator(coordinatorHost) {
        this.coordinatorHost = coordinatorHost;
        this.channels = new Map();
        this.callbackConnector = new $0579da946ed68784$var$CallbackConnector(coordinatorHost);
        this.postMessageConnector = new $0579da946ed68784$var$PostMessageConnector({
            senderHost: coordinatorHost,
            listenerHost: coordinatorHost
        });
    }
    Coordinator.prototype.init = function() {
        var _this = this;
        var handleEvents = function(event) {
            if ($0579da946ed68784$var$isEventPublic(event)) return;
            _this.handleConnect(event);
            _this.handleBroadcast(event);
        };
        this.callbackConnector.addListener(handleEvents);
        this.postMessageConnector.addListener(handleEvents);
    };
    Coordinator.prototype.handleConnect = function(event) {
        if (!$0579da946ed68784$var$isEventOfType(event, $0579da946ed68784$var$INTERNAL_TYPES.connect)) return;
        var channel = this.ensureChannel(event.data.channelId);
        channel.addConnection(event.source);
    };
    Coordinator.prototype.handleBroadcast = function(event) {
        if (!$0579da946ed68784$var$isEventExternal(event)) return;
        var channel = this.ensureChannel(event.data.channelId);
        channel.broadcast(event.data.action);
    };
    Coordinator.prototype.ensureChannel = function(channelId) {
        if (!this.channels.has(channelId)) this.channels.set(channelId, new $0579da946ed68784$var$Channel(channelId, this.coordinatorHost));
        return this.channels.get(channelId);
    };
    return Coordinator;
}();
function $0579da946ed68784$export$84bf689176084133(coordinatorHost) {
    if (coordinatorHost === void 0) coordinatorHost = window;
    if (!!coordinatorHost[$0579da946ed68784$var$LIB_ID]) return;
    var coordinator = new $0579da946ed68784$var$Coordinator(coordinatorHost);
    coordinator.init();
    coordinatorHost[$0579da946ed68784$var$LIB_ID] = coordinator;
}




var $fdfc6e1cf47ae084$var$_a;
const $fdfc6e1cf47ae084$var$SETTINGS_KEY = "@wikia/post-quecast-settings";
let $fdfc6e1cf47ae084$export$539550160b78d8c5 = class CommunicationService {
    constructor(window){
        this.window = window;
        this.history = new Map();
        const { channelId: channelId , coordinatorName: coordinatorName  } = this.getSettings();
        (0, $0579da946ed68784$export$84bf689176084133)();
        this.communicator = new (0, $0579da946ed68784$export$ec474664c5a324f1)({
            channelId: channelId || "default",
            coordinatorHost: window[coordinatorName] || top
        });
    }
    emit(action) {
        this.communicator.dispatch(action);
    }
    on(action, callback) {
        this.communicator.addListener((a)=>this.run(a, action, callback));
    }
    once(action, callback) {
        this.communicator.addListener((a)=>this.runOnce(a, action, callback));
    }
    getSettings() {
        return this.window[$fdfc6e1cf47ae084$var$SETTINGS_KEY] || {};
    }
    run(action, actionToListen, callback) {
        if (this.ofType(action, actionToListen)) callback(action);
    }
    runOnce(action, actionToListen, callback) {
        const key = actionToListen.category + " " + actionToListen.name;
        if (!this.ofType(action, actionToListen)) return;
        if (this.history.has(key)) return;
        this.history.set(key, true);
        callback(action);
    }
    ofType(action, actionToListen) {
        return action.category === actionToListen.category && action.name === actionToListen.name || action.type === actionToListen.category + " " + actionToListen.name;
    }
};
$fdfc6e1cf47ae084$export$539550160b78d8c5 = (0, $c106e002a49a00cb$export$29e00dfd3077644b)([
    (0, $79188624df80f470$export$2e2bcd8739ae039)(),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(0, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $b8e408dd2b31a250$export$56d8a8a25bd48b81))),
    (0, $c106e002a49a00cb$export$f1db080c865becb9)("design:paramtypes", [
        typeof ($fdfc6e1cf47ae084$var$_a = typeof Window !== "undefined" && Window) === "function" ? $fdfc6e1cf47ae084$var$_a : Object
    ])
], $fdfc6e1cf47ae084$export$539550160b78d8c5);


const $9bac733ad19ab912$export$7f305d1b47333a2 = {
    CONSENT_READY: {
        category: "[AdEngine OptIn]",
        name: "set opt in"
    },
    IDENTITY_READY: {
        category: "[IdentityEngine]",
        name: "Identity ready"
    },
    IDENTITY_PARTNER_DATA_OBTAINED: {
        category: "[AdEngine]",
        name: "Identity partner data obtained"
    },
    AGE_GATE_DATA: {
        name: "Age gate result",
        category: "[Identity]"
    },
    AUDIGENT_SEGMENT_LIBRARY_LOADED: {
        name: "Audigent segment library loaded"
    },
    AUDIGENT_MATCHES_LIBRARY_LOADED: {
        name: "Audigent matches library loaded"
    },
    AUDIGENT_SEGMENTS_READY: {
        name: "Audigent segments ready"
    },
    EYEOTA_STARTED: {
        name: "Eyeota started"
    },
    EYEOTA_FAILED: {
        name: "Eyeota loading failed"
    },
    LIVE_CONNECT_STARTED: {
        name: "LiveConnect started"
    },
    LIVE_CONNECT_CACHED: {
        name: "LiveConnect data cached"
    },
    LIVE_CONNECT_RESPONDED_UUID: {
        name: "LiveConnect responded with UUID"
    }
};





var $03c2d474d5127683$exports = {};
function $03c2d474d5127683$var$$parcel$exportWildcard(dest, source) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || dest.hasOwnProperty(key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function get() {
                return source[key];
            }
        });
    });
    return dest;
}
function $03c2d474d5127683$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
$03c2d474d5127683$var$$parcel$export($03c2d474d5127683$exports, "utils", ()=>$03c2d474d5127683$var$$d7167569386d0d4c$exports);
var $03c2d474d5127683$var$$d7167569386d0d4c$exports = {};
var $03c2d474d5127683$var$$3bca631f7e12b649$exports = {};
$03c2d474d5127683$var$$parcel$export($03c2d474d5127683$var$$3bca631f7e12b649$exports, "delay", ()=>$03c2d474d5127683$var$$3bca631f7e12b649$export$1391212d75b2ee65);
function $03c2d474d5127683$var$$3bca631f7e12b649$export$1391212d75b2ee65(timeInMillis) {
    return new Promise((resolve)=>setTimeout(()=>resolve(), timeInMillis));
}
var $03c2d474d5127683$var$$8f8d85013a66f887$exports = {};
$03c2d474d5127683$var$$parcel$export($03c2d474d5127683$var$$8f8d85013a66f887$exports, "getDebugGroup", ()=>$03c2d474d5127683$var$$8f8d85013a66f887$export$c70183eb5acc76d7);
function $03c2d474d5127683$var$$8f8d85013a66f887$export$c70183eb5acc76d7() {
    const searchParams = new URLSearchParams(window.location.search.substring(1));
    if (Boolean(searchParams.get("adengine_debug"))) return searchParams.get("adengine_debug");
    return searchParams.get("identity_debug");
}
var $03c2d474d5127683$var$$d9d01dee3649e94d$exports = {};
$03c2d474d5127683$var$$parcel$export($03c2d474d5127683$var$$d9d01dee3649e94d$exports, "localStorageHelper", ()=>$03c2d474d5127683$var$$d9d01dee3649e94d$export$2a8d33e352660a9b);
class $03c2d474d5127683$var$$d9d01dee3649e94d$export$2a8d33e352660a9b {
    constructor(key, ttlInMilliseconds = 60000){
        this.key = key;
        this.ttlInMilliseconds = ttlInMilliseconds;
    }
    expired(ttl) {
        return ttl ? ttl < Date.now() : true;
    }
    getObjectToStore(data) {
        return {
            data: data,
            ttl: Date.now() + this.ttlInMilliseconds
        };
    }
    parseStoredValue(storedValue) {
        const json = JSON.parse(storedValue);
        return this.expired(json?.ttl) ? null : json.data;
    }
    get() {
        const storedValue = localStorage.getItem(this.key);
        return !storedValue ? null : this.parseStoredValue(storedValue);
    }
    set(data) {
        const objectToStore = this.getObjectToStore(data);
        localStorage.setItem(this.key, JSON.stringify(objectToStore));
    }
}
var $03c2d474d5127683$var$$30ba9362ac1ffe4b$exports = {};
$03c2d474d5127683$var$$parcel$export($03c2d474d5127683$var$$30ba9362ac1ffe4b$exports, "lock", ()=>$03c2d474d5127683$var$$30ba9362ac1ffe4b$export$6a9f04c98a658ecb);
$03c2d474d5127683$var$$parcel$export($03c2d474d5127683$var$$30ba9362ac1ffe4b$exports, "release", ()=>$03c2d474d5127683$var$$30ba9362ac1ffe4b$export$23d3fad09dc44362);
const $03c2d474d5127683$var$$30ba9362ac1ffe4b$var$storage = new $03c2d474d5127683$var$$d9d01dee3649e94d$export$2a8d33e352660a9b("instant-config-lock", 1000);
function $03c2d474d5127683$var$$30ba9362ac1ffe4b$export$6a9f04c98a658ecb() {
    if ($03c2d474d5127683$var$$30ba9362ac1ffe4b$var$storage.get() === "lock") return true;
    $03c2d474d5127683$var$$30ba9362ac1ffe4b$var$storage.set("lock");
    return false;
}
function $03c2d474d5127683$var$$30ba9362ac1ffe4b$export$23d3fad09dc44362() {
    $03c2d474d5127683$var$$30ba9362ac1ffe4b$var$storage.set(null);
}
var $03c2d474d5127683$var$$e0f8e7cf88064837$exports = {};
$03c2d474d5127683$var$$parcel$export($03c2d474d5127683$var$$e0f8e7cf88064837$exports, "getTimeDelta", ()=>$03c2d474d5127683$var$$e0f8e7cf88064837$export$85f2155d703a252d);
$03c2d474d5127683$var$$parcel$export($03c2d474d5127683$var$$e0f8e7cf88064837$exports, "logger", ()=>$03c2d474d5127683$var$$e0f8e7cf88064837$export$af88d00dbe7f521);
$03c2d474d5127683$var$$parcel$export($03c2d474d5127683$var$$e0f8e7cf88064837$exports, "warner", ()=>$03c2d474d5127683$var$$e0f8e7cf88064837$export$73a23a961d4d2188);
const $03c2d474d5127683$var$$e0f8e7cf88064837$var$debugGroup = $03c2d474d5127683$var$$8f8d85013a66f887$export$c70183eb5acc76d7() || "";
const $03c2d474d5127683$var$$e0f8e7cf88064837$var$groups = $03c2d474d5127683$var$$e0f8e7cf88064837$var$debugGroup.split(",");
const $03c2d474d5127683$var$$e0f8e7cf88064837$var$BACKUP_ORIGIN_TIME = Date.now();
function $03c2d474d5127683$var$$e0f8e7cf88064837$export$85f2155d703a252d() {
    const currentTimeStamp = Date.now();
    const originTime = window.performance?.timeOrigin ?? $03c2d474d5127683$var$$e0f8e7cf88064837$var$BACKUP_ORIGIN_TIME;
    const delta = currentTimeStamp - originTime;
    const secondsResult = delta / 1000;
    return secondsResult.toFixed(4);
}
function $03c2d474d5127683$var$$e0f8e7cf88064837$export$af88d00dbe7f521(logGroup, ...logValues) {
    if ($03c2d474d5127683$var$$e0f8e7cf88064837$var$debugGroup === "") return;
    if ($03c2d474d5127683$var$$e0f8e7cf88064837$var$debugGroup === "1" || $03c2d474d5127683$var$$e0f8e7cf88064837$var$groups.indexOf(logGroup) !== -1) window.console.info(`${$03c2d474d5127683$var$$e0f8e7cf88064837$export$85f2155d703a252d()}s\t\t ${logGroup}`, logValues);
}
function $03c2d474d5127683$var$$e0f8e7cf88064837$export$73a23a961d4d2188(warnGroup, ...warnValues) {
    if ($03c2d474d5127683$var$$e0f8e7cf88064837$var$debugGroup === "") return;
    if ($03c2d474d5127683$var$$e0f8e7cf88064837$var$debugGroup === "1" || $03c2d474d5127683$var$$e0f8e7cf88064837$var$groups.indexOf(warnGroup) !== -1) window.console.warn(warnGroup, warnValues);
}
$03c2d474d5127683$var$$parcel$exportWildcard($03c2d474d5127683$var$$d7167569386d0d4c$exports, $03c2d474d5127683$var$$3bca631f7e12b649$exports);
$03c2d474d5127683$var$$parcel$exportWildcard($03c2d474d5127683$var$$d7167569386d0d4c$exports, $03c2d474d5127683$var$$8f8d85013a66f887$exports);
$03c2d474d5127683$var$$parcel$exportWildcard($03c2d474d5127683$var$$d7167569386d0d4c$exports, $03c2d474d5127683$var$$d9d01dee3649e94d$exports);
$03c2d474d5127683$var$$parcel$exportWildcard($03c2d474d5127683$var$$d7167569386d0d4c$exports, $03c2d474d5127683$var$$30ba9362ac1ffe4b$exports);
$03c2d474d5127683$var$$parcel$exportWildcard($03c2d474d5127683$var$$d7167569386d0d4c$exports, $03c2d474d5127683$var$$e0f8e7cf88064837$exports);
var $03c2d474d5127683$var$$583683d1b436d65c$exports = {};
var $03c2d474d5127683$var$$d4581a365416e9ee$exports = {};
$03c2d474d5127683$var$$parcel$export($03c2d474d5127683$var$$d4581a365416e9ee$exports, "EmptyInstantConfigCacheStorage", ()=>$03c2d474d5127683$var$$d4581a365416e9ee$export$c81e13f6e9617a56);
class $03c2d474d5127683$var$$d4581a365416e9ee$export$c81e13f6e9617a56 {
    get(id) {
        return undefined;
    }
    set(data) {}
}
var $03c2d474d5127683$var$$15d63f1bfc4bb821$exports = {};
$03c2d474d5127683$var$$parcel$export($03c2d474d5127683$var$$15d63f1bfc4bb821$exports, "InstantConfigInterpreter", ()=>$03c2d474d5127683$var$$15d63f1bfc4bb821$export$482d435527222f10);
var $03c2d474d5127683$var$$89ffc9b2062f304b$exports = {};
var $03c2d474d5127683$var$$405744dd7ce6d50f$exports = {};
$03c2d474d5127683$var$$parcel$export($03c2d474d5127683$var$$405744dd7ce6d50f$exports, "BrowserMatcher", ()=>$03c2d474d5127683$var$$405744dd7ce6d50f$export$4505b7bf40f87994);
var $03c2d474d5127683$var$$ddc7f0da9f8c7cab$exports = {};
$03c2d474d5127683$var$$parcel$export($03c2d474d5127683$var$$ddc7f0da9f8c7cab$exports, "extractNegation", ()=>$03c2d474d5127683$var$$ddc7f0da9f8c7cab$export$a3f4cf710f4ee0af);
var $03c2d474d5127683$var$$b9c8418edb6cb5ed$exports = {};
var $03c2d474d5127683$var$$8dbd42f8585f4a0f$exports = {};
var $03c2d474d5127683$var$$f37386de1dafa5cb$exports = {};
var $03c2d474d5127683$var$$136f43ccf5c8a695$exports = {};
var $03c2d474d5127683$var$$1573f882a631b63d$exports = {};
var $03c2d474d5127683$var$$3acdfa9f3a7dc4e4$exports = {};
var $03c2d474d5127683$var$$3694c9182cdb2fa5$exports = {};
var $03c2d474d5127683$var$$1af23f87dbb2a880$exports = {};
var $03c2d474d5127683$var$$5ee3e5908b33855d$exports = {};
var $03c2d474d5127683$var$$8514c556b5f7df10$exports = {};
var $03c2d474d5127683$var$$4c1928f7ffe746a1$exports = {};
$03c2d474d5127683$var$$parcel$export($03c2d474d5127683$var$$4c1928f7ffe746a1$exports, "negativePrefix", ()=>$03c2d474d5127683$var$$4c1928f7ffe746a1$export$6a1a21b83e21c671);
$03c2d474d5127683$var$$parcel$export($03c2d474d5127683$var$$4c1928f7ffe746a1$exports, "cacheSuffix", ()=>$03c2d474d5127683$var$$4c1928f7ffe746a1$export$4940459403f61e72);
$03c2d474d5127683$var$$parcel$export($03c2d474d5127683$var$$4c1928f7ffe746a1$exports, "samplingSeparator", ()=>$03c2d474d5127683$var$$4c1928f7ffe746a1$export$8c99e8be8e35246);
$03c2d474d5127683$var$$parcel$export($03c2d474d5127683$var$$4c1928f7ffe746a1$exports, "worldWide", ()=>$03c2d474d5127683$var$$4c1928f7ffe746a1$export$aea6dbf29fd09cb3);
$03c2d474d5127683$var$$parcel$export($03c2d474d5127683$var$$4c1928f7ffe746a1$exports, "precision", ()=>$03c2d474d5127683$var$$4c1928f7ffe746a1$export$b70eeb0e623ceb0d);
const $03c2d474d5127683$var$$4c1928f7ffe746a1$export$6a1a21b83e21c671 = "non-";
const $03c2d474d5127683$var$$4c1928f7ffe746a1$export$4940459403f61e72 = "-cached";
const $03c2d474d5127683$var$$4c1928f7ffe746a1$export$8c99e8be8e35246 = "/";
const $03c2d474d5127683$var$$4c1928f7ffe746a1$export$aea6dbf29fd09cb3 = "XX";
const $03c2d474d5127683$var$$4c1928f7ffe746a1$export$b70eeb0e623ceb0d = 10 ** 6;
$03c2d474d5127683$var$$parcel$exportWildcard($03c2d474d5127683$var$$b9c8418edb6cb5ed$exports, $03c2d474d5127683$var$$8dbd42f8585f4a0f$exports);
$03c2d474d5127683$var$$parcel$exportWildcard($03c2d474d5127683$var$$b9c8418edb6cb5ed$exports, $03c2d474d5127683$var$$f37386de1dafa5cb$exports);
$03c2d474d5127683$var$$parcel$exportWildcard($03c2d474d5127683$var$$b9c8418edb6cb5ed$exports, $03c2d474d5127683$var$$136f43ccf5c8a695$exports);
$03c2d474d5127683$var$$parcel$exportWildcard($03c2d474d5127683$var$$b9c8418edb6cb5ed$exports, $03c2d474d5127683$var$$1573f882a631b63d$exports);
$03c2d474d5127683$var$$parcel$exportWildcard($03c2d474d5127683$var$$b9c8418edb6cb5ed$exports, $03c2d474d5127683$var$$3acdfa9f3a7dc4e4$exports);
$03c2d474d5127683$var$$parcel$exportWildcard($03c2d474d5127683$var$$b9c8418edb6cb5ed$exports, $03c2d474d5127683$var$$3694c9182cdb2fa5$exports);
$03c2d474d5127683$var$$parcel$exportWildcard($03c2d474d5127683$var$$b9c8418edb6cb5ed$exports, $03c2d474d5127683$var$$1af23f87dbb2a880$exports);
$03c2d474d5127683$var$$parcel$exportWildcard($03c2d474d5127683$var$$b9c8418edb6cb5ed$exports, $03c2d474d5127683$var$$5ee3e5908b33855d$exports);
$03c2d474d5127683$var$$parcel$exportWildcard($03c2d474d5127683$var$$b9c8418edb6cb5ed$exports, $03c2d474d5127683$var$$8514c556b5f7df10$exports);
$03c2d474d5127683$var$$parcel$exportWildcard($03c2d474d5127683$var$$b9c8418edb6cb5ed$exports, $03c2d474d5127683$var$$4c1928f7ffe746a1$exports);
function $03c2d474d5127683$var$$ddc7f0da9f8c7cab$export$a3f4cf710f4ee0af(input) {
    return input.startsWith($03c2d474d5127683$var$$4c1928f7ffe746a1$export$6a1a21b83e21c671) ? {
        value: input.replace($03c2d474d5127683$var$$4c1928f7ffe746a1$export$6a1a21b83e21c671, ""),
        negated: true
    } : {
        value: input,
        negated: false
    };
}
class $03c2d474d5127683$var$$405744dd7ce6d50f$export$4505b7bf40f87994 {
    constructor(currentBrowser){
        this.currentBrowser = currentBrowser?.toLowerCase();
    }
    isValid(browsers = []) {
        const browserObjects = browsers.map((browser)=>browser.toLowerCase()).map((browser)=>$03c2d474d5127683$var$$ddc7f0da9f8c7cab$export$a3f4cf710f4ee0af(browser));
        if (browsers.length === 0) return true;
        if (!this.currentBrowser) return true; // FIXME: na pewno? unit test
        if (this.isCurrentNegated(this.currentBrowser, browserObjects)) return false;
        return browserObjects.some((object)=>this.currentBrowser.includes(object.value) !== object.negated);
    }
    isCurrentNegated(currentBrowser, browserObjects) {
        return browserObjects.some((object)=>currentBrowser.includes(object.value) && object.negated);
    }
}
var $03c2d474d5127683$var$$e81ea42c614be70e$exports = {};
$03c2d474d5127683$var$$parcel$export($03c2d474d5127683$var$$e81ea42c614be70e$exports, "DeviceMatcher", ()=>$03c2d474d5127683$var$$e81ea42c614be70e$export$b2a88ef241f2bd3f);
class $03c2d474d5127683$var$$e81ea42c614be70e$export$b2a88ef241f2bd3f {
    constructor(currentDevice){
        this.currentDevice = currentDevice;
    }
    isValid(devices = []) {
        const deviceObjects = devices.map((browser)=>browser.toLowerCase()).map((browser)=>$03c2d474d5127683$var$$ddc7f0da9f8c7cab$export$a3f4cf710f4ee0af(browser));
        if (deviceObjects.length === 0) return true;
        if (!this.currentDevice) return true; // FIXME: na pewno? unit test
        if (this.isCurrentNegated(this.currentDevice, deviceObjects)) return false;
        return deviceObjects.some((object)=>object.value === this.currentDevice !== object.negated);
    }
    isCurrentNegated(currentDevice, deviceObjects) {
        return deviceObjects.some((object)=>currentDevice.includes(object.value) && object.negated);
    }
}
var $03c2d474d5127683$var$$56c45358b989a2ec$exports = {};
$03c2d474d5127683$var$$parcel$export($03c2d474d5127683$var$$56c45358b989a2ec$exports, "DomainMatcher", ()=>$03c2d474d5127683$var$$56c45358b989a2ec$export$48fd90bf831be0f8);
class $03c2d474d5127683$var$$56c45358b989a2ec$export$48fd90bf831be0f8 {
    isValid(domains = []) {
        if (domains.length === 0) return true;
        return domains.some((domain)=>window.location.hostname.includes(domain));
    }
}
var $03c2d474d5127683$var$$8965000d96eca076$exports = {};
$03c2d474d5127683$var$$parcel$export($03c2d474d5127683$var$$8965000d96eca076$exports, "RegionMatcher", ()=>$03c2d474d5127683$var$$8965000d96eca076$export$9dd39bf33dcd6ef6);
class $03c2d474d5127683$var$$8965000d96eca076$export$9dd39bf33dcd6ef6 {
    constructor(geo){
        this.geo = geo;
    }
    isValid(regions = [], validateRegionPredicate) {
        const validRegions = this.filterOutInvalidRegions(regions);
        return validateRegionPredicate ? validateRegionPredicate(validRegions) : this.isProperGeo(validRegions);
    }
    getCountryCode() {
        return this.geo?.country;
    }
    getRegionCode() {
        return this.geo?.region;
    }
    getContinentCode() {
        return this.geo?.continent;
    }
    isProperGeo(countryList = []) {
        return !!(countryList && countryList.indexOf && !this.isGeoExcluded(countryList) && (this.isProperContinent(countryList) || this.isProperCountry(countryList) || this.isProperRegion(countryList)));
    }
    filterOutInvalidRegions(regions) {
        return regions.filter((region)=>!region.includes($03c2d474d5127683$var$$4c1928f7ffe746a1$export$8c99e8be8e35246)).filter((region)=>!region.includes($03c2d474d5127683$var$$4c1928f7ffe746a1$export$4940459403f61e72));
    }
    isProperCountry(countryList) {
        return !!(countryList && countryList.indexOf && (countryList.indexOf(this.getCountryCode()) > -1 || this.isSampledForGeo(countryList, this.getCountryCode())));
    }
    isProperRegion(countryList) {
        const code = `${this.getCountryCode()}-${this.getRegionCode()}`;
        return !!(countryList && countryList.indexOf && (countryList.indexOf(code) > -1 || this.isSampledForGeo(countryList, code)));
    }
    containsContinent(countryList) {
        const geo = `${$03c2d474d5127683$var$$4c1928f7ffe746a1$export$aea6dbf29fd09cb3}-${this.getContinentCode()}`;
        return countryList.indexOf(geo) > -1 || this.isSampledForGeo(countryList, geo);
    }
    containsWorldWide(countryList) {
        return countryList.indexOf($03c2d474d5127683$var$$4c1928f7ffe746a1$export$aea6dbf29fd09cb3) > -1 || this.isSampledForGeo(countryList, $03c2d474d5127683$var$$4c1928f7ffe746a1$export$aea6dbf29fd09cb3);
    }
    isProperContinent(countryList) {
        return !!(countryList && countryList.indexOf && (this.containsWorldWide(countryList) || this.containsContinent(countryList)));
    }
    isGeoExcluded(countryList) {
        return !!(countryList.indexOf(`${$03c2d474d5127683$var$$4c1928f7ffe746a1$export$6a1a21b83e21c671}${this.getCountryCode()}`) > -1 || countryList.indexOf(`${$03c2d474d5127683$var$$4c1928f7ffe746a1$export$6a1a21b83e21c671}${this.getCountryCode()}-${this.getRegionCode()}`) > -1 || countryList.indexOf(`${$03c2d474d5127683$var$$4c1928f7ffe746a1$export$6a1a21b83e21c671}${$03c2d474d5127683$var$$4c1928f7ffe746a1$export$aea6dbf29fd09cb3}-${this.getContinentCode()}`) > -1);
    }
    hasSampling(geo) {
        return (value)=>value.indexOf($03c2d474d5127683$var$$4c1928f7ffe746a1$export$6a1a21b83e21c671) !== 0 && value.indexOf(geo + $03c2d474d5127683$var$$4c1928f7ffe746a1$export$8c99e8be8e35246) > -1;
    }
    getSamplingLimits(value) {
        let [, samplingValue] = value.split($03c2d474d5127683$var$$4c1928f7ffe746a1$export$8c99e8be8e35246);
        samplingValue = samplingValue.replace($03c2d474d5127683$var$$4c1928f7ffe746a1$export$4940459403f61e72, "");
        return Math.round(parseFloat(samplingValue) * $03c2d474d5127683$var$$4c1928f7ffe746a1$export$b70eeb0e623ceb0d) || 0;
    }
    isSampledForGeo(countryList, geo) {
        const countryListWithSampling = countryList.filter(this.hasSampling(geo));
        if (countryListWithSampling.length === 0) return false;
        const randomValue = Math.round(Math.random() * ($03c2d474d5127683$var$$4c1928f7ffe746a1$export$b70eeb0e623ceb0d * 100)) || 0;
        return countryListWithSampling.map((value)=>this.getSamplingLimits(value)).some((value)=>randomValue < value);
    }
}
var $03c2d474d5127683$var$$aa30ebecbe06fe3a$exports = {};
$03c2d474d5127683$var$$parcel$export($03c2d474d5127683$var$$aa30ebecbe06fe3a$exports, "SamplingCacheManager", ()=>$03c2d474d5127683$var$$aa30ebecbe06fe3a$export$7e75aba54255ff4a);
class $03c2d474d5127683$var$$aa30ebecbe06fe3a$export$7e75aba54255ff4a {
    constructor(cacheStorage){
        this.cacheStorage = cacheStorage;
        this.precision = 10 ** 6;
    }
    apply(id, samplingCache, predicate) {
        const cached = this.cacheStorage.get(id);
        if (typeof cached !== "undefined") return cached.result;
        const value = predicate();
        if (typeof samplingCache.sampling !== "number" || value === false) return value;
        const samplingResult = this.getSamplingResult(samplingCache.sampling);
        const cacheData = {
            name: id,
            result: samplingResult,
            withCookie: Boolean(samplingCache.samplingCache),
            group: samplingResult ? "B" : "A",
            limit: +(samplingResult ? samplingCache.sampling : 100 - samplingCache.sampling).toFixed(6)
        };
        this.cacheStorage.set(cacheData);
        return samplingResult;
    }
    getSamplingResult(sampling) {
        const randomValue = Math.round(Math.random() * 100 * this.precision);
        const samplingValue = Math.round(sampling * this.precision);
        return samplingValue > randomValue;
    }
}
$03c2d474d5127683$var$$parcel$exportWildcard($03c2d474d5127683$var$$89ffc9b2062f304b$exports, $03c2d474d5127683$var$$405744dd7ce6d50f$exports);
$03c2d474d5127683$var$$parcel$exportWildcard($03c2d474d5127683$var$$89ffc9b2062f304b$exports, $03c2d474d5127683$var$$e81ea42c614be70e$exports);
$03c2d474d5127683$var$$parcel$exportWildcard($03c2d474d5127683$var$$89ffc9b2062f304b$exports, $03c2d474d5127683$var$$56c45358b989a2ec$exports);
$03c2d474d5127683$var$$parcel$exportWildcard($03c2d474d5127683$var$$89ffc9b2062f304b$exports, $03c2d474d5127683$var$$ddc7f0da9f8c7cab$exports);
$03c2d474d5127683$var$$parcel$exportWildcard($03c2d474d5127683$var$$89ffc9b2062f304b$exports, $03c2d474d5127683$var$$8965000d96eca076$exports);
$03c2d474d5127683$var$$parcel$exportWildcard($03c2d474d5127683$var$$89ffc9b2062f304b$exports, $03c2d474d5127683$var$$aa30ebecbe06fe3a$exports);
class $03c2d474d5127683$var$$15d63f1bfc4bb821$export$482d435527222f10 {
    constructor(browserMatcher = new $03c2d474d5127683$var$$405744dd7ce6d50f$export$4505b7bf40f87994(), deviceMatcher = new $03c2d474d5127683$var$$e81ea42c614be70e$export$b2a88ef241f2bd3f(), domainMatcher = new $03c2d474d5127683$var$$56c45358b989a2ec$export$48fd90bf831be0f8(), regionMatcher = new $03c2d474d5127683$var$$8965000d96eca076$export$9dd39bf33dcd6ef6(), instantConfigCacheService = new $03c2d474d5127683$var$$d4581a365416e9ee$export$c81e13f6e9617a56()){
        this.browserMatcher = browserMatcher;
        this.deviceMatcher = deviceMatcher;
        this.domainMatcher = domainMatcher;
        this.regionMatcher = regionMatcher;
        this.instantConfigCacheService = instantConfigCacheService;
        this.logGroup = "instant-config-interpreter";
        this.configResponse = {};
        this.samplingCache = new $03c2d474d5127683$var$$aa30ebecbe06fe3a$export$7e75aba54255ff4a(instantConfigCacheService);
    }
    init(instantConfig, instantGlobals = {}, regionValidationPredicate) {
        this.configResponse = {
            ...instantGlobals,
            ...instantConfig
        };
        this.regionValidationPredicate = regionValidationPredicate;
        return this;
    }
    getValues() {
        $03c2d474d5127683$var$$d7167569386d0d4c$exports.logger(this.logGroup, "get values called with", this.configResponse);
        return Object.keys(this.configResponse).map((key)=>({
                key: key,
                value: this.configResponse[key]
            })).map(({ key: key , value: value  })=>{
            if (!Array.isArray(value)) return {
                key: key,
                value: value
            };
            return {
                key: key,
                value: this.getValue(key, value)
            };
        }).reduce((prev, curr)=>({
                ...prev,
                [curr.key]: curr.value
            }), {});
    }
    getValue(key, groups) {
        const correct = groups.find((group, index)=>this.samplingCache.apply(`${key}-${index}`, group, this.getPredicate(group)));
        if (typeof correct !== "undefined") return correct.value;
        return undefined;
    }
    getPredicate(group) {
        return ()=>this.browserMatcher.isValid(group.browsers) && this.deviceMatcher.isValid(group.devices) && this.domainMatcher.isValid(group.domains) && this.regionMatcher.isValid(group.regions, this.regionValidationPredicate);
    }
}
var $03c2d474d5127683$var$$85c45f0adbe836ae$exports = {};
$03c2d474d5127683$var$$parcel$export($03c2d474d5127683$var$$85c45f0adbe836ae$exports, "InstantConfigLoader", ()=>$03c2d474d5127683$var$$85c45f0adbe836ae$export$f46cdbfb0a457ef7);
async function $03c2d474d5127683$var$$d4bf72cd649cb2a4$export$a986389b0f83d258(url, timeout = 2000) {
    const controller = new AbortController();
    const id = setTimeout(()=>controller.abort(), timeout);
    const response = await fetch(url, {
        signal: controller.signal
    });
    clearTimeout(id);
    return response;
}
const $03c2d474d5127683$var$$85c45f0adbe836ae$var$logGroup = "instant-config-loader";
const $03c2d474d5127683$var$$85c45f0adbe836ae$var$instantConfigKey = "instantConfig";
const $03c2d474d5127683$var$$85c45f0adbe836ae$var$instantConfigProps = {
    b: "browsers",
    d: "devices",
    s: "sampling",
    c: "samplingCache",
    r: "regions",
    v: "value"
};
class $03c2d474d5127683$var$$85c45f0adbe836ae$export$f46cdbfb0a457ef7 {
    constructor(params, container = window){
        this.params = params;
        this.configPromise = null;
        this.storage = new $03c2d474d5127683$var$$d7167569386d0d4c$exports.localStorageHelper(`instant-config-${params.appName}`, 60000);
        this.instantConfig = this.fromContainer(container);
    }
    async getConfig() {
        if (this.instantConfig) return this.instantConfig;
        if (!this.configPromise) this.configPromise = this.fetchInstantConfig().then((config)=>{
            return config ?? this.fetchFallbackConfig();
        });
        return this.configPromise.then((config)=>{
            return config;
        });
    }
    async fetchInstantConfig(fallback = false) {
        const locked = $03c2d474d5127683$var$$d7167569386d0d4c$exports.lock();
        if (locked && !fallback) {
            await $03c2d474d5127683$var$$3bca631f7e12b649$export$1391212d75b2ee65(500);
            // try again, if lock is still present then try LocalStorage or fetch from ICBM
            return this.fetchInstantConfig(true);
        }
        const baseUrl = this.params.instantConfigEndpoint ?? "https://services.fandom.com";
        const variant = this.params.instantConfigVariant ?? "icbm";
        const appName = this.params.appName;
        const url = `${baseUrl}/${variant}/api/config?app=${appName}`;
        try {
            const cachedConfigString = this.storage.get();
            if (cachedConfigString) {
                $03c2d474d5127683$var$$d7167569386d0d4c$exports.logger($03c2d474d5127683$var$$85c45f0adbe836ae$var$logGroup, "instant config pulled from local storage", cachedConfigString);
                return JSON.parse(cachedConfigString);
            }
            const response = await $03c2d474d5127683$var$$d4bf72cd649cb2a4$export$a986389b0f83d258(url, this.params.requestTimeout);
            if (!response.ok) return undefined;
            const instantConfig = await response.json();
            this.storage.set(JSON.stringify(instantConfig));
            $03c2d474d5127683$var$$d7167569386d0d4c$exports.release();
            $03c2d474d5127683$var$$d7167569386d0d4c$exports.logger($03c2d474d5127683$var$$85c45f0adbe836ae$var$logGroup, "instant config fetched", instantConfig);
            return instantConfig;
        } catch (err) {
            $03c2d474d5127683$var$$d7167569386d0d4c$exports.warner($03c2d474d5127683$var$$85c45f0adbe836ae$var$logGroup, "could not fetch instant config", err);
            $03c2d474d5127683$var$$d7167569386d0d4c$exports.release();
            return undefined;
        }
    }
    async fetchFallbackConfig() {
        $03c2d474d5127683$var$$d7167569386d0d4c$exports.logger($03c2d474d5127683$var$$85c45f0adbe836ae$var$logGroup, "Fetching fallback config");
        const fallbackEndpoint = this.params.instantConfigFallbackEndpoint;
        if (typeof fallbackEndpoint === "undefined") return {};
        try {
            $03c2d474d5127683$var$$d7167569386d0d4c$exports.logger($03c2d474d5127683$var$$85c45f0adbe836ae$var$logGroup, fallbackEndpoint);
            const response = await $03c2d474d5127683$var$$d4bf72cd649cb2a4$export$a986389b0f83d258(fallbackEndpoint, this.params.requestTimeout);
            if (!response.ok) return {};
            const fallbackConfig = await response.json();
            $03c2d474d5127683$var$$d7167569386d0d4c$exports.logger($03c2d474d5127683$var$$85c45f0adbe836ae$var$logGroup, "fallback config fetched", fallbackConfig);
            return fallbackConfig;
        } catch (err) {
            $03c2d474d5127683$var$$d7167569386d0d4c$exports.warner($03c2d474d5127683$var$$85c45f0adbe836ae$var$logGroup, "could not fetch fallback config", err);
            return {};
        }
    }
    fromContainer(container) {
        let appConfig = container[$03c2d474d5127683$var$$85c45f0adbe836ae$var$instantConfigKey];
        if (typeof appConfig === "object" && !appConfig._ready) {
            Object.keys(appConfig).forEach((key)=>{
                const value = appConfig[key];
                if (Array.isArray(value)) appConfig[key] = value.map((e)=>Object.fromEntries(Object.entries(e).map(([k, v])=>[
                            $03c2d474d5127683$var$$85c45f0adbe836ae$var$instantConfigProps[k] ? $03c2d474d5127683$var$$85c45f0adbe836ae$var$instantConfigProps[k] : k,
                            v
                        ])));
            });
            appConfig._ready = true;
            container[$03c2d474d5127683$var$$85c45f0adbe836ae$var$instantConfigKey] = appConfig;
        }
        return appConfig;
    }
}
var $03c2d474d5127683$var$$8031b44000f2c28f$exports = {};
$03c2d474d5127683$var$$parcel$export($03c2d474d5127683$var$$8031b44000f2c28f$exports, "InstantConfigOverrider", ()=>$03c2d474d5127683$var$$8031b44000f2c28f$export$14a2f5ed2c1a484d);
const $03c2d474d5127683$var$$8031b44000f2c28f$var$queryParamPrefixes = [
    "InstantGlobals",
    "icbm"
];
function $03c2d474d5127683$var$$8031b44000f2c28f$var$hasInstantConfigPrefix(key) {
    return $03c2d474d5127683$var$$8031b44000f2c28f$var$queryParamPrefixes.some((prefix)=>{
        return key.startsWith(`${prefix}.`) || key.startsWith(`${prefix}__`);
    });
}
class $03c2d474d5127683$var$$8031b44000f2c28f$export$14a2f5ed2c1a484d {
    override(queryString, config) {
        return [
            ...queryString.keys()
        ].filter((paramKey)=>$03c2d474d5127683$var$$8031b44000f2c28f$var$hasInstantConfigPrefix(paramKey)).map((paramKey)=>{
            const [, key] = paramKey.split(".").map((part)=>part.split("__")).flat();
            return {
                paramKey: paramKey,
                key: key
            };
        }).map(({ paramKey: paramKey , key: key  })=>({
                key: key,
                value: this.parseValue(queryString.get(paramKey))
            })).map(({ key: key , value: value  })=>({
                key: key,
                value: key.startsWith("wg") ? value : this.wrapValueInXXRegions(value)
            })).reduce((newConfig, { key: key , value: value  })=>({
                ...newConfig,
                [key]: value
            }), config);
    }
    parseValue(value) {
        if (value === "true" || value === "false") return value === "true";
        const intValue = parseInt(value, 10);
        if (value === `${intValue}`) return intValue;
        try {
            return JSON.parse(value);
        } catch (ignore) {
            return value || null;
        }
    }
    wrapValueInXXRegions(value) {
        return [
            {
                value: value,
                regions: [
                    "XX"
                ]
            }
        ];
    }
}
$03c2d474d5127683$var$$parcel$exportWildcard($03c2d474d5127683$var$$583683d1b436d65c$exports, $03c2d474d5127683$var$$d4581a365416e9ee$exports);
$03c2d474d5127683$var$$parcel$exportWildcard($03c2d474d5127683$var$$583683d1b436d65c$exports, $03c2d474d5127683$var$$15d63f1bfc4bb821$exports);
$03c2d474d5127683$var$$parcel$exportWildcard($03c2d474d5127683$var$$583683d1b436d65c$exports, $03c2d474d5127683$var$$85c45f0adbe836ae$exports);
$03c2d474d5127683$var$$parcel$exportWildcard($03c2d474d5127683$var$$583683d1b436d65c$exports, $03c2d474d5127683$var$$8031b44000f2c28f$exports);
$03c2d474d5127683$var$$parcel$exportWildcard($03c2d474d5127683$var$$583683d1b436d65c$exports, $03c2d474d5127683$var$$89ffc9b2062f304b$exports);
$03c2d474d5127683$var$$parcel$exportWildcard($03c2d474d5127683$exports, $03c2d474d5127683$var$$583683d1b436d65c$exports);
$03c2d474d5127683$var$$parcel$exportWildcard($03c2d474d5127683$exports, $03c2d474d5127683$var$$b9c8418edb6cb5ed$exports);




var $b33345d01c8a6de2$var$_a, $b33345d01c8a6de2$var$_b, $b33345d01c8a6de2$var$_c, $b33345d01c8a6de2$var$_d, $b33345d01c8a6de2$var$_e;
let $b33345d01c8a6de2$export$7b5f2db24cd34c1f = class InstantConfigService {
    constructor(device, browser, platform, geo, logger){
        this.device = device;
        this.browser = browser;
        this.platform = platform;
        this.geo = geo;
        this.logger = logger;
    }
    init(globals = {}) {
        return (0, $c106e002a49a00cb$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            const appName = this.platform.get();
            const geo = this.geo.get();
            const instantConfigLoader = new (0, $03c2d474d5127683$exports.InstantConfigLoader)({
                appName: appName
            });
            const instantConfigInterpreter = new (0, $03c2d474d5127683$exports.InstantConfigInterpreter)(new (0, $03c2d474d5127683$exports.BrowserMatcher)(this.browser.getBrowser()), new (0, $03c2d474d5127683$exports.DeviceMatcher)(this.device.getDeviceType()), new (0, $03c2d474d5127683$exports.DomainMatcher)(), new (0, $03c2d474d5127683$exports.RegionMatcher)(geo));
            let config = yield instantConfigLoader.getConfig();
            config = new (0, $03c2d474d5127683$exports.InstantConfigOverrider)().override((0, $e7ae57550c9200e9$export$eada748df1dd417f).getURLSearchParams(), config);
            const interpreter = instantConfigInterpreter.init(config, globals);
            this.repository = interpreter.getValues();
            this.logger.info("instantiated with", this.repository);
            return this;
        });
    }
    get(key, defaultValue) {
        if (key in this.repository && this.repository[key] !== undefined) return this.repository[key];
        return defaultValue;
    }
};
$b33345d01c8a6de2$export$7b5f2db24cd34c1f = (0, $c106e002a49a00cb$export$29e00dfd3077644b)([
    (0, $79188624df80f470$export$2e2bcd8739ae039)(),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(0, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $b43564c037fb0894$export$8215d14a63d9fb10))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(1, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $8a0d3010c87d3140$export$5fefc2586e00a689))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(2, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $55349e5534bb6b42$export$2dffd0b5373a4389))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(3, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $2f6e53771cd92caa$export$733db4df510f8a9))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(4, (0, $190b0b497264ac3c$export$2e2bcd8739ae039)((0, $f009ac2c4949a5c1$export$efa9a398d6368992), (0, $f009ac2c4949a5c1$export$e41701f8b288055a), "InstantConfig")),
    (0, $c106e002a49a00cb$export$f1db080c865becb9)("design:paramtypes", [
        typeof ($b33345d01c8a6de2$var$_a = typeof (0, $b43564c037fb0894$export$8215d14a63d9fb10) !== "undefined" && (0, $b43564c037fb0894$export$8215d14a63d9fb10)) === "function" ? $b33345d01c8a6de2$var$_a : Object,
        typeof ($b33345d01c8a6de2$var$_b = typeof (0, $8a0d3010c87d3140$export$5fefc2586e00a689) !== "undefined" && (0, $8a0d3010c87d3140$export$5fefc2586e00a689)) === "function" ? $b33345d01c8a6de2$var$_b : Object,
        typeof ($b33345d01c8a6de2$var$_c = typeof (0, $55349e5534bb6b42$export$2dffd0b5373a4389) !== "undefined" && (0, $55349e5534bb6b42$export$2dffd0b5373a4389)) === "function" ? $b33345d01c8a6de2$var$_c : Object,
        typeof ($b33345d01c8a6de2$var$_d = typeof (0, $2f6e53771cd92caa$export$733db4df510f8a9) !== "undefined" && (0, $2f6e53771cd92caa$export$733db4df510f8a9)) === "function" ? $b33345d01c8a6de2$var$_d : Object,
        typeof ($b33345d01c8a6de2$var$_e = typeof (0, $f009ac2c4949a5c1$export$efa9a398d6368992) !== "undefined" && (0, $f009ac2c4949a5c1$export$efa9a398d6368992)) === "function" ? $b33345d01c8a6de2$var$_e : Object
    ])
], $b33345d01c8a6de2$export$7b5f2db24cd34c1f);


var $b4e61c6332766e68$var$_a, $b4e61c6332766e68$var$_b, $b4e61c6332766e68$var$_c, $b4e61c6332766e68$var$_d;
let $b4e61c6332766e68$export$ba61ea7ee8b810c4 = class OptInService {
    get trackingAllowed() {
        return this._trackingAllowed;
    }
    set trackingAllowed(value) {
        this._trackingAllowed = value;
    }
    constructor(communicationService, consentProviderFactory, logger, instantConfigService){
        this.communicationService = communicationService;
        this.consentProviderFactory = consentProviderFactory;
        this.logger = logger;
        this.instantConfigService = instantConfigService;
        this._trackingAllowed = false;
    }
    init() {
        var _a;
        const icFandom1TEnabled = this.instantConfigService.get("icFandom1TEnabled", false);
        this.consentProvider = this.consentProviderFactory.get(icFandom1TEnabled);
        (_a = this.consentProvider) === null || _a === void 0 || _a.then((consents)=>{
            this.logger.info("Sending consents: ", consents);
            this.sendConsentsToAdEngine(consents);
        });
    }
    sendConsentsToAdEngine(consents) {
        this.communicationService.emit(new (0, $697309025c6aa3ae$export$e19cd5f9376f8cee)((0, $9bac733ad19ab912$export$7f305d1b47333a2).CONSENT_READY, consents));
    }
};
$b4e61c6332766e68$export$ba61ea7ee8b810c4 = (0, $c106e002a49a00cb$export$29e00dfd3077644b)([
    (0, $79188624df80f470$export$2e2bcd8739ae039)(),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(0, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $fdfc6e1cf47ae084$export$539550160b78d8c5))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(1, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $20d61e52c5e2b7c2$export$53c7806d00aa5f5f))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(2, (0, $190b0b497264ac3c$export$2e2bcd8739ae039)((0, $f009ac2c4949a5c1$export$efa9a398d6368992), (0, $f009ac2c4949a5c1$export$e41701f8b288055a), "OptInService")),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(3, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $b33345d01c8a6de2$export$7b5f2db24cd34c1f))),
    (0, $c106e002a49a00cb$export$f1db080c865becb9)("design:paramtypes", [
        typeof ($b4e61c6332766e68$var$_a = typeof (0, $fdfc6e1cf47ae084$export$539550160b78d8c5) !== "undefined" && (0, $fdfc6e1cf47ae084$export$539550160b78d8c5)) === "function" ? $b4e61c6332766e68$var$_a : Object,
        typeof ($b4e61c6332766e68$var$_b = typeof (0, $20d61e52c5e2b7c2$export$53c7806d00aa5f5f) !== "undefined" && (0, $20d61e52c5e2b7c2$export$53c7806d00aa5f5f)) === "function" ? $b4e61c6332766e68$var$_b : Object,
        typeof ($b4e61c6332766e68$var$_c = typeof (0, $f009ac2c4949a5c1$export$efa9a398d6368992) !== "undefined" && (0, $f009ac2c4949a5c1$export$efa9a398d6368992)) === "function" ? $b4e61c6332766e68$var$_c : Object,
        typeof ($b4e61c6332766e68$var$_d = typeof (0, $b33345d01c8a6de2$export$7b5f2db24cd34c1f) !== "undefined" && (0, $b33345d01c8a6de2$export$7b5f2db24cd34c1f)) === "function" ? $b4e61c6332766e68$var$_d : Object
    ])
], $b4e61c6332766e68$export$ba61ea7ee8b810c4);







var $1e200948df01872b$var$_a, $1e200948df01872b$var$_b, $1e200948df01872b$var$_c, $1e200948df01872b$var$_d, $1e200948df01872b$var$_e, $1e200948df01872b$var$_f;
let $1e200948df01872b$export$1a68292eb68beee1 = class IdentityEventSender {
    constructor(logger, httpClient, skin, optInService, window, wikiConfig){
        this.logger = logger;
        this.httpClient = httpClient;
        this.skin = skin;
        this.optInService = optInService;
        this.window = window;
        this.wikiConfig = wikiConfig;
        this.dataWarehouseUrl = "https://beacon.wikia-services.com/__track/special/identityinfo";
    }
    send(payload) {
        this.sendEvent(payload, this.dataWarehouseUrl);
    }
    sendEvent(options, trackingURL) {
        const params = Object.assign(Object.assign(Object.assign({}, options), this.getTimeBasedParams()), this.getTrackingParams());
        const url = this.buildDataWarehouseUrl(params, trackingURL);
        if (url) this.httpClient.get(url);
    }
    getTrackingParams() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        return {
            session_id: (_b = (_a = this.window.fandomContext) === null || _a === void 0 ? void 0 : _a.tracking) === null || _b === void 0 ? void 0 : _b.sessionId,
            pv_number: (_d = (_c = this.window.fandomContext) === null || _c === void 0 ? void 0 : _c.tracking) === null || _d === void 0 ? void 0 : _d.pvNumber,
            pv_number_global: (_f = (_e = this.window.fandomContext) === null || _e === void 0 ? void 0 : _e.tracking) === null || _f === void 0 ? void 0 : _f.pvNumberGlobal,
            pv_unique_id: (_h = (_g = this.window.fandomContext) === null || _g === void 0 ? void 0 : _g.tracking) === null || _h === void 0 ? void 0 : _h.pvUID,
            beacon: (_k = (_j = this.window.fandomContext) === null || _j === void 0 ? void 0 : _j.tracking) === null || _k === void 0 ? void 0 : _k.beaconId,
            ua: (_l = this.window.navigator) === null || _l === void 0 ? void 0 : _l.userAgent,
            c: this.wikiConfig.get("wgCityId") || "unknown",
            ck: this.wikiConfig.get("dsSiteKey") || "unknown",
            lc: this.wikiConfig.get("wgUserLanguage") || "unknown",
            s: this.skin.get(),
            u: this.optInService.trackingAllowed ? this.wikiConfig.get("wgUserId") || 0 : -1,
            a: ((_o = (_m = this.window.fandomContext) === null || _m === void 0 ? void 0 : _m.page) === null || _o === void 0 ? void 0 : _o.articleId) || -1,
            x: this.wikiConfig.get("wgDBname") || "unknown",
            n: this.wikiConfig.get("wgNamespaceNumber") || -1
        };
    }
    getTimeBasedParams() {
        return {
            cb: Math.floor(Math.random() * 99999),
            url: document.URL
        };
    }
    buildDataWarehouseUrl(params, baseUrl) {
        if (!baseUrl) {
            this.logger.error("Error building DWH tracking URL");
            return;
        }
        const queryParams = new URLSearchParams(params);
        queryParams.sort();
        return `${baseUrl}?${queryParams.toString()}`;
    }
};
$1e200948df01872b$export$1a68292eb68beee1 = (0, $c106e002a49a00cb$export$29e00dfd3077644b)([
    (0, $7368727773dc6147$export$2e2bcd8739ae039)(),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(0, (0, $190b0b497264ac3c$export$2e2bcd8739ae039)((0, $f009ac2c4949a5c1$export$efa9a398d6368992), (0, $f009ac2c4949a5c1$export$e41701f8b288055a), "DataWarehouseService")),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(1, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $d5090ec2eb6e9ae9$export$8c6ee871e681f0f4))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(2, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $ab5ccb8e7b321d35$export$b8e0f93a76772233))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(3, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $b4e61c6332766e68$export$ba61ea7ee8b810c4))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(4, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $b8e408dd2b31a250$export$56d8a8a25bd48b81))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(5, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $365ce25d498a7cb4$export$5121bc3ffa707de4))),
    (0, $c106e002a49a00cb$export$f1db080c865becb9)("design:paramtypes", [
        typeof ($1e200948df01872b$var$_a = typeof (0, $f009ac2c4949a5c1$export$efa9a398d6368992) !== "undefined" && (0, $f009ac2c4949a5c1$export$efa9a398d6368992)) === "function" ? $1e200948df01872b$var$_a : Object,
        typeof ($1e200948df01872b$var$_b = typeof (0, $d5090ec2eb6e9ae9$export$8c6ee871e681f0f4) !== "undefined" && (0, $d5090ec2eb6e9ae9$export$8c6ee871e681f0f4)) === "function" ? $1e200948df01872b$var$_b : Object,
        typeof ($1e200948df01872b$var$_c = typeof (0, $ab5ccb8e7b321d35$export$b8e0f93a76772233) !== "undefined" && (0, $ab5ccb8e7b321d35$export$b8e0f93a76772233)) === "function" ? $1e200948df01872b$var$_c : Object,
        typeof ($1e200948df01872b$var$_d = typeof (0, $b4e61c6332766e68$export$ba61ea7ee8b810c4) !== "undefined" && (0, $b4e61c6332766e68$export$ba61ea7ee8b810c4)) === "function" ? $1e200948df01872b$var$_d : Object,
        typeof ($1e200948df01872b$var$_e = typeof Window !== "undefined" && Window) === "function" ? $1e200948df01872b$var$_e : Object,
        typeof ($1e200948df01872b$var$_f = typeof (0, $365ce25d498a7cb4$export$5121bc3ffa707de4) !== "undefined" && (0, $365ce25d498a7cb4$export$5121bc3ffa707de4)) === "function" ? $1e200948df01872b$var$_f : Object
    ])
], $1e200948df01872b$export$1a68292eb68beee1);


var $7282ba2280fb0c96$export$3fd68cdf578a0808;
(function(DataWarehouseEventType) {
    DataWarehouseEventType[DataWarehouseEventType["identity"] = 0] = "identity";
})($7282ba2280fb0c96$export$3fd68cdf578a0808 || ($7282ba2280fb0c96$export$3fd68cdf578a0808 = {}));


var $d34bd813659277b4$var$_a, $d34bd813659277b4$var$_b;
let $d34bd813659277b4$export$bc485e6e25746fed = class DataWarehouseService {
    constructor(logger, identityEventSender){
        this.logger = logger;
        this.identityEventSender = identityEventSender;
    }
    track(eventType, payload) {
        switch(eventType){
            case (0, $7282ba2280fb0c96$export$3fd68cdf578a0808).identity:
                this.identityEventSender.send(payload);
                break;
            default:
                this.logger.info("Invalid event type to track");
        }
    }
};
$d34bd813659277b4$export$bc485e6e25746fed = (0, $c106e002a49a00cb$export$29e00dfd3077644b)([
    (0, $7368727773dc6147$export$2e2bcd8739ae039)(),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(0, (0, $190b0b497264ac3c$export$2e2bcd8739ae039)((0, $f009ac2c4949a5c1$export$efa9a398d6368992), (0, $f009ac2c4949a5c1$export$e41701f8b288055a), "DataWarehouseService")),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(1, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $1e200948df01872b$export$1a68292eb68beee1))),
    (0, $c106e002a49a00cb$export$f1db080c865becb9)("design:paramtypes", [
        typeof ($d34bd813659277b4$var$_a = typeof (0, $f009ac2c4949a5c1$export$efa9a398d6368992) !== "undefined" && (0, $f009ac2c4949a5c1$export$efa9a398d6368992)) === "function" ? $d34bd813659277b4$var$_a : Object,
        typeof ($d34bd813659277b4$var$_b = typeof (0, $1e200948df01872b$export$1a68292eb68beee1) !== "undefined" && (0, $1e200948df01872b$export$1a68292eb68beee1)) === "function" ? $d34bd813659277b4$var$_b : Object
    ])
], $d34bd813659277b4$export$bc485e6e25746fed);














var $4149b844e86fe9e7$var$_a;
let $4149b844e86fe9e7$export$e1336d7798452534 = class CookieRepository {
    constructor(cookiesManager){
        this.cookiesManager = cookiesManager;
    }
    get(name) {
        return this.cookiesManager.get(name);
    }
    set(name, trackingProperty) {
        const { value: value , domain: domain , expiresMS: expiresMS  } = trackingProperty;
        const expirationDate = new Date(new Date().getTime() + expiresMS);
        this.cookiesManager.set(name, value.toString(), {
            domain: domain,
            expires: expirationDate
        });
    }
    remove(name) {
        this.cookiesManager.remove(name);
    }
};
$4149b844e86fe9e7$export$e1336d7798452534 = (0, $c106e002a49a00cb$export$29e00dfd3077644b)([
    (0, $7368727773dc6147$export$2e2bcd8739ae039)(),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(0, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $b8e408dd2b31a250$export$9e98cacf66dcab6a))),
    (0, $c106e002a49a00cb$export$f1db080c865becb9)("design:paramtypes", [
        typeof ($4149b844e86fe9e7$var$_a = typeof CookiesManager !== "undefined" && CookiesManager) === "function" ? $4149b844e86fe9e7$var$_a : Object
    ])
], $4149b844e86fe9e7$export$e1336d7798452534);







var $fb057a8ae4d9c6c2$var$_a;
let $fb057a8ae4d9c6c2$export$7c6bc96f7559de2b = class WindowRepository {
    constructor(window){
        this.window = window;
    }
    get(name) {
        return this.window.fandomContext.tracking[name];
    }
    set(name, trackingProperty) {
        if (!this.window.fandomContext || !this.window.fandomContext.tracking) this.window.fandomContext = Object.assign(Object.assign({}, this.window.fandomContext), {
            tracking: {}
        });
        this.window.fandomContext.tracking[name] = trackingProperty.value;
    }
    remove(name) {
        try {
            delete this.window.fandomContext.tracking[name];
        } catch (_a) {
        // do nothing if there is nothing to delete
        }
    }
};
$fb057a8ae4d9c6c2$export$7c6bc96f7559de2b = (0, $c106e002a49a00cb$export$29e00dfd3077644b)([
    (0, $7368727773dc6147$export$2e2bcd8739ae039)(),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(0, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $b8e408dd2b31a250$export$56d8a8a25bd48b81))),
    (0, $c106e002a49a00cb$export$f1db080c865becb9)("design:paramtypes", [
        typeof ($fb057a8ae4d9c6c2$var$_a = typeof Window !== "undefined" && Window) === "function" ? $fb057a8ae4d9c6c2$var$_a : Object
    ])
], $fb057a8ae4d9c6c2$export$7c6bc96f7559de2b);










var $380f1c450174629c$var$_a;
let $380f1c450174629c$export$b7ed9caa3c7777c1 = class PageViewNumberGenerator {
    constructor(cookiesManager){
        this.cookiesManager = cookiesManager;
    }
    getNextNumberFromCookie(cookieName) {
        const currentNumber = parseInt(this.cookiesManager.get(cookieName));
        if (Number.isNaN(currentNumber)) return 1;
        return currentNumber + 1;
    }
};
$380f1c450174629c$export$b7ed9caa3c7777c1 = (0, $c106e002a49a00cb$export$29e00dfd3077644b)([
    (0, $7368727773dc6147$export$2e2bcd8739ae039)(),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(0, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $b8e408dd2b31a250$export$9e98cacf66dcab6a))),
    (0, $c106e002a49a00cb$export$f1db080c865becb9)("design:paramtypes", [
        typeof ($380f1c450174629c$var$_a = typeof CookiesManager !== "undefined" && CookiesManager) === "function" ? $380f1c450174629c$var$_a : Object
    ])
], $380f1c450174629c$export$b7ed9caa3c7777c1);




var $09d9dac4cd581d14$var$_a, $09d9dac4cd581d14$var$_b, $09d9dac4cd581d14$var$_c, $09d9dac4cd581d14$var$_d, $09d9dac4cd581d14$var$_e, $09d9dac4cd581d14$var$_f;
const $09d9dac4cd581d14$var$MS_30_MIN = 1800000;
const $09d9dac4cd581d14$var$MS_180_DAYS = 15552000000;
let $09d9dac4cd581d14$export$176f30e94bca0133 = class TrackingContextSetupService {
    constructor(windowRepository, cookieRepository, uuid, beaconGenerator, pageViewNumberGenerator, window, wikiConfig){
        this.windowRepository = windowRepository;
        this.cookieRepository = cookieRepository;
        this.uuid = uuid;
        this.beaconGenerator = beaconGenerator;
        this.pageViewNumberGenerator = pageViewNumberGenerator;
        this.window = window;
        this.wikiConfig = wikiConfig;
    }
    set(name, trackingProperty) {
        this.windowRepository.set(name, trackingProperty);
        this.cookieRepository.set(name, trackingProperty);
    }
    remove(name) {
        this.windowRepository.remove(name);
        this.cookieRepository.remove(name);
    }
    setup(domain) {
        const tld = (0, $8aacc0a72dafbc81$export$44dca8fb3e49ffe7).extract(domain);
        this.windowRepository.set("pvUID", {
            domain: domain,
            expiresMS: $09d9dac4cd581d14$var$MS_30_MIN,
            value: this.wikiConfig.get("pvUID") || // UCP
            this.window.pvUID || // F2
            this.uuid()
        });
        const beaconId = this.cookieRepository.get("wikia_beacon_id") || this.cookieRepository.get("beaconId");
        const beaconParams = {
            domain: tld,
            expiresMS: $09d9dac4cd581d14$var$MS_180_DAYS,
            value: beaconId || this.beaconGenerator.generate()
        };
        this.windowRepository.set("beaconId", beaconParams);
        this.cookieRepository.set("wikia_beacon_id", beaconParams);
        const sessionId = this.cookieRepository.get("sessionId");
        const sessionParams = {
            domain: tld,
            expiresMS: $09d9dac4cd581d14$var$MS_30_MIN,
            value: sessionId || this.uuid()
        };
        this.set("sessionId", sessionParams);
        this.set("pvNumber", {
            domain: domain,
            expiresMS: $09d9dac4cd581d14$var$MS_30_MIN,
            value: this.pageViewNumberGenerator.getNextNumberFromCookie("pvNumber")
        });
        this.set("pvNumberGlobal", {
            domain: tld,
            expiresMS: $09d9dac4cd581d14$var$MS_30_MIN,
            value: this.pageViewNumberGenerator.getNextNumberFromCookie("pvNumberGlobal")
        });
    }
    clear() {
        this.remove("beaconId");
        this.remove("sessionId");
        this.remove("pvNumber");
        this.remove("pvNumberGlobal");
    }
};
$09d9dac4cd581d14$export$176f30e94bca0133 = (0, $c106e002a49a00cb$export$29e00dfd3077644b)([
    (0, $79188624df80f470$export$2e2bcd8739ae039)(),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(0, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $fb057a8ae4d9c6c2$export$7c6bc96f7559de2b))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(1, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $4149b844e86fe9e7$export$e1336d7798452534))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(2, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $b8e408dd2b31a250$export$bc35efed93511c4b))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(3, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $489f458020eb01fc$export$e5ea4aa04c1de268))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(4, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $380f1c450174629c$export$b7ed9caa3c7777c1))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(5, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $b8e408dd2b31a250$export$56d8a8a25bd48b81))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(6, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $365ce25d498a7cb4$export$5121bc3ffa707de4))),
    (0, $c106e002a49a00cb$export$f1db080c865becb9)("design:paramtypes", [
        typeof ($09d9dac4cd581d14$var$_a = typeof (0, $fb057a8ae4d9c6c2$export$7c6bc96f7559de2b) !== "undefined" && (0, $fb057a8ae4d9c6c2$export$7c6bc96f7559de2b)) === "function" ? $09d9dac4cd581d14$var$_a : Object,
        typeof ($09d9dac4cd581d14$var$_b = typeof (0, $4149b844e86fe9e7$export$e1336d7798452534) !== "undefined" && (0, $4149b844e86fe9e7$export$e1336d7798452534)) === "function" ? $09d9dac4cd581d14$var$_b : Object,
        Function,
        typeof ($09d9dac4cd581d14$var$_c = typeof (0, $489f458020eb01fc$export$e5ea4aa04c1de268) !== "undefined" && (0, $489f458020eb01fc$export$e5ea4aa04c1de268)) === "function" ? $09d9dac4cd581d14$var$_c : Object,
        typeof ($09d9dac4cd581d14$var$_d = typeof (0, $380f1c450174629c$export$b7ed9caa3c7777c1) !== "undefined" && (0, $380f1c450174629c$export$b7ed9caa3c7777c1)) === "function" ? $09d9dac4cd581d14$var$_d : Object,
        typeof ($09d9dac4cd581d14$var$_e = typeof Window !== "undefined" && Window) === "function" ? $09d9dac4cd581d14$var$_e : Object,
        typeof ($09d9dac4cd581d14$var$_f = typeof (0, $365ce25d498a7cb4$export$5121bc3ffa707de4) !== "undefined" && (0, $365ce25d498a7cb4$export$5121bc3ffa707de4)) === "function" ? $09d9dac4cd581d14$var$_f : Object
    ])
], $09d9dac4cd581d14$export$176f30e94bca0133);




var $a0824533ef024e6a$var$_a, $a0824533ef024e6a$var$_b, $a0824533ef024e6a$var$_c, $a0824533ef024e6a$var$_d;
let $a0824533ef024e6a$export$25007d9e64202fc2 = class CoppaSubject {
    constructor(window, logger, context, cookieRepository){
        this.window = window;
        this.logger = logger;
        this.context = context;
        this.cookieRepository = cookieRepository;
        this.createPartnersContext();
    }
    createPartnersContext() {
        if (!this.window.fandomContext || !this.window.fandomContext.partners) this.window.fandomContext = Object.assign(Object.assign({}, this.window.fandomContext), {
            partners: {}
        });
    }
    setIsCoppaSubjectInContext(isCoppaSubject) {
        this.coppaSubject = isCoppaSubject;
        this.window.fandomContext.partners.directedAtChildren = isCoppaSubject;
        this.window.fandomContext.partners.blockthrough = {
            directedAtChildren: isCoppaSubject
        };
    }
    isCoppaSubject() {
        if (this.coppaSubject === undefined) return this.resolveCoppaStatus();
        return this.coppaSubject;
    }
    resolveCoppaStatus() {
        var _a, _b;
        const wikiDirectedAtChildren = Boolean((_b = (_a = this.context.get()) === null || _a === void 0 ? void 0 : _a.targeting) === null || _b === void 0 ? void 0 : _b.directedAtChildren);
        if (!wikiDirectedAtChildren) {
            this.setIsCoppaSubjectInContext(false);
            return false;
        }
        try {
            const ageGateResult = this.cookieRepository.get("ag");
            const isCoppaSubject = ageGateResult !== "1";
            this.setIsCoppaSubjectInContext(isCoppaSubject);
            return isCoppaSubject;
        } catch (e) {
            this.logger.error("Error while reading age gate cookie");
        }
    }
};
$a0824533ef024e6a$export$25007d9e64202fc2 = (0, $c106e002a49a00cb$export$29e00dfd3077644b)([
    (0, $79188624df80f470$export$2e2bcd8739ae039)(),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(0, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $b8e408dd2b31a250$export$56d8a8a25bd48b81))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(1, (0, $190b0b497264ac3c$export$2e2bcd8739ae039)((0, $f009ac2c4949a5c1$export$efa9a398d6368992), (0, $f009ac2c4949a5c1$export$e41701f8b288055a), "CoppaSubject")),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(2, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $0b30a5935923be01$export$36f603205c7c87a))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(3, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $4149b844e86fe9e7$export$e1336d7798452534))),
    (0, $c106e002a49a00cb$export$f1db080c865becb9)("design:paramtypes", [
        typeof ($a0824533ef024e6a$var$_a = typeof Window !== "undefined" && Window) === "function" ? $a0824533ef024e6a$var$_a : Object,
        typeof ($a0824533ef024e6a$var$_b = typeof (0, $f009ac2c4949a5c1$export$efa9a398d6368992) !== "undefined" && (0, $f009ac2c4949a5c1$export$efa9a398d6368992)) === "function" ? $a0824533ef024e6a$var$_b : Object,
        typeof ($a0824533ef024e6a$var$_c = typeof (0, $0b30a5935923be01$export$36f603205c7c87a) !== "undefined" && (0, $0b30a5935923be01$export$36f603205c7c87a)) === "function" ? $a0824533ef024e6a$var$_c : Object,
        typeof ($a0824533ef024e6a$var$_d = typeof (0, $4149b844e86fe9e7$export$e1336d7798452534) !== "undefined" && (0, $4149b844e86fe9e7$export$e1336d7798452534)) === "function" ? $a0824533ef024e6a$var$_d : Object
    ])
], $a0824533ef024e6a$export$25007d9e64202fc2);







var $05340dab2e7d7c8b$var$_a, $05340dab2e7d7c8b$var$_b, $05340dab2e7d7c8b$var$_c;
let $05340dab2e7d7c8b$export$578f2db7e76a4371 = class HemTrackingService {
    constructor(dataWarehouse, window, logger){
        this.dataWarehouse = dataWarehouse;
        this.window = window;
        this.logger = logger;
    }
    activateTracking() {
        if (!this.isEnabled()) {
            this.logger.info("Hem Tracking is disabled");
            return;
        }
        const hems = this.extractHEMs();
        Object.keys(hems).forEach((key)=>{
            if (hems[key]) this.dataWarehouse.track((0, $7282ba2280fb0c96$export$3fd68cdf578a0808).identity, {
                partner_name: "MediaWiki-" + key,
                partner_identity_id: hems[key]
            });
        });
    }
    isEnabled() {
        var _a, _b, _c;
        return ((_c = (_b = (_a = this.window.ads) === null || _a === void 0 ? void 0 : _a.context) === null || _b === void 0 ? void 0 : _b.opts) === null || _c === void 0 ? void 0 : _c.userEmailHashes) && this.window.ads.context.opts.userEmailHashes.length > 0;
    }
    extractHEMs() {
        const [md5, sha1, sha256] = this.window.ads.context.opts.userEmailHashes;
        return {
            md5: md5,
            sha1: sha1,
            sha256: sha256
        };
    }
};
$05340dab2e7d7c8b$export$578f2db7e76a4371 = (0, $c106e002a49a00cb$export$29e00dfd3077644b)([
    (0, $7368727773dc6147$export$2e2bcd8739ae039)(),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(0, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $d34bd813659277b4$export$bc485e6e25746fed))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(1, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $b8e408dd2b31a250$export$56d8a8a25bd48b81))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(2, (0, $190b0b497264ac3c$export$2e2bcd8739ae039)((0, $f009ac2c4949a5c1$export$efa9a398d6368992), (0, $f009ac2c4949a5c1$export$e41701f8b288055a), "HemTracking")),
    (0, $c106e002a49a00cb$export$f1db080c865becb9)("design:paramtypes", [
        typeof ($05340dab2e7d7c8b$var$_a = typeof (0, $d34bd813659277b4$export$bc485e6e25746fed) !== "undefined" && (0, $d34bd813659277b4$export$bc485e6e25746fed)) === "function" ? $05340dab2e7d7c8b$var$_a : Object,
        typeof ($05340dab2e7d7c8b$var$_b = typeof Window !== "undefined" && Window) === "function" ? $05340dab2e7d7c8b$var$_b : Object,
        typeof ($05340dab2e7d7c8b$var$_c = typeof (0, $f009ac2c4949a5c1$export$efa9a398d6368992) !== "undefined" && (0, $f009ac2c4949a5c1$export$efa9a398d6368992)) === "function" ? $05340dab2e7d7c8b$var$_c : Object
    ])
], $05340dab2e7d7c8b$export$578f2db7e76a4371);







var $799d3e7c42b201d6$var$_a, $799d3e7c42b201d6$var$_b, $799d3e7c42b201d6$var$_c, $799d3e7c42b201d6$var$_d;
let $799d3e7c42b201d6$export$5f937add7079efe4 = class MetricReporterService {
    constructor(serviceBaseUrl, platform, window, logger){
        this.platform = platform;
        this.window = window;
        this.logger = logger;
        this.enabled = false;
        this.endpoint = `${serviceBaseUrl.get()}adeng/api/identity/metrics`;
    }
    init(instantConfigService) {
        var _a;
        const threshold = instantConfigService.get("icMonitorTrafficThreshold", {
            identity: 0
        });
        this.enabled = (0, $cbba3528a6229cb1$export$a6cdc56e425d0d0a)(threshold) && (threshold === null || threshold === void 0 ? void 0 : threshold.identity) > 0 ? threshold.identity >= Math.random() * 100 : false;
        this.logger.info(`Metric reporter enabled: ${this.enabled}, threshold:`, threshold);
        if (this.enabled) {
            if (this.window.document.readyState === "complete") this.sendPerformanceMetrics();
            else (_a = this.window) === null || _a === void 0 || _a.addEventListener("load", ()=>this.sendPerformanceMetrics());
        }
    }
    send(action, value = 0) {
        if (!this.enabled) return;
        const url = new URL(this.endpoint);
        url.searchParams.set("app", this.platform.get());
        url.searchParams.set("action", action);
        const duration = value > 0 ? value : this.logger.getTimeDelta();
        url.searchParams.set("duration", Math.round(duration).toString());
        fetch(url, {
            mode: "no-cors"
        });
    }
    sendPerformanceMetrics() {
        const perfNav = this.window.performance.getEntriesByType("navigation");
        if (perfNav.length > 0) {
            this.send("document_content_loaded", perfNav[0].domContentLoadedEventEnd);
            this.send("document_load_time", perfNav[0].loadEventEnd);
        }
    }
};
$799d3e7c42b201d6$export$5f937add7079efe4 = (0, $c106e002a49a00cb$export$29e00dfd3077644b)([
    (0, $79188624df80f470$export$2e2bcd8739ae039)(),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(0, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $62b9cd2513a767e8$export$14eb8822b262d643))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(1, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $55349e5534bb6b42$export$2dffd0b5373a4389))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(2, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $b8e408dd2b31a250$export$56d8a8a25bd48b81))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(3, (0, $190b0b497264ac3c$export$2e2bcd8739ae039)((0, $f009ac2c4949a5c1$export$efa9a398d6368992), (0, $f009ac2c4949a5c1$export$e41701f8b288055a), "MetricReporterService")),
    (0, $c106e002a49a00cb$export$f1db080c865becb9)("design:paramtypes", [
        typeof ($799d3e7c42b201d6$var$_a = typeof (0, $62b9cd2513a767e8$export$14eb8822b262d643) !== "undefined" && (0, $62b9cd2513a767e8$export$14eb8822b262d643)) === "function" ? $799d3e7c42b201d6$var$_a : Object,
        typeof ($799d3e7c42b201d6$var$_b = typeof (0, $55349e5534bb6b42$export$2dffd0b5373a4389) !== "undefined" && (0, $55349e5534bb6b42$export$2dffd0b5373a4389)) === "function" ? $799d3e7c42b201d6$var$_b : Object,
        typeof ($799d3e7c42b201d6$var$_c = typeof Window !== "undefined" && Window) === "function" ? $799d3e7c42b201d6$var$_c : Object,
        typeof ($799d3e7c42b201d6$var$_d = typeof (0, $f009ac2c4949a5c1$export$efa9a398d6368992) !== "undefined" && (0, $f009ac2c4949a5c1$export$efa9a398d6368992)) === "function" ? $799d3e7c42b201d6$var$_d : Object
    ])
], $799d3e7c42b201d6$export$5f937add7079efe4);





var $65f5bcdd46d7bded$export$b9500f6ce524e250;
(function(IdentityRepositories) {
    IdentityRepositories["LOCAL"] = "local";
    IdentityRepositories["IDENTITY_STORAGE"] = "identity_storage";
})($65f5bcdd46d7bded$export$b9500f6ce524e250 || ($65f5bcdd46d7bded$export$b9500f6ce524e250 = {}));


var $04e5cf4b5719a46f$export$e4a712fff93fb00f;
(function(ActionType) {
    ActionType["IDENTITY"] = "identity";
})($04e5cf4b5719a46f$export$e4a712fff93fb00f || ($04e5cf4b5719a46f$export$e4a712fff93fb00f = {}));






var $ddf043c3ffa0fa71$var$_a, $ddf043c3ffa0fa71$var$_b, $ddf043c3ffa0fa71$var$_c;
let $ddf043c3ffa0fa71$export$c603866f8169960d = class IdentityStorageClient {
    constructor(logger, uuid, storage, serviceBaseUrl){
        this.logger = logger;
        this.uuid = uuid;
        this.storage = storage;
        this.serviceBaseUrl = serviceBaseUrl;
        this.logGroup = "identity-storage";
        this.IdentityStorageKey = "identity";
        this.ISUrl = this.serviceBaseUrl.get() + "identity-storage/";
    }
    fetchData() {
        return (0, $c106e002a49a00cb$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            const controller = new AbortController();
            const timeoutId = setTimeout(()=>controller.abort(), 1000);
            return fetch(this.ISUrl, {
                mode: "cors",
                credentials: "include",
                signal: controller.signal
            }).then((response)=>{
                clearTimeout(timeoutId);
                if (response.status === 200 || response.status === 202) return response.json();
                else return this.createFallbackResponse();
            }).catch((reason)=>{
                this.logger.info(this.logGroup, "Loading Identity LocalStorage data failed", reason);
                return this.createFallbackResponse();
            });
        });
    }
    postData(data) {
        return (0, $c106e002a49a00cb$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            return fetch(this.ISUrl + "identity", {
                credentials: "include",
                mode: "cors",
                headers: {
                    "Content-Type": "application/json"
                },
                method: "PUT",
                body: JSON.stringify({
                    ppid: data.ppid
                })
            }).then((response)=>response.json());
        });
    }
    getLocalData() {
        return this.storage.getItem(this.IdentityStorageKey);
    }
    setLocalData(data) {
        this.storage.setItem(this.IdentityStorageKey, data);
    }
    createFallbackResponse() {
        return {
            timestamp: Date.now(),
            over18: false,
            synced: false,
            ppid: this.uuid()
        };
    }
};
$ddf043c3ffa0fa71$export$c603866f8169960d = (0, $c106e002a49a00cb$export$29e00dfd3077644b)([
    (0, $79188624df80f470$export$2e2bcd8739ae039)(),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(0, (0, $190b0b497264ac3c$export$2e2bcd8739ae039)((0, $f009ac2c4949a5c1$export$efa9a398d6368992), (0, $f009ac2c4949a5c1$export$e41701f8b288055a), "UserIdentity")),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(1, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $b8e408dd2b31a250$export$bc35efed93511c4b))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(2, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $a784d298db20d12c$export$19fffca37ef3e106))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(3, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $62b9cd2513a767e8$export$14eb8822b262d643))),
    (0, $c106e002a49a00cb$export$f1db080c865becb9)("design:paramtypes", [
        typeof ($ddf043c3ffa0fa71$var$_a = typeof (0, $f009ac2c4949a5c1$export$efa9a398d6368992) !== "undefined" && (0, $f009ac2c4949a5c1$export$efa9a398d6368992)) === "function" ? $ddf043c3ffa0fa71$var$_a : Object,
        Function,
        typeof ($ddf043c3ffa0fa71$var$_b = typeof (0, $a784d298db20d12c$export$19fffca37ef3e106) !== "undefined" && (0, $a784d298db20d12c$export$19fffca37ef3e106)) === "function" ? $ddf043c3ffa0fa71$var$_b : Object,
        typeof ($ddf043c3ffa0fa71$var$_c = typeof (0, $62b9cd2513a767e8$export$14eb8822b262d643) !== "undefined" && (0, $62b9cd2513a767e8$export$14eb8822b262d643)) === "function" ? $ddf043c3ffa0fa71$var$_c : Object
    ])
], $ddf043c3ffa0fa71$export$c603866f8169960d);











var $fe8d63873a297d60$var$_a, $fe8d63873a297d60$var$_b, $fe8d63873a297d60$var$_c, $fe8d63873a297d60$var$_d, $fe8d63873a297d60$var$_e;
let $fe8d63873a297d60$export$8e31a80c0b780cb3 = class IdentityStorageService {
    constructor(storage, logger, windowContextRepository, instantConfigService, identityStorageClient){
        this.storage = storage;
        this.logger = logger;
        this.windowContextRepository = windowContextRepository;
        this.instantConfigService = instantConfigService;
        this.identityStorageClient = identityStorageClient;
    }
    get() {
        return (0, $c106e002a49a00cb$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            const localData = yield this.getLocalData();
            if (localData && !localData.synced) this.setRemote(localData);
            if (!localData || this.isDeprecated(localData)) return this.getRemote();
            else {
                this.setIdentityContextVariables(localData);
                return localData;
            }
        });
    }
    setRemote(data) {
        return (0, $c106e002a49a00cb$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            try {
                yield this.identityStorageClient.postData(data);
                const localData = Object.assign(Object.assign({}, this.identityStorageClient.getLocalData()), {
                    synced: true
                });
                this.setIdentityContextVariables(localData);
                this.identityStorageClient.setLocalData(Object.assign(Object.assign({}, localData), {
                    timestamp: Date.now()
                }));
                return localData;
            } catch (ex) {
                this.logger.error("Updating Identity LocalStorage data failed");
            }
        });
    }
    isDeprecated(localData) {
        // Fallback : days * hours * minutes * seconds * milliseconds;
        const timeDifference = this.instantConfigService.get("icIdentityTtl", 604800000);
        const lastWeek = Date.now() - timeDifference;
        return !localData.timestamp || localData.timestamp - lastWeek < 0;
    }
    getLocalData() {
        return (0, $c106e002a49a00cb$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            let localIdentity = yield this.identityStorageClient.getLocalData();
            // ToDo: Remove 1 month after migrating remote storage to IdentityStorage.
            if (!localIdentity) {
                const deprecatedPpid = this.getLocalPPID() || this.getAdmsPPID();
                if (deprecatedPpid) localIdentity = yield this.migrateDeprecatedIdentity(deprecatedPpid);
            }
            return localIdentity;
        });
    }
    migrateDeprecatedIdentity(deprecatedPPID) {
        return (0, $c106e002a49a00cb$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            const remoteData = yield this.setRemote({
                ppid: deprecatedPPID,
                synced: false
            });
            this.clearDeprecatedLocalPpid();
            return remoteData;
        });
    }
    getAdmsPPID() {
        var _a, _b;
        const admsData = this.storage.getItem("silver-surfer-active-data-v2");
        return (_b = (_a = admsData === null || admsData === void 0 ? void 0 : admsData.IDENTITY) === null || _a === void 0 ? void 0 : _a[0].payload) === null || _b === void 0 ? void 0 : _b.identityToken;
    }
    getLocalPPID() {
        return this.storage.getItem("ppid");
    }
    clearDeprecatedLocalPpid() {
        this.storage.removeItem("ppid");
    }
    getRemote() {
        return (0, $c106e002a49a00cb$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            const remoteData = yield this.identityStorageClient.fetchData();
            this.setIdentityContextVariables(remoteData);
            this.identityStorageClient.setLocalData(Object.assign(Object.assign({}, remoteData), {
                timestamp: Date.now()
            }));
            return remoteData;
        });
    }
    setIdentityContextVariables(userData) {
        if (userData.over18) this.windowContextRepository.set("over_18", {
            value: "1"
        });
    }
};
$fe8d63873a297d60$export$8e31a80c0b780cb3 = (0, $c106e002a49a00cb$export$29e00dfd3077644b)([
    (0, $79188624df80f470$export$2e2bcd8739ae039)(),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(0, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $a784d298db20d12c$export$19fffca37ef3e106))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(1, (0, $190b0b497264ac3c$export$2e2bcd8739ae039)((0, $f009ac2c4949a5c1$export$efa9a398d6368992), (0, $f009ac2c4949a5c1$export$e41701f8b288055a), "UserIdentity")),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(2, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $fb057a8ae4d9c6c2$export$7c6bc96f7559de2b))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(3, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $b33345d01c8a6de2$export$7b5f2db24cd34c1f))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(4, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $ddf043c3ffa0fa71$export$c603866f8169960d))),
    (0, $c106e002a49a00cb$export$f1db080c865becb9)("design:paramtypes", [
        typeof ($fe8d63873a297d60$var$_a = typeof (0, $a784d298db20d12c$export$19fffca37ef3e106) !== "undefined" && (0, $a784d298db20d12c$export$19fffca37ef3e106)) === "function" ? $fe8d63873a297d60$var$_a : Object,
        typeof ($fe8d63873a297d60$var$_b = typeof (0, $f009ac2c4949a5c1$export$efa9a398d6368992) !== "undefined" && (0, $f009ac2c4949a5c1$export$efa9a398d6368992)) === "function" ? $fe8d63873a297d60$var$_b : Object,
        typeof ($fe8d63873a297d60$var$_c = typeof (0, $fb057a8ae4d9c6c2$export$7c6bc96f7559de2b) !== "undefined" && (0, $fb057a8ae4d9c6c2$export$7c6bc96f7559de2b)) === "function" ? $fe8d63873a297d60$var$_c : Object,
        typeof ($fe8d63873a297d60$var$_d = typeof (0, $b33345d01c8a6de2$export$7b5f2db24cd34c1f) !== "undefined" && (0, $b33345d01c8a6de2$export$7b5f2db24cd34c1f)) === "function" ? $fe8d63873a297d60$var$_d : Object,
        typeof ($fe8d63873a297d60$var$_e = typeof (0, $ddf043c3ffa0fa71$export$c603866f8169960d) !== "undefined" && (0, $ddf043c3ffa0fa71$export$c603866f8169960d)) === "function" ? $fe8d63873a297d60$var$_e : Object
    ])
], $fe8d63873a297d60$export$8e31a80c0b780cb3);




var $38f6ac180562751d$var$_a, $38f6ac180562751d$var$_b;
let $38f6ac180562751d$export$9e0d76c40331c107 = class IdentityStorageRepository {
    constructor(logger, identityStorageService){
        this.logger = logger;
        this.identityStorageService = identityStorageService;
    }
    get() {
        return (0, $c106e002a49a00cb$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            const userData = yield this.identityStorageService.get();
            this.logger.info(userData);
            return userData.ppid;
        });
    }
};
$38f6ac180562751d$export$9e0d76c40331c107 = (0, $c106e002a49a00cb$export$29e00dfd3077644b)([
    (0, $79188624df80f470$export$2e2bcd8739ae039)(),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(0, (0, $190b0b497264ac3c$export$2e2bcd8739ae039)((0, $f009ac2c4949a5c1$export$efa9a398d6368992), (0, $f009ac2c4949a5c1$export$e41701f8b288055a), "UserIdentity")),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(1, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $fe8d63873a297d60$export$8e31a80c0b780cb3))),
    (0, $c106e002a49a00cb$export$f1db080c865becb9)("design:paramtypes", [
        typeof ($38f6ac180562751d$var$_a = typeof (0, $f009ac2c4949a5c1$export$efa9a398d6368992) !== "undefined" && (0, $f009ac2c4949a5c1$export$efa9a398d6368992)) === "function" ? $38f6ac180562751d$var$_a : Object,
        typeof ($38f6ac180562751d$var$_b = typeof (0, $fe8d63873a297d60$export$8e31a80c0b780cb3) !== "undefined" && (0, $fe8d63873a297d60$export$8e31a80c0b780cb3)) === "function" ? $38f6ac180562751d$var$_b : Object
    ])
], $38f6ac180562751d$export$9e0d76c40331c107);









var $afb14ea6ed0cdbf8$var$_a, $afb14ea6ed0cdbf8$var$_b;
let $afb14ea6ed0cdbf8$export$894c0cc04068361f = class LocalStorageRepository {
    constructor(logger, uuid, storage){
        this.logger = logger;
        this.uuid = uuid;
        this.storage = storage;
    }
    get() {
        return Promise.resolve(this.storage.getItem("ppid") || this.generatePPID());
    }
    generatePPID() {
        this.logger.info("did not found a PPID in LocalStorage");
        const ppid = this.uuid();
        this.storage.setItem("ppid", ppid);
        return ppid;
    }
};
$afb14ea6ed0cdbf8$export$894c0cc04068361f = (0, $c106e002a49a00cb$export$29e00dfd3077644b)([
    (0, $79188624df80f470$export$2e2bcd8739ae039)(),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(0, (0, $190b0b497264ac3c$export$2e2bcd8739ae039)((0, $f009ac2c4949a5c1$export$efa9a398d6368992), (0, $f009ac2c4949a5c1$export$e41701f8b288055a), "UserIdentity")),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(1, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $b8e408dd2b31a250$export$bc35efed93511c4b))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(2, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $a784d298db20d12c$export$19fffca37ef3e106))),
    (0, $c106e002a49a00cb$export$f1db080c865becb9)("design:paramtypes", [
        typeof ($afb14ea6ed0cdbf8$var$_a = typeof (0, $f009ac2c4949a5c1$export$efa9a398d6368992) !== "undefined" && (0, $f009ac2c4949a5c1$export$efa9a398d6368992)) === "function" ? $afb14ea6ed0cdbf8$var$_a : Object,
        Function,
        typeof ($afb14ea6ed0cdbf8$var$_b = typeof (0, $a784d298db20d12c$export$19fffca37ef3e106) !== "undefined" && (0, $a784d298db20d12c$export$19fffca37ef3e106)) === "function" ? $afb14ea6ed0cdbf8$var$_b : Object
    ])
], $afb14ea6ed0cdbf8$export$894c0cc04068361f);








var $c38c6bd9d213b858$var$_a, $c38c6bd9d213b858$var$_b, $c38c6bd9d213b858$var$_c, $c38c6bd9d213b858$var$_d, $c38c6bd9d213b858$var$_e, $c38c6bd9d213b858$var$_f, $c38c6bd9d213b858$var$_g;
let $c38c6bd9d213b858$export$8c5c7bfa0843d044 = class PpidProvider {
    constructor(dataWarehouse, logger, windowContextRepository, instantConfigService, identityStorageRepository, localStorageRepository, communicationService){
        this.dataWarehouse = dataWarehouse;
        this.logger = logger;
        this.windowContextRepository = windowContextRepository;
        this.instantConfigService = instantConfigService;
        this.identityStorageRepository = identityStorageRepository;
        this.localStorageRepository = localStorageRepository;
        this.communicationService = communicationService;
    }
    getPPID(strategy) {
        this.logger.info("active strategy: ", strategy);
        switch(strategy){
            case (0, $65f5bcdd46d7bded$export$b9500f6ce524e250).IDENTITY_STORAGE:
                return this.identityStorageRepository;
            case (0, $65f5bcdd46d7bded$export$b9500f6ce524e250).LOCAL:
            default:
                return this.localStorageRepository;
        }
    }
    generatePPID() {
        return (0, $c106e002a49a00cb$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            try {
                const strategy = this.instantConfigService.get("icPpidRepository", (0, $65f5bcdd46d7bded$export$b9500f6ce524e250).LOCAL);
                const ppid = yield this.getPPID(strategy).get();
                this.dataWarehouse.track((0, $7282ba2280fb0c96$export$3fd68cdf578a0808).identity, {
                    partner_name: "Google",
                    partner_identity_id: ppid
                });
                this.communicationService.emit(new (0, $697309025c6aa3ae$export$e19cd5f9376f8cee)((0, $9bac733ad19ab912$export$7f305d1b47333a2).IDENTITY_PARTNER_DATA_OBTAINED, {
                    payload: {
                        partnerName: "Google",
                        partnerIdentityId: ppid
                    }
                }));
                this.windowContextRepository.set("ppid", {
                    value: ppid
                });
                this.logger.info("Passed PPID to page-level targeting");
            } catch (e) {
                this.logger.error("Setting up PPID has failed!", e);
            }
        });
    }
    setPpid() {
        return (0, $c106e002a49a00cb$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            if (this.instantConfigService.get("icPpid", false)) {
                this.logger.info("enabled - awaiting setup");
                yield this.generatePPID();
            } else this.logger.info("disabled");
        });
    }
};
$c38c6bd9d213b858$export$8c5c7bfa0843d044 = (0, $c106e002a49a00cb$export$29e00dfd3077644b)([
    (0, $79188624df80f470$export$2e2bcd8739ae039)(),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(0, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $d34bd813659277b4$export$bc485e6e25746fed))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(1, (0, $190b0b497264ac3c$export$2e2bcd8739ae039)((0, $f009ac2c4949a5c1$export$efa9a398d6368992), (0, $f009ac2c4949a5c1$export$e41701f8b288055a), "UserIdentity")),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(2, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $fb057a8ae4d9c6c2$export$7c6bc96f7559de2b))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(3, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $b33345d01c8a6de2$export$7b5f2db24cd34c1f))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(4, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $38f6ac180562751d$export$9e0d76c40331c107))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(5, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $afb14ea6ed0cdbf8$export$894c0cc04068361f))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(6, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $fdfc6e1cf47ae084$export$539550160b78d8c5))),
    (0, $c106e002a49a00cb$export$f1db080c865becb9)("design:paramtypes", [
        typeof ($c38c6bd9d213b858$var$_a = typeof (0, $d34bd813659277b4$export$bc485e6e25746fed) !== "undefined" && (0, $d34bd813659277b4$export$bc485e6e25746fed)) === "function" ? $c38c6bd9d213b858$var$_a : Object,
        typeof ($c38c6bd9d213b858$var$_b = typeof (0, $f009ac2c4949a5c1$export$efa9a398d6368992) !== "undefined" && (0, $f009ac2c4949a5c1$export$efa9a398d6368992)) === "function" ? $c38c6bd9d213b858$var$_b : Object,
        typeof ($c38c6bd9d213b858$var$_c = typeof (0, $fb057a8ae4d9c6c2$export$7c6bc96f7559de2b) !== "undefined" && (0, $fb057a8ae4d9c6c2$export$7c6bc96f7559de2b)) === "function" ? $c38c6bd9d213b858$var$_c : Object,
        typeof ($c38c6bd9d213b858$var$_d = typeof (0, $b33345d01c8a6de2$export$7b5f2db24cd34c1f) !== "undefined" && (0, $b33345d01c8a6de2$export$7b5f2db24cd34c1f)) === "function" ? $c38c6bd9d213b858$var$_d : Object,
        typeof ($c38c6bd9d213b858$var$_e = typeof (0, $38f6ac180562751d$export$9e0d76c40331c107) !== "undefined" && (0, $38f6ac180562751d$export$9e0d76c40331c107)) === "function" ? $c38c6bd9d213b858$var$_e : Object,
        typeof ($c38c6bd9d213b858$var$_f = typeof (0, $afb14ea6ed0cdbf8$export$894c0cc04068361f) !== "undefined" && (0, $afb14ea6ed0cdbf8$export$894c0cc04068361f)) === "function" ? $c38c6bd9d213b858$var$_f : Object,
        typeof ($c38c6bd9d213b858$var$_g = typeof (0, $fdfc6e1cf47ae084$export$539550160b78d8c5) !== "undefined" && (0, $fdfc6e1cf47ae084$export$539550160b78d8c5)) === "function" ? $c38c6bd9d213b858$var$_g : Object
    ])
], $c38c6bd9d213b858$export$8c5c7bfa0843d044);













const $a6cbcf107aad529f$export$62c6610974b3eed9 = {
    C0001: "necessary",
    C0002: "performance",
    C0003: "functional",
    C0004: "targeting",
    C0005: "social"
};
class $a6cbcf107aad529f$export$6ebc4ce39035f1d0 {
    constructor(container, queueResolver){
        this.container = container;
        const oldOptanonWrapper = container.OptanonWrapper;
        container.OptanonWrapper = ()=>{
            queueResolver.resolve();
            oldOptanonWrapper === null || oldOptanonWrapper === void 0 || oldOptanonWrapper();
        };
    }
    available() {
        return this.container.OneTrust !== undefined;
    }
    ready() {
        var _a, _b;
        const api = this.container.OneTrust;
        return this.container.OnetrustActiveGroups !== undefined && (((_b = (_a = api.GetDomainData()) === null || _a === void 0 ? void 0 : _a.ConsentModel) === null || _b === void 0 ? void 0 : _b.Name) !== "opt-in" || api.IsAlertBoxClosed());
    }
    resolve() {
        var _a;
        return (_a = this.container.OnetrustActiveGroups) === null || _a === void 0 ? void 0 : _a.split(",").map((g)=>$a6cbcf107aad529f$export$62c6610974b3eed9[g]).filter((g)=>g).reduce((a, v)=>Object.assign(Object.assign({}, a), {
                [v]: true
            }), {});
    }
}



class $64d10a9b2f0a6d48$export$3ad4d4028f1fecc0 {
    constructor(optIn, cookiesManager){
        this.optIn = optIn;
        this.cookiesManager = cookiesManager;
    }
    available() {
        return this.cookiesManager.get("OptanonConsent") !== undefined;
    }
    ready() {
        return !this.optIn || this.cookiesManager.get("OptanonAlertBoxClosed") !== undefined;
    }
    resolve() {
        var _a;
        const groups = (_a = decodeURIComponent(this.cookiesManager.get("OptanonConsent"))) === null || _a === void 0 ? void 0 : _a.match(/groups=([^&]+)/);
        if (groups && groups[1]) return groups[1].toUpperCase().split(",").map((g)=>{
            const nameVal = g.split(":");
            return nameVal[1] === "1" ? (0, $a6cbcf107aad529f$export$62c6610974b3eed9)[nameVal[0]] : undefined;
        }).filter((c)=>c).reduce((a, v)=>Object.assign(Object.assign({}, a), {
                [v]: true
            }), {});
        return {};
    }
}



var $6ea5ac91bc607eac$var$_a, $6ea5ac91bc607eac$var$_b, $6ea5ac91bc607eac$var$_c;
const $6ea5ac91bc607eac$var$resolveTimeout = 5000; // TODO: set in ICBM per platform
const $6ea5ac91bc607eac$var$optInCategories = {
    necessary: true
};
const $6ea5ac91bc607eac$var$optOutCategories = {
    necessary: true,
    performance: true,
    functional: true,
    targeting: true,
    social: true
};
let $6ea5ac91bc607eac$export$a0751927bd694ee7 = class ConsentCallbackQueueResolver {
    constructor(container, logger, cookiesManager){
        var _a, _b;
        this.container = container;
        this.logger = logger;
        this.cookiesManager = cookiesManager;
        const geo = this.cookiesManager.get("Geo");
        this.queue = container.consentCallbackQueue;
        this.optIn = geo ? (0, $c2def7e558dee4a0$export$c50418c2c95b7cca).includes((_b = (_a = JSON.parse(decodeURIComponent(geo))) === null || _a === void 0 ? void 0 : _a.country) === null || _b === void 0 ? void 0 : _b.toLowerCase()) : false;
        if (this.queue !== undefined) this.init();
    }
    resolve() {
        if (this.wasResolved()) return true;
        if (this.ifAvailableThenResolveIfReady(this.apiConsentResolver)) {
            this.logger.info("API available, resolved?:", this.categories);
            return this.wasResolved();
        }
        if (this.ifAvailableThenResolveIfReady(this.cookieConsentResolver)) {
            this.logger.info("Cookies available, resolved?:", this.categories);
            return this.wasResolved();
        }
        return false;
    }
    wasResolved() {
        return this.categories !== undefined;
    }
    init() {
        this.logger.info("Setting up with opt-in status:", this.optIn);
        this.apiConsentResolver = new (0, $a6cbcf107aad529f$export$6ebc4ce39035f1d0)(this.container, this);
        this.cookieConsentResolver = new (0, $64d10a9b2f0a6d48$export$3ad4d4028f1fecc0)(this.optIn, this.cookiesManager);
        if (!this.resolve()) setTimeout(()=>this.resolveWithFallback(), $6ea5ac91bc607eac$var$resolveTimeout);
    }
    resolveWithFallback() {
        if (this.resolve()) return;
        if (this.apiConsentResolver.available() || this.cookieConsentResolver.available()) {
            this.logger.info("Still waiting for consent resolve with available api:", this.apiConsentResolver.available(), "or cookie:", this.cookieConsentResolver.available());
            setTimeout(()=>this.resolveWithFallback, $6ea5ac91bc607eac$var$resolveTimeout);
        } else {
            this.categories = this.fallback();
            this.logger.info("Unable to resolve consent, fallback to:", this.categories);
            this.resolveQueue();
        }
    }
    ifAvailableThenResolveIfReady(resolver) {
        const available = resolver.available();
        if (available && resolver.ready()) {
            this.categories = resolver.resolve();
            this.resolveQueue();
        }
        return available;
    }
    checkAndRun(name, callback, requiredCategory) {
        this.logger.info("About to callback:", name, "for:", requiredCategory, "with:", this.categories);
        if (requiredCategory === undefined || this.categories[requiredCategory]) {
            callback(this.categories);
            return true;
        }
        return false;
    }
    resolveQueue() {
        this.flushQueue();
        this.queue.push = (name, callback, category)=>this.checkAndRun(name, callback, category);
        this.container.consentCallback = (name, callback, category)=>this.checkAndRun(name, callback, category);
    }
    flushQueue() {
        const queue = this.queue.queue;
        this.logger.info("Consent resolved, flushing queue of size:", queue.length);
        for(let i = queue.length - 1; i >= 0; i--){
            const callback = queue[i];
            if (this.checkAndRun(callback.name, callback.callback, callback.category)) queue.splice(i, 1);
        }
    }
    fallback() {
        return this.optIn ? $6ea5ac91bc607eac$var$optInCategories : $6ea5ac91bc607eac$var$optOutCategories;
    }
};
$6ea5ac91bc607eac$export$a0751927bd694ee7 = (0, $c106e002a49a00cb$export$29e00dfd3077644b)([
    (0, $79188624df80f470$export$2e2bcd8739ae039)(),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(0, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $b8e408dd2b31a250$export$56d8a8a25bd48b81))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(1, (0, $190b0b497264ac3c$export$2e2bcd8739ae039)((0, $f009ac2c4949a5c1$export$efa9a398d6368992), (0, $f009ac2c4949a5c1$export$e41701f8b288055a), "ConsentCallbackQueueHandler")),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(2, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $b8e408dd2b31a250$export$9e98cacf66dcab6a))),
    (0, $c106e002a49a00cb$export$f1db080c865becb9)("design:paramtypes", [
        typeof ($6ea5ac91bc607eac$var$_a = typeof Window !== "undefined" && Window) === "function" ? $6ea5ac91bc607eac$var$_a : Object,
        typeof ($6ea5ac91bc607eac$var$_b = typeof (0, $f009ac2c4949a5c1$export$efa9a398d6368992) !== "undefined" && (0, $f009ac2c4949a5c1$export$efa9a398d6368992)) === "function" ? $6ea5ac91bc607eac$var$_b : Object,
        typeof ($6ea5ac91bc607eac$var$_c = typeof CookiesManager !== "undefined" && CookiesManager) === "function" ? $6ea5ac91bc607eac$var$_c : Object
    ])
], $6ea5ac91bc607eac$export$a0751927bd694ee7);






var $46e48dfefa7370c1$var$_a, $46e48dfefa7370c1$var$_b;
let $46e48dfefa7370c1$export$91b222e09aa51169 = class ConsentCallbackQueue {
    constructor(window, logger){
        this.window = window;
        this.logger = logger;
        this.queue = [];
    }
    install() {
        this.logger.info("installing consent queue");
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const self = this;
        this.window.consentCallbackQueue = this;
        this.window.consentCallback = (name, callback, category)=>self.push(name, callback, category);
        return this;
    }
    push(name, callback, requiredCategory) {
        this.logger.warn("dialog not resolved, enqueued:", name);
        this.queue.push({
            name: name,
            callback: callback,
            category: requiredCategory
        });
    }
};
$46e48dfefa7370c1$export$91b222e09aa51169 = (0, $c106e002a49a00cb$export$29e00dfd3077644b)([
    (0, $79188624df80f470$export$2e2bcd8739ae039)(),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(0, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $b8e408dd2b31a250$export$56d8a8a25bd48b81))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(1, (0, $190b0b497264ac3c$export$2e2bcd8739ae039)((0, $f009ac2c4949a5c1$export$efa9a398d6368992), (0, $f009ac2c4949a5c1$export$e41701f8b288055a), "ConsentCallbackQueue")),
    (0, $c106e002a49a00cb$export$f1db080c865becb9)("design:paramtypes", [
        typeof ($46e48dfefa7370c1$var$_a = typeof Window !== "undefined" && Window) === "function" ? $46e48dfefa7370c1$var$_a : Object,
        typeof ($46e48dfefa7370c1$var$_b = typeof (0, $f009ac2c4949a5c1$export$efa9a398d6368992) !== "undefined" && (0, $f009ac2c4949a5c1$export$efa9a398d6368992)) === "function" ? $46e48dfefa7370c1$var$_b : Object
    ])
], $46e48dfefa7370c1$export$91b222e09aa51169);



var $aca33b21dc11252c$var$_a, $aca33b21dc11252c$var$_b, $aca33b21dc11252c$var$_c, $aca33b21dc11252c$var$_d, $aca33b21dc11252c$var$_e, $aca33b21dc11252c$var$_f, $aca33b21dc11252c$var$_g, $aca33b21dc11252c$var$_h, $aca33b21dc11252c$var$_j, $aca33b21dc11252c$var$_k, $aca33b21dc11252c$var$_l, $aca33b21dc11252c$var$_m, $aca33b21dc11252c$var$_o, $aca33b21dc11252c$var$_p, $aca33b21dc11252c$var$_q;
(0, $bef43bd5f0c77276$export$9544d5bb712b01ea).register((0, $b8e408dd2b31a250$export$9e98cacf66dcab6a), {
    useValue: (0, (/*@__PURE__*/$parcel$interopDefault($428fcb2015744f49$exports)))
});
(0, $bef43bd5f0c77276$export$9544d5bb712b01ea).register((0, $b8e408dd2b31a250$export$bc35efed93511c4b), {
    useValue: (0, $27d7069422be255c$export$2e2bcd8739ae039)
});
(0, $bef43bd5f0c77276$export$9544d5bb712b01ea).register((0, $b8e408dd2b31a250$export$56d8a8a25bd48b81), {
    useValue: window
});
let $aca33b21dc11252c$var$IdentityEngine = class IdentityEngine {
    constructor(geoCookie, ageGateHandler, communicationService, optInService, hemTrackingService, trackingContextSetupService, consentResolver, instantConfigService, window1, logger, ppidProvider, consentCallbackQueue, consentCallbackQueueResolver, coppaSubject, metricReporterService){
        this.geoCookie = geoCookie;
        this.ageGateHandler = ageGateHandler;
        this.communicationService = communicationService;
        this.optInService = optInService;
        this.hemTrackingService = hemTrackingService;
        this.trackingContextSetupService = trackingContextSetupService;
        this.consentResolver = consentResolver;
        this.instantConfigService = instantConfigService;
        this.window = window1;
        this.logger = logger;
        this.ppidProvider = ppidProvider;
        this.consentCallbackQueue = consentCallbackQueue;
        this.consentCallbackQueueResolver = consentCallbackQueueResolver;
        this.coppaSubject = coppaSubject;
        this.metricReporterService = metricReporterService;
    }
    initializeAgeGateHandler() {
        return (0, $c106e002a49a00cb$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            return this.ageGateHandler.init(this.communicationService);
        });
    }
    updateGTMConsent(granted) {
        if (this.window.dataLayer === undefined) this.window.dataLayer = [];
        this.window.dataLayer.push({
            event: "user-consent",
            consent: granted.toString()
        });
    }
    initializeTracking() {
        return (0, $c106e002a49a00cb$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            this.logger.info("Setting up tracking");
            this.optInService.trackingAllowed = true;
            this.hemTrackingService.activateTracking();
            yield this.ppidProvider.setPpid();
            this.communicationService.emit(new (0, $697309025c6aa3ae$export$e19cd5f9376f8cee)((0, $9bac733ad19ab912$export$7f305d1b47333a2).IDENTITY_READY));
            this.metricReporterService.send("ready");
        });
    }
    init() {
        return (0, $c106e002a49a00cb$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            yield this.geoCookie.setGeoCookieIfNotExist();
            yield this.instantConfigService.init();
            this.optInService.init();
            this.metricReporterService.init(this.instantConfigService);
            this.metricReporterService.send("init");
        });
    }
    run() {
        // 2.6.1 will be replaced with version from package.json
        this.logger.info("Starting identity engine v2.6.1");
        const domain = this.window.location.hostname;
        this.communicationService.once((0, $9bac733ad19ab912$export$7f305d1b47333a2).CONSENT_READY, (consents)=>{
            this.trackingContextSetupService.setup(domain);
            this.consentResolver.resolve(consents, ()=>(0, $c106e002a49a00cb$export$1050f835b63b671e)(this, void 0, void 0, function*() {
                    this.updateGTMConsent(true);
                    yield this.initializeAgeGateHandler();
                    this.coppaSubject.resolveCoppaStatus();
                    yield this.initializeTracking();
                }), ()=>{
                this.updateGTMConsent(false);
                this.coppaSubject.resolveCoppaStatus();
                this.optInService.trackingAllowed = false;
                this.communicationService.emit(new (0, $697309025c6aa3ae$export$e19cd5f9376f8cee)((0, $9bac733ad19ab912$export$7f305d1b47333a2).IDENTITY_READY));
                this.metricReporterService.send("ready");
                this.logger.info("Tracking rejected");
            });
        });
    }
};
$aca33b21dc11252c$var$IdentityEngine = (0, $c106e002a49a00cb$export$29e00dfd3077644b)([
    (0, $79188624df80f470$export$2e2bcd8739ae039)(),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(0, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $aafb2d1d298b1a56$export$8d20793915672011))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(1, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $2339baf3570cc7fc$export$a6e611db690f864e))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(2, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $fdfc6e1cf47ae084$export$539550160b78d8c5))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(3, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $b4e61c6332766e68$export$ba61ea7ee8b810c4))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(4, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $05340dab2e7d7c8b$export$578f2db7e76a4371))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(5, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $09d9dac4cd581d14$export$176f30e94bca0133))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(6, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $c46fbf90e37984d9$export$69b6c01a07c4eb3a))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(7, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $b33345d01c8a6de2$export$7b5f2db24cd34c1f))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(8, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $b8e408dd2b31a250$export$56d8a8a25bd48b81))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(9, (0, $190b0b497264ac3c$export$2e2bcd8739ae039)((0, $f009ac2c4949a5c1$export$efa9a398d6368992), (0, $f009ac2c4949a5c1$export$e41701f8b288055a), "IdentityEngine")),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(10, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $c38c6bd9d213b858$export$8c5c7bfa0843d044))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(11, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $46e48dfefa7370c1$export$91b222e09aa51169))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(12, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $6ea5ac91bc607eac$export$a0751927bd694ee7))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(13, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $a0824533ef024e6a$export$25007d9e64202fc2))),
    (0, $c106e002a49a00cb$export$d5ad3fd78186038f)(14, (0, $5c0ddbbfd03410de$export$2e2bcd8739ae039)((0, $799d3e7c42b201d6$export$5f937add7079efe4))),
    (0, $c106e002a49a00cb$export$f1db080c865becb9)("design:paramtypes", [
        typeof ($aca33b21dc11252c$var$_a = typeof (0, $aafb2d1d298b1a56$export$8d20793915672011) !== "undefined" && (0, $aafb2d1d298b1a56$export$8d20793915672011)) === "function" ? $aca33b21dc11252c$var$_a : Object,
        typeof ($aca33b21dc11252c$var$_b = typeof (0, $2339baf3570cc7fc$export$a6e611db690f864e) !== "undefined" && (0, $2339baf3570cc7fc$export$a6e611db690f864e)) === "function" ? $aca33b21dc11252c$var$_b : Object,
        typeof ($aca33b21dc11252c$var$_c = typeof (0, $fdfc6e1cf47ae084$export$539550160b78d8c5) !== "undefined" && (0, $fdfc6e1cf47ae084$export$539550160b78d8c5)) === "function" ? $aca33b21dc11252c$var$_c : Object,
        typeof ($aca33b21dc11252c$var$_d = typeof (0, $b4e61c6332766e68$export$ba61ea7ee8b810c4) !== "undefined" && (0, $b4e61c6332766e68$export$ba61ea7ee8b810c4)) === "function" ? $aca33b21dc11252c$var$_d : Object,
        typeof ($aca33b21dc11252c$var$_e = typeof (0, $05340dab2e7d7c8b$export$578f2db7e76a4371) !== "undefined" && (0, $05340dab2e7d7c8b$export$578f2db7e76a4371)) === "function" ? $aca33b21dc11252c$var$_e : Object,
        typeof ($aca33b21dc11252c$var$_f = typeof (0, $09d9dac4cd581d14$export$176f30e94bca0133) !== "undefined" && (0, $09d9dac4cd581d14$export$176f30e94bca0133)) === "function" ? $aca33b21dc11252c$var$_f : Object,
        typeof ($aca33b21dc11252c$var$_g = typeof (0, $c46fbf90e37984d9$export$69b6c01a07c4eb3a) !== "undefined" && (0, $c46fbf90e37984d9$export$69b6c01a07c4eb3a)) === "function" ? $aca33b21dc11252c$var$_g : Object,
        typeof ($aca33b21dc11252c$var$_h = typeof (0, $b33345d01c8a6de2$export$7b5f2db24cd34c1f) !== "undefined" && (0, $b33345d01c8a6de2$export$7b5f2db24cd34c1f)) === "function" ? $aca33b21dc11252c$var$_h : Object,
        typeof ($aca33b21dc11252c$var$_j = typeof Window !== "undefined" && Window) === "function" ? $aca33b21dc11252c$var$_j : Object,
        typeof ($aca33b21dc11252c$var$_k = typeof (0, $f009ac2c4949a5c1$export$efa9a398d6368992) !== "undefined" && (0, $f009ac2c4949a5c1$export$efa9a398d6368992)) === "function" ? $aca33b21dc11252c$var$_k : Object,
        typeof ($aca33b21dc11252c$var$_l = typeof (0, $c38c6bd9d213b858$export$8c5c7bfa0843d044) !== "undefined" && (0, $c38c6bd9d213b858$export$8c5c7bfa0843d044)) === "function" ? $aca33b21dc11252c$var$_l : Object,
        typeof ($aca33b21dc11252c$var$_m = typeof (0, $46e48dfefa7370c1$export$91b222e09aa51169) !== "undefined" && (0, $46e48dfefa7370c1$export$91b222e09aa51169)) === "function" ? $aca33b21dc11252c$var$_m : Object,
        typeof ($aca33b21dc11252c$var$_o = typeof (0, $6ea5ac91bc607eac$export$a0751927bd694ee7) !== "undefined" && (0, $6ea5ac91bc607eac$export$a0751927bd694ee7)) === "function" ? $aca33b21dc11252c$var$_o : Object,
        typeof ($aca33b21dc11252c$var$_p = typeof (0, $a0824533ef024e6a$export$25007d9e64202fc2) !== "undefined" && (0, $a0824533ef024e6a$export$25007d9e64202fc2)) === "function" ? $aca33b21dc11252c$var$_p : Object,
        typeof ($aca33b21dc11252c$var$_q = typeof (0, $799d3e7c42b201d6$export$5f937add7079efe4) !== "undefined" && (0, $799d3e7c42b201d6$export$5f937add7079efe4)) === "function" ? $aca33b21dc11252c$var$_q : Object
    ])
], $aca33b21dc11252c$var$IdentityEngine);
function $aca33b21dc11252c$var$initialize() {
    const identityEngine = (0, $bef43bd5f0c77276$export$9544d5bb712b01ea).resolve($aca33b21dc11252c$var$IdentityEngine);
    identityEngine.init().then(()=>{
        identityEngine.run();
    });
}
$aca33b21dc11252c$var$initialize();

})();
//# sourceMappingURL=index.js.map
